webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(775)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(950),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0695f2fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = login;
/* harmony export (immutable) */ __webpack_exports__["b"] = user;
/* harmony export (immutable) */ __webpack_exports__["n"] = inputData;
/* harmony export (immutable) */ __webpack_exports__["g"] = inputAllData;
/* harmony export (immutable) */ __webpack_exports__["i"] = orderPlant;
/* harmony export (immutable) */ __webpack_exports__["p"] = getInvoicingTodayData;
/* harmony export (immutable) */ __webpack_exports__["o"] = updateInvoicingData;
/* harmony export (immutable) */ __webpack_exports__["m"] = predictionData;
/* harmony export (immutable) */ __webpack_exports__["k"] = assignOrder;
/* harmony export (immutable) */ __webpack_exports__["l"] = getCarOrder;
/* harmony export (immutable) */ __webpack_exports__["j"] = getStatus;
/* harmony export (immutable) */ __webpack_exports__["c"] = depot;
/* harmony export (immutable) */ __webpack_exports__["f"] = driver;
/* harmony export (immutable) */ __webpack_exports__["e"] = car;
/* harmony export (immutable) */ __webpack_exports__["d"] = gas;
/* harmony export (immutable) */ __webpack_exports__["h"] = depotValume;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_init_p__ = __webpack_require__(350);


function login(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('login', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

function user(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('user', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

function inputData(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('input_data', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

function inputAllData(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('input_all_data', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

function orderPlant(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('order_plant', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

function getInvoicingTodayData(parm) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('invoicing', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].GET, parm);
}

function updateInvoicingData(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('invoicing', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

function predictionData() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('prediction_data', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].GET);
}

function assignOrder(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('order', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

function getCarOrder() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('order', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].GET);
}

function getStatus(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('redis_data', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

function depot(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('depot', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

function driver(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('driver', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

function car(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('car', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

function gas(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('gas', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

function depotValume(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios_init_p__["a" /* baseAPIRequest */])('depot_valume', __WEBPACK_IMPORTED_MODULE_0__axios_init_p__["b" /* httpRequestMethods */].POST, data);
}

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapCp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cmpDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return listToChartData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return listToTableData; });
/* unused harmony export strToMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return concatList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clSortDatas; });
/* unused harmony export printDom */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return outPutExcelFile; });
/* unused harmony export clSort */
/* unused harmony export checkFile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return checkData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return checkRkData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return checkAllData; });
/* unused harmony export testList1ContainList2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return readExcelFileData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return dateOperating; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xlsx__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(33);





window.XLSX = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a;

var mapCp = function mapCp(mapY) {
  var newMap = {};
  for (var key in mapY) {
    newMap[key] = mapY[key];
  }
  return newMap;
};

var cmpDate = function cmpDate(dateStr) {
  return new Date(dateStr.length === 10 ? dateStr : dateStr.substr(0, 10) + 'T' + dateStr.substr(11, 8));
};

var listToChartData = function listToChartData(dataList, xKey, legendKey, chartDataKey) {
  var xDatas = [];
  var legends = [];
  var chartDatas = [];
  var dealData = {};
  dataList.forEach(function (item) {
    if (!dealData[item[xKey]]) {
      xDatas.push(item[xKey]);
      dealData[item[xKey]] = {};
    }
    if (legends.indexOf(item[legendKey]) === -1) {
      legends.push(item[legendKey]);
    }
    dealData[item[xKey]][item[legendKey]] = item[chartDataKey];
  });
  legends.forEach(function (item) {
    var newData = [];
    xDatas.forEach(function (xItem) {
      newData.push(dealData[xItem][item]);
    });
    chartDatas.push(newData);
  });
  return { xDatas: xDatas, legends: legends, chartDatas: chartDatas, dealData: dealData };
};

var listToTableData = function listToTableData(dataList, mergeKeyList) {
  if (mergeKeyList.length === 0) {
    return dataList;
  }
  var mergeKey = mergeKeyList[0];
  var reList = [];
  var dataMap = {};
  dataList.forEach(function (itemData) {
    if (!dataMap[itemData[mergeKey]]) {
      dataMap[itemData[mergeKey]] = [];
    }
    dataMap[itemData[mergeKey]].push(itemData);
  });
  for (var mergeData in dataMap) {
    dataMap[mergeData] = listToTableData(dataMap[mergeData], mergeKeyList.slice(1));
  }

  var _loop = function _loop(_mergeData) {
    dataMap[_mergeData].forEach(function (item, index) {
      var newDataMap = mapCp(item);
      newDataMap[mergeKey] = {
        'label': item[mergeKey],
        'rowspan': index === 0 ? dataMap[_mergeData].length : 0
      };
      reList.push(newDataMap);
    });
  };

  for (var _mergeData in dataMap) {
    _loop(_mergeData);
  }
  return reList;
};

var strToMap = function strToMap(str) {
  var mapData = {};
  var listData = str.split(',');
  listData.forEach(function (item) {
    var listData1 = item.split('=');
    mapData[listData1[0]] = listData1[1];
  });
  return mapData;
};

var concatList = function concatList(list1, list2) {
  var newData = [];
  list1.forEach(function (item) {
    newData.push(item);
  });
  list2.forEach(function (item) {
    newData.push(item);
  });
  return newData;
};

var clSortDatas = function clSortDatas(datas, funSort) {
  if (datas.length < 2) {
    return datas;
  }
  for (var indexA in datas) {
    for (var indexB in datas) {
      var nIndexB = Number(indexB);
      if (nIndexB < datas.length - 1 - indexA && funSort(datas[nIndexB], datas[nIndexB + 1])) {
        var _ref = [datas[nIndexB + 1], datas[nIndexB]];
        datas[nIndexB] = _ref[0];
        datas[nIndexB + 1] = _ref[1];
      }
    }
  }
  return datas;
};

var printDom = function printDom(domId) {
  var pDom = document.getElementById(domId);
  var win = window.open('');
  win.document.write(pDom.outerHTML);
  win.print();
};

var outPutExcelFile = function outPutExcelFile(datas, fileName) {
  var workbook = new window.Excel.Workbook();
  datas.forEach(function (item) {
    var worksheet1 = new window.Excel.Worksheet();
    worksheet1.addAllData(item.data);
    worksheet1.setName(item.sheetName);
    workbook.add(worksheet1);
  });
  workbook.setName(fileName);
  workbook.download();
};

var clSort = function clSort(data, key) {
  var dataType = [];
  var newData = [];
  data.forEach(function (item) {
    if (dataType.indexOf(item[key]) === -1) {
      dataType.push(item[key]);
    }
  });
  dataType.forEach(function (item) {
    data.forEach(function (item2) {
      if (item2[key] === item) {
        newData.push([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(item2)));
      }
    });
  });
  return newData;
};

var checkFile = function checkFile(file, type) {};

var checkData = function checkData(data) {
  return Number(data['期初库存']) + Number(data['入库升数']) - Number(data['出库升数']) - Number(data['期末库存']) - Number(data['损溢']);
};

var checkRkData = function checkRkData(data, datas) {
  var jhsh = 0;
  datas.forEach(function (item) {
    if (item['油品名称'] === data['油品名称']) {
      jhsh = jhsh + item['配送计划'] - item['入库升数'];
    }
  });
  return jhsh > -2000 && jhsh < 2000;
};

var checkAllData = function checkAllData(data, datas) {
  if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.oilArea === 'dl') {
    return checkData(data) === 0;
  } else {
    return checkData(data) === 0 && checkRkData(data, datas);
  }
};

var testList1ContainList2 = function testList1ContainList2(_ref2) {
  var list1 = _ref2.list1,
      list2 = _ref2.list2,
      list2Key = _ref2.list2Key;

  var contain = true;
  list2.forEach(function (item) {
    if (list1.indexOf(list2Key ? item[list2Key] : item) === -1) {
      contain = false;
    }
  });
  return contain;
};

var dealSheetDataToMap = function dealSheetDataToMap(sheetDatas, needDataKeys) {
  var newDataList = [];
  sheetDatas.forEach(function (itemMap) {
    var newData = {};
    needDataKeys.forEach(function (itemKey) {
      var value = itemKey.key ? itemMap[itemKey.key] : itemMap[itemKey];
      newData[itemKey] = itemKey.delData ? itemKey.formatData(value) : value;
    });
    newDataList.push(newData);
  });
  return newDataList;
};

var dealSheetDataToList = function dealSheetDataToList(sheetDatas) {
  var newDataList = [];
  sheetDatas.split('\n').forEach(function (itemStr) {
    newDataList.push(itemStr.split(','));
  });
  return newDataList;
};

var readExcelFileData = function readExcelFileData(_ref3) {
  var file = _ref3.file,
      sheets = _ref3.sheets,
      type = _ref3.type,
      allsheets = _ref3.allsheets;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
      try {
        var dataMap = {};
        var data = e.target.result;
        var wb = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.read(data, {
          type: 'binary'
        });
        // 获取所有sheet数据
        if (allsheets) {
          wb.SheetNames.forEach(function (sheetItem) {
            var delFun = type === 'row_object_array' ? __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.sheet_to_row_object_array : __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.sheet_to_csv;
            var sheetDatas = delFun(wb.Sheets[sheetItem]);
            window.cldata = sheetDatas;
            dataMap[sheetItem] = type === 'row_object_array' ? dealSheetDataToMap(sheetDatas, sheets[0].needDataKeys) : dealSheetDataToList(sheetDatas);
          });
          resolve(dataMap);
        } else if (testList1ContainList2({ list1: wb.SheetNames, list2: sheets, list2Key: 'name' })) {
          sheets.forEach(function (item) {
            var sheetDatas = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.sheet_to_row_object_array(wb.Sheets[item.name]);
            dataMap[item.key] = dealSheetDataToMap(sheetDatas, item.needDataKeys);
          });
          resolve(dataMap);
        } else {
          reject(new Error('导入数据格式不规范！'));
        }
      } catch (error) {
        reject(error);
      }
    };
    fileReader.readAsBinaryString(file);
  });
};

var dateOperating = {
  // 当前时间加减几天days, hours
  computeDay: function computeDay() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { format: 'number', days: 0 },
        _ref4$format = _ref4.format,
        format = _ref4$format === undefined ? 'number' : _ref4$format,
        _ref4$days = _ref4.days,
        days = _ref4$days === undefined ? 0 : _ref4$days,
        date = _ref4.date;

    var nowDate = date || new Date();
    if (days && days !== 0) {
      nowDate.setDate(nowDate.getDate() + days);
    }
    return this.formatDate({
      date: nowDate.getTime(),
      format: format
    });
  },
  formatDate: function formatDate() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { date: null, format: 'number', days: 0 },
        _ref5$date = _ref5.date,
        date = _ref5$date === undefined ? null : _ref5$date,
        _ref5$format = _ref5.format,
        format = _ref5$format === undefined ? 'number' : _ref5$format,
        _ref5$days = _ref5.days,
        days = _ref5$days === undefined ? 0 : _ref5$days;

    date = date ? new Date(date) : new Date();
    var month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : String(0) + (date.getMonth() + 1);
    var day = date.getDate() > 9 ? date.getDate() : String(0) + date.getDate();
    if (format === 'yy-mm-dd') {
      return date.getFullYear() + '-' + month + '-' + day;
    } else if (format === 'yy/mm/dd') {
      return date.getFullYear() + '/' + month + '/' + day;
    } else if (format === 'yy年mm月dd日') {
      return date.getFullYear() + '年' + month + '月' + day + '日';
    } else if (format === 'yy.mm.dd') {
      return date.getFullYear() + '.' + month + '.' + day;
    } else if (format === 'yy-mm-dd hh:mm') {
      return date.getFullYear() + '-' + month + '-' + day + ' ' + date.getHours() + ':' + date.getMinutes();
    } else {
      return date.getTime();
    }
  },
  getMonthDays: function getMonthDays(year, month) {
    if (!year || !month) {
      return 0;
    }
    year = Number(year);
    month = Number(month);
    var date1 = new Date(year + '-' + month + '-01 00:00:00');
    var date2Year = month === 12 ? year + 1 : year;
    var date2Month = month === 12 ? 1 : month + 1;
    var date2 = new Date(date2Year + '-' + date2Month + '-01 00:00:00');
    return (date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24;
  },
  minusDate: function minusDate() {
    var d1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var d2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

    return d1.getTime() - d2.getTime();
  },
  intervalDays: function intervalDays(dateStr) {
    var date = new Date(dateStr).getDate();
    var date2 = new Date().getDate();
    return date - date2;
  }
};

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjU0OUQ2NUM2MkUwMTFFNzlFMDQ5OENGMzFGQjc4QzIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjU0OUQ2NUQ2MkUwMTFFNzlFMDQ5OENGMzFGQjc4QzIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCNTQ5RDY1QTYyRTAxMUU3OUUwNDk4Q0YzMUZCNzhDMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCNTQ5RDY1QjYyRTAxMUU3OUUwNDk4Q0YzMUZCNzhDMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvASGVkAAAF4SURBVHjadNNLKERRHMfxGcaQ91smZSfZYqNsFHlsFEnkkR1lVuyshIWlhY0USl7JQslG7DxWNNhYKQsiz8hjPL5//aZOHv/63Llz7v9/zrnnnOuNyy72OBGLGrSiEH684QSzWMNTJNnrFFvyGPKxjj1cIQMlqMYFggi5xVa4gn3048zzOwIYRjkacGDFfo10jhYnOQbJeMCr0z6BIlRGcalXr0EnoRLzWMUC6pxnfeq0ycelQ1O+0sNaFSY5BVVoxzLusIROG7kA20qKQ8+PQot4dCNR/3eQE6V3u1SjTSfX83fkIU33NsuwFYeRqsZHXP9TbAPc6z7FBrXiUxQ7xVPq0I1PTOt9Pcq/jfYlBPxatFltSUgdpuMDRxjBpDqx9x/FnO2zTWEDmzogkUgVG+3GaR/U9lbYyC/cHGIIWdjVDJ5tavqNrPiAdqMLx+7ZLsO4khd0tq81eikatdq92Pr5YVhkog3N2ut3RGshFzGjj+M7vgQYAAhEVqeVjLmzAAAAAElFTkSuQmCC"

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjU0OUQ2NTg2MkUwMTFFNzlFMDQ5OENGMzFGQjc4QzIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjU0OUQ2NTk2MkUwMTFFNzlFMDQ5OENGMzFGQjc4QzIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFQUY2NURFMTYyREQxMUU3OUUwNDk4Q0YzMUZCNzhDMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFQUY2NURFMjYyREQxMUU3OUUwNDk4Q0YzMUZCNzhDMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrZlVyYAAAFzSURBVHjadNNJKEVRHMfx53mml+llIVJ2ssdeGQolZYhkThnKSrFTys7KwsKCR5mJUrJDCdkgS6WUlLxkiI1n+P7rd+sQpz517z3nd8//nHtuzEw47HNaAirQjHzE4x2XmMc23rzBASdogyeQix1sIoIMFGIU/RjAhRu24AbO0Ikb38+2gHGMaVwtzv0qbRKnaHKCcZo1Xve36MCuxgctXINsleO1MixhC8uocvoGkYoGK7tNpUTUWalgihMoRyvW8YRVtNvMeTjSoET0/QpaC6IXybo/RqZfa7vXQysny/d3y0FI11Zl1MJRpOvhKx7+CdsEz7pOs0ktfI0CJxzWC932hVmt16fxjxZe1Hfz1mMnqQv7uMIBejDtrL/ecn7t3AdGnJnm9AlLUI0pfKpvGEk2SUCl2Dde00vsFL1YWeLu+JB23WaOeMfzEHU6OcU6GCfaPNvMIvWHFNz7/WPYC0rRgkZ0q5JYbeSKlnPnBb4FGACCClcVbn899wAAAABJRU5ErkJggg=="

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_source_data__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_parm__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_db_map__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_db_pre_map__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_process__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_assign__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_loading__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_case__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_notice__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_user_info__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_ele__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_demo_map__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_oil_base__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_oil_check_data__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_oil_input_data__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_oil_prediction__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_oil_prediction_order__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_oil_oil_ps_detail__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_oil_oil_hxchx__ = __webpack_require__(365);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);























var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    assign: __WEBPACK_IMPORTED_MODULE_7__modules_assign__["a" /* default */],
    ele: __WEBPACK_IMPORTED_MODULE_12__modules_ele__["a" /* default */],
    sourceData: __WEBPACK_IMPORTED_MODULE_2__modules_source_data__["a" /* default */],
    parm: __WEBPACK_IMPORTED_MODULE_3__modules_parm__["a" /* default */],
    dbMap: __WEBPACK_IMPORTED_MODULE_4__modules_db_map__["a" /* default */],
    dbPreMap: __WEBPACK_IMPORTED_MODULE_5__modules_db_pre_map__["a" /* default */],
    solutionProcess: __WEBPACK_IMPORTED_MODULE_6__modules_process__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_8__modules_loading__["a" /* default */],
    dataCase: __WEBPACK_IMPORTED_MODULE_9__modules_case__["a" /* default */],
    notice: __WEBPACK_IMPORTED_MODULE_10__modules_notice__["a" /* default */],
    userInfo: __WEBPACK_IMPORTED_MODULE_11__modules_user_info__["a" /* default */],
    oilBase: __WEBPACK_IMPORTED_MODULE_14__modules_oil_base__["a" /* default */],
    oilChecked: __WEBPACK_IMPORTED_MODULE_15__modules_oil_check_data__["a" /* default */],
    oilInputData: __WEBPACK_IMPORTED_MODULE_16__modules_oil_input_data__["a" /* default */],
    oilPrediction: __WEBPACK_IMPORTED_MODULE_17__modules_oil_prediction__["a" /* default */],
    oilPredictionOrder: __WEBPACK_IMPORTED_MODULE_18__modules_oil_prediction_order__["a" /* default */],
    demoMap: __WEBPACK_IMPORTED_MODULE_13__modules_demo_map__["a" /* default */],
    oilPsDetail: __WEBPACK_IMPORTED_MODULE_19__modules_oil_oil_ps_detail__["a" /* default */],
    oilHxchx: __WEBPACK_IMPORTED_MODULE_20__modules_oil_oil_hxchx__["a" /* default */]
  },
  strict: debug
}));

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(809)
  __webpack_require__(810)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(977),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e61a0cb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(843)
  __webpack_require__(844)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(1001),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-864f10c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return delData; });
var localStorageOperating = {
  updateData: function updateData(key, value) {
    var reData = 0;
    try {
      if (window.localStorage.getItem(key) !== null) {
        this.deleteData(key);
      }
      window.localStorage.setItem(key, window.JSON.stringify(value));
      reData = 1;
    } catch (error) {
      console.log('数据存储失败' + error);
      var SaveError = function SaveError(message, code) {
        this.message = message;
        this.code = code;
      };
      reData = 0;
      // 数据存储失败还没进行回滚处理
      throw new SaveError('数据存储失败' + error, -100);
    }
    return reData;
  },
  deleteData: function deleteData(key) {
    window.localStorage.removeItem(key);
  },
  getData: function getData(key) {
    var data = window.localStorage.getItem(key);
    return typeof data === 'undefined' || data === null ? data : JSON.parse(data);
  }
};

var saveData = function saveData(_ref) {
  var key = _ref.key,
      data = _ref.data;

  localStorageOperating.updateData(key, data);
};

var getData = function getData(key) {
  return localStorageOperating.getData(key);
};

var delData = function delData(key) {
  return localStorageOperating.deleteData(key);
};

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return axiosSysApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return axiosSysApi2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return axiosDataApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var aixoSysConfig = {
  baseURL: '',
  timeout: 1800000,
  headers: {
    'Accept': 'application/json, text/plain, */*'
  }
};

var aixoDataConfig = {
  baseURL: 'https://api.data.e-forward.cn/network',
  // baseURL: 'http://0.0.0.0:8080/network',
  timeout: 180000,
  headers: {
    'content-type': 'application/json'
  }
};

var axiosSysApi = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create(aixoSysConfig);

var axiosSysApi2 = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create(aixoSysConfig);

var axiosDataApi = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create(aixoDataConfig);

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(817)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(982),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4dcb4262",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(785)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(959),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d91c5e1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(790)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(964),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-25412971",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initOption; });
/* unused harmony export extractXYZ */
/* unused harmony export extractXY */
var setPublicOption = function setPublicOption(option, _ref) {
  var title = _ref.title;

  option.title = {
    text: title,
    left: 'left',
    top: 20,
    textStyle: {
      color: '#ccc'
    }
  };
  option.toolbox = {
    feature: {
      dataView: { readOnly: false },
      restore: {},
      saveAsImage: {}
    }
  };
  option.grid = {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  };
};

var initOptionGauge = function initOptionGauge() {
  var option = {};
  option.tooltip = {
    formatter: '{a} <br/>{b} : {c}%'
  };
  option.series = [{
    name: '业务指标',
    type: 'gauge',
    detail: { formatter: '{value}%' },
    data: [{ value: 50, name: '完成率' }]
  }];
  return option;
};

var initOptionFunnel = function initOptionFunnel() {
  var option = {};
  option.tooltip = {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c}%'
  };
  option.legend = {
    data: []
  };
  option.calculable = true;
  option.series = [{
    name: '漏斗图',
    type: 'funnel',
    left: '10%',
    top: 60,
    bottom: 60,
    width: '80%',
    min: 0,
    max: 700,
    minSize: '0%',
    maxSize: '100%',
    sort: 'descending',
    gap: 2,
    label: {
      normal: {
        show: true,
        position: 'inside'
      },
      emphasis: {
        textStyle: {
          fontSize: 20
        }
      }
    },
    labelLine: {
      normal: {
        length: 10,
        lineStyle: {
          width: 1,
          type: 'solid'
        }
      }
    },
    itemStyle: {
      normal: {
        borderColor: '#fff',
        borderWidth: 1
      }
    },
    data: []
  }];

  return option;
};

var initOptionRadar = function initOptionRadar() {
  var option = {};
  option.tooltip = {};
  option.legend = [];
  option.radar = {
    indicator: []
  };
  option.series = [{
    name: 'asd',
    type: 'radar',
    data: []
  }];
  return option;
};

var initOptionHuan = function initOptionHuan() {
  var option = {};
  option.tooltip = {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c} ({d}%)'
  };
  option.grid = {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  };
  option.legend = {
    orient: 'vertical',
    x: 'left',
    data: []
  };
  option.series = [{
    name: '看看看',
    type: 'pie',
    radius: ['50%', '70%'],
    data: [],
    label: {
      normal: {
        show: false,
        position: 'center'
      },
      emphasis: {
        show: true,
        textStyle: {
          fontSize: '30',
          fontWeight: 'bold'
        }
      }
    },
    labelLine: {
      normal: {
        lineStyle: {
          show: false
        }
      }
    }
  }];
  return option;
};

var initOptionPie = function initOptionPie() {
  var option = {};
  option.backgroundColor = '#2c343c';
  option.tooltip = {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c} ({d}%)'
  };
  option.grid = {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  };
  option.xAxis = [{
    type: 'category',
    data: []
  }];
  option.yAxis = [{
    type: 'value'
  }];
  option.series = [{
    name: '看看看',
    type: 'pie',
    radius: '55%',
    center: ['50%', '50%'],
    data: [],
    roseType: 'radius',
    label: {
      normal: {
        textStyle: {
          color: 'rgba(255, 255, 255, 0.3)'
        }
      }
    },
    labelLine: {
      normal: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.3)'
        },
        smooth: 0.2,
        length: 10,
        length2: 20
      }
    },
    itemStyle: {
      normal: {
        color: '#c23531',
        shadowBlur: 200,
        shadowColor: 'rgba(0, 0, 0, 0.5)'
      }
    },
    animationType: 'scale',
    animationEasing: 'elasticOut',
    animationDelay: function animationDelay(idx) {
      return Math.random() * 200;
    }
  }];
  return option;
};

var initOptionZzt = function initOptionZzt() {
  var optionZzt = {};
  optionZzt.tooltip = {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  };
  optionZzt.legend = { data: [] };
  optionZzt.xAxis = [{
    type: 'category',
    data: []
  }];
  optionZzt.yAxis = [{
    type: 'value'
  }];
  optionZzt.series = [];
  return optionZzt;
};

var buildOptionGauag = function buildOptionGauag(data, pageOption) {
  var newOption = initOptionGauge();
  return newOption;
};

var buildOptionRadar = function buildOptionRadar(data) {
  var newOption = initOptionRadar();
  var seriesData = [];
  var indicatorData = [];
  data.dataZs.forEach(function (item) {
    var seriesDataOne = { value: data.dataYmap[item], name: item };
    seriesData.push(seriesDataOne);
  });
  data.dataXs.forEach(function (item) {
    indicatorData.push({ name: item, max: data.oterOption && data.oterOption.max ? data.oterOption.max : data.XmaxY[item] * 1.1 });
  });
  newOption.legend = { data: data.dataZs };
  newOption.radar.indicator = indicatorData;
  newOption.series[0].data = seriesData;
  return newOption;
};

var buildOptionFunel = function buildOptionFunel(data) {
  var newOption = initOptionFunnel();
  var seriesData = [];
  setPublicOption(newOption, { title: data.oterOption && data.oterOption.title ? data.oterOption.title : '' });
  data.dataXs.forEach(function (item) {
    seriesData.push({ name: item, value: data.dataYmap[item] });
  });
  newOption.legend.data = data.dataXs;
  newOption.series[0].data = seriesData;
  return newOption;
};

var buildOptionPie = function buildOptionPie(data) {
  var newOption = initOptionPie();
  var seriesData = [];
  setPublicOption(newOption, { title: data.oterOption && data.oterOption.title ? data.oterOption.title : '' });
  data.dataXs.forEach(function (item) {
    seriesData.push({ name: item, value: data.dataYmap[item] });
  });
  newOption.series[0].data = seriesData;
  return newOption;
};

var buildOptionHuan = function buildOptionHuan(data) {
  var newOption = initOptionHuan();
  var seriesData = [];
  setPublicOption(newOption, { title: data.oterOption && data.oterOption.title ? data.oterOption.title : '' });
  data.dataXs.forEach(function (item) {
    seriesData.push({ name: item, value: data.dataYmap[item] });
  });
  newOption.legend.data = data.dataXs;
  newOption.series[0].data = seriesData;
  return newOption;
};

var buildOptionXy = function buildOptionXy(data, type) {
  var newOption = initOptionZzt();
  var seriesData = [];
  setPublicOption(newOption, { title: data.oterOption && data.oterOption.title ? data.oterOption.title : '' });
  data.dataZs.forEach(function (item) {
    var seriesDataOne = { type: type, data: data.dataYmap[item], name: item };
    if (data.oterOption && data.oterOption.total) {
      seriesDataOne.stack = '总量';
    }
    seriesData.push(seriesDataOne);
  });
  newOption.legend = { data: data.dataZs };
  newOption.xAxis[0].data = data.dataXs;
  newOption.series = seriesData;
  return newOption;
};

var buildOptionLine = function buildOptionLine(data) {
  return buildOptionXy(data, 'line');
};

var buildOptionBar = function buildOptionBar(data) {
  return buildOptionXy(data, 'bar');
};

var typeFun = {
  'line': buildOptionLine,
  'bar': buildOptionBar,
  'pie': buildOptionPie,
  'huan': buildOptionHuan,
  'radar': buildOptionRadar,
  'funnel': buildOptionFunel
};

var initOption = function initOption(data, pageOption) {
  if (pageOption.chartType === 'gauge') {
    return buildOptionGauag(data, pageOption);
  } else {
    var maxY = ['radar'].indexOf(pageOption.chartType) > -1;
    var extractData = {};
    if (pageOption.dataZ) {
      extractData = extractXYZ({ data: data, dataX: pageOption.dataX, maxY: maxY, dataY: pageOption.dataY, dataZ: pageOption.dataZ, oterOption: pageOption.oterOption });
    } else {
      extractData = extractXY({ data: data, dataX: pageOption.dataX, maxY: maxY, dataY: pageOption.dataY, oterOption: pageOption.oterOption });
    }
    return typeFun[pageOption.chartType](extractData);
  }
};

var extractXYZ = function extractXYZ(_ref2) {
  var data = _ref2.data,
      dataX = _ref2.dataX,
      dataY = _ref2.dataY,
      dataZ = _ref2.dataZ,
      _ref2$maxY = _ref2.maxY,
      maxY = _ref2$maxY === undefined ? false : _ref2$maxY,
      oterOption = _ref2.oterOption;

  var extractData = { dataXs: [], dataZs: [], dataYmap: {}, XmaxY: {}, oterOption: oterOption };
  var dataMap = [];
  data.forEach(function (item) {
    var ZOne = item[dataZ];
    if (extractData.dataZs.indexOf(ZOne) === -1) {
      extractData.dataZs.push(ZOne);
    }
    var XOne = item[dataX];
    if (extractData.dataXs.indexOf(XOne) === -1) {
      extractData.dataXs.push(XOne);
    }
    dataMap[ZOne + '-' + XOne] = item[dataY];
    if (maxY) {
      extractData.XmaxY[XOne] = typeof extractData.XmaxY[XOne] === 'undefined' ? Number(item[dataY]) : extractData.XmaxY[XOne] > Number(item[dataY]) ? extractData.XmaxY[XOne] : Number(item[dataY]);
    }
  });
  extractData.dataZs.forEach(function (item) {
    extractData.dataYmap[item] = [];
    extractData.dataXs.forEach(function (itemx) {
      extractData.dataYmap[item].push(dataMap[item + '-' + itemx]);
    });
  });
  return extractData;
};

var extractXY = function extractXY(_ref3) {
  var data = _ref3.data,
      dataX = _ref3.dataX,
      dataY = _ref3.dataY,
      _ref3$maxY = _ref3.maxY,
      maxY = _ref3$maxY === undefined ? false : _ref3$maxY,
      oterOption = _ref3.oterOption;

  var extractData = { dataXs: [], dataYmap: {}, XmaxY: null, oterOption: oterOption };
  data.forEach(function (item) {
    var xOne = item[dataX];
    if (extractData.dataXs.indexOf(xOne) === -1) {
      extractData.dataXs.push(xOne);
    }
    extractData.dataYmap[xOne] = extractData.dataYmap[xOne] ? extractData.dataYmap[xOne] + Number(item[dataY]) : Number(item[dataY]);
    if (maxY) {
      extractData.XmaxY = extractData.XmaxY === null ? Number(item[dataY]) : extractData.XmaxY > extractData.dataYmap[xOne] ? extractData.XmaxY : Number(extractData.dataYmap[xOne]);
    }
  });
  return extractData;
};

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initOptionDemo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return initOption; });
/* unused harmony export addList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initGasOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return initPreOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setDataOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setChartDataOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDataGasOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setDataPreOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addCarData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addCarPreData; });
/* unused harmony export addSourceData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map_style__ = __webpack_require__(353);


var planePath = 'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z';
var colors = ['#FAD860', '#FFBFFF', '#FF44FF', '#930093', '#9BCA63', '#FE8463', '#E87C25', '#F3A43B', '#F4E001', '#FFF7FF'];

var initOptionDemo = function initOptionDemo(_ref) {
  var _ref$legendData = _ref.legendData,
      legendData = _ref$legendData === undefined ? ['客户', '通力物流园', '乡镇卫生院'] : _ref$legendData;

  var option = {};
  option.bmap = {
    center: [102.501392, 24.387242],
    zoom: 13,
    roam: true,
    mapStyle: {
      styleJson: __WEBPACK_IMPORTED_MODULE_0__map_style__["a" /* mapStyle */]
    }
  };
  option.title = {
    id: 'title_select',
    text: '',
    left: '15%',
    bottom: '38%',
    width: 100,
    textStyle: {
      color: '#fff',
      fontSize: 16
    }
  };
  option.backgroundColor = '#404a59';
  option.legend = [{
    id: 'legend_point',
    orient: 'vertical',
    bottom: 20,
    right: 10,
    data: legendData,
    textStyle: {
      color: '#fff'
    }
  }];
  option.toolbox = {
    top: 10,
    right: 10,
    iconStyle: {
      normal: {
        borderColor: '#fff'
      },
      emphasis: {
        borderColor: '#b1e4ff'
      }
    },
    feature: {
      mark: { show: true },
      magicType: { show: true, type: ['stack', 'tiled'] },
      restore: { show: true },
      saveAsImage: { show: true }
    }
  };
  option.tooltip = {
    trigger: 'item',
    formatter: function formatter(params) {
      return params.name || params.seriesName + '<br/>' + params.data.fromName + '->' + params.data.toName;
    }
  };
  option.xAxis = {
    type: 'value',
    scale: true,
    position: 'top',
    boundaryGap: false,
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      show: false,
      margin: 2,
      textStyle: {
        color: '#aaa'
      }
    }
  };
  option.yAxis = {
    show: false,
    data: [],
    type: 'category',
    nameTextStyle: {
      color: '#fff'
    }
  };
  option.grid = {
    left: '13%',
    bottom: 20,
    height: '30%',
    width: '20%'
    // 圈选
  };option.brush = {
    outOfBrush: {
      color: '#abc'
    },
    brushStyle: {
      borderWidth: 2,
      color: 'rgba(0,0,0,0.2)',
      borderColor: 'rgba(0,0,0,0.5)'
    },
    seriesIndex: 0,
    throttleType: 'debounce',
    throttleDelay: 300,
    geoIndex: 0
  };
  option.series = [{
    id: 'Location',
    name: legendData[0],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 10,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ffa022'
      }
    }
  }, {
    id: 'Plant',
    name: legendData[1],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 15,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ff3333'
      }
    }
  }, {
    id: 'centroids',
    name: legendData[2],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 10,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#23c6c8'
      }
    }
  }, {
    id: 'bar',
    zlevel: 2,
    type: 'bar',
    tooltip: {
      trigger: 'item',
      formatter: ' {b}<br/> 干货需求：<br/>{c}'
    },
    symbol: 'none',
    itemStyle: {
      normal: {
        color: '#5CADAD'
      }
    },
    data: []
  }];
  return option;
};

var initOption = function initOption(_ref2) {
  var _ref2$legendData = _ref2.legendData,
      legendData = _ref2$legendData === undefined ? ['客户', '工厂', '中心点'] : _ref2$legendData,
      _ref2$row = _ref2.row,
      row = _ref2$row === undefined ? ['干货', '新鲜货', '冰冻货'] : _ref2$row;

  var option = {};
  option.bmap = {
    center: [106.50, 29.56],
    zoom: 13,
    roam: true,
    mapStyle: {
      styleJson: __WEBPACK_IMPORTED_MODULE_0__map_style__["a" /* mapStyle */]
    }
  };
  option.title = {
    id: 'title_select',
    text: '',
    left: '15%',
    bottom: '38%',
    width: 100,
    textStyle: {
      color: '#fff',
      fontSize: 16
    }
  };
  option.backgroundColor = '#404a59';
  option.legend = [{
    id: 'legend_point',
    orient: 'vertical',
    bottom: 20,
    right: 10,
    data: legendData,
    textStyle: {
      color: '#fff'
    }
  }];
  option.toolbox = {
    top: 10,
    right: 10,
    iconStyle: {
      normal: {
        borderColor: '#fff'
      },
      emphasis: {
        borderColor: '#b1e4ff'
      }
    },
    feature: {
      mark: { show: true },
      magicType: { show: true, type: ['stack', 'tiled'] },
      restore: { show: true },
      saveAsImage: { show: true }
    }
  };
  option.xAxis = {
    type: 'value',
    scale: true,
    position: 'top',
    boundaryGap: false,
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      show: false,
      margin: 2,
      textStyle: {
        color: '#aaa'
      }
    }
  };
  option.yAxis = {
    show: false,
    data: [],
    type: 'category',
    nameTextStyle: {
      color: '#fff'
    }
  };
  option.grid = {
    left: '13%',
    bottom: 20,
    height: '30%',
    width: '20%'
    // 圈选
  };option.brush = {
    outOfBrush: {
      color: '#abc'
    },
    brushStyle: {
      borderWidth: 2,
      color: 'rgba(0,0,0,0.2)',
      borderColor: 'rgba(0,0,0,0.5)'
    },
    seriesIndex: 0,
    throttleType: 'debounce',
    throttleDelay: 300,
    geoIndex: 0
  };
  option.tooltip = {
    trigger: 'item',
    formatter: function formatter(params) {
      var result = '';
      switch (params.seriesIndex) {
        case 0:
          {
            result = params.name + ' 需求:<br/>' + row[0] + params.value[2].dry + '/' + params.value[3].dry + ' <br/>' + row[1] + params.value[2].fresh + '/' + params.value[3].fresh + ' <br/>' + row[2] + params.value[2].frozen + '/' + params.value[3].frozen;
            break;
          }
        case 1:
          {
            result = params.name;
            break;
          }
        case 2:
          {
            result = params.name + '<br/>中心点:' + params.value[2].center + '<br/>顾客数：' + params.value[2].customer_num + '<br/>订货总量：' + params.value[2].order_num + '<br/>总距离：' + params.value[2].distance;
            break;
          }
        default:
          {
            result = params.seriesName + '<br/>' + params.data.fromName + '->' + params.data.toName;
            break;
          }
      }
      return result;
    }
  };
  option.series = [{
    id: 'Location',
    name: legendData[0],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 10,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ffa022'
      }
    }
  }, {
    id: 'Plant',
    name: legendData[1],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 15,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ff3333'
      }
    }
  }, {
    id: 'centroids',
    name: legendData[2],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 10,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#23c6c8'
      }
    }
  }, {
    id: 'bar',
    zlevel: 2,
    type: 'bar',
    tooltip: {
      trigger: 'item',
      formatter: ' {b}<br/> 干货需求：<br/>{c}'
    },
    symbol: 'none',
    itemStyle: {
      normal: {
        color: '#5CADAD'
      }
    },
    data: []
  }];
  return option;
};

var addList = function addList(datas) {
  datas = JSON.parse(datas);
  var sum = 0;
  datas.forEach(function (item) {
    sum += item;
  });
  return sum;
};

var initGasOption = function initGasOption() {
  document.body.onmousemove = function () {
    if (window.tooltipDom) {
      window.tooltipDom.style = 'display: none;';
    }
  };
  var legendData = ['正常加油站', '小罐多销加油站'];
  var option = {};
  option.legend = [{
    id: 'legend_point',
    orient: 'vertical',
    top: 20,
    right: 10,
    data: legendData,
    textStyle: {
      color: '#fff'
    }
  }];
  option.bmap = {
    center: [102.73, 25.04],
    zoom: 12,
    roam: true,
    mapStyle: {
      styleJson: __WEBPACK_IMPORTED_MODULE_0__map_style__["a" /* mapStyle */]
    }
  };
  option.backgroundColor = '#404a59';
  option.tooltip = {
    trigger: 'item',
    position: function position(point, params, dom, rect, size) {
      window.tooltipDom = dom;
      setTimeout(function () {
        dom.style = 'position: absolute; display: block; border-style: solid; white-space: nowrap; z-index: 9999999; transition: left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1); background-color: rgba(50, 50, 50, 0.7); border-width: 0px; border-color: rgb(51, 51, 51); border-radius: 4px; color: rgb(255, 255, 255); font-style: normal; font-variant: normal; font-weight: normal; font-stretch: normal; font-size: 14px; font-family: sans-serif; line-height: 21px; padding: 5px; left: ' + (point[0] + 26) + 'px; top: ' + (point[1] + 4) + 'px;';
      }, 200);
      return { left: point[0], top: point[1] };
    },
    formatter: function formatter(data) {
      var reStr = '';
      reStr += data.name + '：' + data.value[3].total + 'L<br/>';
      data.value[3].datas.forEach(function (item) {
        reStr += item['油品名称'] + '： ' + item['平均销量'] + 'L<br/>';
      });
      return reStr;
    }
  };
  option.series = [{
    id: 'gas_nom',
    type: 'scatter',
    symbol: 'pin',
    name: legendData[0],
    coordinateSystem: 'bmap',
    symbolSize: 18,
    data: [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#89fed2'
      }
    }
  }, {
    id: 'gas_xgdx',
    type: 'scatter',
    symbol: 'pin',
    name: legendData[1],
    coordinateSystem: 'bmap',
    symbolSize: 25,
    data: [],
    label: {
      normal: {
        formatter: 'asdasdasd',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ff0000'
      }
    }
  }];
  return option;
};

var initPreOption = function initPreOption() {
  var legendData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['加油站', '油库'];

  document.body.onmousemove = function () {
    if (window.tooltipDom) {
      window.tooltipDom.style = 'display: none;';
    }
  };
  var option = {};
  option.bmap = {
    center: [102.73, 25.04],
    zoom: 11,
    roam: true,
    mapStyle: {
      styleJson: __WEBPACK_IMPORTED_MODULE_0__map_style__["a" /* mapStyle */]
    }
  };
  option.tooltip = {
    trigger: 'item',
    position: function position(point, params, dom, rect, size) {
      window.tooltipDom = dom;
      setTimeout(function () {
        dom.style = 'position: absolute; display: block; border-style: solid; white-space: nowrap; z-index: 9999999; transition: left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1); background-color: rgba(50, 50, 50, 0.7); border-width: 0px; border-color: rgb(51, 51, 51); border-radius: 4px; color: rgb(255, 255, 255); font-style: normal; font-variant: normal; font-weight: normal; font-stretch: normal; font-size: 14px; font-family: sans-serif; line-height: 21px; padding: 5px; left: ' + (point[0] + 26) + 'px; top: ' + (point[1] + 4) + 'px;';
      }, 200);
      return { left: point[0], top: point[1] };
    }
  };
  option.title = {
    id: 'title_select',
    text: '',
    left: '15%',
    bottom: '38%',
    width: 100,
    textStyle: {
      color: '#fff',
      fontSize: 16
    }
  };
  option.backgroundColor = '#404a59';
  option.legend = [{
    id: 'legend_point',
    orient: 'vertical',
    bottom: 20,
    right: 10,
    data: legendData,
    textStyle: {
      color: '#fff'
    }
  }];
  option.series = [{
    id: 'Location',
    name: legendData[0],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 10,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ffa022'
      }
    }
  }, {
    id: 'centroids',
    name: legendData[1],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 10,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#23c6c8'
      }
    }
  }];
  return option;
};

var setDataOption = function setDataOption(key, data) {
  window.myChat.setOption({
    series: {
      id: key,
      data: data
    }
  });
};

var setChartDataOption = function setChartDataOption(chart, key, data) {
  chart.setOption({
    series: {
      id: key,
      data: data
    }
  });
};

var setDataGasOption = function setDataGasOption(key, data) {
  window.myGasChat.setOption({
    series: {
      id: key,
      data: data
    }
  });
};

var setDataPreOption = function setDataPreOption(key, data) {
  window.myPreChat.setOption({
    series: {
      id: key,
      data: data
    }
  });
};

var initData = function initData(_ref3, index) {
  var name = _ref3.name,
      data = _ref3.data;

  var delData = {};
  delData.d1 = {
    id: name,
    name: name,
    type: 'lines',
    mapType: 'china',
    coordinateSystem: 'bmap',
    zlevel: 1,
    lineStyle: {
      normal: {
        color: colors[index % colors.length],
        width: 2,
        curveness: 0.2
      }
    },
    data: data
  };
  delData.d2 = {
    id: name + '_p',
    name: name,
    type: 'lines',
    mapType: 'china',
    coordinateSystem: 'bmap',
    zlevel: 2,
    effect: {
      show: true,
      period: 6,
      trailLength: 0,
      symbol: planePath,
      symbolSize: 12
    },
    lineStyle: {
      normal: {
        color: colors[index % colors.length],
        width: 2,
        opacity: 0.4,
        curveness: 0.2
      }
    },
    data: data
  };
  return delData;
};

var initPreData = function initPreData(_ref4, index) {
  var name = _ref4.name,
      data = _ref4.data;

  var delData = {};
  delData.d1 = {
    id: name + index,
    name: name,
    type: 'lines',
    mapType: 'china',
    coordinateSystem: 'bmap',
    zlevel: 1,
    lineStyle: {
      normal: {
        color: colors[index % colors.length],
        width: 2,
        curveness: 0.2
      }
    },
    data: data
  };
  delData.d2 = {
    id: name + index + '_p',
    name: name,
    type: 'lines',
    mapType: 'china',
    coordinateSystem: 'bmap',
    zlevel: 2,
    effect: {
      show: true,
      period: 6,
      trailLength: 0,
      symbol: 'arrow',
      symbolSize: 12
    },
    lineStyle: {
      normal: {
        color: colors[index % colors.length],
        width: 2,
        opacity: 0.4,
        curveness: 0.2
      }
    },
    data: data
  };
  return delData;
};

var addCarData = function addCarData(chat, carData) {
  var legendData = [];
  var seriesData = [];
  carData.forEach(function (item, index) {
    legendData.push(item.name);
    var sData = initData(item, index);
    seriesData.push(sData.d1);
    seriesData.push(sData.d2);
  });
  chat.setOption({ series: seriesData });
  if (legendData.length > 0) {
    var option = chat.getOption();
    legendData.sort(function (a, b) {
      return Number(a.slice(2)) - Number(b.slice(2));
    });
    var legend = {
      orient: 'vertical',
      bottom: 20,
      right: 130,
      data: legendData,
      textStyle: {
        color: '#fff'
      }
    };
    option.legend.push(legend);
    chat.setOption(option);
  }
};

var addCarPreData = function addCarPreData(chat, carData) {
  var seriesData = [];
  carData.forEach(function (item, index) {
    var sData = initPreData(item, index);
    seriesData.push(sData.d1);
    seriesData.push(sData.d2);
  });
  chat.setOption({ series: seriesData });
};

var addSourceData = function addSourceData(chat, carData) {
  if (carData.length === 0) {
    return;
  }
  var legendData = [];
  var seriesData = [];
  carData.forEach(function (item, index) {
    legendData.push(item.name);
    var sData = initData(item, index);
    seriesData.push(sData.d1);
    seriesData.push(sData.d2);
  });
  legendData.sort(function (a, b) {
    return Number(a.slice(2)) - Number(b.slice(2));
  });
  var legend = {
    orient: 'vertical',
    bottom: 20,
    right: 100,
    data: legendData,
    textStyle: {
      color: '#fff'
    }
  };
  var option = chat.getOption();
  option.legend.push(legend);
  chat.setOption({ series: seriesData });
  chat.setOption(option);
};

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-s.28037ac.png";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(811)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(978),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-480bb290",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(802)
  __webpack_require__(801)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(972),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3520a874",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(829)
  __webpack_require__(830)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(991),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65f0591c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PSZX_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PASS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AXLE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GASG_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OIL_TYPES; });
var PSZX_LIST = [{
  key: 'km',
  label: '昆配'
}, {
  key: 'dl',
  label: '大配'
}, {
  key: 'zt',
  label: '昭配'
}, {
  key: 'cx',
  label: '楚配'
}, {
  key: 'hh',
  label: '红配'
}, {
  key: 'qj',
  label: '曲配'
}, {
  key: 'yx',
  label: '玉配'
}];

var PASS_LIST = [{
  label: '一环通行证',
  key: '90'
}, {
  label: '二环通行证',
  key: '50'
}, {
  label: '三环通行证',
  key: '10'
}, {
  label: '无',
  key: '0'
}];

var AXLE_LIST = [{
  label: '2',
  key: '2'
}, {
  label: '3',
  key: '3'
}, {
  label: '4',
  key: '4'
}, {
  label: '5',
  key: '5'
}, {
  label: '6',
  key: '6'
}, {
  label: '无',
  key: '0'
}];

var GASG_STATUS = [{
  label: '开启',
  key: '开启'
}, {
  label: '维护',
  key: '维护'
}, {
  label: '关闭',
  key: '关闭'
}];

var OIL_TYPES = ['90号汽油(Ⅲ)', '92号车用汽油(Ⅴ)', '93号汽油(Ⅲ)', '93号车用汽油(Ⅳ)', '95号车用汽油(Ⅴ)', '97号汽油(Ⅲ)', '97号车用汽油(Ⅳ)', '98号车用汽油(Ⅴ)', '0号普通柴油', '0号柴油', '0号车用柴油(Ⅲ)', '0号车用柴油(Ⅴ)', '0号车用柴油(Ⅳ)', '1号煤油(旧)', '国二号标准汽油90#', '国二号标准汽油93#', '国二号标准汽油97#'];

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_index__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__view_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_login__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__view_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_register__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__view_register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_home_base__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_home_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__view_home_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_demo__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__view_demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_oil_single_home__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_oil_single_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__view_oil_single_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_oil_oil_chart__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_oil_oil_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__view_oil_oil_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_oil_gas_map__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_oil_gas_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__view_oil_gas_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__view_oil_single__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__view_oil_single___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__view_oil_single__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_oil_car__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_oil_car___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__view_oil_car__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__view_oil_driver__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__view_oil_driver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__view_oil_driver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__view_oil_gas__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__view_oil_gas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__view_oil_gas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__view_oil_oil_depot__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__view_oil_oil_depot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__view_oil_oil_depot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__view_oil_source_data_pre__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__view_oil_source_data_pre___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__view_oil_source_data_pre__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__view_oil_prediction_check__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__view_oil_prediction_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__view_oil_prediction_check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__view_oil_prediction__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__view_oil_prediction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__view_oil_prediction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__view_oil_prediction_car__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__view_oil_prediction_car___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__view_oil_prediction_car__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__view_oil_prediction_station__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__view_oil_prediction_station___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__view_oil_prediction_station__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__view_oil_adjust_order__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__view_oil_adjust_order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__view_oil_adjust_order__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__view_oil_adjust_home__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__view_oil_adjust_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__view_oil_adjust_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__view_oil_input_data__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__view_oil_input_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__view_oil_input_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__view_oil_input_data_date__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__view_oil_input_data_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__view_oil_input_data_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__view_oil_ruku_check__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__view_oil_ruku_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__view_oil_ruku_check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__view_down__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__view_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__view_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__view_cycle__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__view_cycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__view_cycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__view_import__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__view_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__view_import__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__view_setting__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__view_setting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__view_setting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__view_cars__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__view_cars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__view_cars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__view_car_route__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__view_car_route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__view_car_route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__view_output__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__view_output___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__view_output__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__view_source_data__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__view_source_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__view_source_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__view_error__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__view_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__view_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__view_ele_index__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__view_ele_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__view_ele_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__view_ele_ele_import__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__view_ele_ele_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__view_ele_ele_import__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__view_ele_ele_case__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__view_ele_ele_case___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__view_ele_ele_case__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__view_ele_ele_result__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__view_ele_ele_result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__view_ele_ele_result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__view_ele_ele_source_data__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__view_ele_ele_source_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__view_ele_ele_source_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__view_ele_ele_compare__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__view_ele_ele_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__view_ele_ele_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__view_tobacco__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__view_tobacco___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__view_tobacco__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__view_tobacco_import_to__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__view_tobacco_import_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__view_tobacco_import_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__view_tobacco_source_data_to__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__view_tobacco_source_data_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__view_tobacco_source_data_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__view_tobacco_prediction_to__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__view_tobacco_prediction_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__view_tobacco_prediction_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__view_tobacco_setting_to__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__view_tobacco_setting_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__view_tobacco_setting_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__view_tobacco_cars_to__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__view_tobacco_cars_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__view_tobacco_cars_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__view_tobacco_car_route_to__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__view_tobacco_car_route_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__view_tobacco_car_route_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__view_tobacco_output_to__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__view_tobacco_output_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__view_tobacco_output_to__);

























































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index___default.a,
    children: [{
      path: 'down',
      name: 'down',
      component: __WEBPACK_IMPORTED_MODULE_25__view_down___default.a
    }]
  }, {
    path: '/demo',
    name: 'demo',
    component: __WEBPACK_IMPORTED_MODULE_6__view_demo___default.a
  }, {
    path: '/adjust_home',
    name: 'adjust_home',
    component: __WEBPACK_IMPORTED_MODULE_21__view_oil_adjust_home___default.a
  }, {
    path: '/input_data',
    name: 'input_data',
    component: __WEBPACK_IMPORTED_MODULE_22__view_oil_input_data___default.a
  }, {
    path: '/input_data_date',
    name: 'input_data_date',
    component: __WEBPACK_IMPORTED_MODULE_23__view_oil_input_data_date___default.a
  }, {
    path: '/single_home',
    name: 'single_home',
    redirect: {
      name: 'single.single'
    },
    component: __WEBPACK_IMPORTED_MODULE_7__view_oil_single_home___default.a,
    children: [{
      path: 'oil_chart',
      name: 'oil_chart',
      component: __WEBPACK_IMPORTED_MODULE_8__view_oil_oil_chart___default.a
    }, {
      path: 'gas_map',
      name: 'gas_map',
      component: __WEBPACK_IMPORTED_MODULE_9__view_oil_gas_map___default.a
    }, {
      path: 'single',
      name: 'single.single',
      component: __WEBPACK_IMPORTED_MODULE_10__view_oil_single___default.a,
      children: [{
        path: 'prediction',
        name: 'single.prediction',
        component: __WEBPACK_IMPORTED_MODULE_17__view_oil_prediction___default.a
      }, {
        path: 'prediction_check',
        name: 'single.prediction_check',
        component: __WEBPACK_IMPORTED_MODULE_16__view_oil_prediction_check___default.a
      }, {
        path: 'prediction_car',
        name: 'single.prediction_car',
        component: __WEBPACK_IMPORTED_MODULE_18__view_oil_prediction_car___default.a
      }, {
        path: 'source_data_pre',
        name: 'single.source_data_pre',
        component: __WEBPACK_IMPORTED_MODULE_15__view_oil_source_data_pre___default.a
      }, {
        path: 'prediction_station',
        name: 'single.prediction_station',
        component: __WEBPACK_IMPORTED_MODULE_19__view_oil_prediction_station___default.a
      }, {
        path: 'adjust_order',
        name: 'single.adjust_order',
        component: __WEBPACK_IMPORTED_MODULE_20__view_oil_adjust_order___default.a
      }, {
        path: 'input_data',
        name: 'single.input_data',
        component: __WEBPACK_IMPORTED_MODULE_22__view_oil_input_data___default.a
      }, {
        path: 'input_data_date',
        name: 'single.input_data_date',
        component: __WEBPACK_IMPORTED_MODULE_23__view_oil_input_data_date___default.a
      }, {
        path: 'ruku_check',
        name: 'single.ruku_check',
        component: __WEBPACK_IMPORTED_MODULE_24__view_oil_ruku_check___default.a
      }, {
        path: 'car',
        name: 'single.car',
        component: __WEBPACK_IMPORTED_MODULE_11__view_oil_car___default.a
      }, {
        path: 'driver',
        name: 'single.driver',
        component: __WEBPACK_IMPORTED_MODULE_12__view_oil_driver___default.a
      }, {
        path: 'gas',
        name: 'single.gas',
        component: __WEBPACK_IMPORTED_MODULE_13__view_oil_gas___default.a
      }, {
        path: 'oil_depot',
        name: 'single.oil_depot',
        component: __WEBPACK_IMPORTED_MODULE_14__view_oil_oil_depot___default.a
      }]
    }]
  }, {
    path: '/electricity',
    name: 'ele',
    component: __WEBPACK_IMPORTED_MODULE_34__view_ele_index___default.a,
    children: [{
      path: 'ele_import',
      name: 'ele_import',
      component: __WEBPACK_IMPORTED_MODULE_35__view_ele_ele_import___default.a
    }, {
      path: 'ele_case',
      name: 'ele_case',
      component: __WEBPACK_IMPORTED_MODULE_36__view_ele_ele_case___default.a
    }, {
      path: 'ele_result',
      name: 'ele_result',
      component: __WEBPACK_IMPORTED_MODULE_37__view_ele_ele_result___default.a
    }, {
      path: 'ele_source_data',
      name: 'ele_source_data',
      component: __WEBPACK_IMPORTED_MODULE_38__view_ele_ele_source_data___default.a
    }, {
      path: 'ele_compare',
      name: 'ele_compare',
      component: __WEBPACK_IMPORTED_MODULE_39__view_ele_ele_compare___default.a
    }]
  }, {
    path: '/tobacco',
    name: 'tobacco',
    component: __WEBPACK_IMPORTED_MODULE_40__view_tobacco___default.a,
    children: [{
      path: 'import_to',
      name: 'import_to',
      component: __WEBPACK_IMPORTED_MODULE_41__view_tobacco_import_to___default.a
    }, {
      path: 'source_data_to',
      name: 'source_data_to',
      component: __WEBPACK_IMPORTED_MODULE_42__view_tobacco_source_data_to___default.a
    }, {
      path: 'prediction_to',
      name: 'prediction_to',
      component: __WEBPACK_IMPORTED_MODULE_43__view_tobacco_prediction_to___default.a
    }, {
      path: 'setting_to',
      name: 'setting_to',
      component: __WEBPACK_IMPORTED_MODULE_44__view_tobacco_setting_to___default.a
    }, {
      path: 'cars_to',
      name: 'cars_to',
      component: __WEBPACK_IMPORTED_MODULE_45__view_tobacco_cars_to___default.a
    }, {
      path: 'car_route_to',
      name: 'car_route_to',
      component: __WEBPACK_IMPORTED_MODULE_46__view_tobacco_car_route_to___default.a
    }, {
      path: 'output_to',
      name: 'output_to',
      component: __WEBPACK_IMPORTED_MODULE_47__view_tobacco_output_to___default.a
    }]
  }, {
    path: '/home',
    name: 'home_base',
    component: __WEBPACK_IMPORTED_MODULE_5__view_home_base___default.a,
    children: [{
      path: 'cycle',
      name: 'cycle',
      component: __WEBPACK_IMPORTED_MODULE_26__view_cycle___default.a,
      children: [{
        path: 'import',
        name: 'import',
        component: __WEBPACK_IMPORTED_MODULE_27__view_import___default.a
      }, {
        path: 'source_data',
        name: 'source_data',
        component: __WEBPACK_IMPORTED_MODULE_32__view_source_data___default.a
      }, {
        path: 'setting',
        name: 'setting',
        component: __WEBPACK_IMPORTED_MODULE_28__view_setting___default.a
      }, {
        path: 'cars',
        name: 'cars',
        component: __WEBPACK_IMPORTED_MODULE_29__view_cars___default.a
      }, {
        path: 'car_route',
        name: 'car_route',
        component: __WEBPACK_IMPORTED_MODULE_30__view_car_route___default.a
      }]
    }, {
      path: 'single',
      name: 'single',
      component: __WEBPACK_IMPORTED_MODULE_10__view_oil_single___default.a,
      children: [{
        path: 'prediction',
        name: 'prediction',
        component: __WEBPACK_IMPORTED_MODULE_17__view_oil_prediction___default.a
      }, {
        path: 'prediction_check',
        name: 'prediction_check',
        component: __WEBPACK_IMPORTED_MODULE_16__view_oil_prediction_check___default.a
      }, {
        path: 'prediction_car',
        name: 'prediction_car',
        component: __WEBPACK_IMPORTED_MODULE_18__view_oil_prediction_car___default.a
      }, {
        path: 'source_data_pre',
        name: 'source_data_pre',
        component: __WEBPACK_IMPORTED_MODULE_15__view_oil_source_data_pre___default.a
      }, {
        path: 'prediction_station',
        name: 'prediction_station',
        component: __WEBPACK_IMPORTED_MODULE_19__view_oil_prediction_station___default.a
      }]
    }, {
      path: 'output',
      name: 'output',
      component: __WEBPACK_IMPORTED_MODULE_31__view_output___default.a
    }, {
      path: 'error',
      name: 'error',
      component: __WEBPACK_IMPORTED_MODULE_33__view_error___default.a
    }]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_3__view_login___default.a
  }, {
    path: '/register',
    name: 'register',
    component: __WEBPACK_IMPORTED_MODULE_4__view_register___default.a
  }]
}));

/***/ }),
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initChatContinuousOption; });
/* unused harmony export initChatPreOptionBak */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initChatPreOption; });
var initChatContinuousOption = function initChatContinuousOption(data) {
  var ping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var area = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var option = {};
  option = {
    visualMap: [{
      show: false,
      type: 'continuous',
      seriesIndex: 0,
      min: 0,
      max: data.max | 2
    }],
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    legend: {
      data: data.legend
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: [{
      data: data.xData
    }],
    yAxis: [{
      splitLine: { show: false }
    }],
    series: []
  };
  data.yData.forEach(function (item, index) {
    option.series.push({
      type: 'line',
      name: data.legend[index],
      step: ping ? 'start' : '',
      areaStyle: area ? { normal: {} } : {},
      showSymbol: false,
      data: item
    });
  });
  return option;
};

var initChatPreOptionBak = function initChatPreOptionBak(data) {
  var option = {};
  option = {
    title: {
      text: '成本',
      left: 'center',
      top: 20,
      textStyle: {
        color: '#ccc'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    visualMap: {
      show: false,
      min: 0,
      max: 2000,
      inRange: {
        colorLightness: [0, 1]
      }
    },
    series: [{
      name: '成本',
      type: 'pie',
      radius: '55%',
      center: ['50%', '50%'],
      data: data.sort(function (a, b) {
        return a.value - b.value;
      }),
      roseType: 'radius',
      label: {
        normal: {
          textStyle: {
            color: 'rgba(0, 0, 0, 0.3)'
          }
        }
      },
      labelLine: {
        normal: {
          lineStyle: {
            color: 'rgba(0,0, 0, 0.3)'
          },
          smooth: 0.2,
          length: 10,
          length2: 20
        }
      },
      itemStyle: {
        normal: {
          color: '#c23531',
          shadowBlur: 200,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      },
      animationType: 'scale',
      animationEasing: 'elasticOut',
      animationDelay: function animationDelay(idx) {
        return Math.random() * 1000;
      }
    }]
  };
  return option;
};

var initChatPreOption = function initChatPreOption(data) {
  var option = {};
  option = {
    title: {
      text: '成本',
      left: 'center',
      top: 20,
      textStyle: {
        color: '#666'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c} ({d}%)'
    },
    series: [{
      type: 'pie',
      radius: '55%',
      center: ['50%', '60%'],
      data: data,
      itemStyle: {
        emphasis: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }]
  };
  return option;
};

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-login.abf99b5.png";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(824)
  __webpack_require__(825)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(988),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5bcb0f58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(778)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(953),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0e324534",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(814)
  __webpack_require__(815)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(980),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b3c6d59",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(789)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(963),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2238b415",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(827)
  __webpack_require__(826)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(989),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f41a14f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 305 */,
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(856)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(1011),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveEleCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearEleCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEleCase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_local_storage__ = __webpack_require__(52);


var caseLocalKay = 'ele_case';

var saveEleCase = function saveEleCase(caseData) {
  var allData = getEleCase() || [];
  allData.push(caseData);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_local_storage__["b" /* saveData */])({ key: caseLocalKay, data: allData });
};

var clearEleCase = function clearEleCase(caseName) {
  var allData = getEleCase() || [];
  var newData = [];
  allData.forEach(function (item) {
    if (item.name !== caseName) {
      newData.push(item);
    }
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_local_storage__["b" /* saveData */])({ key: caseLocalKay, data: newData });
};

var getEleCase = function getEleCase(nameList) {
  var data = [];
  var allData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_local_storage__["a" /* getData */])(caseLocalKay);
  if (nameList) {
    allData.forEach(function (item) {
      if (nameList.indexOf(item.name) > -1) {
        data.push(item);
      }
    });
  } else {
    data = allData;
  }
  return data;
};

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return httpRequestMethods; });
/* unused harmony export axiosInstance */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseAPIRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(33);






var axiosCommonConfig = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze___default()({
  timeout: 30000000,
  // baseURL: 'http://bjx.reemii.cn/bjcx',
  baseURL: 'http://localhost:8000/',
  // baseURL: '',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/json;charset=UTF-8'
  }
});

var httpRequestMethods = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze___default()({
  GET: 'get',
  POST: 'post',
  DELETE: 'delete',
  PUT: 'put',
  PATCH: 'patch'
});

var axiosInstance = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create(axiosCommonConfig);

// http request 拦截器
axiosInstance.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  console.error('Error: Http request failed!, %o', error.message || error);
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

// http response 拦截器
axiosInstance.interceptors.response.use(function (response) {
  var code = response.data.code;
  if ([0, -1].indexOf(code) > -1) {
    if (code === -1) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(new Error(response.data.msg));
    }
  }
  return response.data;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

var baseAPIRequest = function baseAPIRequest(endPoint, method, params) {
  var config = {
    method: method,
    url: endPoint + (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.oilArea ? '?area=' + __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.oilArea : ''),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  };
  if (['post', 'put', 'patch'].includes(method)) {
    config.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params);
  } else {
    config.params = params;
  }
  return axiosInstance.request(config).then(function (data) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
  }, function (error) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
  }).catch(function (e) {
    console.log(e);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(e);
  });
};

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initOptionBar1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initOptionBar2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return initOptionBar3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return initOptionBar4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initOptionTreemap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

var echarts = __webpack_require__(51);

var initOptionBar1 = function initOptionBar1(xData, legendData, barData) {
  var option = {};
  option.color = ['#0c28b8', '#2e5cc6', '#beb390', '#b87e4f'];
  option.grid = {
    right: '25%',
    top: '10%',
    bottom: '13%',
    left: 130
  };
  option.tooltip = {
    show: true
  };
  option.legend = {
    data: legendData,
    orient: 'vertical',
    right: '10%',
    top: '10%',
    textStyle: {
      color: '#fff'
    }
  };
  option.xAxis = [{
    type: 'category',
    data: xData,
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    axisLabel: {
      height: '10px'
    },
    axisTick: {
      show: false
    }
  }];
  option.yAxis = [{
    type: 'value',
    textStyle: {
      color: '#fff'
    },
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    splitLine: {
      show: false
    },
    axisTick: {
      inside: true
    }
  }];
  option.series = [];
  barData.forEach(function (item, index) {
    var oneData = {
      name: legendData[index],
      type: 'bar',
      data: item,
      barWidth: '10px',
      barGap: 0.6,
      itemStyle: {
        barBorderRadius: [5, 5, 0, 0]
      }
    };
    option.series.push(oneData);
  });
  return option;
};

var initOptionBar2 = function initOptionBar2(xData, legendData, barData, barData2) {
  var option = {};
  option.color = ['#ff0000', '#ff6e00', '#168fff'];
  option.grid = {
    right: '25%',
    top: '10%',
    bottom: '22%',
    left: 130
  };
  option.tooltip = {
    show: true
  };
  option.legend = {
    data: legendData,
    orient: 'vertical',
    right: '10%',
    top: '10%',
    textStyle: {
      color: '#fff'
    }
  };
  option.xAxis = [{
    type: 'category',
    data: xData,
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    axisLabel: {
      rotate: -25,
      fontSize: 10
    },
    axisTick: {
      show: false
    }
  }];
  option.yAxis = [{
    type: 'value',
    textStyle: {
      color: '#fff'
    },
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    splitLine: {
      show: false
    },
    axisTick: {
      inside: true
    }
  }];
  option.series = [];
  barData.forEach(function (item, index) {
    var oneData = {
      name: legendData[index + 1],
      type: 'bar',
      stack: '总量',
      data: item,
      barWidth: '13px',
      barGap: 0.3
    };
    option.series.push(oneData);
  });
  barData2.forEach(function (item, index) {
    var oneData = {
      name: legendData[index],
      type: 'bar',
      data: item,
      barWidth: '13px',
      barGap: 0.3
    };
    option.series.push(oneData);
  });
  return option;
};

var initOptionBar3 = function initOptionBar3(xData, barData) {
  var option = {};
  option.color = ['#168fff'];
  option.grid = {
    right: 35,
    top: '10%',
    bottom: '22%',
    left: '18%'
  };
  option.tooltip = {
    show: true
  };
  option.xAxis = [{
    type: 'category',
    data: xData,
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    axisLabel: {
      rotate: -25,
      fontSize: 10
    },
    axisTick: {
      show: false
    }
  }];
  option.yAxis = [{
    type: 'value',
    textStyle: {
      color: '#fff'
    },
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: 'rgba(255,255,255,0.1)'
      }
    },
    axisTick: {
      inside: false
    }
  }];
  option.series = [];
  barData.forEach(function (item, index) {
    var oneData = {
      type: 'bar',
      data: item,
      barWidth: '10px',
      barGap: 0.6,
      itemStyle: {
        barBorderRadius: [5, 5, 0, 0]
      }
    };
    option.series.push(oneData);
  });
  return option;
};

var initOptionBar4 = function initOptionBar4(xData, barData) {
  var option = {};
  option.grid = {
    right: 35,
    top: '10%',
    bottom: '22%',
    left: '18%'
  };
  option.tooltip = {
    trigger: 'axis'
  };
  option.xAxis = [{
    type: 'category',
    boundaryGap: false,
    data: [''].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(xData), ['']),
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    axisLabel: {
      rotate: -25,
      fontSize: 10
    },
    axisTick: {
      show: false
    }
  }];
  option.yAxis = [{
    type: 'value',
    textStyle: {
      color: '#fff'
    },
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    splitLine: {
      show: false
    },
    axisTick: {
      inside: true
    }
  }];
  option.series = [{
    data: [0].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(barData), [0]),
    type: 'line',
    symbol: 'none',
    lineStyle: {
      width: 1,
      color: '#ef6606'
    },
    areaStyle: {
      normal: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#ef6606'
        }, {
          offset: 0.5,
          color: 'rgba(239, 102, 6, 0.7)'
        }, {
          offset: 0.8,
          color: 'rgba(239, 102, 6, 0.5)'
        }, {
          offset: 1,
          color: 'rgba(239, 102, 6, 0.2)'
        }])
      }
    }
  }];
  return option;
};

var initOptionTreemap = function initOptionTreemap(legendData, chartData) {
  var option = {};
  var colors = ['#65c4d7', '#168fff', '#6ab4a0'];
  chartData.forEach(function (item, index) {
    item['color'] = [colors[index % 3]];
  });
  option.tooltip = {
    show: true,
    formatter: function formatter(params) {
      return params['treePathInfo'][1]['name'] + '<br />' + params['treePathInfo'][2]['name'] + '：' + params['treePathInfo'][2]['value'] + 'L';
    }
  };
  option.legend = {
    data: legendData,
    orient: 'vertical',
    right: '10%',
    top: '10%',
    textStyle: {
      color: '#fff'
    }
  };
  option.backgroundColor = 'rgba(0,0,0,0)';
  option.series = [{
    type: 'treemap',
    roam: false,
    nodeClick: false,
    breadcrumb: {
      show: false
    },
    label: {
      ellipsis: false
    },
    itemStyle: {
      gapWidth: 0.5
    },
    data: chartData
  }];
  return option;
};

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// import { getData } from '@/api/local_storage'

window.ECharts = __webpack_require__(51);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);

// store.dispatch('setLoginData', {data: getData('loginInfo'), save: false})
// store.dispatch('login')

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
window.myvm = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapStyle; });
/* unused harmony export mapStyleGas */
var mapStyle = [{
  'featureType': 'land',
  'elementType': 'geometry',
  'stylers': {
    'color': '#081734'
  }
}, {
  'featureType': 'building',
  'elementType': 'geometry',
  'stylers': {
    'color': '#04406F'
  }
}, {
  // 调整建筑物标签是否可视
  'featureType': 'building',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'on'
  }
}, {
  // 调整高速道路颜色
  'featureType': 'highway',
  'elementType': 'geometry',
  'stylers': {
    'color': '#015B99'
  }
}, {
  // 调整高速名字是否可视
  'featureType': 'highway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
}, {
  // 调整一些干道颜色
  'featureType': 'arterial',
  'elementType': 'geometry',
  'stylers': {
    'color': '#003051'
  }
}, {
  'featureType': 'arterial',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
}, {
  'featureType': 'green',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
}, {
  'featureType': 'water',
  'elementType': 'geometry',
  'stylers': {
    'color': '#044161'
  }
}, {
  // 调整地铁颜色
  'featureType': 'subway',
  'elementType': 'geometry.stroke',
  'stylers': {
    'color': '#003051'
  }
}, {
  'featureType': 'subway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
}, {
  'featureType': 'railway',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
}, {
  'featureType': 'railway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
}, {
  // 调整所有的标签的边缘颜色
  'featureType': 'all',
  'elementType': 'labels.text.stroke',
  'stylers': {
    'color': '#081734'
  }
}, {
  // 调整所有标签的填充颜色
  'featureType': 'all',
  'elementType': 'labels.text.fill',
  'stylers': {
    'color': '#081734'
  }
}, {
  'featureType': 'manmade',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
}, {
  'featureType': 'manmade',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
}, {
  'featureType': 'local',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
}, {
  'featureType': 'local',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
}, {
  'featureType': 'subway',
  'elementType': 'geometry',
  'stylers': {
    'lightness': -65
  }
}, {
  'featureType': 'railway',
  'elementType': 'all',
  'stylers': {
    'lightness': -40
  }
}, {
  'featureType': 'boundary',
  'elementType': 'geometry',
  'stylers': {
    'color': '#8b8787',
    'weight': '1',
    'lightness': -29
  }
}];

var mapStyleGas = [{
  'featureType': 'road',
  'elementType': 'all',
  'stylers': {
    'visibility': 'off'
  }
}, {
  'featureType': 'poilabel',
  'elementType': 'all',
  'stylers': {
    'visibility': 'off'
  }
}, {
  'featureType': 'background',
  'elementType': 'all',
  'stylers': {
    'color': '#010c48',
    'visibility': 'on'
  }
}, {
  'featureType': 'districtlabel',
  'elementType': 'all',
  'stylers': {
    'color': '#ff0000ff',
    'visibility': 'off'
  }
}, {
  'featureType': 'boundary',
  'elementType': 'all',
  'stylers': {
    'color': '#3d71c4ff',
    'visibility': 'off'
  }
}];

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_init__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_local_storage__ = __webpack_require__(52);




var state = {
  assign_data: [],
  solution_data: [],
  centroids: [],
  cluster_cutomer: [],
  cars: [],
  car_routes: []
};

var getters = {
  assignData: function assignData(state) {
    return state.assign_data;
  },
  clusterCutomer: function clusterCutomer(state) {
    return state.cluster_cutomer;
  },
  centroids: function centroids(state) {
    return state.centroids;
  },
  cars: function cars(state) {
    return state.cars;
  },
  carRoutes: function carRoutes(state) {
    return state.car_routes;
  },
  solutionData: function solutionData(state) {
    return state.solution_data;
  }
};

var actions = {
  setAssignData: function setAssignData(_ref, data) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('changeAssignData', data);
    dispatch('delAssignData', data);
  },
  saveAssignData: function saveAssignData(_ref2, data) {
    var getters = _ref2.getters;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_local_storage__["b" /* saveData */])({ key: 'assign_data' + data, data: getters.assignData });
  },
  clearAssignData: function clearAssignData(_ref3, data) {
    var commit = _ref3.commit;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_local_storage__["c" /* delData */])('assign_data' + data);
  },
  saveRouteData: function saveRouteData(_ref4, data) {
    var getters = _ref4.getters;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_local_storage__["b" /* saveData */])({ key: 'solution_data' + data, data: getters.solutionData });
  },
  clearRouteData: function clearRouteData(_ref5, data) {
    var commit = _ref5.commit;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_local_storage__["c" /* delData */])('solution_data' + data);
  },
  initAssignData: function initAssignData(_ref6, data) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    if (data === 'clear' || !data.centroids) {
      commit('changeAssignData', {});
      dispatch('setCars', []);
      dispatch('setCentroids', []);
      dispatch('setClusterCutomer', []);
      dispatch('setMapDataCenter', []);
      return;
    } else {
      dispatch('delAssignData', data);
    }
  },
  setSolutionData: function setSolutionData(_ref7, data) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    commit('changeSolutionData', data === 'clear' ? {} : data);
    dispatch('delSolutionData', data);
  },
  setClusterCutomer: function setClusterCutomer(_ref8, data) {
    var commit = _ref8.commit;

    commit('changeClusterCutomer', data);
  },
  setCentroids: function setCentroids(_ref9, data) {
    var commit = _ref9.commit;

    commit('changeCentroids', data);
  },
  setCars: function setCars(_ref10, data) {
    var commit = _ref10.commit;

    commit('changeCars', data);
  },
  setCarRoutes: function setCarRoutes(_ref11, data) {
    var commit = _ref11.commit;

    commit('changeCarRoutes', data);
  },
  delAssignData: function delAssignData(_ref12, data) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;

    var centroidsData = [];
    var carsData = [];
    var mapDataCenter = [];
    data.centroids.forEach(function (item) {
      var carName = '车辆' + item[0].slice(2);
      carsData.push(carName);
      centroidsData.push({ 'car_name': carName, 'center': item[3], 'customer_num': item[4], 'order_num': item[5], 'distance': item[6] });
      mapDataCenter.push({
        name: '车辆' + item[0].slice(2) + '-' + item[3],
        value: [item[1], item[2], {
          center: item[3],
          customer_num: item[4],
          order_num: item[5],
          distance: item[6]
        }]
      });
    });
    dispatch('setCars', carsData);
    dispatch('setCentroids', centroidsData);
    dispatch('setClusterCutomer', data.clustercutomer);
    dispatch('setMapDataCenter', mapDataCenter);
    dispatch('setSolutionStatus', 30);
  },
  delSolutionData: function delSolutionData(_ref13, data) {
    var commit = _ref13.commit,
        getters = _ref13.getters,
        dispatch = _ref13.dispatch;

    if (data === 'clear' || !data['路线']) {
      dispatch('setCarRoutes', []);
      dispatch('setMapDataRoute', []);
      return;
    }
    var routeData = [];
    var mapRouteData = [];
    data['路线'].forEach(function (item) {
      var mapRouteDataOne = { 'name': '车辆' + item[0].slice(2), data: [] };
      routeData.push({
        car: '车辆' + item[0].slice(2),
        route_data: item.slice(1).sort(function (a, b) {
          return a[2] > b[2] ? 1 : -1;
        })
      });
      item.slice(1).forEach(function (item) {
        var from = getters.shopCoordinate[item[0]];
        var to = getters.shopCoordinate[item[1]];
        if (from && to) {
          mapRouteDataOne.data.push({
            fromName: item[0],
            toName: item[1],
            coords: [from, to]
          });
        }
      });
      mapRouteData.push(mapRouteDataOne);
    });
    dispatch('setCarRoutes', routeData);
    dispatch('setMapDataRoute', mapRouteData);
    dispatch('setSolutionStatus', 40);
  },
  startAssignData: function startAssignData(_ref14, data) {
    var commit = _ref14.commit,
        getters = _ref14.getters,
        dispatch = _ref14.dispatch;

    if (getters.solutionDay !== 0 && !getters.solutionDay) {
      dispatch('showNoticeMsg', {
        type: 'warning',
        title: '系统提示',
        message: '请先选择送货日期！'
      });
      return;
    }
    dispatch('setLoading', true);
    dispatch('setLoadingText', '分配客户中');
    dispatch('setPercentage', { 'start': 0, 'next': 60 });
    dispatch('setSolutionStatus', 25);
    var postData = {
      parameter: getters.parm,
      OrderDays: getters.sourceData.OrderDays,
      Plant: getters.sourceData.Plant,
      Location: getters.sourceData.Location,
      Distance: getters.sourceData.Distance,
      week: getters.solutionWeeks[getters.solutionDay],
      solvericon: getters.solutionWays[getters.solutionWay],
      solver: 'AssignClusters5',
      ct: getters.sourceData.ct
    };
    console.log('开始分配客户');
    __WEBPACK_IMPORTED_MODULE_0__axios_init__["c" /* axiosDataApi */].post('/solve', window.JSON.stringify(postData)).then(function (response) {
      console.log('分配客户完成');
      dispatch('setLoadingText', '解析客户数据');
      dispatch('setPercentage', { 'start': 60, 'next': 100 });
      dispatch('setAssignData', response.data);
      dispatch('setLoadingText', '分配完成');
      dispatch('setPercentage', { 'start': 100, 'next': 100 });
    }).catch(function (e) {
      dispatch('setSolutionStatus', 20);
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '分配客户异常',
        message: '错误信息:' + e
      });
      dispatch('setLoadingText', '分配客户异常');
      dispatch('setPercentage', { 'start': 100, 'next': 100 });
      console.log(e);
    });
  },
  startSolutionData: function startSolutionData(_ref15) {
    var commit = _ref15.commit,
        getters = _ref15.getters,
        dispatch = _ref15.dispatch;

    dispatch('setLoading', true);
    dispatch('setLoadingText', '求解路径中');
    dispatch('setPercentage', { 'start': 0, 'next': 60 });
    dispatch('setSolutionStatus', 35);
    var postData = {
      parameter: getters.parm,
      ClusterMiddle: getters.assignData.ClusterMiddle,
      Distance: getters.sourceData.Distance,
      Location: getters.sourceData.Location,
      OrderDays: getters.sourceData.OrderDays,
      Plant: getters.sourceData.Plant,
      centroids: getters.assignData.centroids,
      cpc: getters.assignData.cpc,
      week: getters.solutionWeeks[getters.solutionDay],
      solver: 'CreateRoutes5'
    };
    console.log('开始求解路径');
    __WEBPACK_IMPORTED_MODULE_0__axios_init__["c" /* axiosDataApi */].post('/solve', window.JSON.stringify(postData)).then(function (response) {
      dispatch('setLoadingText', '解析路径');
      dispatch('setPercentage', { 'start': 60, 'next': 100 });
      console.log('求解路径完成');
      dispatch('setSolutionData', response.data);
      dispatch('setLoadingText', '求解完成');
      dispatch('setPercentage', { 'start': 100, 'next': 100 });
    }).catch(function (e) {
      dispatch('setSolutionStatus', 30);
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '求解路径异常',
        message: '错误信息:' + e
      });
      dispatch('setLoadingText', '求解路径异常');
      dispatch('setPercentage', { 'start': 100, 'next': 100 });
      console.log(e);
    });
  }
};

var mutations = {
  changeAssignData: function changeAssignData(state, data) {
    state.assign_data = data;
  },
  changeSolutionData: function changeSolutionData(state, data) {
    state.solution_data = data;
  },
  changeClusterCutomer: function changeClusterCutomer(state, data) {
    state.cluster_cutomer = data;
  },
  changeCentroids: function changeCentroids(state, data) {
    state.centroids = data;
  },
  changeCars: function changeCars(state, data) {
    state.cars = data;
  },
  changeCarRoutes: function changeCarRoutes(state, data) {
    state.car_routes = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_local_storage__ = __webpack_require__(52);


var getCaseData = function getCaseData(key) {
  var data = {
    sourceData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_local_storage__["a" /* getData */])('source_data' + key),
    assignData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_local_storage__["a" /* getData */])('assign_data' + key),
    parmData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_local_storage__["a" /* getData */])('parm_data' + key),
    routeData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_local_storage__["a" /* getData */])('solution_data' + key)
  };
  return data;
};

var state = {
  case_list: [],
  active_case: {
    // new 新建的 old 纪录中的
    status: '',
    name: '',
    key: '',
    solutionStatus: ''
  }
};

var getters = {
  caseList: function caseList(state) {
    return state.case_list;
  },
  activeCase: function activeCase(state) {
    return state.active_case;
  },
  caseName: function caseName(state) {
    return state.active_case.name;
  }
};

var actions = {
  saveCaseFail: function saveCaseFail(_ref, key) {
    var dispatch = _ref.dispatch;

    // case存储失败 需要提示，然后清除该case 相关localstorage 数据
    dispatch('showNoticeMsg', {
      type: 'warning',
      title: 'case存储失败',
      message: '由于浏览器存储空间不足或其他原因，该case存储失败！'
    });
    dispatch('clearCaseStoreData', key);
  },
  clearCaseStoreData: function clearCaseStoreData(_ref2, key) {
    var dispatch = _ref2.dispatch;

    dispatch('clearSourceData', key);
    dispatch('clearAssignData', key);
    dispatch('clearParmData', key);
    dispatch('clearRouteData', key);
  },
  getCaseList: function getCaseList(_ref3, data) {
    var commit = _ref3.commit;

    commit('changeCaseList', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_local_storage__["a" /* getData */])('case_list') || []);
  },
  setCaseName: function setCaseName(_ref4, data) {
    var commit = _ref4.commit;

    commit('changeCaseName', data);
  },
  addCase: function addCase(_ref5, data) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    // 初始化数据  包括 原始数据、配置数据、客户分配数据、路径分配数据
    dispatch('setSolutionStatus', 0);
    dispatch('initCaseData', {});
    commit('newCase', data);
  },
  saveCase: function saveCase(_ref6) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch,
        getters = _ref6.getters,
        state = _ref6.state;

    var key = state.active_case.key;
    try {
      dispatch('saveSourceData', key);
      dispatch('saveAssignData', key);
      dispatch('saveParmData', key);
      dispatch('saveRouteData', key);
      commit('changeCaseStatus', { key: key, status: 'old' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_local_storage__["b" /* saveData */])({ key: 'case_list', data: getters.caseList });
      dispatch('showNoticeMsg', {
        type: 'success',
        title: 'case存储成功',
        message: '您可以在数据导入中自由切换该case！'
      });
    } catch (error) {
      dispatch('saveCaseFail', key);
    }
  },
  switchCase: function switchCase(_ref7, switchKey) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch,
        getters = _ref7.getters;

    window.myChat.clear();
    dispatch('setSourceDataType', switchKey.indexOf('oil') !== -1 ? 'oil' : 'shop');
    dispatch('setLoading', true);
    dispatch('setLoadingText', '切换case中');
    dispatch('setPercentage', { 'start': 0, 'next': 100 });
    if (getters.activeCase.status === 'new') {
      commit('delCaseList');
    }
    commit('changeActiveCase', switchKey);
    // 提取数据 原始数据、配置数据、客户分配数据、路径分配数据
    var caseData = getCaseData(switchKey);
    // 初始化数据  包括 原始数据、配置数据、客户分配数据、路径分配数据
    dispatch('initCaseData', caseData);
    dispatch('setLoadingText', 'case切换完成');
    dispatch('setLoading', false);
    dispatch('setPercentage', { 'start': 100, 'next': 100 });
  },
  initCaseData: function initCaseData(_ref8, data) {
    var dispatch = _ref8.dispatch;

    dispatch('clearMapOption');
    dispatch('initSourceData', data.sourceData || 'clear');
    dispatch('initAssignData', data.assignData || 'clear');
    dispatch('initParmData', data.parmData || 'clear');
    dispatch('setSolutionData', data.routeData || 'clear');
  }
};

var mutations = {
  changeActiveCase: function changeActiveCase(state, data) {
    state.case_list.forEach(function (item) {
      if (item.key === data) {
        state.active_case = item;
      }
    });
  },
  newCase: function newCase(state, data) {
    var newCase = {
      key: (data === '石化DEMO' ? 'oil' : 'shop') + String(new Date().getTime()),
      name: data || 'new case',
      status: 'new'
    };
    state.active_case = newCase;
    state.case_list.push(newCase);
  },
  changeCaseList: function changeCaseList(state, data) {
    state.case_list = data;
  },
  changeCaseName: function changeCaseName(state, data) {
    state.active_case.name = data;
  },
  changeCaseStatus: function changeCaseStatus(state, data) {
    state.case_list.forEach(function (item) {
      if (item.key === data.key) {
        item.status = data.status;
      }
    });
    if (data.key === state.active_case.key) {
      state.active_case.status = data.status;
    }
  },
  delCaseList: function delCaseList(state) {
    var data = state.active_case;
    var newCaseList = [];
    state.case_list.forEach(function (item) {
      if (item.key !== data.key) {
        newCaseList.push(item);
      }
    });
    state.case_list = newCaseList;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapTools__ = __webpack_require__(100);



var buildFun = function buildFun(parm) {
  var renderBrushed = function renderBrushed(params) {
    console.log(parm);
    var legendData = parm === 'tobacco' ? ['红塔山', '玉溪', '云烟'] : parm === 'shop' ? ['干货', '新鲜货', '冰冻货'] : ['0号柴油', '92号汽油', '95号汽油'];
    var mainSeries = params.batch[0].selected[0];
    var seriesData = window.myChat.getOption().series[0].data;
    var selectedItems = [];
    var categoryData = [];
    var barData = [];
    var maxBar = 10;
    var sum = 0;
    var count = 0;
    for (var _i = 0; _i < mainSeries.dataIndex.length; _i++) {
      var rawIndex = mainSeries.dataIndex[_i];
      var dataItem = seriesData[rawIndex];
      var pmValue = dataItem.value[2].dry + dataItem.value[2].fresh + dataItem.value[2].frozen;
      sum += pmValue;
      count++;
      selectedItems.push({
        name: dataItem.name,
        value: [dataItem.value[2].dry, dataItem.value[2].fresh, dataItem.value[2].frozen]
      });
    }
    selectedItems.sort(function (a, b) {
      return b.value[2] - a.value[2];
    });
    barData = [{
      id: 'bar1',
      type: 'bar',
      stack: '总量',
      name: legendData[0],
      data: [],
      tooltip: {
        trigger: 'item',
        formatter: function formatter(params) {
          return params.seriesName + '<br/>' + params.data;
        }
      }
    }, {
      id: 'bar2',
      type: 'bar',
      stack: '总量',
      name: legendData[1],
      data: [],
      tooltip: {
        trigger: 'item',
        formatter: function formatter(params) {
          return params.seriesName + '<br/>' + params.data;
        }
      }
    }, {
      id: 'bar' + i,
      type: 'bar',
      stack: '总量',
      name: legendData[2],
      data: [],
      tooltip: {
        trigger: 'item',
        formatter: function formatter(params) {
          return params.seriesName + '<br/>' + params.data;
        }
      }
    }];
    for (var i = 0; i < Math.min(selectedItems.length, maxBar); i++) {
      categoryData.push(selectedItems[i].name);
      barData[0].data.push(selectedItems[i].value[0]);
      barData[1].data.push(selectedItems[i].value[1]);
      barData[2].data.push(selectedItems[i].value[2]);
    }
    window.myChat.setOption({
      xAxis: {
        axisLabel: {
          show: !!count
        }
      },
      yAxis: {
        data: categoryData,
        type: 'category',
        show: !!count,
        axisLine: {
          lineStyle: {
            color: '#fff'
          }
        }
      },
      grid: {
        left: '13%',
        bottom: '5%',
        height: '30%',
        width: '20%'
      },
      title: {
        id: 'title_select',
        text: count ? '平均: ' + (sum / count).toFixed(2) : ''
      },
      series: barData
    });
  };
  return renderBrushed;
};

var state = {
  // 0开始 1初始化完成 2 option设置完成 -1 离开页面
  chat_status: 0,
  db_chat: null,
  all_day_map_customer: [],
  all_map_data_customer: [],
  map_data_customer: [],
  map_data_plant: [],
  map_data_center: [],
  map_data_route: []
};

var getters = {
  dbChat: function dbChat(state) {
    return state.db_chat;
  },
  mapDataCustomer: function mapDataCustomer(state) {
    return state.map_data_customer;
  },
  allMapDataCustomer: function allMapDataCustomer(state) {
    return state.all_map_data_customer;
  },
  mapDataPlant: function mapDataPlant(state) {
    return state.map_data_plant;
  },
  mapDataCenter: function mapDataCenter(state) {
    return state.map_data_center;
  }
};

var actions = {
  clearMapOption: function clearMapOption(_ref) {
    var commit = _ref.commit,
        getters = _ref.getters,
        dispatch = _ref.dispatch;

    var dataP = null;
    if (getters.sourceDataType === 'shop') {
      dataP = {
        legendData: ['客户', '工厂', '中心点'],
        row: ['干货', '新鲜货', '冰冻货']
      };
    } else if (getters.sourceDataType === 'tobacco') {
      dataP = {
        legendData: ['商店', '卷烟配送中心', '中心点'],
        row: ['红塔山', '玉溪', '云烟']
      };
    } else {
      dataP = {
        legendData: ['加油站', '油库', '中心点'],
        row: ['0号柴油', '92号汽油', '95号汽油']
      };
    }
    window.myChat.clear();
    window.myChat.setOption(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["i" /* initOption */])(dataP), true);
    window.myChat.on('brushselected', buildFun(getters.sourceDataType));
  },
  initMapOption: function initMapOption(_ref2) {
    var commit = _ref2.commit,
        getters = _ref2.getters,
        dispatch = _ref2.dispatch;

    window.myChat.clear();
    var dataP = null;
    if (getters.sourceDataType === 'shop') {
      dataP = {
        legendData: ['客户', '工厂', '中心点'],
        row: ['干货', '新鲜货', '冰冻货']
      };
    } else if (getters.sourceDataType === 'tobacco') {
      dataP = {
        legendData: ['商店', '配送中心', '中心点'],
        row: ['红塔山', '玉溪', '云烟']
      };
    } else {
      dataP = {
        legendData: ['加油站', '油库', '中心点'],
        row: ['0号柴油', '92号汽油', '95号汽油']
      };
    }
    window.myChat.setOption(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["i" /* initOption */])(dataP), true);
    dispatch('setChatStatus', 2);
  },
  setAllMapDataCustomer: function setAllMapDataCustomer(_ref3, data) {
    var commit = _ref3.commit;

    commit('changeAllMapDataCustomer', data);
  },
  setChatStatus: function setChatStatus(_ref4, data) {
    var commit = _ref4.commit;

    commit('changeChatStatus', data);
  },
  selectMapDataCustomer: function selectMapDataCustomer(_ref5, data) {
    var commit = _ref5.commit;

    commit('changeSelectMapDataCustomer', data);
  },
  selectMapCarCustomer: function selectMapCarCustomer(_ref6, data) {
    var commit = _ref6.commit,
        getters = _ref6.getters;

    commit('changeSelectMapCarCustomer', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ clusterCutomer: getters.clusterCutomer }, data));
  },
  setOption: function setOption(_ref7, data) {
    var commit = _ref7.commit;

    commit('changeOption', data);
  },
  setDbChat: function setDbChat(_ref8, data) {
    var commit = _ref8.commit;

    commit('changeDbChat', data);
  },
  setMapDataCustomer: function setMapDataCustomer(_ref9, data) {
    var commit = _ref9.commit;

    commit('changeMapDataCustomer', data);
  },
  setMapDataPlant: function setMapDataPlant(_ref10, data) {
    var commit = _ref10.commit;

    commit('changeMapDataPlant', data);
  },
  setMapDataCenter: function setMapDataCenter(_ref11, data) {
    var commit = _ref11.commit;

    commit('changeMapDataCenter', data);
  },
  setMapDataRoute: function setMapDataRoute(_ref12, data) {
    var commit = _ref12.commit;

    commit('changeMapDataRoute', data);
  }
};

var mutations = {
  changeChatStatus: function changeChatStatus(state, data) {
    state.chat_status = data;
    if (data === 2) {
      var optionList = [{
        key: 'Location',
        data: state.map_data_customer
      }, {
        key: 'Plant',
        data: state.map_data_plant
      }, {
        key: 'centroids',
        data: state.map_data_center
      }];
      optionList.forEach(function (item) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["j" /* setDataOption */])(item.key, item.data);
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["e" /* addCarData */])(window.myChat, state.map_data_route);
    }
  },
  changeOption: function changeOption(state, data) {
    state.db_chat = data;
  },
  changeDbChat: function changeDbChat(state, data) {
    state.db_chat = data;
  },
  changeMapDataCustomer: function changeMapDataCustomer(state, data) {
    if (state.chat_status === 2) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["j" /* setDataOption */])('Location', data);
    }
    state.map_data_customer = data;
  },
  changeSelectMapDataCustomer: function changeSelectMapDataCustomer(state, data) {
    var newData = [];
    state.all_map_data_customer.forEach(function (item) {
      if (item.order_days && item.order_days.indexOf(data) > -1 || !data) {
        newData.push(item);
      }
    });
    state.all_day_map_customer = newData;
    state.map_data_customer = newData;
    if (state.chat_status === 2) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["j" /* setDataOption */])('Location', newData);
    }
  },
  changeSelectMapCarCustomer: function changeSelectMapCarCustomer(state, data) {
    var custormer = [];
    data.clusterCutomer.forEach(function (item) {
      if (item[0].slice(2) === data.car.slice(2)) {
        custormer = item.slice(1);
        return;
      }
    });
    if (data.status) {
      var newData = [];
      state.map_data_customer.forEach(function (item) {
        newData.push(item);
      });
      // 提取数据后加进去
      state.all_day_map_customer.forEach(function (item) {
        if (custormer.indexOf(item.name) > -1) {
          newData.push(item);
        }
      });
      state.map_data_customer = newData;
    } else {
      // 直接从map_data_customer中删去
      var _newData = [];
      state.map_data_customer.forEach(function (item) {
        if (custormer.indexOf(item.name) === -1) {
          _newData.push(item);
        }
      });
      state.map_data_customer = _newData;
    }
    if (state.chat_status === 2) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["j" /* setDataOption */])('Location', state.map_data_customer);
    }
  },
  changeMapDataPlant: function changeMapDataPlant(state, data) {
    if (state.chat_status === 2) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["j" /* setDataOption */])('Plant', data);
    }
    state.map_data_plant = data;
  },
  changeAllMapDataCustomer: function changeAllMapDataCustomer(state, data) {
    state.all_map_data_customer = data;
  },
  changeMapDataCenter: function changeMapDataCenter(state, data) {
    if (state.chat_status === 2) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["j" /* setDataOption */])('centroids', data);
    }
    state.map_data_center = data;
  },
  changeMapDataRoute: function changeMapDataRoute(state, data) {
    if (state.chat_status === 2) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["e" /* addCarData */])(window.myChat, data);
    }
    state.map_data_route = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapTools__ = __webpack_require__(100);


var state = {
  // 0开始 1初始化完成 2 option设置完成 -1 离开页面
  chat_pre_status: 0,
  map_oil: [],
  all_map_oil: [],
  map_station: [],
  all_map_station: [],
  map_one_route: [],
  all_map_one_route: [],
  active_station: ''
};

var getters = {
  mapOil: function mapOil(state) {
    return state.map_oil;
  },
  activeStation: function activeStation(state) {
    return state.active_station;
  },
  mapStation: function mapStation(state) {
    return state.map_station;
  },
  mapOneRoute: function mapOneRoute(state) {
    return state.map_one_route;
  },
  allMapOil: function allMapOil(state) {
    return state.all_map_oil;
  },
  allMapStation: function allMapStation(state) {
    return state.all_map_station;
  },
  allMapOneRoute: function allMapOneRoute(state) {
    return state.all_map_one_route;
  }
};

var actions = {
  setMapPreCenter: function setMapPreCenter(_ref, data) {
    var commit = _ref.commit;

    // 设置地图中心点
    var option = window.myPreChat.getOption();
    option.bmap[0].center = data.center;
    option.bmap[0].zoom = data.zoom;
    window.myPreChat.setOption(option, true);
  },
  initMapPreOption: function initMapPreOption(_ref2) {
    var commit = _ref2.commit,
        getters = _ref2.getters,
        dispatch = _ref2.dispatch;

    // 初始化地图配置
    window.myPreChat.clear();
    window.myPreChat.setOption(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["f" /* initPreOption */])(), true);
    dispatch('setChatPreStatus', 2);
  },
  setChatPreStatus: function setChatPreStatus(_ref3, data) {
    var commit = _ref3.commit;

    // 设置地图状态
    commit('changeChatPreStatus', data);
  },
  selectMapOil: function selectMapOil(_ref4, data) {
    var commit = _ref4.commit,
        getters = _ref4.getters,
        dispatch = _ref4.dispatch;

    //
    var allData = getters.allMapOil;
    if (!data) {
      dispatch('setMapOil', allData);
      return;
    }
    var newData = [];
    var oilData = getters.gasLocation;
    allData.forEach(function (item) {
      if (oilData[item.name][2] === data) {
        newData.push(item);
      }
    });
    var newData2 = [];
    if (getters.mapOneRoute.length > 0) {
      newData.forEach(function (item) {
        getters.mapOneRoute.forEach(function (item2) {
          if (item2.data[0].toName === item.name) {
            newData2.push(item);
          }
        });
      });
    } else {
      newData2 = newData;
    }
    dispatch('setMapOil', newData2);
  },
  selectMapStation: function selectMapStation(_ref5, data) {
    var commit = _ref5.commit,
        getters = _ref5.getters,
        dispatch = _ref5.dispatch;

    // 选择地图上的油库
    var allData = getters.allMapStation;
    if (!data) {
      dispatch('setMapStation', allData);
      return;
    }
    var newData = [];
    allData.forEach(function (item) {
      if (item.name === data) {
        newData.push(item);
      }
    });
    dispatch('setMapStation', newData);
  },
  selectMapOneRoute: function selectMapOneRoute(_ref6, data) {
    var commit = _ref6.commit,
        getters = _ref6.getters,
        dispatch = _ref6.dispatch;

    var allData = getters.allMapOneRoute;
    if (!data) {
      dispatch('setMapOneRoute', allData);
      return;
    }
    var newData = [];
    allData.forEach(function (item) {
      if (item.data[0].fromName === data) {
        newData.push(item);
      }
    });
    dispatch('setMapOneRoute', newData);
  },
  setMapOil: function setMapOil(_ref7, data) {
    var commit = _ref7.commit;

    commit('changeMapOil', data);
  },
  setMapStation: function setMapStation(_ref8, data) {
    var commit = _ref8.commit;

    commit('changeMapStation', data);
  },
  setMapOneRoute: function setMapOneRoute(_ref9, data) {
    var commit = _ref9.commit;

    commit('changeMapOneRoute', data);
  },
  setAllMapOil: function setAllMapOil(_ref10, data) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch,
        getters = _ref10.getters;

    commit('changeAllMapOil', data);
    dispatch('selectMapOil', getters.activeStation);
  },
  setActiveStation: function setActiveStation(_ref11, data) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch,
        getters = _ref11.getters;

    // 地图上设置油库
    commit('changeActiveStation', data);
    data = data === '全部' ? '' : data;
    var mapOption = getters.depotLocation[data];
    if (data && mapOption) {
      dispatch('setMapPreCenter', { center: mapOption, zoom: 12 });
    }
    dispatch('selectMapOneRoute', data);
    dispatch('selectMapOil', data);
    dispatch('selectMapStation', data);
  },
  setAllMapStation: function setAllMapStation(_ref12, data) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch,
        getters = _ref12.getters;

    commit('changeAllMapStation', data);
    dispatch('selectMapStation', getters.activeStation);
  },
  setAllMapOneRoute: function setAllMapOneRoute(_ref13, data) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;

    commit('changeAllMapOneRoute', data);
    dispatch('selectMapOneRoute', '');
  }
};

var mutations = {
  changeChatPreStatus: function changeChatPreStatus(state, data) {
    state.chat_pre_status = data;
    if (data === 2) {
      var optionList = [{
        key: 'Location',
        data: state.map_oil
      }, {
        key: 'centroids',
        data: state.map_station
      }];
      optionList.forEach(function (item) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["g" /* setDataPreOption */])(item.key, item.data);
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["h" /* addCarPreData */])(window.myPreChat, state.map_one_route);
    }
  },
  changeActiveStation: function changeActiveStation(state, data) {
    state.active_station = data;
  },
  changeMapOil: function changeMapOil(state, data) {
    if (state.chat_pre_status === 2) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["g" /* setDataPreOption */])('Location', data);
    }
    state.map_oil = data;
  },
  changeMapStation: function changeMapStation(state, data) {
    if (state.chat_pre_status === 2) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["g" /* setDataPreOption */])('centroids', data);
    }
    state.map_station = data;
  },
  changeMapOneRoute: function changeMapOneRoute(state, data) {
    if (state.chat_pre_status === 2) {
      var option = window.myPreChat.getOption();
      option.series = option.series.slice(0, 2);
      window.myPreChat.setOption(option, true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["h" /* addCarPreData */])(window.myPreChat, data);
    }
    state.map_one_route = data;
  },
  changeAllMapOil: function changeAllMapOil(state, data) {
    state.all_map_oil = data;
  },
  changeAllMapStation: function changeAllMapStation(state, data) {
    state.all_map_station = data;
  },
  changeAllMapOneRoute: function changeAllMapOneRoute(state, data) {
    state.all_map_one_route = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapTools__ = __webpack_require__(100);


var state = {
  // 0开始 1初始化完成 2 option设置完成 -1 离开页面
  demo_chat_status: 0,
  demo_map_data_customer: [],
  demo_map_data_plant: [],
  demo_map_data_route: [],
  demo_map_data_center: []
};

var getters = {};

var actions = {
  setDemoChatStatus: function setDemoChatStatus(_ref, data) {
    var commit = _ref.commit;

    commit('changeDemoChatStatus', data);
  },
  initDemoMapOption: function initDemoMapOption(_ref2) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    window.myDemoChat.clear();
    var dataP = {
      legendData: ['客户', '通力物流园', '乡镇卫生院'],
      row: []
    };
    window.myDemoChat.setOption(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["c" /* initOptionDemo */])(dataP), true);
    dispatch('setDemoChatStatus', 2);
  },
  setDemoMapDataCustomer: function setDemoMapDataCustomer(_ref3, data) {
    var commit = _ref3.commit;

    commit('changeDemoMapDataCustomer', data);
  },
  setDemoMapDataPlant: function setDemoMapDataPlant(_ref4, data) {
    var commit = _ref4.commit;

    commit('changeDemoMapDataPlant', data);
  },
  setDemoMapDataCenter: function setDemoMapDataCenter(_ref5, data) {
    var commit = _ref5.commit;

    commit('changeDemoMapDataCenter', data);
  },
  setDemoMapDataRoute: function setDemoMapDataRoute(_ref6, data) {
    var commit = _ref6.commit;

    commit('changeDemoMapDataRoute', data);
  }
};

var mutations = {
  changeDemoChatStatus: function changeDemoChatStatus(state, data) {
    state.demo_chat_status = data;
    if (data === 2) {
      var optionList = [{
        key: 'Location',
        data: state.demo_map_data_customer
      }, {
        key: 'Plant',
        data: state.demo_map_data_plant
      }, {
        key: 'centroids',
        data: state.demo_map_data_center
      }];
      optionList.forEach(function (item) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["d" /* setChartDataOption */])(window.myDemoChat, item.key, item.data);
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["e" /* addCarData */])(window.myDemoChat, state.demo_map_data_route);
    }
  },
  changeDemoMapDataCustomer: function changeDemoMapDataCustomer(state, data) {
    if (state.demo_chat_status === 2) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["d" /* setChartDataOption */])(window.myDemoChat, 'Location', data);
    }
    state.demo_map_data_customer = data;
  },
  changeDemoMapDataPlant: function changeDemoMapDataPlant(state, data) {
    if (state.demo_chat_status === 2) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["d" /* setChartDataOption */])(window.myDemoChat, 'Plant', data);
    }
    state.demo_map_data_plant = data;
  },
  changeDemoMapDataRoute: function changeDemoMapDataRoute(state, data) {
    if (state.demo_chat_status === 2) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["e" /* addCarData */])(window.myDemoChat, data);
    }
    state.demo_map_data_route = data;
  },
  changeDemoMapDataCenter: function changeDemoMapDataCenter(state, data) {
    if (state.demo_chat_status === 2) {
      console.log(data);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mapTools__["d" /* setChartDataOption */])(window.myDemoChat, 'centroids', data);
    }
    state.demo_map_data_center = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_init__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_ele_local__ = __webpack_require__(349);




var state = {
  // 0 start 10 获取原始数据完成 20 选择case完成  30 求解完成
  ele_status: 0,
  source_data_ele: [],
  cases_ele: [],
  show_cases_name: [],
  compare_cases_name: [],
  all_save_cases_name: []
};

var getters = {
  allSaveCasesName: function allSaveCasesName(state) {
    return state.all_save_cases_name;
  },
  compareCasesName: function compareCasesName(state) {
    return state.compare_cases_name;
  },
  showCasesName: function showCasesName(state) {
    return state.show_cases_name;
  },
  eleStatus: function eleStatus(state) {
    return state.ele_status;
  },
  sourceDataEle: function sourceDataEle(state) {
    return state.source_data_ele;
  },
  casesEle: function casesEle(state) {
    return state.cases_ele;
  }
};

var actions = {
  getAllSaveCasesName: function getAllSaveCasesName(_ref) {
    var commit = _ref.commit;

    var allSaveCase = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_ele_local__["a" /* getEleCase */])() || [];
    var data = [];
    allSaveCase.forEach(function (item) {
      data.push(item.name);
    });
    commit('changeAllSaveCasesName', data);
  },
  saveOneEleCase: function saveOneEleCase(_ref2, caseData) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_ele_local__["b" /* saveEleCase */])(caseData);
    dispatch('getAllSaveCasesName');
  },
  clearOneEleCase: function clearOneEleCase(_ref3, caseName) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_ele_local__["c" /* clearEleCase */])(caseName);
    dispatch('getAllSaveCasesName');
  },
  oupoutEleCase: function oupoutEleCase(_ref4, nameList) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    var newCaseData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_ele_local__["a" /* getEleCase */])(nameList);
    newCaseData.forEach(function (item) {
      dispatch('addCasesEle', item);
    });
  },
  setCompareCasesName: function setCompareCasesName(_ref5, data) {
    var commit = _ref5.commit;

    commit('changeCompareCasesName', data);
  },
  setShowCasesName: function setShowCasesName(_ref6, data) {
    var commit = _ref6.commit;

    commit('changeShowCasesName', data);
  },
  setEleStatus: function setEleStatus(_ref7, data) {
    var commit = _ref7.commit;

    commit('changeEleStatus', data);
  },
  setSourceDataEle: function setSourceDataEle(_ref8, data) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    commit('changeSourceDataEle', data);
    dispatch('setEleStatus', 10);
  },
  addCasesEle: function addCasesEle(_ref9, data) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;

    if (data.status < 30) {
      data.status = 20;
      commit('pushCasesEle', data);
      dispatch('startSolutionEle', data);
    } else {
      commit('pushCasesEle', data);
    }
  },
  setCasesEle: function setCasesEle(_ref10, data) {
    var commit = _ref10.commit;

    commit('changeCasesEle', data);
  },
  setCaseResultEle: function setCaseResultEle(_ref11, data) {
    var commit = _ref11.commit;

    commit('changeCaseResultEle', data);
  },
  loadSourceDataEle: function loadSourceDataEle(_ref12, data) {
    var commit = _ref12.commit,
        getters = _ref12.getters,
        dispatch = _ref12.dispatch;

    dispatch('setLoading', true);
    dispatch('setLoadingText', '获取数据中');
    dispatch('setPercentage', { 'start': 0, 'next': 100 });
    __WEBPACK_IMPORTED_MODULE_0__axios_init__["b" /* axiosSysApi */].get('/static/ele_source_data.json').then(function (response) {
      dispatch('setSourceDataEle', response.data);
      dispatch('setLoadingText', '获取数据完成');
      dispatch('setPercentage', { 'start': 100, 'next': 100 });
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '获取数据异常',
        message: '错误信息:' + e
      });
      dispatch('setEleStatus', 0);
      dispatch('setLoadingText', '获取数据异常');
      dispatch('setPercentage', { 'start': 100, 'next': 100 });
      console.log(e);
    });
  },
  startSolutionEle: function startSolutionEle(_ref13, data) {
    var commit = _ref13.commit,
        getters = _ref13.getters,
        dispatch = _ref13.dispatch;

    var postData = {
      '天气': data.d1,
      '光伏成本': data.d2,
      '固定存储容量': Number(data.d3.split('k')[0]),
      'SOC下限': data.d4,
      'SOC上限': data.d5,
      'SOC初始值': data.d6,
      '储能放电成本': data.d7,
      generator: getters.sourceDataEle.generator,
      grid_price: getters.sourceDataEle.grid_price,
      load: getters.sourceDataEle.load,
      new_eng: getters.sourceDataEle.new_eng,
      period: getters.sourceDataEle.period,
      solver: 'microgrid'
    };
    __WEBPACK_IMPORTED_MODULE_0__axios_init__["c" /* axiosDataApi */].post('/solve', window.JSON.stringify(postData)).then(function (response) {
      dispatch('setCaseResultEle', { data: response.data, caseName: data.name });
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '求解异常',
        message: '错误信息:' + e
      });
      console.log(e);
    });
  }
};

var mutations = {
  changeCaseResultEle: function changeCaseResultEle(state, data) {
    state.cases_ele.forEach(function (item) {
      if (item.name === data.caseName) {
        item.result = data.data;
        item.status = 30;
      }
    });
  },
  changeAllSaveCasesName: function changeAllSaveCasesName(state, data) {
    state.all_save_cases_name = data;
  },
  changeCompareCasesName: function changeCompareCasesName(state, data) {
    state.compare_cases_name = data;
  },
  changeShowCasesName: function changeShowCasesName(state, data) {
    state.show_cases_name = data;
  },
  changeEleStatus: function changeEleStatus(state, data) {
    state.ele_status = data;
  },
  changeSourceDataEle: function changeSourceDataEle(state, data) {
    state.source_data_ele = data;
  },
  changeCasesEle: function changeCasesEle(state, data) {
    state.cases_ele = data;
  },
  pushCasesEle: function pushCasesEle(state, data) {
    state.cases_ele.push(data);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  loading: false,
  loading_text: '加载中',
  percentage: {
    start: 0,
    next: 100
  }
};

var getters = {
  loading: function loading(state) {
    return state.loading;
  },
  loadingText: function loadingText(state) {
    return state.loading_text;
  },
  percentage: function percentage(state) {
    return state.percentage;
  }
};

var actions = {
  setLoading: function setLoading(_ref, data) {
    var commit = _ref.commit;

    commit('changeLoading', data);
  },
  setLoadingText: function setLoadingText(_ref2, data) {
    var commit = _ref2.commit;

    commit('changeLoadingText', data);
  },
  setPercentage: function setPercentage(_ref3, data) {
    var commit = _ref3.commit;

    commit('changePercentage', data);
  }
};

var mutations = {
  changeLoading: function changeLoading(state, data) {
    state.loading = data;
  },
  changeLoadingText: function changeLoadingText(state, data) {
    state.loading_text = data;
  },
  changePercentage: function changePercentage(state, data) {
    state.percentage = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  notice: {
    type: 'info',
    message: '警告',
    title: '警告'
  }
};

var getters = {
  notice: function notice(state) {
    return state.notice;
  }
};

var actions = {
  showNoticeMsg: function showNoticeMsg(_ref, data) {
    var dispatch = _ref.dispatch;

    dispatch('setNotice', data);
  },
  setNotice: function setNotice(_ref2, data) {
    var commit = _ref2.commit;

    commit('changeNotice', data);
  }
};

var mutations = {
  changeNotice: function changeNotice(state, data) {
    state.notice = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_init__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_local_storage__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_static_data__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_oli_api__ = __webpack_require__(13);








// 石油相关
var state = {
  oilArea: null,
  inputDataLoading: true,
  todayStr: '',
  yesterDayStr: '',
  canChoosePSZXs: [],
  // 流程状态 0: start 10:数据导入完成 20:数据校验完成 30:预测完成 40: 订单分配完成 -90: 流程错误
  flowStatus: 0,
  gasLocation: [],
  depotLocation: []
};

var getters = {
  oilArea: function oilArea(state) {
    return state.oilArea;
  },
  todayStr: function todayStr(state) {
    return state.todayStr;
  },
  yesterDayStr: function yesterDayStr(state) {
    return state.yesterDayStr;
  },
  flowStatus: function flowStatus(state) {
    return state.flowStatus;
  },
  canChoosePSZXs: function canChoosePSZXs(state) {
    return state.canChoosePSZXs;
  },
  gasLocation: function gasLocation(state) {
    return state.gasLocation;
  },
  depotLocation: function depotLocation(state) {
    return state.depotLocation;
  },
  inputDataLoading: function inputDataLoading(state) {
    return state.inputDataLoading;
  }
};

var actions = {
  setCanChoosePSZXs: function setCanChoosePSZXs(_ref, data) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        getters = _ref.getters;

    var newDatas = [];
    __WEBPACK_IMPORTED_MODULE_2__api_static_data__["e" /* PSZX_LIST */].forEach(function (item) {
      if (data.includes(item['key'])) {
        newDatas.push(item);
      }
    });
    commit('setCanChoosePSZXs', newDatas);
    dispatch('setOilArea', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_local_storage__["a" /* getData */])('oil_area'));
  },
  setOilArea: function setOilArea(_ref2, data) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    var canChoose = false;
    if (data) {
      getters.canChoosePSZXs.forEach(function (item) {
        if (item['key'] === data) {
          canChoose = true;
        }
      });
    }
    if (!canChoose) {
      data = getters.canChoosePSZXs.length > 0 ? getters.canChoosePSZXs[0].key : null;
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_local_storage__["b" /* saveData */])({ key: 'oil_area', data: data });
    if (getters.oilArea && getters.oilArea !== data) {
      window.location.reload();
    }
    commit('setOilArea', data);
  },
  loadLocationData: function loadLocationData(_ref3, data) {
    var commit = _ref3.commit,
        getters = _ref3.getters,
        dispatch = _ref3.dispatch;

    // 加油站、油库位置数据
    __WEBPACK_IMPORTED_MODULE_0__axios_init__["b" /* axiosSysApi */].get('/static/location.json').then(function (response) {
      dispatch('setGasLocation', response.data['加油站位置']);
      dispatch('setDepotLocation', response.data['油库位置']);
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '分析预测异常',
        message: '错误信息:' + e
      });
      console.log(e);
    });
  },
  setInputDataLoading: function setInputDataLoading(_ref4, data) {
    var commit = _ref4.commit;

    commit('setInputDataLoading', data);
  },
  setTodayStr: function setTodayStr(_ref5, data) {
    var commit = _ref5.commit;

    commit('setTodayStr', data);
  },
  setGasLocation: function setGasLocation(_ref6, data) {
    var commit = _ref6.commit;

    commit('setGasLocation', data);
  },
  setDepotLocation: function setDepotLocation(_ref7, data) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    var newData = [];
    for (var key in data) {
      newData.push({
        name: key,
        value: data[key]
      });
    }
    dispatch('setAllMapStation', newData);
    commit('setDepotLocation', data);
  },
  setYesterDayStr: function setYesterDayStr(_ref8, data) {
    var commit = _ref8.commit;

    commit('setYesterDayStr', data);
  },
  setFlowStatus: function setFlowStatus(_ref9, data) {
    var commit = _ref9.commit;

    commit('setFlowStatus', data);
  },
  loadInputData: function loadInputData(_ref10) {
    var dispatch = _ref10.dispatch,
        getters = _ref10.getters;

    dispatch('setInputDataLoading', true);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["p" /* getInvoicingTodayData */])().then(function (data) {
      dispatch('setTodayStr', data.toDay2);
      dispatch('setYesterDayStr', data.yesterDay);
      if (data.data.length) {
        dispatch('dealDatasToHisJxcDatas', data.data);
        dispatch('setInputJxcOk');
      }
      if (data.data_depot_volume === '1') {
        dispatch('setInputDepotValumeOk');
      }
      if (data.data_plant === '1') {
        dispatch('setInputOrderPlantOk');
      }
      if (data.to_goods === '1') {
        dispatch('setInputToGoodsOk');
      }
      dispatch('setInputDataLoading', false);
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'warning',
        title: '系统提示',
        message: '服务器错误，请联系管理员'
      });
      dispatch('setInputDataLoading', false);
    });
  }
};

var mutations = {
  setCanChoosePSZXs: function setCanChoosePSZXs(state, data) {
    state.canChoosePSZXs = data;
  },
  setOilArea: function setOilArea(state, data) {
    state.oilArea = data;
  },
  setInputDataLoading: function setInputDataLoading(state, data) {
    state.inputDataLoading = data;
  },
  setGasLocation: function setGasLocation(state, data) {
    state.gasLocation = data;
  },
  setDepotLocation: function setDepotLocation(state, data) {
    state.depotLocation = data;
  },
  setFlowStatus: function setFlowStatus(state, data) {
    state.flowStatus = data;
  },
  setTodayStr: function setTodayStr(state, data) {
    state.todayStr = data;
  },
  setYesterDayStr: function setYesterDayStr(state, data) {
    state.yesterDayStr = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export goUpdateInvoicingData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cllib__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_oli_api__ = __webpack_require__(13);




// 石油相关
var state = {
  hisGasList: [],
  selectHisGas: null,
  hisJxcDatas: [],
  areaHisJxcDatas: [],
  errorHisJxcDatas: [],
  allAreas: []
};

var goUpdateInvoicingData = function goUpdateInvoicingData(data) {
  var parm = {
    which: data.data,
    data: {
      key: data.key,
      value: data.value
    }
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["o" /* updateInvoicingData */])(parm).then(function (reData) {
    console.log(reData);
  }).catch(function (e) {
    console.log(e);
  });
};

var getters = {
  hisGasList: function hisGasList(state) {
    return state.hisGasList;
  },
  selectHisGas: function selectHisGas(state) {
    return state.selectHisGas;
  },
  hisJxcDatas: function hisJxcDatas(state) {
    return state.hisJxcDatas;
  },
  errorHisJxcDatas: function errorHisJxcDatas(state) {
    return state.errorHisJxcDatas;
  },
  areaHisJxcDatas: function areaHisJxcDatas(state) {
    return state.areaHisJxcDatas;
  },
  allAreas: function allAreas(tate) {
    return state.allAreas;
  }
};

var actions = {
  setAllAreas: function setAllAreas(_ref, data) {
    var commit = _ref.commit;

    commit('setAllAreas', data);
  },
  filteHisJxcDatas: function filteHisJxcDatas(_ref2, _ref3) {
    var commit = _ref2.commit,
        getters = _ref2.getters;
    var area = _ref3.area,
        oilType = _ref3.oilType;

    var data = [];
    if (area) {
      getters.hisJxcDatas.forEach(function (itemA) {
        itemA['data'].forEach(function (item) {
          if (item['区域'] === area && (!item['油品名称'] || item['油品名称'].indexOf(oilType)) > -1) {
            data.push(item);
          }
        });
      });
    }
    commit('setAreaHisJxcDatas', data);
  },
  editOneHisJxcData: function editOneHisJxcData(_ref4, data) {
    var commit = _ref4.commit;

    commit('editOneHisJxcData', data);
  },
  updateErrorHisJxcDatas: function updateErrorHisJxcDatas(_ref5) {
    var getters = _ref5.getters,
        dispatch = _ref5.dispatch;

    var newData = [];
    getters.errorHisJxcDatas.forEach(function (item) {
      var datas = [];
      getters.hisJxcDatas.forEach(function (itemData) {
        if (itemData.oil === item['加油站名称']) {
          datas = itemData.data;
        }
      });
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["l" /* checkAllData */])(item, datas)) {
        newData.push(item);
      }
    });
    dispatch('setErrorHisJxcDatas', newData);
  },
  hlErrorHisJxcDatas: function hlErrorHisJxcDatas(_ref6) {
    var dispatch = _ref6.dispatch;

    dispatch('setErrorHisJxcDatas', []);
  },
  checkHisJxcData: function checkHisJxcData(_ref7) {
    var commit = _ref7.commit,
        getters = _ref7.getters,
        dispatch = _ref7.dispatch;

    // 数据校验
    setTimeout(function () {
      var errorData = [];
      getters.hisJxcDatas.forEach(function (itemData) {
        itemData.data.forEach(function (itemD) {
          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["l" /* checkAllData */])(itemD, itemData.data)) {
            errorData.push(itemD);
          }
        });
      });
      dispatch('setErrorHisJxcDatas', errorData);
    }, 200);
  },
  dealDatasToHisJxcDatas: function dealDatasToHisJxcDatas(_ref8, data) {
    var dispatch = _ref8.dispatch;

    var dealData = {};
    var allAreas = [];
    data.forEach(function (item) {
      if (allAreas.indexOf(item['区域']) === -1) {
        allAreas.push(item['区域']);
      }
      if (!dealData[item['加油站名称']]) {
        dealData[item['加油站名称']] = [];
      }
      dealData[item['加油站名称']].push(item);
    });
    dispatch('setAllAreas', allAreas);
    var delPData = [];
    // let oilStations = []
    for (var key in dealData) {
      // oilStations.push(key)
      var newPData = dealData[key].sort(function (a, b) {
        return a['油品名称'] > b['油品名称'];
      });
      var oneOil = { 'oil': key, data: newPData };
      delPData.push(oneOil);
    }
    // dispatch('setHisGasList', oilStations)
    dispatch('setHisJxcDatas', delPData);
  },
  setHisGasList: function setHisGasList(_ref9, data) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch,
        getters = _ref9.getters;

    commit('setHisGasList', data);
    if (!getters.selectHisGas && data.length > 0) {
      dispatch('setSelectHisGas', data[0]);
    }
  },
  setSelectHisGas: function setSelectHisGas(_ref10, data) {
    var commit = _ref10.commit;

    commit('setSelectHisGas', data);
  },
  setHisJxcDatas: function setHisJxcDatas(_ref11, data) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;

    commit('setHisJxcDatas', data);
    dispatch('checkHisJxcData');
  },
  setErrorHisJxcDatas: function setErrorHisJxcDatas(_ref12, data) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;

    commit('setErrorHisJxcDatas', data);
    if (data.length === 0) {
      dispatch('setFlowStatus', 20);
    }
  }
};

var mutations = {
  setAllAreas: function setAllAreas(state, data) {
    state.allAreas = data;
  },
  setAreaHisJxcDatas: function setAreaHisJxcDatas(state, data) {
    state.areaHisJxcDatas = data;
  },
  setHisGasList: function setHisGasList(state, data) {
    state.hisGasList = data;
  },
  setSelectHisGas: function setSelectHisGas(state, data) {
    state.selectHisGas = data;
  },
  setHisJxcDatas: function setHisJxcDatas(state, data) {
    state.hisJxcDatas = data;
  },
  setErrorHisJxcDatas: function setErrorHisJxcDatas(state, data) {
    state.errorHisJxcDatas = data;
  },
  editOneHisJxcData: function editOneHisJxcData(state, data) {
    state.hisJxcDatas.forEach(function (item) {
      if (item.oil === data.data['加油站名称']) {
        item.data.forEach(function (itemD) {
          if ((itemD['加油站名称'] === data.data['加油站名称'] || itemD['油品名称'].label === data.data['油品名称']) && itemD['日期'] === data.data['日期'] && itemD['罐号'] === data.data['罐号']) {
            itemD[data.key] = data.value;
            goUpdateInvoicingData(data);
          }
        });
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_oli_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cllib__ = __webpack_require__(19);
// 数据导入




var state = {
  // 需要导入当日进销存数据，今天的运送计划，油库指标量
  // 每导入成功一个加1 到3的时候导入完成
  inputJxcOk: false,
  inputOrderPlantOk: false,
  inputDepotValumeOk: false,
  inputToGoodsOk: false,
  toGoodsErrorData: [],
  toGoodsCount: []
};

var getters = {
  toGoodsCount: function toGoodsCount(state) {
    return state.toGoodsCount;
  },
  toGoodsErrorData: function toGoodsErrorData(state) {
    return state.toGoodsErrorData;
  },
  inputJxcOk: function inputJxcOk(state) {
    return state.inputJxcOk;
  },
  inputOrderPlantOk: function inputOrderPlantOk(state) {
    return state.inputOrderPlantOk;
  },
  inputDepotValumeOk: function inputDepotValumeOk(state) {
    return state.inputDepotValumeOk;
  },
  inputToGoodsOk: function inputToGoodsOk(state) {
    return state.inputToGoodsOk;
  }
};

var dealJxcMap = function dealJxcMap(dataMap) {
  var dataOne = {};
  for (var key in dataMap) {
    if (key.indexOf('L') !== -1) {
      dataOne[key.slice(0, -3)] = Number(dataMap[key]) || 0;
    } else if (key === 'Retail组') {
      dataOne['RETAIL组'] = dataMap[key];
    } else if (key === 'Retail罐号') {
      dataOne['RETAIL罐号'] = dataMap[key];
    } else if (key === 'Retail状态') {
      dataOne['RETAIL状态'] = dataMap[key];
    } else if (key === '进货差值') {
      dataOne[key] = Number(dataMap[key]) || 0;
    } else {
      dataOne[key] = dataMap[key];
    }
  }
  return dataOne;
};

var actions = {
  dealJxcExceldata: function dealJxcExceldata(_ref, _ref2) {
    var commit = _ref.commit,
        getters = _ref.getters,
        dispatch = _ref.dispatch;
    var excelFile = _ref2.excelFile,
        fileId = _ref2.fileId,
        date = _ref2.date;

    var sheets = [{
      needDataKeys: ['区域', '单位名称', '加油站名称', '油品名称', '油站代码', '罐号', '油罐状态', '期初库存(L)', '入库升数(L)', '出库升数(L)', '期末库存(L)', '空容(L)', '损溢(L)', '平均销量(L)', '在途计划升数(L)', '配送计划(L)', '物理容积(L)', '停泵库存(L)', '有效容积(L)', '库存时间', '班次', 'Retail罐号', 'Retail状态', '进货差值', '传输状态', '数据来源', '采集时间', '传输时间', 'Retail组']
    }];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cllib__["e" /* readExcelFileData */])({ file: excelFile, sheets: sheets, allsheets: true, type: 'row_object_array' }).then(function (data) {
      var allData = [];
      for (var key in data) {
        data[key].forEach(function (item) {
          item['日期'] = date || getters.yesterDayStr;
          var newMap = dealJxcMap(item);
          allData.push(newMap);
        });
      }
      dispatch('inputJxcData', allData);
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '导入文件解析失败',
        message: '请检查文件格式是否符合导入规则'
      });
      document.getElementById(fileId).value = '';
    });
  },
  inputJxcData: function inputJxcData(_ref3, allData) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    dispatch('showNoticeMsg', {
      type: 'success',
      title: '系统提示',
      message: '传输数据到服务器！'
    });
    dispatch('setLoading', true);
    dispatch('setLoadingText', '导入数据中');
    dispatch('setPercentage', { 'start': 0, 'next': 100 });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["n" /* inputData */])(allData).then(function (data) {
      dispatch('getInsertJxcDataStatus');
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '系统提示',
        message: '数据传输至服务器失败,请联系管理员'
      });
    });
  },
  getInsertJxcDataStatus: function getInsertJxcDataStatus(_ref4, data) {
    var dispatch = _ref4.dispatch;

    setTimeout(function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["j" /* getStatus */])({ key: 'inputData' }).then(function (data) {
        var inputStatus = data.data;
        if (inputStatus === 'doing') {
          dispatch('getInsertJxcDataStatus');
        } else {
          dispatch('loadInputData');
          dispatch('setLoadingText', '数据导入完成');
          dispatch('setPercentage', { 'start': 100, 'next': 100 });
        }
      });
    }, 5000);
  },
  inputDepotValume: function inputDepotValume(_ref5, _ref6) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        getters = _ref5.getters;
    var excelFile = _ref6.excelFile,
        fileId = _ref6.fileId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cllib__["e" /* readExcelFileData */])({ file: excelFile, allsheets: true, type: 'csv' }).then(function (data) {
      var needData = '';
      for (var key in data) {
        if (!needData) {
          needData = key;
        }
      }
      var newData = [{
        '油库代码': '33450015',
        '油品': '92号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][12][5])
      }, {
        '油库代码': '33450015',
        '油品': '95号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][13][5])
      }, {
        '油库代码': '33450015',
        '油品': '98号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][14][5])
      }, {
        '油库代码': '33450015',
        '油品': '0号车用柴油(Ⅴ)',
        '指标量': Number(data[needData][17][5])
      }, {
        '油库代码': '33450016',
        '油品': '92号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][18][5])
      }, {
        '油库代码': '33450016',
        '油品': '95号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][19][5])
      }, {
        '油库代码': '33450016',
        '油品': '98号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][20][5])
      }, {
        '油库代码': '33450016',
        '油品': '0号车用柴油(Ⅴ)',
        '指标量': Number(data[needData][23][5])
      }, {
        '油库代码': '36910016',
        '油品': '92号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][94][5])
      }, {
        '油库代码': '36910016',
        '油品': '95号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][95][5])
      }, {
        '油库代码': '36910016',
        '油品': '98号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][96][5])
      }, {
        '油库代码': '36910016',
        '油品': '0号车用柴油(Ⅴ)',
        '指标量': Number(data[needData][99][5])
      }];
      var inputDatas = [];
      newData.forEach(function (item) {
        inputDatas.push({ '油库代码': item['油库代码'], '油品名称': item['油品'], '指标量': item['指标量'], '区域': '昆明', '日期': getters.todayStr });
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["h" /* depotValume */])({ action: 'add_depot_valume', data: inputDatas }).then(function (data) {
        if (data['code'] !== '-1') {
          dispatch('setInputDepotValumeOk');
        } else {
          throw new Error('error');
        }
      }).catch(function (e) {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '数据传输至服务器失败,请联系管理员'
        });
      });
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '导入文件解析失败',
        message: '请检查文件格式是否符合导入规则'
      });
      document.getElementById(fileId).value = '';
      console.log(e);
    });
  },
  inputOlderPlan: function inputOlderPlan(_ref7, _ref8) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch,
        getters = _ref7.getters;
    var excelFile = _ref8.excelFile,
        fileId = _ref8.fileId,
        date = _ref8.date,
        realData = _ref8.realData;

    var sheets = [{
      needDataKeys: ['车辆', '灌号', '油品名称', '配送升数', 'ERP出库时间', '发站代码', '到站代码', '配送升数ERP', 'ERP单号', '趟', '隔舱']
    }];
    date = date || getters.todayStr;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cllib__["e" /* readExcelFileData */])({ file: excelFile, sheets: sheets, allsheets: true, type: 'row_object_array' }).then(function (data) {
      var allData = [];
      for (var key in data) {
        data[key].forEach(function (item) {
          item['时间'] = date;
          allData.push(item);
        });
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["i" /* orderPlant */])({ action: realData === 2 ? 'input_data_pssj' : realData ? 'input_data_real' : 'input_data', data: { data: allData, date: date } }).then(function (data) {
        if (data['code'] !== '-1') {
          dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '导入配送计划成功'
          });
          dispatch('setInputOrderPlantOk');
        } else {
          throw new Error('error');
        }
      });
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '导入文件解析失败',
        message: '请检查文件格式是否符合导入规则'
      });
      document.getElementById(fileId).value = '';
      console.log(e);
    });
  },
  inputToGoods: function inputToGoods(_ref9, _ref10) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch,
        getters = _ref9.getters;
    var excelFile = _ref10.excelFile,
        fileId = _ref10.fileId;

    dispatch('setToGoodsErrorData', []);
    dispatch('setToGoodsCount', []);
    var sheets = [{
      needDataKeys: ['加油站代码', '92#', '95#', '98#', '0#', '备注']
    }];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cllib__["e" /* readExcelFileData */])({ file: excelFile, sheets: sheets, allsheets: true, type: 'row_object_array' }).then(function (data) {
      var allData = [];
      for (var key in data) {
        data[key].forEach(function (item) {
          item['日期'] = getters.todayStr;
          allData.push(item);
        });
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["i" /* orderPlant */])({ action: 'input_to_goods_data', data: allData }).then(function (data) {
        if (data['code'] !== '-1') {
          if (data['errorData'] && data['errorData'].length > 0) {
            dispatch('showNoticeMsg', {
              type: 'error',
              title: '系统提示',
              message: '导入要货数据异常'
            });
            dispatch('setToGoodsErrorData', data['errorData']);
            document.getElementById(fileId).value = '';
          } else {
            dispatch('setToGoodsCount', data['count']);
            dispatch('setInputToGoodsOk');
          }
        } else {
          throw new Error('error');
        }
      }).catch(function (e) {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '导入文件失败',
          message: '请联系管理员'
        });
        document.getElementById(fileId).value = '';
      });
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '导入文件解析失败',
        message: '请检查文件格式是否符合导入规则'
      });
      document.getElementById(fileId).value = '';
      console.log(e);
    });
  },
  inputCarData: function inputCarData(_ref11, _ref12) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch,
        getters = _ref11.getters;
    var excelFile = _ref12.excelFile,
        fileId = _ref12.fileId;

    var sheets = [{
      needDataKeys: ['配送中心', '承运商', '车牌号', '挂车牌号', '车辆轴数', '核定载质量', '道路运输证准运油品', '电子运单装载油品', '合计', '前仓', '中仓', '后仓', '停车点']
    }];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cllib__["e" /* readExcelFileData */])({ file: excelFile, sheets: sheets, allsheets: true, type: 'row_object_array' }).then(function (data) {
      var allData = [];
      for (var key in data) {
        data[key].forEach(function (item) {
          allData.push(item);
        });
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["i" /* orderPlant */])({ action: 'input_data', data: allData }).then(function (data) {
        if (data['code'] !== '-1') {
          dispatch('setInputOrderPlantOk');
        } else {
          throw new Error('error');
        }
      });
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '导入文件解析失败',
        message: '请检查文件格式是否符合导入规则'
      });
      document.getElementById(fileId).value = '';
      console.log(e);
    });
  },
  checkInputStatus: function checkInputStatus(_ref13) {
    var dispatch = _ref13.dispatch,
        getters = _ref13.getters;

    if (getters.inputJxcOk && getters.inputOrderPlantOk && getters.inputDepotValumeOk) {
      dispatch('setFlowStatus', 10);
    }
  },
  setInputJxcOk: function setInputJxcOk(_ref14) {
    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;

    commit('setInputJxcOk', true);
    dispatch('checkInputStatus');
  },
  setInputToGoodsOk: function setInputToGoodsOk(_ref15) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    commit('setInputToGoodsOk', true);
  },
  setInputOrderPlantOk: function setInputOrderPlantOk(_ref16) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    commit('setInputOrderPlantOk', true);
    dispatch('checkInputStatus');
  },
  setInputDepotValumeOk: function setInputDepotValumeOk(_ref17) {
    var commit = _ref17.commit,
        dispatch = _ref17.dispatch;

    commit('setInputDepotValumeOk', true);
    dispatch('checkInputStatus');
  },
  setToGoodsErrorData: function setToGoodsErrorData(_ref18, data) {
    var commit = _ref18.commit;

    commit('setToGoodsErrorData', data);
  },
  setToGoodsCount: function setToGoodsCount(_ref19, data) {
    var commit = _ref19.commit;

    commit('setToGoodsCount', data);
  }
};

var mutations = {
  setToGoodsCount: function setToGoodsCount(state, data) {
    state.toGoodsCount = data;
  },
  setToGoodsErrorData: function setToGoodsErrorData(state, data) {
    state.toGoodsErrorData = data;
  },
  setInputJxcOk: function setInputJxcOk(state, data) {
    state.inputJxcOk = data;
  },
  setInputOrderPlantOk: function setInputOrderPlantOk(state, data) {
    state.inputOrderPlantOk = data;
  },
  setInputToGoodsOk: function setInputToGoodsOk(state, data) {
    state.inputToGoodsOk = data;
  },
  setInputDepotValumeOk: function setInputDepotValumeOk(state, data) {
    state.inputDepotValumeOk = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_oli_api__ = __webpack_require__(13);


var state = {
  hxDate: '',
  allPs: false,
  waitHxList: [],
  canHxPsjhList: [],
  hxJxc: null,
  loadingHxJxc: false,
  loadingCanHxPsjh: false,
  loadingSysHx: false,
  loadingUserHx: false
};

var getters = {
  loadingHxJxc: function loadingHxJxc(state) {
    return state.loadingHxJxc;
  },
  loadingCanHxPsjh: function loadingCanHxPsjh(state) {
    return state.loadingCanHxPsjh;
  },
  loadingSysHx: function loadingSysHx(state) {
    return state.loadingSysHx;
  },
  loadingUserHx: function loadingUserHx(state) {
    return state.loadingUserHx;
  },
  hxJxc: function hxJxc(state) {
    return state.hxJxc;
  },
  hxDate: function hxDate(state) {
    return state.hxDate;
  },
  allPs: function allPs(state) {
    return state.allPs;
  },
  waitHxList: function waitHxList(state) {
    return state.waitHxList;
  },
  canHxPsjhList: function canHxPsjhList(state) {
    return state.canHxPsjhList;
  }
};

var actions = {
  loadWaitHx: function loadWaitHx(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        getters = _ref.getters;

    commit('setLoadingHxJxc', true);
    dispatch('setWaitHxList', []);
    // 获取未核销数据
    var parm = {
      action: 'get_whx_jxc',
      data: {
        date: getters.hxDate,
        allPs: getters.allPs ? 1 : 0
      }
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["g" /* inputAllData */])(parm).then(function (data) {
      data.forEach(function (item) {
        item['核销状态'] = item['核销'] ? '完成' : '待核销';
      });
      dispatch('setWaitHxList', data);
      commit('setLoadingHxJxc', false);
    });
  },
  sysHxjxc: function sysHxjxc(_ref2, data) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        getters = _ref2.getters;

    if (getters.loadingSysHx) {
      return;
    }
    commit('setLoadingSysHxh', true);
    // 系统核销
    var parm = {
      action: 'hexiao_jxc',
      data: {
        date: getters.hxDate,
        allPs: getters.allPs ? 1 : 0
      }
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["g" /* inputAllData */])(parm).then(function (data) {
      dispatch('showNoticeMsg', {
        type: 'success',
        title: '系统提示',
        message: '该日数据已核销！'
      });
      commit('setLoadingSysHxh', false);
      dispatch('loadWaitHx');
    });
  },
  userHxjxc: function userHxjxc(_ref3, data) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        getters = _ref3.getters;

    if (getters.loadingUserHx) {
      return;
    }
    commit('setLoadingUserHx', true);
    // 手动核销
    var parm = {
      action: 'user_hexiao_jxc',
      data: {
        jxc: getters.hxJxc,
        psjh: data
      }
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["g" /* inputAllData */])(parm).then(function (data) {
      commit('setLoadingUserHx', false);
      dispatch('loadWaitHx');
    });
  },
  getCanHxPsjhList: function getCanHxPsjhList(_ref4) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        getters = _ref4.getters;

    commit('setLoadingCanHxPsjh', true);
    dispatch('setCanHxPsjhList', []);
    // 获取可用核销配送计划
    var parm = {
      action: 'get_canhx_psjh',
      data: {
        date: getters.hxDate,
        jxc: getters.hxJxc
      }
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["g" /* inputAllData */])(parm).then(function (data) {
      dispatch('setCanHxPsjhList', data);
      commit('setLoadingCanHxPsjh', false);
    });
  },
  setHxDate: function setHxDate(_ref5, data) {
    var commit = _ref5.commit;

    commit('setHxDate', data);
  },
  setUserHxJxc: function setUserHxJxc(_ref6, data) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    commit('setUserHxJxc', data);
  },
  setAllPs: function setAllPs(_ref7, data) {
    var commit = _ref7.commit;

    commit('setAllPs', data);
  },
  setWaitHxList: function setWaitHxList(_ref8, data) {
    var commit = _ref8.commit;

    commit('setWaitHxList', data);
  },
  setCanHxPsjhList: function setCanHxPsjhList(_ref9, data) {
    var commit = _ref9.commit;

    commit('setCanHxPsjhList', data);
  }
};

var mutations = {
  setLoadingUserHx: function setLoadingUserHx(state, data) {
    state.loadingUserHx = data;
  },
  setLoadingHxJxc: function setLoadingHxJxc(state, data) {
    state.loadingHxJxc = data;
  },
  setLoadingCanHxPsjh: function setLoadingCanHxPsjh(state, data) {
    state.loadingCanHxPsjh = data;
  },
  setLoadingSysHxh: function setLoadingSysHxh(state, data) {
    state.loadingSysHx = data;
  },
  setUserHxJxc: function setUserHxJxc(state, data) {
    state.hxJxc = data;
  },
  setHxDate: function setHxDate(state, data) {
    state.hxDate = data;
  },
  setAllPs: function setAllPs(state, data) {
    state.allPs = data;
  },
  setWaitHxList: function setWaitHxList(state, data) {
    state.waitHxList = data;
  },
  setCanHxPsjhList: function setCanHxPsjhList(state, data) {
    state.canHxPsjhList = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_oli_api__ = __webpack_require__(13);


var state = {
  opdOilCode: null,
  opdLoading: false,
  oilHisJxcDatas: [],
  opdOilDetail: {
    map: {},
    orderList: {}
  }
};

var getters = {
  opdOilCode: function opdOilCode(state) {
    return state.opdOilCode;
  },
  opdOilDetail: function opdOilDetail(state) {
    return state.opdOilDetail;
  },
  opdLoading: function opdLoading(state) {
    return state.opdLoading;
  },
  oilHisJxcDatas: function oilHisJxcDatas(state) {
    return state.oilHisJxcDatas;
  }
};

var actions = {
  setOpdOilCode: function setOpdOilCode(_ref, data) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        getters = _ref.getters;

    commit('setOpdOilCode', data);
    dispatch('filtOilHisJxcDatas', data);
    if (getters.opdLoading) {
      return;
    }
    dispatch('setOilDetail', {
      map: {},
      orderList: {}
    });
    if (data) {
      commit('setOpdLoading', true);
      var parm = {
        action: 'get_oil_ps_detail',
        data: {
          oil_code: data
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["i" /* orderPlant */])(parm).then(function (data) {
        if (data.code === '-1') {
          commit('setOpdLoading', false);
          return;
        }
        dispatch('setOilDetail', { map: data['oilDetail'] || {}, orderList: data['orderList'] || {} });
        commit('setOpdLoading', false);
      }).catch(function (e) {
        commit('setOpdLoading', false);
      });
    }
  },
  filtOilHisJxcDatas: function filtOilHisJxcDatas(_ref2, data) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    if (!data) {
      return;
    }
    var datas = [];
    getters.hisJxcDatas.forEach(function (itemA) {
      itemA.data.forEach(function (item) {
        if (item['油站代码'] === data) {
          datas.push(item);
        }
      });
    });
    commit('setOilHisJxcDatas', datas);
  },
  setOilDetail: function setOilDetail(_ref3, data) {
    var commit = _ref3.commit;

    commit('setOpdOilDetail', data);
  },
  setOpdLoading: function setOpdLoading(_ref4, data) {
    var commit = _ref4.commit;

    commit('setOpdLoading', data);
  }
};

var mutations = {
  setOilHisJxcDatas: function setOilHisJxcDatas(state, data) {
    state.oilHisJxcDatas = data;
  },
  setOpdOilCode: function setOpdOilCode(state, data) {
    state.opdOilCode = data;
  },
  setOpdOilDetail: function setOpdOilDetail(state, data) {
    state.opdOilDetail = data;
  },
  setOpdLoading: function setOpdLoading(state, data) {
    state.opdLoading = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_oli_api__ = __webpack_require__(13);



// 进销存预测
var state = {
  predictionDatas: [],
  // 小罐多销
  predictionDatasXD: [],
  // 小罐每日订单
  predictionDatasDay: [],
  selectPredictionGas: null,
  predictionGasList: []
};

var getters = {
  predictionDatas: function predictionDatas(state) {
    return state.predictionDatas;
  },
  predictionDatasXD: function predictionDatasXD(state) {
    return state.predictionDatasXD;
  },
  predictionDatasDay: function predictionDatasDay(state) {
    return state.predictionDatasDay;
  },
  selectPredictionGas: function selectPredictionGas(state) {
    return state.selectPredictionGas;
  },
  predictionGasList: function predictionGasList(state) {
    return state.predictionGasList;
  }
};

var actions = {
  prediction: function prediction(_ref, data) {
    var dispatch = _ref.dispatch;

    dispatch('setLoading', true);
    dispatch('setLoadingText', '分析预测中');
    dispatch('setPercentage', { 'start': 0, 'next': 100 });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["m" /* predictionData */])().then(function (data) {
      if (data.code === 1) {
        dispatch('getPredictionStatus');
        return;
      }
      dispatch('dealPredictionData', data);
      dispatch('setFlowStatus', 30);
      dispatch('setLoadingText', '分析预测完成');
      dispatch('setPercentage', { 'start': 100, 'next': 100 });
    });
  },
  dealPredictionData: function dealPredictionData(_ref2, data) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        getters = _ref2.getters;

    var preData = {
      jcxDatas: {},
      dayOrder: [],
      xgdx: []
    };
    data.forEach(function (item) {
      item.sub = (item['有效容积'] - item['平均销量']).toFixed(2);
      item['消耗率'] = (item['平均销量'] / 24).toFixed(2);
      if (typeof preData['jcxDatas'][item['加油站名称']] === 'undefined') {
        preData['jcxDatas'][item['加油站名称']] = [];
      }
      preData['jcxDatas'][item['加油站名称']].push(item);
      if (item['订单紧急程度'] !== '库存充足订单' && item['时间'] === getters.todayStr) {
        preData['dayOrder'].push(item);
      }
      if (item['小罐多销'] === 1) {
        preData['xgdx'].push(item);
      }
    });
    var pData = preData['jcxDatas'];
    var delPData = [];
    var oilStations = [];
    for (var key in pData) {
      oilStations.push(key);
      var sData = pData[key].sort(function (a, b) {
        return a['代号'] > b['代号'];
      });
      delPData.push({ 'oil': key, data: sData });
    }
    dispatch('setPredictionGasList', oilStations);
    dispatch('setPredictionDatas', delPData);
    dispatch('setPredictionDatasXD', preData['xgdx']);
    dispatch('setPredictionDatasDay', preData['dayOrder']);
  },
  getPredictionStatus: function getPredictionStatus(_ref3, data) {
    var dispatch = _ref3.dispatch;

    setTimeout(function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["j" /* getStatus */])({ key: 'prediction' }).then(function (data) {
        var pStatus = data.data;
        if (pStatus === 'doing') {
          dispatch('getPredictionStatus');
        } else if (pStatus === 'idle') {
          dispatch('prediction');
        }
      });
    }, 5000);
  },
  setPredictionDatas: function setPredictionDatas(_ref4, data) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        getters = _ref4.getters;

    // 设置预测数据
    var newData = [];
    var gasLocation = getters.gasLocation;
    data.forEach(function (item) {
      if (gasLocation && gasLocation[item.oil]) {
        newData.push({
          name: item.oil,
          value: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(gasLocation[item.oil]))
        });
      }
    });
    dispatch('setAllMapOil', newData);
    commit('setPredictionDatas', data);
  },
  setPredictionDatasXD: function setPredictionDatasXD(_ref5, data) {
    var commit = _ref5.commit;

    commit('setPredictionDatasXD', data);
  },
  setPredictionDatasDay: function setPredictionDatasDay(_ref6, data) {
    var commit = _ref6.commit;

    commit('setPredictionDatasDay', data);
  },
  setSelectPredictionGas: function setSelectPredictionGas(_ref7, data) {
    var commit = _ref7.commit;

    commit('setSelectPredictionGas', data);
  },
  setPredictionGasList: function setPredictionGasList(_ref8, data) {
    var commit = _ref8.commit,
        getters = _ref8.getters,
        dispatch = _ref8.dispatch;

    commit('setPredictionGasList', data);
    if (!getters.selectPredictionGas && data.length) {
      dispatch('setSelectPredictionGas', data[0]);
    }
  }
};

var mutations = {
  setPredictionDatas: function setPredictionDatas(state, data) {
    state.predictionDatas = data;
  },
  setPredictionDatasXD: function setPredictionDatasXD(state, data) {
    state.predictionDatasXD = data;
  },
  setPredictionDatasDay: function setPredictionDatasDay(state, data) {
    state.predictionDatasDay = data;
  },
  setSelectPredictionGas: function setSelectPredictionGas(state, data) {
    state.selectPredictionGas = data;
  },
  setPredictionGasList: function setPredictionGasList(state, data) {
    state.predictionGasList = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_oli_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cllib__ = __webpack_require__(19);




// 运单分配

var oilType = {
  '0': '60205886',
  '92': '60206059',
  '95': '60206060',
  '98': '60209058'
};

var state = {
  orderCar: [],
  orderGas: [],
  canChooseCars: [],
  orderTj: []
};

var getters = {
  orderCar: function orderCar(state) {
    return state.orderCar;
  },
  orderGas: function orderGas(state) {
    return state.orderGas;
  },
  canChooseCars: function canChooseCars(state) {
    return state.canChooseCars;
  },
  orderTj: function orderTj(state) {
    return state.orderTj;
  }
};

var getTime = function getTime(order, num) {
  num = num || 7000;
  var heNum = 0;
  JSON.parse(order[8]).forEach(function (item) {
    heNum += item;
  });
  var hour = (heNum - order[5]) / num;
  var day = hour > 0 ? hour > 23 ? '15' : '14' : '13';
  if (hour < 0) {
    hour = 24 + hour;
  }
  var hourNum = parseInt(hour);
  var min = (hour - hourNum) * 60;
  var minNum = parseInt(min);
  return '09-' + day + ' ' + (hourNum % 24 < 10 ? '0' + hourNum % 24 : hourNum % 24) + ':' + (minNum < 10 ? '0' + minNum : minNum);
};

var actions = {
  getAssignStatus: function getAssignStatus(_ref) {
    var dispatch = _ref.dispatch;

    setTimeout(function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["j" /* getStatus */])({ key: 'assign_order' }).then(function (data) {
        var inputStatus = Number(data.data);
        if (inputStatus === 1) {
          dispatch('getAssignStatus');
        } else if (inputStatus === 0) {
          dispatch('assignCarOrder2');
        } else if (inputStatus === -1) {
          dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '订单分配失败，请联系管理员！'
          });
          dispatch('setPercentage', { 'start': 100, 'next': 100 });
        }
      });
    }, 5000);
  },
  assignCarOrder: function assignCarOrder(_ref2, data) {
    var dispatch = _ref2.dispatch,
        getters = _ref2.getters;

    if (data) {
      dispatch('setLoading', true);
      dispatch('setLoadingText', '匹配车辆中');
      dispatch('setPercentage', { 'start': 0, 'next': 100 });
    }
    dispatch('assignCarOrder2', data);
  },
  assignCarOrder2: function assignCarOrder2(_ref3, data) {
    var dispatch = _ref3.dispatch,
        getters = _ref3.getters;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["k" /* assignOrder */])({ 'sys_pipei': data ? 1 : 0 }).then(function (data) {
      if (data.msg === 'jx') {
        dispatch('getAssignStatus');
        return;
      }
      if (data.msg === 'nocar') {
        dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '无可用车辆，请先签到！'
        });
        dispatch('setPercentage', { 'start': 100, 'next': 100 });
        return;
      }
      var stations = [];
      var cars = [];
      data.forEach(function (item) {
        item['在途时间'] = Number(item['在途时间']).toFixed(2);
        stations.push(item);
        cars.push(item);
      });
      dispatch('setOrderGas', stations);
      dispatch('setOrderCar', cars);
      dispatch('setFlowStatus', 40);
      dispatch('setLoadingText', '匹配车辆完成');
      dispatch('setPercentage', { 'start': 100, 'next': 100 });
    }).catch(function (e) {
      console.log(e);
      dispatch('setPercentage', { 'start': 100, 'next': 100 });
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '系统提示',
        message: '订单分配失败，请联系管理员！'
      });
    });
  },
  outputPsDatas: function outputPsDatas(_ref4, data) {
    var getters = _ref4.getters,
        dispatch = _ref4.dispatch;

    var datas = [{
      data: [],
      sheetName: 'data1'
    }];
    var row1 = ['配送日期', '车牌号', '隔仓号', '到站代码', '到站名称', '罐号', '油品代码', '油品名称', '升数 （升）', '数量（公斤）', '油库代码', '油库名称', '趟', '次', '班次', '驾驶员代码', '驾驶员姓名', '送达时间', '进销货标识', '配送类型', '进货类型'];
    datas[0].data.push(row1);
    getters.orderCar.forEach(function (item) {
      var need = false;
      data.oilType.forEach(function (itemOilType) {
        if (item['油品名称'].includes(itemOilType)) {
          need = true;
        }
      });
      if (need) {
        var psDate = item['预计发车时间'] ? item['时间'].slice(0, 5) + item['预计发车时间'].slice(0, 5) : __WEBPACK_IMPORTED_MODULE_2__cllib__["g" /* dateOperating */].computeDay({ date: new Date(), days: 1, format: 'yy-mm-dd' });
        psDate = psDate.split('-')[0] + '/' + Number(psDate.split('-')[1]) + '/' + Number(psDate.split('-')[2]);
        var gch = item['隔仓号'] || 1;
        var ypdm = oilType[item['油品名称'].split('号')[0]] || '';
        var tang = item['趟次'] || 1;
        datas[0].data.push([psDate, item['车牌号'], gch, item['油站代码'], item['加油站名称'], item['罐号'], ypdm, item['油品名称'], item['配送升数'], '', item['油库代码'], item['油库名称'], tang, 1, 1, '66', '', psDate, '', '', '']);
      }
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cllib__["a" /* outPutExcelFile */])(datas, '每日订单' + getters.todayStr + '.xls');
    if (data.clear) {
      dispatch('setOrderCar', []);
    }
  },
  getOrderCars: function getOrderCars(_ref5) {
    var dispatch = _ref5.dispatch,
        getters = _ref5.getters;

    dispatch('setOrderCar', []);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["l" /* getCarOrder */])().then(function (data) {
      if (!data || data.length === 0) {
        dispatch('showNoticeMsg', {
          type: 'info',
          title: '系统提示',
          message: '无配送单！'
        });
        return;
      }
      var allData = [];
      data.forEach(function (item) {
        item['在途时间'] = Number(item['在途时间']).toFixed(2);
        allData.push(item);
      });
      dispatch('setOrderCar', allData);
    }).catch(function (e) {
      console.log(e);
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '系统提示',
        message: '获取配送单失败，请联系管理员！'
      });
    });
  },
  getTjData: function getTjData(_ref6, data) {
    var dispatch = _ref6.dispatch,
        getters = _ref6.getters;

    dispatch('setOrderTj', []);
    var parm = {
      action: 'get_depot_pstj',
      data: data
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["c" /* depot */])(parm).then(function (data) {
      dispatch('setOrderTj', data || []);
    }).catch(function (e) {
      console.log(e);
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '系统提示',
        message: '获取配送单失败，请联系管理员！'
      });
    });
  },
  loadCanChooseCars: function loadCanChooseCars(_ref7, data) {
    var dispatch = _ref7.dispatch;

    var parm = {
      action: 'get_cars',
      data: {
        '配送中心': '昆配',
        '车辆轴数': ''
      }
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["e" /* car */])(parm).then(function (data) {
      var newData = [];
      data.forEach(function (item) {
        var changeed = Number(item['更改油品']) === 1;
        var oneData = ['昆明', item['车牌号'], Number(changeed ? item['合计_G'] : item['合计']) || '', 0, Number(item['前仓']) || '', Number(changeed ? item['中仓_G'] : item['中仓']) || '', Number(changeed ? item['后仓_G'] : item['后仓']) || '', ''];
        oneData[3] = (oneData[4] ? 1 : 0) + (oneData[5] ? 1 : 0) + (oneData[6] ? 1 : 0);
        newData.push(oneData);
      });
      dispatch('setCanChooseCars', newData);
    });
  },
  setOrderTj: function setOrderTj(_ref8, data) {
    var commit = _ref8.commit;

    commit('setOrderTj', data);
  },
  setOrderCar: function setOrderCar(_ref9, data) {
    var commit = _ref9.commit;

    var newData = [];
    var cars = {};
    data.forEach(function (item) {
      cars[item['车牌号']] = cars[item['车牌号']] || [];
      cars[item['车牌号']].push(item);
    });
    for (var key in cars) {
      cars[key].forEach(function (item) {
        newData.push(item);
      });
    }
    commit('setOrderCar', newData);
  },
  setOrderGas: function setOrderGas(_ref10, data) {
    var commit = _ref10.commit,
        getters = _ref10.getters,
        dispatch = _ref10.dispatch;

    var newData = [];
    var day = getters.todayStr;
    var newData2 = [];
    data.forEach(function (item) {
      var oilName = item['加油站名称'];
      var itemDay = item['时间'];
      if (itemDay === day) {
        newData2.push(item);
        var allGasLocation = getters.gasLocation;
        var stationName = allGasLocation[oilName] ? allGasLocation[oilName][2] : '';
        if (stationName !== '' && stationName !== '') {
          var allDepotLocation = getters.depotLocation;
          var oilLocation = allGasLocation[oilName] ? [allGasLocation[oilName][0], allGasLocation[oilName][1]] : [];
          var stationLocation = allDepotLocation[allGasLocation[oilName][2]] ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(allDepotLocation[allGasLocation[oilName][2]])) : [];
          if (oilLocation.length > 0 && stationLocation.length > 0) {
            newData.push({
              name: item['油库名称'],
              data: [{
                fromName: stationName,
                toName: oilName,
                coords: [stationLocation, oilLocation],
                info: item
              }]
            });
          } else {
            console.log(stationName);
          }
        }
      }
    });
    dispatch('setAllMapOneRoute', newData);
    commit('setOrderGas', data);
  },
  editOrderCar: function editOrderCar(_ref11, data) {
    var commit = _ref11.commit;

    // 修改订单车辆
    commit('editOrderCar', data);
  },
  editOrderDepot: function editOrderDepot(_ref12, data) {
    var commit = _ref12.commit;

    // 修改订单油库
    commit('editOrderDepot', data);
  },
  setCanChooseCars: function setCanChooseCars(_ref13, data) {
    var commit = _ref13.commit;

    commit('setCanChooseCars', data);
  }
};

var mutations = {
  editOrderDepot: function editOrderDepot(state, _ref14) {
    var index = _ref14.index,
        station = _ref14.station;

    var order = state.orderGas[index];
    order['油库名称'] = station;
    var data = [];
    state.orderGas.forEach(function (item) {
      data.push(item);
    });
    state.orderGas = data;
  },
  editOrderCar: function editOrderCar(state, _ref15) {
    var index = _ref15.index,
        carId = _ref15.carId;

    var order = state.orderGas[index];
    order['车牌号'] = carId;
    var data = [];
    state.orderGas.forEach(function (item) {
      data.push(item);
    });
    state.orderGas = data;
  },
  setOrderTj: function setOrderTj(state, data) {
    state.orderTj = data;
  },
  setCanChooseCars: function setCanChooseCars(state, data) {
    state.canChooseCars = data;
  },
  setOrderCar: function setOrderCar(state, data) {
    state.orderCar = data;
  },
  setOrderGas: function setOrderGas(state, data) {
    state.orderGas = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_local_storage__ = __webpack_require__(52);


var state = {
  groups_num: 10,
  max_customers_num: 15,
  group_time_limit: 30,
  group_mip_gap: 0.01,
  route_time_limit: 30,
  route_mip_gap: 0.01,
  solution_day: null,
  solution_way: 0,
  parm: [['群组数', 10], ['每个群组最大客户数', 15], ['分配群组模型的TimeLimit', 30], ['分配群组模型的MIPGap', 0.01], ['分配路线模型的TimeLimit', 30], ['分配路线模型的MIPGap', 0.01]],
  solution_weeks: ['星期天', '星期一', '星期二', '星期三', '星期四'],
  solution_ways: ['cbc', 'gurobi']
};

var getters = {
  parm: function parm(state) {
    return state.parm;
  },
  groupsNum: function groupsNum(state) {
    return state.groups_num;
  },
  maxCustomersNum: function maxCustomersNum(state) {
    return state.max_customers_num;
  },
  groupTimeLimit: function groupTimeLimit(state) {
    return state.group_time_limit;
  },
  groupMipGap: function groupMipGap(state) {
    return state.group_mip_gap;
  },
  routeTimeLimit: function routeTimeLimit(state) {
    return state.route_time_limit;
  },
  routeMipGap: function routeMipGap(state) {
    return state.route_mip_gap;
  },
  solutionDay: function solutionDay(state) {
    return state.solution_day;
  },
  solutionWay: function solutionWay(state) {
    return state.solution_way;
  },
  solutionWeeks: function solutionWeeks(state) {
    return state.solution_weeks;
  },
  solutionWays: function solutionWays(state) {
    return state.solution_ways;
  }
};

var actions = {
  initParmData: function initParmData(_ref, data) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    var parm = data === 'clear' ? {} : data;
    dispatch('setGroupsNum', parm.groups_num || 10);
    dispatch('setMaxCustomersNum', parm.max_customers_num || 15);
    dispatch('setGroupTimeLimit', parm.group_time_limit || 30);
    dispatch('setGroupMipGap', parm.group_mip_gap || 0.01);
    dispatch('setRouteTimeLimit', parm.route_time_limit || 30);
    dispatch('setRouteMipGap', parm.route_mip_gap || 0.01);
    dispatch('setSolutionDay', parm.solution_day || null);
    dispatch('setSolutionWay', parm.solution_way || 0);
  },
  saveParmData: function saveParmData(_ref2, data) {
    var commit = _ref2.commit;

    commit('saveParmData', data);
  },
  clearParmData: function clearParmData(_ref3, data) {
    var commit = _ref3.commit;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_local_storage__["c" /* delData */])('parm_data' + data);
  },
  setGroupsNum: function setGroupsNum(_ref4, data) {
    var commit = _ref4.commit;

    commit('changeGroupsNum', data);
  },
  setMaxCustomersNum: function setMaxCustomersNum(_ref5, data) {
    var commit = _ref5.commit;

    commit('changeMaxCustomersNum', data);
  },
  setGroupTimeLimit: function setGroupTimeLimit(_ref6, data) {
    var commit = _ref6.commit;

    commit('changeGroupTimeLimit', data);
  },
  setGroupMipGap: function setGroupMipGap(_ref7, data) {
    var commit = _ref7.commit;

    commit('changeGroupMipGap', data);
  },
  setRouteTimeLimit: function setRouteTimeLimit(_ref8, data) {
    var commit = _ref8.commit;

    commit('changeRouteTimeLimit', data);
  },
  setRouteMipGap: function setRouteMipGap(_ref9, data) {
    var commit = _ref9.commit;

    commit('changeRouteMipGap', data);
  },
  setSolutionDay: function setSolutionDay(_ref10, data) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;

    commit('changeSolutionDay', data);
    dispatch('selectMapDataCustomer', data);
  },
  setSolutionWay: function setSolutionWay(_ref11, data) {
    var commit = _ref11.commit;

    commit('changeSolutionWay', data);
  }
};

var mutations = {
  saveParmData: function saveParmData(state, data) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_local_storage__["b" /* saveData */])({ key: 'parm_data' + data, data: state });
  },
  changeGroupsNum: function changeGroupsNum(state, data) {
    state.groups_num = data;
    state.parm[0][1] = data;
  },
  changeMaxCustomersNum: function changeMaxCustomersNum(state, data) {
    state.max_customers_num = data;
    state.parm[1][1] = data;
  },
  changeGroupTimeLimit: function changeGroupTimeLimit(state, data) {
    state.group_time_limit = data;
    state.parm[2][1] = data;
  },
  changeGroupMipGap: function changeGroupMipGap(state, data) {
    state.group_mip_gap = data;
    state.parm[3][1] = data;
  },
  changeRouteTimeLimit: function changeRouteTimeLimit(state, data) {
    state.route_time_limit = data;
    state.parm[4][1] = data;
  },
  changeRouteMipGap: function changeRouteMipGap(state, data) {
    state.route_mip_gap = data;
    state.parm[5][1] = data;
  },
  changeSolutionDay: function changeSolutionDay(state, data) {
    state.solution_day = data;
  },
  changeSolutionWay: function changeSolutionWay(state, data) {
    state.solution_way = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  // 0: start 10:数据导入完成 20:设置参数完成 30: 分配客户完成 40:路线求解完成
  solution_status: 0
};

var getters = {
  solutionStatus: function solutionStatus(state) {
    return state.solution_status;
  }
};

var actions = {
  setSolutionStatus: function setSolutionStatus(_ref, data) {
    var commit = _ref.commit;

    commit('changeSolutionStatus', data);
  }
};

var mutations = {
  changeSolutionStatus: function changeSolutionStatus(state, data) {
    state.solution_status = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_init__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_local_storage__ = __webpack_require__(52);




var state = {
  source_data_field: {
    shop: {
      shop: '城市',
      dry: '干货',
      Fresh: '新鲜货',
      frozen: ' 冰冻货'
    },
    oil: {
      shop: '加油站',
      dry: '0号柴油',
      Fresh: '92号汽油',
      frozen: '95号汽油'
    },
    tobacco: {
      shop: '商店',
      dry: '红塔山',
      Fresh: '玉溪',
      frozen: '云烟'
    }
  },
  source_data_type: 'shop',
  source_data: {},
  order_weight: [],
  order_volume: [],
  order_days: [],
  shop_coordinate: {}
};

var getters = {
  sourceDataField: function sourceDataField(state) {
    return state.source_data_field;
  },
  sourceDataType: function sourceDataType(state) {
    return state.source_data_type;
  },
  sourceData: function sourceData(state) {
    return state.source_data;
  },
  orderWeight: function orderWeight(state) {
    return state.order_weight;
  },
  orderVolume: function orderVolume(state) {
    return state.order_volume;
  },
  orderDays: function orderDays(state) {
    return state.order_days;
  },
  shopCoordinate: function shopCoordinate(state) {
    return state.shop_coordinate;
  }
};

var actions = {
  setSourceDataType: function setSourceDataType(_ref, data) {
    var commit = _ref.commit;

    commit('changeSourceDataType', data);
  },
  editSourceData: function editSourceData(_ref2, data) {
    // commit('editCustomerSourceData', data)
    // dispatch('initCustomerData', getters.sourceData)

    var commit = _ref2.commit,
        getters = _ref2.getters;
  },
  initCustomerData: function initCustomerData(_ref3, data) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        getters = _ref3.getters;

    // 订单重量
    var orderWeight = [];
    // 订单体积
    var orderVolume = [];
    // 客户地图数据
    var mapDataCustomer = [];
    data.Location.forEach(function (item) {
      orderWeight.push({ 'shop': item[0], 'dry': item[3], 'Fresh': item[4], 'frozen': item[5] });
      orderVolume.push({ 'shop': item[0], 'dry': item[6], 'Fresh': item[7], 'frozen': item[8] });
      mapDataCustomer.push({
        'name': item[0],
        'value': [item[1], item[2], { 'dry': item[3], 'fresh': item[4], 'frozen': item[5] }, { 'dry': item[6], 'fresh': item[7], 'frozen': item[8] }]
      });
    });
    // 中心点座标
    dispatch('setOrderWeight', orderWeight);
    dispatch('setOrderVolume', orderVolume);
    // 中心点地图数据
    data.OrderDays.forEach(function (item) {
      var workDats = [];
      item.forEach(function (value, index) {
        if (value === 1) {
          workDats.push(index - 1);
        }
      });
      mapDataCustomer.forEach(function (itemC) {
        if (itemC.name === item[0]) {
          itemC['order_days'] = workDats;
        }
      });
    });
    dispatch('setMapDataCustomer', mapDataCustomer);
    dispatch('setAllMapDataCustomer', mapDataCustomer);
  },
  initSourceData: function initSourceData(_ref4, data) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        getters = _ref4.getters;

    if (data === 'clear' || !data.Location) {
      commit('changeSourceData', {});
      dispatch('setOrderWeight', []);
      dispatch('setOrderVolume', []);
      dispatch('setShopCoordinate', []);
      dispatch('setMapDataPlant', []);
      dispatch('setMapDataCustomer', []);
      dispatch('setOrderDays', []);
      dispatch('setSolutionStatus', 0);
    } else {
      dispatch('setSourceData', data);
    }
  },
  setSourceData: function setSourceData(_ref5, data) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        getters = _ref5.getters;

    commit('changeSourceData', data);
    // 订单重量
    var orderWeight = [];
    // 订单体积
    var orderVolume = [];
    // 店铺座标
    var shopCoordinate = {};
    // 客户地图数据
    var mapDataCustomer = [];
    // 订货时间
    var orderDays = [];
    data.Location.forEach(function (item) {
      orderWeight.push({ 'shop': item[0], 'dry': item[3], 'Fresh': item[4], 'frozen': item[5] });
      orderVolume.push({ 'shop': item[0], 'dry': item[6], 'Fresh': item[7], 'frozen': item[8] });
      shopCoordinate[String(item[0])] = [item[1], item[2]];
      mapDataCustomer.push({
        'name': item[0],
        'value': [item[1], item[2], { 'dry': item[3], 'fresh': item[4], 'frozen': item[5] }, { 'dry': item[6], 'fresh': item[7], 'frozen': item[8] }]
      });
    });
    // 中心点座标
    shopCoordinate[data.Plant[0][0]] = [data.Plant[0][1], data.Plant[0][2]];
    dispatch('setOrderWeight', orderWeight);
    dispatch('setOrderVolume', orderVolume);
    dispatch('setShopCoordinate', shopCoordinate);
    // 中心点地图数据
    dispatch('setMapDataPlant', [{ name: data.Plant[0][0], value: [data.Plant[0][1], data.Plant[0][2]] }]);
    data.OrderDays.forEach(function (item) {
      var workDats = [];
      item.forEach(function (value, index) {
        if (value === 1) {
          workDats.push(index - 1);
        }
      });
      orderDays.push({ 'shop': item[0], 'order_days': workDats });
      mapDataCustomer.forEach(function (itemC) {
        if (itemC.name === item[0]) {
          itemC['order_days'] = workDats;
        }
      });
    });
    dispatch('setMapDataCustomer', mapDataCustomer);
    dispatch('setAllMapDataCustomer', mapDataCustomer);
    dispatch('setOrderDays', orderDays);
    dispatch('setSolutionStatus', 10);
  },
  saveSourceData: function saveSourceData(_ref6, data) {
    var commit = _ref6.commit;

    commit('saveSourceData', data);
  },
  clearSourceData: function clearSourceData(_ref7, data) {
    var commit = _ref7.commit;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_local_storage__["c" /* delData */])('source_data' + data);
  },
  setOrderWeight: function setOrderWeight(_ref8, data) {
    var commit = _ref8.commit;

    commit('changeOrderWeight', data);
  },
  setOrderVolume: function setOrderVolume(_ref9, data) {
    var commit = _ref9.commit;

    commit('changeOrderVolume', data);
  },
  setOrderDays: function setOrderDays(_ref10, data) {
    var commit = _ref10.commit;

    commit('changeOrderDays', data);
  },
  setShopCoordinate: function setShopCoordinate(_ref11, data) {
    var commit = _ref11.commit;

    commit('changeShopCoordinate', data);
  },
  loadSourceData: function loadSourceData(_ref12, path) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;

    dispatch('setLoading', true);
    dispatch('setLoadingText', '加载数据中');
    dispatch('setPercentage', { 'start': 0, 'next': 80 });
    __WEBPACK_IMPORTED_MODULE_0__axios_init__["b" /* axiosSysApi */].get('/static/' + path).then(function (response) {
      dispatch('setLoadingText', '解析数据中');
      dispatch('setPercentage', { 'start': 80, 'next': 100 });
      dispatch('setSourceData', response.data);
      dispatch('setLoadingText', '解析数据完成');
      dispatch('setPercentage', { 'start': 100, 'next': 100 });
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '导入数据异常',
        message: '错误信息:' + e
      });
      dispatch('setLoadingText', '导入数据异常');
      dispatch('setPercentage', { 'start': 100, 'next': 100 });
    });
  }
};

var mutations = {
  editCustomerSourceData: function editCustomerSourceData(state, data) {},
  changeSourceData: function changeSourceData(state, data) {
    state.source_data = data;
  },
  changeSourceDataType: function changeSourceDataType(state, data) {
    state.source_data_type = data;
  },
  changeOrderWeight: function changeOrderWeight(state, data) {
    state.order_weight = data;
  },
  changeOrderVolume: function changeOrderVolume(state, data) {
    state.order_volume = data;
  },
  changeOrderDays: function changeOrderDays(state, data) {
    state.order_days = data;
  },
  changeShopCoordinate: function changeShopCoordinate(state, data) {
    state.shop_coordinate = data;
  },
  saveSourceData: function saveSourceData(state, data) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_local_storage__["b" /* saveData */])({ key: 'source_data' + data, data: state.source_data });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_local_storage__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_oli_api__ = __webpack_require__(13);






var state = {
  logined: 0,
  userId: null,
  userInfo: {},
  userData: {},
  loginFor: null
};

var getters = {
  logined: function logined(state) {
    return state.logined;
  },
  userId: function userId(state) {
    return state.userId;
  },
  userInfo: function userInfo(state) {
    return state.userInfo;
  },
  userData: function userData(state) {
    return state.userData;
  },
  loginFor: function loginFor(state) {
    return state.loginFor;
  }
};

var actions = {
  login: function login(_ref) {
    var getters = _ref.getters,
        dispatch = _ref.dispatch;

    var parm = {
      USER_ACCOUNT: getters.userInfo['USER_ACCOUNT'],
      PWD: getters.userInfo['PWD']
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["a" /* login */])(parm).then(function (data) {
      if (data.code === 1) {
        dispatch('setLoginData', { data: data, save: true });
      } else {
        dispatch('logOut');
        if (getters.userInfo['USER_ACCOUNT']) {
          __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({ name: 'login' });
        }
      }
    }).catch(function (e) {
      dispatch('logOut');
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({ name: 'login' });
    });
  },
  setLogined: function setLogined(_ref2, data) {
    var commit = _ref2.commit;

    commit('setLogined', data);
  },
  setUserId: function setUserId(_ref3, data) {
    var commit = _ref3.commit;

    commit('setUserId', data);
  },
  setUserInfo: function setUserInfo(_ref4, data) {
    var commit = _ref4.commit;

    commit('setUserInfo', data);
  },
  setUserData: function setUserData(_ref5, data) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    commit('setUserData', data);
    dispatch('setCanChoosePSZXs', data['PSZXs'] || []);
  },
  setLoginFor: function setLoginFor(_ref6, data) {
    var commit = _ref6.commit;

    commit('setLoginFor', data);
  },
  logOut: function logOut(_ref7) {
    var dispatch = _ref7.dispatch;

    dispatch('setLogined', 0);
    dispatch('setUserId', null);
    dispatch('setUserInfo', {});
    dispatch('setUserData', {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_local_storage__["b" /* saveData */])({ key: 'loginInfo', data: {} });
  },
  setLoginData: function setLoginData(_ref8, _ref9) {
    var dispatch = _ref8.dispatch;
    var data = _ref9.data,
        save = _ref9.save;

    if (data && data['userInfo'] && data['userInfo']['USER_ID']) {
      dispatch('setUserInfo', data['userInfo']);
      dispatch('setUserData', data['datas']);
      dispatch('setUserId', data['userInfo']['USER_ID']);
      dispatch('setLogined', 1);
    } else {
      dispatch('logOut');
    }
    if (save) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_local_storage__["b" /* saveData */])({ key: 'loginInfo', data: data });
    }
  }
};

var mutations = {
  setLogined: function setLogined(state, data) {
    state.logined = data;
  },
  setUserId: function setUserId(state, data) {
    state.userId = data;
  },
  setUserInfo: function setUserInfo(state, data) {
    state.userInfo = data;
  },
  setUserData: function setUserData(state, data) {
    state.userData = data;
  },
  setLoginFor: function setLoginFor(state, data) {
    state.loginFor = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  computed: {
    notice: {
      get: function get() {
        return this.$store.getters.notice;
      }
    }
  },
  watch: {
    notice: function notice() {
      this.$notify({
        title: this.notice.title,
        message: this.notice.message,
        type: this.notice.type
      });
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

var echarts = __webpack_require__(51);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'echarts',
  props: ['chart_id', 'option'],
  data: function data() {
    return {
      chart: null
    };
  },

  watch: {
    option: function option() {
      this.setOption();
    }
  },
  mounted: function mounted() {
    this.chart = echarts.init(document.getElementById(this.chart_id));
    this.setOption();
  },

  methods: {
    setOption: function setOption() {
      this.chart.setOption(this.option);
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hoverMenuIndex: -1,
      big_size: true,
      active_index: -1,
      menus: [{
        leabel: '单点配送',
        icon: 'icon-node-alone',
        active: true,
        key: 'single',
        children: [{
          leabel: '数据导入',
          key: 'source_data_pre',
          active: true
        }, {
          leabel: '数据校验',
          key: 'prediction_check',
          active: false
        }, {
          leabel: '分析预测',
          key: 'prediction',
          active: false
        }, {
          leabel: '每日订单<br>加油站',
          key: 'prediction_station',
          active: false
        }, {
          leabel: '每日订单<br>车辆',
          key: 'prediction_car',
          active: false
        }]
      }, {
        leabel: '循环配送',
        icon: 'icon-xunhuan',
        active: true,
        key: 'cycle',
        children: [{
          leabel: '数据导入',
          key: 'import',
          active: true
        }, {
          leabel: '设置参数',
          key: 'setting',
          active: false
        }, {
          leabel: '车辆调度',
          key: 'cars',
          active: false
        }, {
          leabel: '路径规划',
          key: 'car_route',
          active: false
        }]
      }, {
        leabel: '数据导出',
        icon: 'icon-shujudaochu',
        key: 'output',
        active: true
      }]
    };
  },

  computed: {
    path: {
      get: function get() {
        var path = this.$store.state.route.path;
        var vm = this;
        var routeName = this.$router.history.current.name;
        this.menus.forEach(function (item, index) {
          if (item.key && item.key === routeName) {
            vm.active_index = index;
          } else if (item.children) {
            item.children.forEach(function (itemC) {
              if (itemC.key === routeName) {
                vm.active_index = index;
              }
            });
          }
        });
        return path;
      }
    },
    preStatus: {
      get: function get() {
        var data = this.$store.getters.preStatus;
        if (data === 0) {
          this.menus[0].children[0].active = true;
          this.menus[0].children[1].active = false;
          this.menus[0].children[2].active = false;
          this.menus[0].children[3].active = false;
          this.menus[0].children[4].active = false;
        } else if (data === 5) {
          this.menus[0].children[0].active = true;
          this.menus[0].children[1].active = true;
          this.menus[0].children[2].active = false;
          this.menus[0].children[3].active = false;
          this.menus[0].children[4].active = false;
        } else if (data === 10) {
          this.menus[0].children[0].active = true;
          this.menus[0].children[1].active = true;
          this.menus[0].children[2].active = true;
          this.menus[0].children[3].active = false;
          this.menus[0].children[4].active = false;
        } else if (data === 20 || data === 40) {
          this.menus[0].children[0].active = true;
          this.menus[0].children[1].active = true;
          this.menus[0].children[2].active = true;
          this.menus[0].children[3].active = true;
          this.menus[0].children[4].active = true;
        }
        return data;
      }
    },
    solutionStatus: {
      get: function get() {
        var data = this.$store.getters.solutionStatus;
        if (data === 0) {
          this.menus[1].children[0].active = true;
          this.menus[1].children[1].active = false;
          this.menus[1].children[2].active = false;
          this.menus[1].children[3].active = false;
        }
        if (data === 10) {
          this.menus[1].children[0].active = true;
          this.menus[1].children[1].active = true;
          this.menus[1].children[2].active = false;
          this.menus[1].children[3].active = false;
        }
        if (data === 20) {
          this.menus[1].children[0].active = true;
          this.menus[1].children[1].active = true;
          this.menus[1].children[2].active = true;
          this.menus[1].children[3].active = false;
        }
        if (data === 30 || data === 40) {
          this.menus[1].children[0].active = true;
          this.menus[1].children[1].active = true;
          this.menus[1].children[2].active = true;
          this.menus[1].children[3].active = true;
        }
        return data;
      }
    }
  },
  methods: {
    clickMenuF: function clickMenuF(key, index) {
      if (key) {
        this.$router.push({ name: key });
        this.active_index = index;
      }
    },
    clickMenu: function clickMenu(key, active, index) {
      if (active && key) {
        this.active_index = index;
        if (key === 'cars' && this.solutionStatus === 20) {
          this.$store.dispatch('startAssignData');
          this.$router.push({ name: 'cycle' });
        } else if (key === 'car_route' && this.solutionStatus === 30) {
          this.$store.dispatch('startSolutionData');
          this.$router.push({ name: 'cycle' });
        } else {
          this.$router.push({ name: key });
        }
      }
    },
    goOther: function goOther() {
      window.open('http://mii-ro.com/VRPdemo7.html');
    }
  },
  created: function created() {
    var vm = this;
    this.menus.forEach(function (item, index) {
      if (vm.$route.name === item.key) {
        vm.active_key = item.key;
      }
    });
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hoverMenuIndex: -1,
      big_size: true,
      active_index: -1,
      menus: [{
        leabel: '数据导入',
        icon: 'icon-node-alone',
        active: true,
        key: 'ele_import'
      }, {
        leabel: '参数设置',
        icon: 'icon-xunhuan',
        active: false,
        key: 'ele_case'
      }, {
        leabel: '求解结果',
        icon: 'icon-shujudaochu',
        key: 'ele_result',
        active: false
      }, {
        leabel: '方案对比',
        icon: 'icon-compare',
        key: 'ele_compare',
        active: false
      }]
    };
  },

  computed: {
    path: {
      get: function get() {
        var path = this.$store.state.route.path;
        var vm = this;
        var routeName = this.$router.history.current.name;
        this.menus.forEach(function (item, index) {
          if (item.key && item.key === routeName) {
            vm.active_index = index;
          }
        });
        return path;
      }
    }
  },
  methods: {
    clickMenuF: function clickMenuF(key, index) {
      if (key) {
        this.$router.push({ name: key });
        this.active_index = index;
      }
    }
  },
  created: function created() {
    var vm = this;
    this.menus.forEach(function (item, index) {
      if (vm.$route.name === item.key) {
        vm.active_key = item.key;
      }
    });
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      big_size: true,
      active_type: '',
      active_index: -1,
      bottomMenus: [{
        leabel: '基础数据',
        icon: 'icon-jichuziyuan',
        key: 'single.gas',
        active: true,
        children: [{
          leabel: '加油站',
          key: 'single.gas',
          active: true
        }, {
          leabel: '车辆',
          key: 'single.car',
          active: true
        }, {
          leabel: '驾驶员',
          key: 'single.driver',
          active: true
        }, {
          leabel: '油库',
          key: 'single.oil_depot',
          active: true
        }]
      }, {
        leabel: '图表展示',
        icon: 'icon-tubiao',
        key: 'oil_chart',
        active: true
      }],
      menus_top: [{
        icon: 'icon-qiandao',
        leabel: '车辆签到',
        key: 'single.car',
        active: true
      }],
      menus: [{
        icon: 'icon-shujudaoru',
        leabel: '数据导入',
        key: 'single.source_data_pre',
        active: true
      }, {
        icon: 'icon-duocengshujuxiaoyan',
        leabel: '数据校验',
        key: 'single.prediction_check',
        active: false
      }, {
        icon: 'icon-xiansunfenxi',
        leabel: '分析预测',
        key: 'single.prediction',
        active: false
      }, {
        icon: 'icon-huanyihuan',
        leabel: '订单调整',
        key: 'single.adjust_order',
        active: false
      }, {
        icon: 'icon-youguanche',
        leabel: '每日订单',
        key: 'single.prediction_station',
        active: false,
        children: [{
          leabel: '加油站',
          key: 'single.prediction_station',
          active: false
        }, {
          leabel: '车辆',
          key: 'single.prediction_car',
          active: false
        }]
      }]
    };
  },

  computed: {
    path: {
      get: function get() {
        var path = this.$store.state.route.path;
        var vm = this;
        var routeName = this.$router.history.current.name;
        this.menus.forEach(function (item, index) {
          if (item.key && item.key === routeName) {
            vm.active_index = index;
          }
        });
        return path;
      }
    },
    preStatus: {
      get: function get() {
        var data = this.$store.getters.flowStatus;
        if (data === 10) {
          this.menus[1].active = true;
        } else if (data === 20) {
          this.menus[2].active = true;
        } else if (data === 30) {
          this.menus[3].active = true;
        } else if (data === 40) {
          this.menus[4].active = true;
          this.menus[4].children[0].active = true;
          this.menus[4].children[1].active = true;
        }
        return data;
      }
    }
  },
  methods: {
    clickMenuF: function clickMenuF(menu, index, type) {
      if (menu.active && menu.key) {
        this.$router.push({ name: menu.key });
        this.active_index = index;
        this.active_type = type;
      }
    },
    clickMenu: function clickMenu(key, active, index, type) {
      if (active && key) {
        this.active_index = index;
        this.$router.push({ name: key });
        this.active_type = type;
      }
    },
    goOther: function goOther() {
      window.open('http://mii-ro.com/VRPdemo7.html');
    }
  },
  created: function created() {
    var vm = this;
    this.menus.forEach(function (item, index) {
      if (vm.$route.name === item.key) {
        vm.active_index = index;
      }
    });
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hoverMenuIndex: -1,
      big_size: true,
      active_index: -1,
      menus: [{
        leabel: '数据导入',
        icon: 'icon-xunhuan',
        key: 'import_to',
        active: true
      }, {
        leabel: '分析预测',
        icon: 'icon-xunhuan',
        key: 'prediction_to',
        active: false
      }, {
        leabel: '设置参数',
        icon: 'icon-xunhuan',
        key: 'setting_to',
        active: false
      }, {
        leabel: '车辆调度',
        icon: 'icon-xunhuan',
        key: 'cars_to',
        active: false
      }, {
        leabel: '路径规划',
        icon: 'icon-xunhuan',
        key: 'car_route_to',
        active: false
      }, {
        leabel: '数据导出',
        icon: 'icon-shujudaochu',
        key: 'output_to',
        active: true
      }]
    };
  },

  computed: {
    path: {
      get: function get() {
        var path = this.$store.state.route.path;
        var vm = this;
        var routeName = this.$router.history.current.name;
        this.menus.forEach(function (item, index) {
          if (item.key && item.key === routeName) {
            vm.active_index = index;
          }
        });
        return path;
      }
    },
    solutionStatus: {
      get: function get() {
        var data = this.$store.getters.solutionStatus;
        if (data === 0) {
          this.menus[0].active = true;
          this.menus[1].active = false;
          this.menus[2].active = false;
          this.menus[3].active = false;
          this.menus[4].active = false;
        }
        if (data === 10) {
          this.menus[0].active = true;
          this.menus[1].active = true;
          this.menus[2].active = true;
          this.menus[3].active = false;
          this.menus[4].active = false;
        }
        if (data === 20) {
          this.menus[0].active = true;
          this.menus[1].active = true;
          this.menus[2].active = true;
          this.menus[3].active = true;
          this.menus[4].active = false;
        }
        if (data === 30 || data === 40) {
          this.menus[0].active = true;
          this.menus[1].active = true;
          this.menus[2].active = true;
          this.menus[3].active = true;
          this.menus[4].active = true;
        }
        return data;
      }
    }
  },
  methods: {
    clickMenuF: function clickMenuF(key, index, active) {
      if (key && active) {
        this.active_index = index;
        if (key === 'cars_to' && this.solutionStatus === 20) {
          this.$store.dispatch('startAssignData');
          this.$router.push({ name: 'tobacco' });
        } else if (key === 'car_route_to' && this.solutionStatus === 30) {
          this.$store.dispatch('startSolutionData');
          this.$router.push({ name: 'tobacco' });
        } else {
          this.$router.push({ name: key });
        }
      }
    },
    clickMenu: function clickMenu(key, active, index) {
      if (active && key) {
        this.active_index = index;
        if (key === 'cars' && this.solutionStatus === 20) {
          this.$store.dispatch('startAssignData');
          this.$router.push({ name: 'cycle' });
        } else if (key === 'car_route' && this.solutionStatus === 30) {
          this.$store.dispatch('startSolutionData');
          this.$router.push({ name: 'cycle' });
        } else {
          this.$router.push({ name: key });
        }
      }
    },
    goOther: function goOther() {
      window.open('http://edata.reemii.cn/VRPdemo7.html');
    }
  },
  created: function created() {
    var vm = this;
    this.menus.forEach(function (item, index) {
      if (vm.$route.name === item.key) {
        vm.active_key = item.key;
      }
    });
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_UserInfo__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_UserInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_UserInfo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserInfo: __WEBPACK_IMPORTED_MODULE_0__components_bit_UserInfo___default.a
  },
  props: ['noLogin'],
  data: function data() {
    return {
      active_menu_index: null,
      show_menu: '',
      active_menu: '',
      left_menus: [],
      right_menus: [],
      left_menus_p: [],
      right_menus_p: [],
      left_menus_ps: [],
      right_menus_ps: [],
      other_menus: [],
      menus: [{
        leabel: '订单相关信息',
        minStatus: 10,
        type: 'left',
        route_name: 'source_data'
      }, {
        leabel: '车辆相关信息',
        minStatus: 30,
        type: 'right',
        route_name: 'cars'
      }, {
        leabel: '路径相关信息',
        minStatus: 40,
        type: 'right',
        route_name: 'car_route'
      }, {
        leabel: '进销存数据',
        type: 'pre_left',
        minStatus: 5,
        route_name: 'prediction_check'
      }, {
        leabel: '分析预测',
        type: 'pre_left',
        minStatus: 20,
        route_name: 'prediction'
      }, {
        leabel: '每日订单-加油站',
        type: 'pre_right',
        minStatus: 30,
        route_name: 'prediction_station'
      }, {
        leabel: '每日订单-车辆',
        type: 'pre_right',
        minStatus: 30,
        route_name: 'prediction_car'
      }, {
        leabel: '进销存数据',
        type: 'sin_left',
        minStatus: 5,
        route_name: 'single.prediction_check'
      }, {
        leabel: '分析预测',
        type: 'sin_left',
        minStatus: 20,
        route_name: 'single.prediction'
      }, {
        leabel: '每日订单-加油站',
        type: 'sin_right',
        minStatus: 30,
        route_name: 'single.prediction_station'
      }, {
        leabel: '每日订单-车辆',
        type: 'sin_right',
        minStatus: 30,
        route_name: 'single.prediction_car'
      }]
    };
  },

  computed: {
    pszxDatas: {
      get: function get() {
        var _this = this;

        var showData = [];
        this.$store.getters.canChoosePSZXs.forEach(function (item) {
          if (item.key !== _this.oilArea) {
            showData.push(item);
          }
        });
        return showData;
      }
    },
    path: {
      get: function get() {
        var path = this.$store.state.route.path;
        var vm = this;
        this.active_menu = this.$router.history.current.name;
        this.menus.forEach(function (item, index) {
          if (vm.active_menu === item.route_name) {
            vm.show_menu = item.type.indexOf('pre_') > -1 || item.type.indexOf('sin_') > -1 ? item.type.slice(4) : item.type;
          }
        });
        return path;
      }
    },
    solutionStatus: {
      get: function get() {
        return this.$store.getters.solutionStatus;
      }
    },
    oilArea: {
      get: function get() {
        return this.$store.getters.oilArea;
      },
      set: function set(value) {
        this.$store.dispatch('setOilArea', value);
      }
    },
    preStatus: {
      get: function get() {
        return this.$store.getters.preStatus;
      }
    }
  },
  created: function created() {
    var vm = this;
    this.menus.forEach(function (item) {
      if (item.type === 'left') {
        vm.left_menus.push(item);
      } else if (item.type === 'right') {
        vm.right_menus.push(item);
      } else if (item.type === 'pre_left') {
        vm.left_menus_p.push(item);
      } else if (item.type === 'pre_right') {
        vm.right_menus_p.push(item);
      } else if (item.type === 'sin_left') {
        vm.left_menus_ps.push(item);
      } else if (item.type === 'sin_right') {
        vm.right_menus_ps.push(item);
      }
    });
  },

  methods: {
    goOther: function goOther() {
      if (this.path.indexOf('adjust_home') > -1) {
        window.open('/#/single_home/single');
      } else {
        window.open('/#/adjust_home');
      }
      window.close();
    },
    getLabel: function getLabel(key) {
      var label = '';
      this.$store.getters.canChoosePSZXs.forEach(function (item) {
        if (key === item['key']) {
          label = item.label;
        }
      });
      return label;
    },
    goHaveFun: function goHaveFun() {
      this.$router.push({ name: 'single_home' });
    },
    gohome: function gohome() {
      this.$router.push({ name: 'index' });
    },
    clickLeftMenu: function clickLeftMenu(key) {
      this.show_menu = key;
    },
    chooseMenu: function chooseMenu(menu) {
      this.active_menu = menu.route_name;
      this.show_menu = menu.type.indexOf('pre') > -1 ? menu.type.slice(4) : menu.type;
      this.$router.push({ name: menu.route_name });
    },
    chooseMenuIndex: function chooseMenuIndex(index) {
      this.active_menu_index = index;
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_UserInfo__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_UserInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_UserInfo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserInfo: __WEBPACK_IMPORTED_MODULE_0__components_bit_UserInfo___default.a
  },
  props: ['noLogin'],
  data: function data() {
    return {};
  },

  computed: {
    path: {
      get: function get() {
        return this.$store.state.route.path;
      }
    },
    pszxDatas: {
      get: function get() {
        var _this = this;

        var showData = [];
        this.$store.getters.canChoosePSZXs.forEach(function (item) {
          if (item.key !== _this.oilArea) {
            showData.push(item);
          }
        });
        return showData;
      }
    },
    oilArea: {
      get: function get() {
        return this.$store.getters.oilArea;
      },
      set: function set(value) {
        this.$store.dispatch('setOilArea', value);
      }
    }
  },
  methods: {
    goOther: function goOther() {
      if (this.path.indexOf('adjust_home') > -1) {
        window.open('/#/single_home/single');
      } else {
        window.open('/#/adjust_home');
      }
      window.close();
    },
    getLabel: function getLabel(key) {
      var label = '';
      this.$store.getters.canChoosePSZXs.forEach(function (item) {
        if (key === item['key']) {
          label = item.label;
        }
      });
      return label;
    },
    gohome: function gohome() {
      this.$router.push({ name: 'index' });
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    login: {
      get: function get() {
        return this.$store.getters.login;
      }
    },
    path: {
      get: function get() {
        return this.$store.state.route.path;
      }
    },
    eleStatus: {
      get: function get() {
        return this.$store.getters.eleStatus;
      }
    }
  },
  methods: {
    loginOut: function loginOut() {
      this.$store.dispatch('loginOut');
    },
    goLogin: function goLogin() {
      this.$store.dispatch('setLoginFor', this.path);
      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      active_menu_index: null,
      show_menu: '',
      active_menu: '',
      left_menus: [],
      right_menus: [],
      left_menus_p: [],
      right_menus_p: [],
      other_menus: [],
      menus: [{
        leabel: '订单相关信息',
        minStatus: 10,
        type: 'left',
        route_name: 'source_data_to'
      }, {
        leabel: '分析预测',
        type: 'left',
        minStatus: 10,
        route_name: 'prediction_to'
      }, {
        leabel: '车辆相关信息',
        minStatus: 30,
        type: 'right',
        route_name: 'cars_to'
      }, {
        leabel: '路径相关信息',
        minStatus: 40,
        type: 'right',
        route_name: 'car_route_to'
      }]
    };
  },

  computed: {
    path: {
      get: function get() {
        var path = this.$store.state.route.path;
        var vm = this;
        this.active_menu = this.$router.history.current.name;
        this.menus.forEach(function (item, index) {
          if (vm.active_menu === item.route_name) {
            vm.show_menu = item.type.indexOf('pre_') > -1 ? item.type.slice(4) : item.type;
          }
        });
        return path;
      }
    },
    solutionStatus: {
      get: function get() {
        return this.$store.getters.solutionStatus;
      }
    },
    preStatus: {
      get: function get() {
        return this.$store.getters.preStatus;
      }
    },
    login: {
      get: function get() {
        return this.$store.getters.login;
      }
    }
  },
  created: function created() {
    var vm = this;
    this.menus.forEach(function (item) {
      if (item.type === 'left') {
        vm.left_menus.push(item);
      } else if (item.type === 'right') {
        vm.right_menus.push(item);
      } else if (item.type === 'pre_left') {
        vm.left_menus_p.push(item);
      } else if (item.type === 'pre_right') {
        vm.right_menus_p.push(item);
      }
    });
  },

  methods: {
    loginOut: function loginOut() {
      this.$store.dispatch('loginOut');
    },
    goLogin: function goLogin() {
      this.$store.dispatch('setLoginFor', this.path);
      this.$router.push('/login');
    },
    gohome: function gohome() {
      this.$router.push({ name: 'index' });
    },
    clickLeftMenu: function clickLeftMenu(key) {
      this.show_menu = key;
    },
    chooseMenu: function chooseMenu(menu) {
      this.active_menu = menu.route_name;
      this.show_menu = menu.type.indexOf('pre') > -1 ? menu.type.slice(4) : menu.type;
      this.$router.push({ name: menu.route_name });
    },
    chooseMenuIndex: function chooseMenuIndex(index) {
      this.active_menu_index = index;
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cllib__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'content-title': __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a
  },
  methods: {
    optPutFile: function optPutFile() {
      var datas = [{
        data: [],
        sheetName: 'data1'
      }];
      var vm = this;
      var row1 = ['时间'];
      var row2 = [''];
      this.ths.slice(1).forEach(function (thsItem) {
        vm.caseDatas.forEach(function (item) {
          row1.push(thsItem.label);
          row2.push(item.name);
        });
      });
      datas[0].data.push(row1);
      datas[0].data.push(row2);
      this.caseDatas[0]['result']['调度方案'].forEach(function (item, index1) {
        var data = [];
        vm.ths.forEach(function (item2, index2) {
          if (index2 !== 0) {
            vm.caseDatas.forEach(function (item3) {
              data.push(item3['result']['调度方案'][index1][item2.key]);
            });
          } else {
            data.push(vm.caseDatas[0]['result']['调度方案'][index1][item2.key]);
          }
        });
        datas[0].data.push(data);
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cllib__["a" /* outPutExcelFile */])(datas, '结果对比.xls');
    }
  },
  computed: {
    table_style_height: {
      get: function get() {
        if (this.table_height && this.scroll_table) {
          return {
            height: this.table_height + 'rem'
          };
        } else {
          return {};
        }
      }
    }
  },
  data: function data() {
    return {
      scroll_table: true,
      scroll_table_2: true,
      ths: [{
        label: '时间',
        key: 0
      }, {
        label: '光伏发电',
        key: 2
      }, {
        label: '购电量',
        key: 4
      }, {
        label: '卖电量',
        key: 5
      }, {
        label: '电池充电',
        key: 7
      }, {
        label: '电池放电',
        key: 8
      }, {
        label: 'SOC',
        key: 9
      }],
      ths2: [{
        label: '购电成本',
        key: 0
      }, {
        label: '储能成本',
        key: 1
      }, {
        label: '光伏发电成本',
        key: 2
      }]
    };
  },

  props: ['caseDatas', 'table_height']
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'actions', 'rightText', 'searchInput', 'clearNum'],
  data: function data() {
    return {
      inputValue: ''
    };
  },

  watch: {
    inputValue: function inputValue(value) {
      this.$emit('searchInputChange', value);
    },
    clearNum: function clearNum(value) {
      this.inputValue = '';
    }
  },
  methods: {
    clickMenu: function clickMenu(key) {
      this.$emit('clickMenu', key);
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loadingPercentage: 0,
      startTime: 80,
      nextTime: 200
    };
  },

  methods: {
    closeLoading: function closeLoading() {
      var vm = this;
      window.setTimeout(function () {
        vm.$store.dispatch('setLoading', false);
      }, 1000);
    },
    addPercentage: function addPercentage(time) {
      window.setTimeout(this.add, time);
    },
    add: function add() {
      if (this.percentage.next > this.loadingPercentage) {
        this.loadingPercentage++;
      }
      if (this.percentage.start > this.loadingPercentage) {
        this.startTime = this.startTime > 24 ? this.startTime - 5 : this.startTime;
        this.addPercentage(this.startTime);
      } else if (this.percentage.next * 0.9 > this.loadingPercentage) {
        this.nextTime = this.nextTime + 200;
        this.addPercentage(this.nextTime);
      }
      if (this.loadingPercentage === 100) {
        this.closeLoading();
      }
    }
  },
  computed: {
    loading: {
      get: function get() {
        return this.$store.getters.loading;
      },
      set: function set(value) {
        this.$store.dispatch('setLoading', false);
      }
    },
    loadingText: {
      get: function get() {
        return this.$store.getters.loadingText;
      }
    },
    percentage: {
      get: function get() {
        return this.$store.getters.percentage;
      },
      set: function set(value) {
        this.$store.dispatch('setPercentage', value);
      }
    },
    loading_style: {
      get: function get() {
        return {
          width: this.loadingPercentage + '%'
        };
      }
    }
  },
  watch: {
    percentage: function percentage() {
      this.startTime = 80;
      this.nextTime = 200;
      if (this.percentage.start === 0) {
        this.loadingPercentage = 0;
      }
      if (this.percentage.start > this.loadingPercentage) {
        this.addPercentage(80);
      } else if (this.percentage.next * 0.9 > this.loadingPercentage) {
        this.addPercentage(200);
      }
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cllib__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    table_style_height: {
      get: function get() {
        if (this.table_height && this.scroll_table) {
          return {
            height: this.table_height + 'rem'
          };
        } else {
          return {};
        }
      }
    },
    tableData: {
      get: function get() {
        var vm = this;
        var data = [];
        this.datas.forEach(function (item) {
          data.push(item);
        });
        if (this.shortKey) {
          data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["c" /* clSortDatas */])(data, function (a, b) {
            var short = false;
            if (vm.shortType === 'time') {
              var aStr = a[vm.shortKey] && a[vm.shortKey] !== '无' ? '2018-' + a[vm.shortKey] : '2000-01-01';
              var bStr = b[vm.shortKey] && b[vm.shortKey] !== '无' ? '2018-' + b[vm.shortKey] : '2000-01-01';
              short = vm.shortOrderMax ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["d" /* cmpDate */])(aStr).getTime() > __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["d" /* cmpDate */])(bStr).getTime() : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["d" /* cmpDate */])(aStr).getTime() < __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["d" /* cmpDate */])(bStr).getTime();
            } else if (vm.shortType === 'date_time') {
              var _aStr = a[vm.shortKey] && a[vm.shortKey] !== '无' ? a[vm.shortKey] : '2000-01-01';
              var _bStr = b[vm.shortKey] && b[vm.shortKey] !== '无' ? b[vm.shortKey] : '2000-01-01';
              short = vm.shortOrderMax ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["d" /* cmpDate */])(_aStr).getTime() > __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["d" /* cmpDate */])(_bStr).getTime() : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["d" /* cmpDate */])(_aStr).getTime() < __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["d" /* cmpDate */])(_bStr).getTime();
            } else if (vm.shortType === 'text') {
              short = vm.shortOrderMax ? a[vm.shortKey] > b[vm.shortKey] : a[vm.shortKey] < b[vm.shortKey];
            } else {
              short = vm.shortOrderMax ? Number(a[vm.shortKey]) > Number(b[vm.shortKey]) : Number(a[vm.shortKey]) < Number(b[vm.shortKey]);
            }
            return short;
          });
        }
        return data;
      }
    }
  },
  data: function data() {
    return {
      chooseRow: -1,
      checkedAll: false,
      scroll_table_2: false,
      style: 0,
      page: 1,
      start_index: 0,
      shortKey: null,
      shortOrderMax: true,
      shortType: null
    };
  },

  watch: {
    chooseRowValue: function chooseRowValue(value) {
      var _this = this;

      if (value.includes('car_id')) {
        var newData = null;
        var carId = value.split('car_id-')[1];
        this.tableData.forEach(function (item) {
          if (carId === item[_this.lineSuo]) {
            newData = item;
          }
        });
        if (newData) {
          this.chooseRow = carId;
          this.$emit(this.chooseAction['action'], this.chooseAction.key ? { data: newData, key: this.chooseAction.key } : newData);
        }
      } else if (value.includes('top')) {
        // this.chooseRow = value
        this.nextData('top');
      } else {
        this.nextData('btm');
      }
    },
    checkedAll: function checkedAll(value) {
      if (value) {
        this.datas.forEach(function (item) {
          item.checked = true;
        });
      } else {
        this.datas.forEach(function (item) {
          item.checked = false;
        });
      }
    }
  },
  methods: {
    nextData: function nextData(key) {
      var _this2 = this;

      if (!this.chooseAction) {
        return;
      }
      // 已有
      if (this.tableData.length > 0) {
        var newData = {};
        if (this.chooseRow) {
          var oldIndex = -1;
          this.tableData.forEach(function (item, index) {
            if (item[_this2.lineSuo] === _this2.chooseRow) {
              oldIndex = index;
            }
          });
          if (oldIndex === -1) {
            newData = this.tableData[0];
          } else if (oldIndex === 0 && key === 'top') {
            this.$store.dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '已经是第一条数据了！'
            });
          } else if (oldIndex === this.tableData.length - 1 && key === 'btm') {
            this.$store.dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '已经是最后一条数据了！'
            });
          } else if (key === 'top') {
            newData = this.tableData[oldIndex - 1];
          } else if (key === 'btm') {
            newData = this.tableData[oldIndex + 1];
          }
        } else {
          newData = this.tableData[0];
        }
        if (newData[this.lineSuo]) {
          this.chooseRow = newData[this.lineSuo];
          this.$emit(this.chooseAction['action'], this.chooseAction.key ? { data: newData, key: this.chooseAction.key } : newData);
        }
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'info',
          title: '系统提示',
          message: '无数据!'
        });
      }
    },
    getlineStyle: function getlineStyle(data) {
      var styleMap = {};
      if (!this.lineQF) {
        return {};
      } else if (data['订单紧急程度'] === '紧急订单') {
        styleMap['background-color'] = '#f1a9a0';
      } else if (data['订单紧急程度'] === '可配送订单') {
        styleMap['background-color'] = '#fde3a7';
      } else if (data['订单紧急程度'] === '库存充足订单') {
        styleMap['background-color'] = '#90c695';
      }
      return styleMap;
    },
    sortData: function sortData(key, shortType) {
      this.shortType = shortType;
      this.shortKey = key;
      this.shortOrderMax = !this.shortOrderMax;
    },
    clickRow: function clickRow(data, index) {
      if (this.lineSuo) {
        this.chooseRow = data[this.lineSuo] || -1;
      }
      this.$emit('click_row', data);
    },
    clickRowData: function clickRowData(data, thKey, actionKey) {
      this.$emit('click_row_data', { value: data[thKey], action: actionKey, rowdata: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["b" /* mapCp */])(data) });
    },
    pageChange: function pageChange(currentPage) {
      this.start_index = (currentPage - 1) * this.row_num;
    },
    clickTdBtn: function clickTdBtn(data, key, index) {
      if (this.lineSuo) {
        this.chooseRow = data[this.lineSuo] || -1;
      }
      this.$emit('clickTdBtn', { data: data, key: key });
    }
  },
  props: ['datas', 'ths', 'table_style', 'row_num', 'show_pagination', 'scroll_table', 'table_height', 'table_actions', 'show_checkbox', 'realAction', 'lineQF', 'notShowThs', 'lineSuo', 'show_dian', 'chooseRowValue', 'chooseAction'],
  created: function created() {
    this.style = (this.datas || []).length > 10 ? this.table_style : (this.datas || []).length % 2 === 0 ? this.table_style : 3 - this.table_style;
    this.scroll_table_2 = this.scroll_table;
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['datas', 'ths', 'page_parm', 'rowDef', 'scroll_table'],
  methods: {
    pageChange: function pageChange(page) {
      this.$emit('pageChange', page);
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cllib__ = __webpack_require__(19);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'content-title': __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default.a
  },
  computed: {
    show_data: {
      get: function get() {
        var data = [];
        if (this.show_pagination) {
          data = (this.datas || []).slice(this.start_index, this.start_index + this.row_num);
        } else {
          data = this.datas || [];
        }
        return data;
      }
    },
    table_style_height: {
      get: function get() {
        if (this.table_height && this.scroll_table) {
          return {
            height: this.table_height + 'rem'
          };
        } else {
          return {};
        }
      }
    }
  },
  data: function data() {
    return {
      scroll_table_2: false,
      new_value: null,
      edit_value: {
        column: -1,
        key: '',
        unit: ''
      },
      style: 0,
      page: 1,
      start_index: 0
    };
  },

  methods: {
    optPutFile: function optPutFile() {
      var datas = [{
        data: [],
        sheetName: 'data1'
      }];
      var vm = this;
      var row1 = [];
      this.ths.forEach(function (thsItem) {
        row1.push(thsItem.label);
      });
      datas[0].data.push(row1);
      this.datas.forEach(function (item) {
        var data = [];
        vm.ths.forEach(function (item2) {
          data.push(item[item2.key]);
        });
        datas[0].data.push(data);
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cllib__["a" /* outPutExcelFile */])(datas, (this.oputput_file_name || 'MiiRo') + '.xls');
    },
    pageChange: function pageChange(currentPage) {
      this.start_index = (currentPage - 1) * this.row_num;
    },
    startEdit: function startEdit(index, key, value, unit) {
      this.edit_value = {
        column: index,
        key: key,
        unit: unit
      };
      this.new_value = value;
    },
    save: function save() {
      this.$store.dispatch('editSourceData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ newData: this.new_value }, this.edit_value));
      this.edit_value = {
        column: -1,
        key: '',
        unit: ''
      };
    }
  },
  props: ['datas', 'ths', 'title', 'table_style', 'one_row', 'row_num', 'show_pagination', 'canEdit', 'scroll_table', 'table_height', 'output_file', 'oputput_file_name'],
  created: function created() {
    this.style = (this.datas || []).length > 10 ? this.table_style : (this.datas || []).length % 2 === 0 ? this.table_style : 3 - this.table_style;
    this.scroll_table_2 = this.scroll_table;
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cllib__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      checkedAll: false,
      checkedData: [],
      shortKey: '',
      shortOrderMax: true,
      currentPage: 0
    };
  },

  props: ['datas', 'columns', 'tableStyle', 'pageParm', 'tableAction', 'checkboxParm', 'mergeRowKeyList', 'listTable', 's_key'],
  computed: {
    tableData: {
      get: function get() {
        var vm = this;
        var data = [];
        var showDatas = this.pageParm && this.pageParm.tablePagination ? this.datas.slice(this.currentPage * this.pageParm.row_num, (this.currentPage + 1) * this.pageParm.row_num) : this.datas;
        // tablePagination 为true 传出完整数据, 为false，传入分页后数据
        showDatas.forEach(function (item) {
          data.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["b" /* mapCp */])(item));
        });
        if (this.mergeRowKeyList && this.mergeRowKeyList.length > 0) {
          // 列合并
          data = this.listTable ? data : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["h" /* listToTableData */])(data, this.mergeRowKeyList);
        } else if (this.shortKey) {
          // 点击表头排序
          data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["c" /* clSortDatas */])(data, function (a, b) {
            return vm.shortOrderMax ? Number(a[vm.shortKey]) > Number(b[vm.shortKey]) : Number(a[vm.shortKey]) < Number(b[vm.shortKey]);
          });
        }
        return data;
      }
    },
    showCheckbox: {
      get: function get() {
        return this.checkboxParm && true;
      }
    }
  },
  methods: {
    handleSizeChange: function handleSizeChange(pageSize) {
      this.$emit('pageSizeChange', pageSize);
    },
    pageChange: function pageChange(currentPage) {
      if (this.pageParm && this.pageParm.tablePagination) {
        this.currentPage = currentPage - 1;
      } else {
        this.$emit('pageChange', currentPage);
      }
    },
    clickRow: function clickRow(data) {
      this.$emit('click_row', data);
    },
    sortData: function sortData(key) {
      this.shortKey = key;
      this.shortOrderMax = !this.shortOrderMax;
    },
    clickTdBtn: function clickTdBtn(data, key) {
      this.$emit('clickTdBtn', { data: data, key: key });
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isMap: false
    };
  },

  props: ['mapPathName'],
  methods: {
    change: function change() {
      this.isMap ? this.$router.go(-1) : this.$router.push({ name: this.mapPathName });
    }
  },
  computed: {
    path: {
      get: function get() {
        this.isMap = this.$store.state.route.name === 'cycle' || this.$store.state.route.name === 'single' || this.$store.state.route.name === 'tobacco' || this.$store.state.route.name === 'single.single';
        return this.$store.state.route.path;
      }
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_oli_api__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showChangePwd: false,
      password: '',
      repassword: ''
    };
  },

  computed: {
    formOk: {
      get: function get() {
        return this.password && this.password === this.repassword;
      }
    },
    logined: {
      get: function get() {
        return this.$store.getters.logined;
      }
    },
    userInfo: {
      get: function get() {
        return this.$store.getters.userInfo;
      }
    }
  },
  methods: {
    logOut: function logOut() {
      this.$router.push({ name: 'login' });
    },
    saveUserPwd: function saveUserPwd() {
      var _this = this;

      if (!this.formOk) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提醒',
          message: '两次输入密码不一致'
        });
        return;
      }
      var parm = {
        action: 'change_pwd',
        data: {
          USER_ID: this.userInfo['USER_ID'],
          new_pwd: this.password
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["b" /* user */])(parm).then(function (data) {
        if (data.code === 1) {
          _this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提醒',
            message: '密码修改成功'
          });
          _this.showChangePwd = false;
          _this.logOut();
        } else {
          _this.$store.dispatch('showNoticeMsg', {
            type: 'warning',
            title: '系统提醒',
            message: '密码修改失败'
          });
        }
      }).catch(function (e) {
        _this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提醒',
          message: '密码修改失败'
        });
      });
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'content-title': __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a
  },
  data: function data() {
    return {
      columns: [{
        leabel: '星期天'
      }, {
        leabel: '星期一'
      }, {
        leabel: '星期二'
      }, {
        leabel: '星期三'
      }, {
        leabel: '星期四'
      }],
      start_index: 0
    };
  },

  methods: {
    pageChange: function pageChange(currentPage) {
      this.start_index = (currentPage - 1) * 15;
    }
  },
  props: ['datas', 'title']
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Echarts__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EchartsOptions__ = __webpack_require__(99);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cars',
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default.a,
    MiiTable: __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable___default.a,
    Echarts: __WEBPACK_IMPORTED_MODULE_2__components_Echarts___default.a
  },
  computed: {
    sourceDataType: {
      get: function get() {
        return this.$store.getters.sourceDataType;
      }
    },
    carRoutes: {
      get: function get() {
        return this.$store.getters.carRoutes;
      }
    },
    solutionData: {
      get: function get() {
        return this.$store.getters.solutionData;
      }
    },
    echartsOption: {
      get: function get() {
        var echartsOption = {
          option: {},
          outOption: {
            style: ''
          }
        };
        var showDatas = {
          car: this.car2,
          data: [{
            'value1': this.sourceDataType !== 'shop' ? '0号柴油' : '干货',
            'value2': 0
          }, {
            'value1': this.sourceDataType !== 'shop' ? '92号汽油' : '新鲜货',
            'value2': 0
          }, {
            'value1': this.sourceDataType !== 'shop' ? '95号汽油' : '冰冻货',
            'value2': 0
          }]
        };
        if (this.car2) {
          var customers = [];
          var vm = this;
          this.clusterCutomer.forEach(function (item) {
            if (item[0].slice(2) === vm.car2.slice(2)) {
              customers = item.slice(1);
            }
          });
          this.orderWeight.forEach(function (item) {
            if (customers.indexOf(item.shop) > -1) {
              showDatas.data[0]['value2'] += item.Fresh;
              showDatas.data[1]['value2'] += item.dry;
              showDatas.data[2]['value2'] += item.frozen;
            }
          });
          console.log(showDatas);
          echartsOption = { option: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__EchartsOptions__["a" /* initOption */])(showDatas.data, this.option), outOption: { style: this.option.style } };
        }
        return echartsOption;
      }
    },
    clusterCutomer: {
      get: function get() {
        return this.$store.getters.clusterCutomer;
      }
    },
    orderWeight: {
      get: function get() {
        return this.$store.getters.orderWeight;
      }
    },
    cars: {
      get: function get() {
        this.car_first = this.car_first || this.$store.getters.cars[0];
        this.car2 = this.car2 || this.$store.getters.cars[0];
        return this.$store.getters.cars;
      }
    },
    oneCarRoutes: {
      get: function get() {
        var data = [];
        var vm = this;
        this.carRoutes.forEach(function (item) {
          if (item.car === vm.car_first) {
            item.route_data.forEach(function (one) {
              data.push({ 'route': one[0] + '<i class="iconfont icon-jiantou"></i>' + one[1] });
            });
          }
        });
        return data;
      }
    }
  },
  data: function data() {
    return {
      car_first: '',
      car2: '',
      option: {
        chartType: 'huan',
        dataX: 'value1',
        dataY: 'value2',
        otherOption: {
          title: ''
        },
        style: ''
      },
      ths2: [{
        key: 'route'
      }]
    };
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Echarts__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EchartsOptions__ = __webpack_require__(99);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cars',
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default.a,
    MiiTable: __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable___default.a,
    Echarts: __WEBPACK_IMPORTED_MODULE_2__components_Echarts___default.a
  },
  methods: {},
  computed: {
    sourceDataType: {
      get: function get() {
        return this.$store.getters.sourceDataType;
      }
    },
    orderWeight: {
      get: function get() {
        return this.$store.getters.orderWeight;
      }
    },
    carOrders: {
      get: function get() {
        var data = [];
        if (this.show_order_car) {
          var customers = [];
          var vm = this;
          this.clusterCutomer.forEach(function (item) {
            if (item[0].slice(2) === vm.show_order_car.slice(2)) {
              customers = item.slice(1);
            }
          });
          this.orderWeight.forEach(function (item) {
            if (customers.indexOf(item.shop) > -1) {
              data.push(item);
            }
          });
        }
        return data;
      }
    },
    echarts_option: {
      get: function get() {
        var vm = this;
        var datas = [];
        this.carOrders.forEach(function (item) {
          vm.ths.forEach(function (one, index) {
            if (index > 0) {
              datas.push({ value1: item.shop, value2: one.label, value3: item[one.key] });
            }
          });
        });
        return { option: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__EchartsOptions__["a" /* initOption */])(datas, this.option), outOption: { style: this.option.style } };
      }
    },
    cars: {
      get: function get() {
        var data = this.$store.getters.cars;
        if (data.length > 0) {
          this.show_order_car = data[0];
        }
        return data;
      },
      set: function set(value) {
        return this.$store.dispatch('setCars', value);
      }
    },
    clusterCutomer: {
      get: function get() {
        return this.$store.getters.clusterCutomer;
      },
      set: function set(value) {
        return this.$store.dispatch('setClusterCutomer', value);
      }
    },
    centroids: {
      get: function get() {
        return this.$store.getters.centroids;
      },
      set: function set(value) {
        return this.$store.dispatch('setCentroids', value);
      }
    },
    ths: {
      get: function get() {
        var ths = [{
          key: 'shop'
        }, {
          key: 'dry'
        }, {
          key: 'Fresh'
        }, {
          key: 'frozen'
        }];
        var labels = this.$store.getters.sourceDataField[this.$store.getters.sourceDataType];
        ths.forEach(function (item) {
          item.label = labels[item.key];
        });
        return ths;
      }
    }
  },
  data: function data() {
    return {
      show_order_car: '',
      datas: [],
      option: {
        chartType: 'bar',
        dataX: 'value1',
        dataY: 'value3',
        dataZ: 'value2',
        otherOption: {
          title: ''
        },
        style: ''
      },
      thsCentroids: [{
        label: '车辆名称',
        key: 'car_name'
      }, {
        label: '中心点',
        key: 'center'
      }, {
        label: '顾客数',
        key: 'customer_num'
      }, {
        label: '订货数量',
        key: 'order_num'
      }, {
        label: '总距离',
        key: 'distance'
      }]
    };
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_map__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_SwitchMapBtn__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_SwitchMapBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_SwitchMapBtn__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    switch_map_btn: __WEBPACK_IMPORTED_MODULE_1__components_bit_SwitchMapBtn___default.a,
    chart_map: __WEBPACK_IMPORTED_MODULE_0__view_map___default.a
  },
  created: function created() {
    this.$store.dispatch('getCaseList');
    if (this.solutionStatus === 0 && this.$router.history.current.name === 'cycle') {
      this.$router.push({ name: 'import' });
    }
  },

  computed: {
    solutionStatus: {
      get: function get() {
        return this.$store.getters.solutionStatus;
      }
    },
    path: {
      get: function get() {
        return this.$store.state.route.path;
      }
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_init__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_demo_map__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_demo_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__view_demo_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHead__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // 坐标
      routerOk: false,
      lData: {},
      tableData: []
    };
  },

  components: {
    switch_map_btn: __WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn___default.a,
    DemoMap: __WEBPACK_IMPORTED_MODULE_1__view_demo_map___default.a,
    PageHead: __WEBPACK_IMPORTED_MODULE_2__components_PageHead___default.a
  },
  created: function created() {
    this.loadLocation();
  },

  methods: {
    loadLocation: function loadLocation() {
      var _this = this;

      var dispatch = this.$store.dispatch;
      dispatch('setLoading', true);
      dispatch('setLoadingText', '获取数据中');
      dispatch('setPercentage', { 'start': 0, 'next': 100 });
      __WEBPACK_IMPORTED_MODULE_0__axios_init__["b" /* axiosSysApi */].get('/static/inputdemodata.json').then(function (response) {
        var sData = [];
        var eData = [];
        var hData = [];
        response.data.Coordinate.forEach(function (item) {
          var location = item[1].split(',');
          location.forEach(function (itemL, index) {
            location[index] = Number(itemL);
          });
          _this.lData[item[0]] = location;
          if (item[2] === 'center') {
            sData.push({ name: item[0], value: location });
          } else if (item[2] === 'hos') {
            hData.push({ name: item[0], value: location });
            console.log('wtf!!!!!!!!!!!!!');
          } else {
            eData.push({ name: item[0], value: location });
          }
        });
        dispatch('setDemoMapDataPlant', sData);
        dispatch('setDemoMapDataCustomer', eData);
        dispatch('setDemoMapDataCenter', hData);
        dispatch('setLoadingText', '获取数据完成');
        dispatch('setPercentage', { 'start': 100, 'next': 100 });
      }).catch(function (e) {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '获取数据异常',
          message: '错误信息:' + e
        });
        dispatch('setLoadingText', '获取数据异常');
        dispatch('setPercentage', { 'start': 100, 'next': 100 });
        console.log(e);
      });
    },
    loadRouter: function loadRouter() {
      var _this2 = this;

      var dispatch = this.$store.dispatch;
      dispatch('setLoading', true);
      dispatch('setLoadingText', '求解路径中');
      dispatch('setPercentage', { 'start': 0, 'next': 100 });
      this.tableData = [];
      __WEBPACK_IMPORTED_MODULE_0__axios_init__["b" /* axiosSysApi */].get('/static/demooutput.json').then(function (response) {
        var newData = [];
        response.data.forEach(function (item) {
          newData[item[2]] = item;
        });
        var routers = [{ name: '车辆1', data: [] }];
        _this2.tableData = ['车辆1'];
        newData.forEach(function (item) {
          _this2.tableData.push(item[0]);
          routers[0].data.push({
            fromName: item[0],
            toName: item[1],
            coords: [_this2.lData[item[0]], _this2.lData[item[1]]]
          });
        });
        dispatch('setDemoMapDataRoute', routers);
        dispatch('setLoadingText', '获取数据完成');
        dispatch('setPercentage', { 'start': 100, 'next': 100 });
      }).catch(function (e) {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '获取数据异常',
          message: '错误信息:' + e
        });
        dispatch('setLoadingText', '获取数据异常');
        dispatch('setPercentage', { 'start': 100, 'next': 100 });
        console.log(e);
      });
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

window.echarts = __webpack_require__(51);
window.myDemoChat = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loadJs: false,
      first: '0'
    };
  },
  created: function created() {
    this.$store.dispatch('setDemoChatStatus', 0);
  },
  mounted: function mounted() {
    window.initMapDemo = this.initChar;
    var chat = window.echarts.init(document.getElementById('chart-map-demo'));
    window.myDemoChat = chat;
    this.$store.dispatch('setDemoChatStatus', 1);
    this.loadBdmapApi();
  },

  methods: {
    loadBdmapApi: function loadBdmapApi() {
      this.loadJs = true;
      var script = document.createElement('script');
      script.src = 'https://api.map.baidu.com/api?v=2.0&ak=O8eyfQgNIOYnnGYqM2xVAqXtmqkyk6CT&callback=initMapDemo';
      document.body.appendChild(script);
    },
    initChar: function initChar() {
      this.$store.dispatch('initDemoMapOption');
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a
  },
  data: function data() {
    return {
      down2: false,
      down3: false
    };
  },

  computed: {
    login: {
      get: function get() {
        return this.$store.getters.login;
      }
    }
  },
  methods: {
    goLgin: function goLgin() {
      this.$router.push('/login');
      this.$store.dispatch('setLoginFor', '/down');
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a
  },
  data: function data() {
    return {
      showImport: false,
      importCases: [],
      newCase: {
        name: '',
        d1: '雨天',
        d2: 0,
        d3: '4500kWh',
        d4: 0.01,
        d5: 0.99,
        d6: 0.5,
        d7: 0,
        // 0 start 10 新增完成 20 求解中 30 求解完成
        status: 0,
        result: {}
      },
      status_text: {
        '0': 'start',
        '10': '新增完成',
        '20': '求解中。。。',
        '30': '求解完成'
      },
      addCase: false,
      weathers: ['晴天', '雨天'],
      datas1: [0, 0.5, -0.42],
      datas2: ['4500kWh', '100kWh'],
      datas3: [0.3, 0.1, 0.01],
      datas4: [0.95, 0.99],
      datas5: [0.5],
      datas6: [0, 0.2]
    };
  },

  methods: {
    testImported: function testImported(caseName) {
      var data = false;
      this.casesEle.forEach(function (item) {
        if (caseName === item.name) {
          data = true;
        }
      });
      return data;
    },
    importCase: function importCase() {
      this.showImport = false;
      this.$store.dispatch('oupoutEleCase', this.importCases);
      this.importCases = [];
    },
    chooseCase: function chooseCase(data) {
      if (this.allSaveCasesName.indexOf(data.name) > -1) {
        this.$store.dispatch('clearOneEleCase', data.name);
      } else {
        this.$store.dispatch('saveOneEleCase', data);
      }
    },
    showAdd: function showAdd() {
      this.addCase = true;
      this.newCase = {
        name: '方案' + (this.casesEle.length + 1),
        d1: '雨天',
        d2: 0,
        d3: '4500kWh',
        d4: 0.01,
        d5: 0.99,
        d6: 0.5,
        d7: 0,
        status: 0,
        result: {}
      };
    },
    addNewCase: function addNewCase() {
      this.addCase = false;
      this.$store.dispatch('addCasesEle', this.newCase);
    }
  },
  computed: {
    eleStatus: {
      get: function get() {
        return this.$store.getters.eleStatus;
      }
    },
    allSaveCasesName: {
      get: function get() {
        return this.$store.getters.allSaveCasesName;
      }
    },
    casesEle: {
      get: function get() {
        return this.$store.getters.casesEle;
      }
    }
  },
  created: function created() {
    if (this.eleStatus < 10) {
      this.$router.push({ name: 'ele_import' });
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_CaseCompareTable__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_CaseCompareTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_CaseCompareTable__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CaseCompareTable: __WEBPACK_IMPORTED_MODULE_0__components_bit_CaseCompareTable___default.a
  },
  computed: {
    eleStatus: {
      get: function get() {
        return this.$store.getters.eleStatus;
      }
    },
    compareCasesName: {
      get: function get() {
        return this.$store.getters.compareCasesName;
      },
      set: function set(value) {
        this.$store.dispatch('setCompareCasesName', value);
      }
    },
    casesEle: {
      get: function get() {
        return this.$store.getters.casesEle;
      }
    },
    compareCases: {
      get: function get() {
        var vm = this;
        var newData = [];
        if (this.casesEle) {
          this.casesEle.forEach(function (item, index) {
            if (vm.compareCasesName.indexOf(item.name) > -1) {
              item.index = index;
              newData.push(item);
            }
          });
        }
        return newData;
      }
    }
  },
  created: function created() {
    if (this.eleStatus < 10) {
      this.$router.push({ name: 'ele_import' });
    }
  },
  mounted: function mounted() {
    if (this.compareCasesName.length === 0) {
      var newData = [];
      this.casesEle.forEach(function (item) {
        if (item.status === 30) {
          newData.push(item.name);
        }
      });
      this.compareCasesName = newData.slice(0, 2);
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xlsx__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a
  },
  methods: {
    importf: function importf(e) {
      this.localFile = null;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (['xlsx'].indexOf(files[0].name.split('.').slice(-1)[0]) > -1) {
        this.localFile = files[0];
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择excel文件。'
        });
        document.getElementById('file-1').value = '';
      }
    },
    readData: function readData() {
      var vm = this;
      var reader = new FileReader();
      reader.onload = function (e) {
        var allDatas = {};
        var data = e.target.result;
        var wb = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.read(data, {
          type: 'binary'
        });
        if (vm.testSheets(wb.SheetNames)) {
          vm.sheets.forEach(function (item) {
            var newDatas = [];
            if (item.name === '负荷数据') {
              var datas = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.sheet_to_row_object_array(wb.Sheets[item.name]);
              datas.forEach(function (item) {
                newDatas.push([item['时间'], Number(item['工作日'])]);
              });
            } else if (item.name === '光伏出力') {
              var _datas = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.sheet_to_row_object_array(wb.Sheets[item.name]);
              _datas.forEach(function (item) {
                newDatas.push(['sun', item['时间'], Number(item['阴雨天']), Number(item['晴天'])]);
              });
            } else if (item.name === '电价') {
              var _datas2 = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.sheet_to_row_object_array(wb.Sheets[item.name]);
              _datas2.forEach(function (item) {
                newDatas.push(['master', item['时间'], Number(item['网购电价']), Number(item['余量上网电价'])]);
              });
            } else if (item.name === '固定储能（通用储能特性）') {
              var _datas3 = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.sheet_to_row_object_array(wb.Sheets[item.name]);
              _datas3.forEach(function (item) {
                newDatas.push([item['电量'], Number(item['功率下限']), Number(item['功率上限'])]);
              });
            } else if (item.name === '移动储能') {
              var _datas4 = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.sheet_to_row_object_array(wb.Sheets[item.name]);
              var timeDatas = [];
              _datas4.forEach(function (item) {
                newDatas.push([item['时间'], Number(item['在网车辆数目']), Number(item['新增初始能量']), Number(item['储能下限']), Number(item['储能上限'])]);
                timeDatas.push(item['时间']);
              });
              allDatas['period'] = timeDatas;
            }
            allDatas[item.key] = newDatas;
          });
          allDatas['generator'] = [['wind', 'wind'], ['sun', 'sun'], ['battery', 'battery'], ['thermal', 'thermal'], ['master', 'master']];
          vm.$store.dispatch('setSourceDataEle', allDatas);
          vm.$router.push({ 'name': 'ele_source_data' });
        } else {
          vm.$store.dispatch('showNoticeMsg', {
            type: 'warning',
            title: '系统提示',
            message: '导入数据格式不规范！'
          });
          document.getElementById('file-1').value = '';
        }
      };
      reader.readAsBinaryString(this.localFile);
    },
    goSourceDataPage: function goSourceDataPage() {
      if (this.activeImportWayKey === 'demo') {
        this.$store.dispatch('loadSourceDataEle');
        this.$router.push({ 'name': 'ele_source_data' });
      } else if (this.localFile) {
        this.readData();
      }
    },
    testSheets: function testSheets(data) {
      var ok = true;
      this.sheets.forEach(function (item) {
        if (data.indexOf(item.name) === -1) {
          ok = false;
        }
      });
      return ok;
    }
  },
  computed: {
    caseList: {
      get: function get() {
        return this.$store.getters.caseList;
      }
    },
    activeCase: {
      get: function get() {
        return this.$store.getters.activeCase;
      }
    }
  },
  data: function data() {
    return {
      localFile: null,
      dialogVisible: false,
      sheets: [{
        name: '负荷数据',
        key: 'load',
        needDataKeys: ['时间', '工作日']
      }, {
        name: '光伏出力',
        key: 'new_eng',
        needDataKeys: ['时间', '阴雨天', '晴天']
      }, {
        name: '电价',
        key: 'grid_price',
        needDataKeys: ['时间', '网购电价', '余量上网电价']
      }, {
        name: '固定储能（通用储能特性）',
        key: 'Steady_battery',
        needDataKeys: ['电量', '功率下限', '功率上限']
      }, {
        name: '移动储能',
        key: 'Move_battery',
        needDataKeys: ['时间', '功率下限', '功率上限']
      }],
      activeImportWayKey: '',
      importWays: [{
        name: '本地文件',
        key: 'local_file'
      }, {
        name: 'DEMO',
        key: 'demo'
      }]
    };
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiTable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_MiiTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_CaseCompareTable__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_CaseCompareTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_bit_CaseCompareTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eleChatOption__ = __webpack_require__(191);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MiiTable: __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiTable___default.a,
    CaseCompareTable: __WEBPACK_IMPORTED_MODULE_2__components_bit_CaseCompareTable___default.a
  },
  data: function data() {
    return {
      dialogVisible: false,
      dialog_content: '',
      oldLength: '',
      ths: [{
        label: '时间',
        key: 0
      }, {
        label: '光伏发电',
        key: 2
      }, {
        label: '购电量',
        key: 4
      }, {
        label: '卖电量',
        key: 5
      }, {
        label: '电池充电',
        key: 7
      }, {
        label: '电池放电',
        key: 8
      }, {
        label: 'SOC',
        key: 9
      }]
    };
  },

  methods: {
    goCompare: function goCompare() {
      this.$router.push({ name: 'ele_compare' });
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    gooter: function gooter(value) {
      if (this.oldLength > value.length) {
        return;
      }
      var goCaseName = value[value.length - 1];
      var showIndex = 0;
      this.showCases.forEach(function (item, index) {
        if (item.name === goCaseName) {
          showIndex = index;
        }
      });
      var dom = document.getElementById('result-page');
      dom.scrollTop = dom.scrollHeight / this.showCases.length * showIndex;
      this.oldLength = value.length;
    },
    initCat1: function initCat1(caseData, index, num) {
      var data = this.$store.getters.sourceDataEle.load;
      var myChat = window.echarts.init(document.getElementById('chart-' + index));
      var chatData = { max: 0, xData: [], yData: [[], [], []], legend: ['光伏发电', '负荷', 'SOC'] };
      caseData.forEach(function (item, index) {
        chatData.max = chatData.max < item[2] ? item[2] : chatData.max;
        chatData.xData.push(item[0]);
        chatData.yData[0].push(item[2]);
        chatData.yData[1].push(data[index][1]);
        chatData.yData[2].push(item[9] * num);
      });
      myChat.setOption(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__eleChatOption__["a" /* initChatContinuousOption */])(chatData), true);
    },
    initCat2: function initCat2(caseData, index) {
      var myChat = window.echarts.init(document.getElementById('chart-2-' + index));
      var data = [{
        name: '购电成本',
        value: caseData[0]
      }, {
        name: '储能成本',
        value: caseData[1]
      }, {
        name: '光伏发电成本',
        value: caseData[2]
      }];
      myChat.setOption(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__eleChatOption__["b" /* initChatPreOption */])(data));
    }
  },
  computed: {
    eleStatus: {
      get: function get() {
        return this.$store.getters.eleStatus;
      }
    },
    showCasesName: {
      get: function get() {
        return this.$store.getters.showCasesName;
      },
      set: function set(value) {
        this.$store.dispatch('setShowCasesName', value);
      }
    },
    casesEle: {
      get: function get() {
        return this.$store.getters.casesEle;
      }
    },
    showCases: {
      get: function get() {
        var vm = this;
        var newData = [];
        if (this.casesEle) {
          this.casesEle.forEach(function (item, index) {
            if (vm.showCasesName.indexOf(item.name) > -1) {
              item.index = index;
              newData.push(item);
              __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
                // vm.initCat1(item.result['调度方案'], index, Number(item.d3.split('k')[0]))
                vm.initCat2(item.result['成本'][0], index);
              });
            }
          });
        }
        return newData;
      }
    }
  },
  created: function created() {
    if (this.eleStatus < 10) {
      this.$router.push({ name: 'ele_import' });
    }
  },
  mounted: function mounted() {
    if (this.showCasesName.length === 0) {
      var newData = [];
      this.casesEle.forEach(function (item) {
        if (item.status === 30) {
          newData.push(item.name);
        }
      });
      this.showCasesName = newData.slice(0, 2);
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiTable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_MiiTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eleChatOption__ = __webpack_require__(191);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MiiTable: __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiTable___default.a
  },
  data: function data() {
    return {
      active_type: -1,
      table_height: 24,
      data_types: ['电价', '负荷', '光伏出力', '固定储能', '移动储能'],
      chat_grid_price: null,
      chat_load: null,
      chat_new_eng: null,
      chat_1: null,
      chat_2: null,
      ths_1: [{
        label: 'id',
        key: 0
      }, {
        label: '时间',
        key: 1
      }, {
        label: '电价',
        key: 2
      }, {
        label: '卖价',
        key: 3
      }],
      ths_2: [{
        label: '时间',
        key: 0
      }, {
        label: '负荷',
        key: 1
      }],
      ths_3: [{
        label: 'id',
        key: 0
      }, {
        label: '时间',
        key: 1
      }, {
        label: '雨天',
        key: 2
      }, {
        label: '晴天',
        key: 3
      }],
      ths_4: [{
        label: '电量',
        key: 0
      }, {
        label: '功率下限',
        key: 1
      }, {
        label: '功率上限',
        key: 2
      }],
      ths_5: [{
        label: '时间',
        key: 0
      }, {
        label: '在网车辆数目',
        key: 1
      }, {
        label: '新增初始能量',
        key: 2
      }, {
        label: '储能下限',
        key: 3
      }, {
        label: '储能上限',
        key: 4
      }]
    };
  },

  computed: {
    sourceDataEle: {
      get: function get() {
        if (this.$store.getters.sourceDataEle) {
          var vm = this;
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
            vm.active_type = (vm.active_type + 1) % 3;
          });
        }
        return this.$store.getters.sourceDataEle;
      }
    },
    eleStatus: {
      get: function get() {
        return this.$store.getters.eleStatus;
      }
    },
    dataGridPrice: {
      get: function get() {
        return this.sourceDataEle.grid_price;
      }
    },
    dataLoad: {
      get: function get() {
        return this.sourceDataEle.load;
      }
    },
    dataNewEng: {
      get: function get() {
        return this.sourceDataEle.new_eng;
      }
    },
    dataSteadyBattery: {
      get: function get() {
        return this.sourceDataEle.Steady_battery;
      }
    },
    dataMoveBattery: {
      get: function get() {
        return this.sourceDataEle.Move_battery;
      }
    }
  },
  methods: {
    initChatGridPrice: function initChatGridPrice() {
      this.chat_grid_price = window.echarts.init(document.getElementById('chart-grid_price'));
      var data = this.dataGridPrice;
      if (data) {
        var chatData = { max: 0, xData: [], yData: [[], []], legend: ['电价', '卖价'] };
        data.forEach(function (item) {
          chatData.max = chatData.max < item[2] ? item[2] : chatData.max;
          chatData.xData.push(item[1]);
          chatData.yData[0].push(item[2]);
          chatData.yData[1].push(item[3]);
        });
        this.chat_grid_price.setOption(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__eleChatOption__["a" /* initChatContinuousOption */])(chatData, true), true);
      }
    },
    initChatLoad: function initChatLoad() {
      this.chat_load = window.echarts.init(document.getElementById('chart-load'));
      var data = this.dataLoad;
      if (data) {
        var chatData = { max: 0, xData: [], yData: [[]], legend: ['负荷'] };
        data.forEach(function (item) {
          chatData.max = chatData.max < item[1] ? item[1] : chatData.max;
          chatData.xData.push(item[0]);
          chatData.yData[0].push(item[1]);
        });
        this.chat_load.setOption(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__eleChatOption__["a" /* initChatContinuousOption */])(chatData), true);
      }
    },
    initChatNewEng: function initChatNewEng() {
      this.chat_new_eng = window.echarts.init(document.getElementById('chart-new_eng'));
      var data = this.dataNewEng;
      if (data) {
        var chatData = { max: 0, xData: [], yData: [[], []], legend: ['雨天', '晴天'] };
        data.forEach(function (item) {
          chatData.max = chatData.max < item[3] ? item[3] : chatData.max;
          chatData.xData.push(item[1]);
          chatData.yData[0].push(item[2]);
          chatData.yData[1].push(item[3]);
        });
        this.chat_new_eng.setOption(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__eleChatOption__["a" /* initChatContinuousOption */])(chatData), true);
      }
    },
    initChatSteadyBattery: function initChatSteadyBattery() {
      this.chat_1 = window.echarts.init(document.getElementById('chart-steady-b'));
      var data = this.dataSteadyBattery;
      if (data) {
        var chatData = { max: 0, xData: [], yData: [[], []], legend: ['功率下限', '功率上限'] };
        data.forEach(function (item) {
          chatData.max = chatData.max < item[2] ? item[2] : chatData.max;
          chatData.xData.push(item[0]);
          chatData.yData[0].push(item[1]);
          chatData.yData[1].push(item[2]);
        });
        this.chat_1.setOption(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__eleChatOption__["a" /* initChatContinuousOption */])(chatData, false, true), true);
      }
    },
    initChatMoveBattery: function initChatMoveBattery() {
      this.chat_2 = window.echarts.init(document.getElementById('chart-move-b'));
      var data = this.dataMoveBattery;
      if (data) {
        var chatData = { max: 0, xData: [], yData: [[], [], []], legend: ['新增初始能量', '储能下限', '储能上限'] };
        data.forEach(function (item) {
          chatData.max = chatData.max < item[3] ? item[3] : chatData.max;
          chatData.xData.push(item[0]);
          chatData.yData[0].push(item[2]);
          chatData.yData[1].push(item[3]);
          chatData.yData[2].push(item[4]);
        });
        this.chat_2.setOption(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__eleChatOption__["a" /* initChatContinuousOption */])(chatData), true);
      }
    }
  },
  watch: {
    active_type: function active_type(val, oldVal) {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
        if (val === 0) {
          vm.initChatGridPrice();
        } else if (val === 1) {
          vm.initChatLoad();
        } else if (val === 2) {
          vm.initChatNewEng();
        } else if (val === 3) {
          vm.initChatSteadyBattery();
        } else if (val === 4) {
          vm.initChatMoveBattery();
        }
      });
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_map__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LeftBarEle__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LeftBarEle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_LeftBarEle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeadEle__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeadEle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeadEle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bit_Loading__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bit_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_bit_Loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    left_bar_ele: __WEBPACK_IMPORTED_MODULE_1__components_LeftBarEle___default.a,
    page_head: __WEBPACK_IMPORTED_MODULE_2__components_PageHeadEle___default.a,
    switch_map_btn: __WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn___default.a,
    chart_map: __WEBPACK_IMPORTED_MODULE_0__view_map___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_4__components_bit_Loading___default.a
  },
  created: function created() {
    this.$store.dispatch('getAllSaveCasesName');
    if (this.solutionStatus === 0 && this.$router.history.current.name === 'home_base') {
      this.$router.push({ name: 'import' });
    }
  },

  computed: {
    solutionStatus: {
      get: function get() {
        return this.$store.getters.solutionStatus;
      }
    },
    path: {
      get: function get() {
        return this.$store.state.route.path;
      }
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_map__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LeftBar__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_LeftBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHead__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bit_Loading__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bit_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_bit_Loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    left_bar: __WEBPACK_IMPORTED_MODULE_1__components_LeftBar___default.a,
    page_head: __WEBPACK_IMPORTED_MODULE_2__components_PageHead___default.a,
    switch_map_btn: __WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn___default.a,
    chart_map: __WEBPACK_IMPORTED_MODULE_0__view_map___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_4__components_bit_Loading___default.a
  },
  created: function created() {
    this.$store.dispatch('getCaseList');
    if (this.solutionStatus === 0 && this.$router.history.current.name === 'home_base') {
      this.$router.push({ name: 'import' });
    }
  },

  computed: {
    solutionStatus: {
      get: function get() {
        return this.$store.getters.solutionStatus;
      }
    },
    path: {
      get: function get() {
        return this.$store.state.route.path;
      }
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a
  },
  methods: {
    startImport: function startImport(throwAway) {
      if (this.activeCase.status === 'new' && !throwAway) {
        this.dialogVisible = true;
      } else {
        this.$store.dispatch('addCase', this.activeImportWayKey === 'demo2' ? '石化DEMO' : '零售DEMO');
        this.$store.dispatch('setSourceDataType', this.activeImportWayKey === 'demo2' ? 'oil' : 'shop');
        this.$store.dispatch('initMapOption');
        this.$store.dispatch('loadSourceData', this.activeImportWayKey === 'demo2' ? 'source_data_oil.json' : 'source_data_shop.json');
        this.$router.push({ name: 'cycle' });
      }
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    changeCase: function changeCase(data) {
      this.$store.dispatch('switchCase', data.key);
      this.$router.push({ name: 'cycle' });
    }
  },
  computed: {
    caseList: {
      get: function get() {
        return this.$store.getters.caseList;
      }
    },
    activeCase: {
      get: function get() {
        return this.$store.getters.activeCase;
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      importWays: [{
        name: '零售DEMO',
        key: 'demo1'
      }, {
        name: '石化DEMO',
        key: 'demo2'
      }],
      activeImportWayKey: 'demo1',
      outPutWays: [{
        name: '存储至浏览器',
        key: 'browser'
      }, {
        name: '导出至Excel',
        key: 'excel'
      }],
      activeOutPutWayKey: 'browser',
      down1: true
    };
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageHead__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PageHead__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    page_head: __WEBPACK_IMPORTED_MODULE_0__components_PageHead___default.a
  },
  methods: {
    goSingle: function goSingle() {
      this.$router.push({ name: 'single_home' });
    },
    gowork: function gowork() {
      this.$router.push({ name: 'home_base' });
    }
  },
  computed: {
    path: {
      get: function get() {
        return this.$store.state.route.path;
      }
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_oli_api__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false,
      checked: true,
      account: '',
      password: ''
    };
  },
  created: function created() {
    this.$store.dispatch('logOut');
  },

  methods: {
    login: function login() {
      var vm = this;
      if (!this.account) {
        vm.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提醒',
          message: '请输入账号'
        });
        return;
      }
      if (!this.password) {
        vm.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提醒',
          message: '请输入密码'
        });
        return;
      }
      vm.loading = true;
      var parm = {
        USER_ACCOUNT: this.account,
        PWD: this.password
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["a" /* login */])(parm).then(function (data) {
        if (data.code === 1) {
          vm.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提醒',
            message: data.msg
          });
          vm.$store.dispatch('setLoginData', { data: data, save: vm.checked });
          vm.$router.push({ name: vm.$store.getters.loginFor || 'index' });
        } else {
          vm.$store.dispatch('showNoticeMsg', {
            type: 'warning',
            title: '系统提醒',
            message: data.msg
          });
        }
        vm.loading = false;
      }).catch(function (e) {
        vm.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '登录失败',
          message: e
        });
        vm.loading = false;
      });
    },
    goRegister: function goRegister() {
      this.$router.push('/register');
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

window.echarts = __webpack_require__(51);

window.myChat = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loadJs: false,
      first: '0'
    };
  },
  created: function created() {
    this.$store.dispatch('setChatStatus', 0);
  },
  mounted: function mounted() {
    window.initMap = this.initChar;
    var chat = window.echarts.init(document.getElementById('chart-map'));
    window.myChat = chat;
    this.$store.dispatch('setChatStatus', 1);
    this.loadBdmapApi();
  },

  computed: {
    sourceDataType: {
      get: function get() {
        return this.$store.getters.sourceDataType;
      }
    },
    solutionStatus: {
      get: function get() {
        return this.$store.getters.solutionStatus;
      }
    },
    solutionDay: {
      get: function get() {
        return this.$store.getters.solutionDay;
      },
      set: function set(value) {
        return this.$store.dispatch('setSolutionDay', value);
      }
    },
    solutionWeeks: {
      get: function get() {
        return this.$store.getters.solutionWeeks;
      }
    }
  },
  methods: {
    hideAllcar: function hideAllcar() {
      window.myChat.getOption().legend[1].data.forEach(function (item) {
        window.myChat.dispatchAction({
          type: 'legendToggleSelect',
          name: item
        });
      });
    },
    changeColor: function changeColor() {
      var option = window.myChat.getOption();
      var color = option.bmap[0].mapStyle.styleJson[14].color;
      if (color === '#081734') {
        option.bmap[0].mapStyle.styleJson[14].color = '#FFFFFF';
        window.myChat.setOption(option);
      } else {
        option.bmap[0].mapStyle.styleJson[14].color = '#081734';
        window.myChat.setOption(option);
      }
    },
    loadBdmapApi: function loadBdmapApi() {
      this.loadJs = true;
      var script = document.createElement('script');
      script.src = 'https://api.map.baidu.com/api?v=2.0&ak=O8eyfQgNIOYnnGYqM2xVAqXtmqkyk6CT&callback=initMap';
      document.body.appendChild(script);
    },
    initChar: function initChar() {
      var vm = this;
      this.$store.dispatch('initMapOption');
      window.myChat.on('legendselectchanged', function (params) {
        if (params.name.indexOf('车辆') > -1) {
          vm.$store.dispatch('selectMapCarCustomer', { car: params.name, status: params.selected[params.name] });
        }
      });
    },
    initBMap: function initBMap() {
      var option = window.myChat.getOption();
      option.bmap[0].center = [106.54904, 29.5513];
      option.bmap[0].zoom = 12;
      window.myChat.setOption(option, true);
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

window.echarts = __webpack_require__(51);

window.myPreChat = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loadJs: false,
      first: '0'
    };
  },
  created: function created() {
    this.$store.dispatch('setChatPreStatus', 0);
  },
  mounted: function mounted() {
    window.initMap = this.initChar;
    var chat = window.echarts.init(document.getElementById('chart-map-pre'));
    window.myPreChat = chat;
    this.$store.dispatch('setChatPreStatus', 1);
    this.loadBdmapApi();
  },

  computed: {
    activeStation: {
      get: function get() {
        return this.$store.getters.activeStation;
      },
      set: function set(value) {
        this.$store.dispatch('setActiveStation', value);
      }
    },
    flowStatus: {
      get: function get() {
        return this.$store.getters.flowStatus;
      }
    },
    stationLocationList: {
      get: function get() {
        return ['全部', '云南昆东油库', '云南长坡油库', '云南中油安宁油库'];
      }
    },
    mapOption: {
      get: function get() {
        return this.$store.getters.mapOption;
      }
    }
  },
  methods: {
    changeColor: function changeColor() {
      var option = window.myPreChat.getOption();
      var color = option.bmap[0].mapStyle.styleJson[14].color;
      if (color === '#081734') {
        option.bmap[0].mapStyle.styleJson[14].color = '#FFFFFF';
        window.myPreChat.setOption(option);
      } else {
        option.bmap[0].mapStyle.styleJson[14].color = '#081734';
        window.myPreChat.setOption(option);
      }
    },
    loadBdmapApi: function loadBdmapApi() {
      this.loadJs = true;
      var script = document.createElement('script');
      script.src = 'https://api.map.baidu.com/api?v=2.0&ak=O8eyfQgNIOYnnGYqM2xVAqXtmqkyk6CT&callback=initMap';
      document.body.appendChild(script);
    },
    initChar: function initChar() {
      this.$store.dispatch('initMapPreOption');
    },
    initBMap: function initBMap() {
      var option = window.myPreChat.getOption();
      option.bmap[0].center = this.mapOption.center;
      option.bmap[0].zoom = this.mapOption.zoom;
      window.myPreChat.setOption(option, true);
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_oil_adjust_order__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_oil_adjust_order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__view_oil_adjust_order__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeadAdjust__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeadAdjust___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeadAdjust__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bit_Loading__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bit_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_bit_Loading__);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.logined !== 1) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('setLoginFor', 'adjust_home');
      next({ name: 'login' });
    } else if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.oilArea) {
      next({ name: 'index' });
    } else {
      next();
    }
  },

  components: {
    PageHead: __WEBPACK_IMPORTED_MODULE_2__components_PageHeadAdjust___default.a,
    AdjustOrder: __WEBPACK_IMPORTED_MODULE_1__view_oil_adjust_order___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_3__components_bit_Loading___default.a
  },
  created: function created() {
    this.$store.dispatch('loadInputData');
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiBaseTable__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiBaseTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_bit_MiiBaseTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__oil_ps_detail__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__oil_ps_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__oil_ps_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__area_jxc__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__area_jxc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__area_jxc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_bit_MiiTableOil__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_bit_MiiTableOil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_bit_MiiTableOil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_oli_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cllib__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var nullOrder = {
  '油站代码': '',
  '代号': '',
  '时间': '',
  '平均销量': '',
  '期初库存': 0,
  '入库升数': '',
  '出库升数': 10000,
  '期末库存': '',
  '空容': '',
  '断货时间': '',
  '订单紧急程度': '库存充足订单',
  '小罐多销': 0,
  '油库代码': '',
  '建议配送量': 10000,
  '不容纳时间': '',
  '当日加单': 0
};

var jhOrderThs = [{
  label: 'ID',
  key: 'SFID'
}, {
  label: '加油站',
  key: '油站名',
  shortType: 'text'
}, {
  label: '罐',
  key: '罐号'
}, {
  label: '油品',
  key: '油品名',
  shortType: 'text'
}, {
  label: '预配送',
  key: '建议配送量'
}];

var orderAdjustStatus = {
  'normal': '未',
  'locking': '定',
  'plan': '待',
  'done': '已'
};

var allOrderThs = [{
  label: '',
  key: 'STATUS',
  shortType: 'text',
  showText: function showText(data) {
    return orderAdjustStatus[data];
  }
}, {
  label: '加油站',
  key: '油站名',
  shortType: 'text',
  clickAction: 'choose_station'
}, {
  label: '罐',
  key: '罐号',
  clickAction: 'choose_station_guan'
}, {
  label: '油品',
  key: '油品名',
  shortType: 'text',
  clickAction: 'choose_station_oiltype'
}, {
  label: '不容纳',
  key: '不容纳时间',
  shortType: 'time'
}, {
  label: '断货',
  key: '断货时间',
  shortType: 'time'
}, {
  label: '预配送',
  key: '建议配送量',
  clickAction: 'choose_jyps'
}, {
  label: '运距',
  key: '运距'
}, {
  label: '油库',
  key: '油库',
  shortType: 'text'
}];

var carTeamDl = ['丽江车队', '迪庆车队', '德宏车队', '大理车队', '临沧车队', '保山车队', '景东车队', '怒江车队'];
var carTeamKm = ['昆东', '长坡'];
var carTeamHh = ['红河车队', '文山车队'];
var carTeamYp = ['玉溪车队', '景洪车队', '普洱西盟江城澜沧孟连车队'];
var carTeamZp = ['松林油库', '水富油库', '北闸油库'];

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default.a,
    MiiBaseTable: __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiBaseTable___default.a,
    OilPsDetail: __WEBPACK_IMPORTED_MODULE_3__oil_ps_detail___default.a,
    AreaJxc: __WEBPACK_IMPORTED_MODULE_4__area_jxc___default.a,
    MiiTableOil: __WEBPACK_IMPORTED_MODULE_5__components_bit_MiiTableOil___default.a
  },
  data: function data() {
    return {
      yaoHuoMin: '',
      outPutOilType: ['汽油', '柴油'],
      yaoHuoOilType: ['汽油', '柴油'],
      showOilCarOrderList: [],
      carOrderTitle: '',
      jxcTitle: '',
      carOrderOilData: '',
      showCarOrderType: 'car',
      searchYaohuo: '',
      yaoHuoCheckList: [],
      showYaohuo: false,
      yaoHuoBJ: false,
      allCarOrder: 'tang',
      leftRightQH: null,
      num: 0,
      chooseCarValue: -1,
      chooseOrderValue: -1,
      boardings: ['no_delivery'],
      allCar: false,
      selectArea: '',
      chooseOrder1: -1,
      chooseOrder2: -1,
      chooseOrder3: -1,
      chooseGIndex: -1,
      showOilDetail: false,
      oilDetailMap: {},
      clearNum: 0,
      clearNumZd: 0,
      tc: '',
      chooseOrderBXHis: null,
      chooseOrderBX: null,
      showAddTs: false,
      showAreaJxc: false,
      chooseOrderHis: [],
      tcList: [],
      wfpKey: '',
      carKey: '',
      team: '',
      splitNum: 2,
      inputCKSS: 0,
      inputPSL: 0,
      actions: [{
        icon: 'icon-clear',
        key: 'clear'
      }],
      actions3: [{
        icon: 'icon-clear',
        key: 'clear3'
      }],
      actions_search: [{
        icon: 'icon-cheliangtiaodu',
        key: 'sys_pipei'
      }],
      actions2: [{
        icon: 'icon-addfriend',
        key: 'add'
      }],
      actions4: [{
        icon: 'icon-woyaorongzi00',
        key: 'yaohuo_check'
      }, {
        icon: 'icon-daochu',
        key: 'out_put'
      }],
      newOrder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__cllib__["b" /* mapCp */])(nullOrder),
      gasDatas: [],
      showSplitOrder: false,
      showAdd: false,
      showTctz: false,
      showCarDetail: false,
      carDetail: {
        psData: [],
        xzData: {}
      },
      depotList: [],
      carTeams: [],
      oilType: '汽油',
      orderStatus: ['紧急订单', '可配送订单', '库存充足订单'],
      carList: [],
      orderList: [],
      carOrderList: [],
      yunJuMap: {},
      showOutput: false,
      showChooseDepot: false,
      showChooseDepotPs: false,
      carLoading: false,
      orderLoading: false,
      carOrderLoading: false,
      chooseCar: null,
      chooseOrder: null,
      chooseOrders: [],
      psDepot: '',
      chooseOrderChangeDepot: {},
      chooseOrderCg: [],
      chooseCarOrder: null,
      orderTjThs: [{
        label: '油库',
        key: '油库名称'
      }, {
        label: '油品',
        key: '油品名称'
      }, {
        label: '总重量(吨)',
        key: 'DEPOT_TOTAL'
      }, {
        label: '总升数(L)',
        key: 'DEPOT_TOTAL_L'
      }, {
        label: '配送中心',
        key: '配送中心'
      }, {
        label: '总重量(吨)',
        key: 'DEPOT_PSZX_TOTAL'
      }, {
        label: '总升数(L)',
        key: 'DEPOT_PSZX_TOTAL_L'
      }],
      yaohuoThs: [{
        label: '加油站',
        key: '加油站名称'
      }, {
        label: '油品',
        key: '油品名称'
      }, {
        label: '要货量',
        key: '要货量'
      }, {
        label: '合计上车量',
        key: 'TOTAL_PS'
      }, {
        label: '差值',
        key: '差值'
      }, {
        label: '罐号',
        key: '罐号'
      }, {
        label: '上车量',
        key: '配送升数'
      }],
      psjlThs: [{
        label: '时间',
        key: '时间'
      }, {
        label: '配送加油站',
        key: '加油站名称'
      }, {
        label: '配送升数(L)',
        key: '配送升数'
      }],
      carListThs: [{
        label: '车牌号',
        key: '车牌号',
        shortType: 'text'
      }, {
        label: '容积和',
        key: '合计'
      }, {
        label: '在途',
        key: '在途时间'
      }, {
        label: '承运商',
        key: '承运商',
        shortType: 'text'
      }, {
        label: '运距和',
        key: 'sumYJ'
      }, {
        label: '最后配送',
        key: 'oldPs',
        shortType: 'text'
      }],
      jxcThs: [{
        label: '加油站',
        key: '油站名'
      }, {
        label: '罐号',
        key: '罐号'
      }, {
        label: '油品',
        key: '油品名'
      }, {
        label: '入库',
        key: '入库升数'
      }, {
        label: '出库',
        key: '出库升数'
      }, {
        label: '期末',
        key: '期末库存'
      }, {
        label: '空容',
        key: '空容'
      }, {
        label: '销量',
        key: '平均销量'
      }, {
        label: '在途',
        key: '在途计划升数'
      }, {
        label: '预配送',
        key: '配送计划'
      }, {
        label: '物理容积',
        key: '物理容积'
      }, {
        label: '停泵库存',
        key: '停泵库存'
      }, {
        label: '有效容积',
        key: '有效容积'
      }],
      tableActionOrder: [{
        label: '详',
        key: 'oil_detail'
      }, {
        label: '库',
        key: 'change_depot',
        hideByData: function hideByData(data) {
          return data['STATUS'] === 'normal';
        }
      }, {
        label: '拆',
        key: 'split_order',
        hideByData: function hideByData(data) {
          return data['STATUS'] === 'normal';
        }
      }],
      tableActionCar: [{
        label: '详',
        key: 'detail'
      }],
      tableActionOrder2: [{
        label: '销',
        key: 'area_jxc'
      }, {
        label: '清',
        key: 'back'
      }],
      tableActionOrder3: [{
        label: '销',
        key: 'area_jxc'
      }, {
        label: '清',
        key: 'back'
      }, {
        label: '定',
        key: 'clock'
      }],
      tableAction: [{
        label: '保存',
        key: 'save',
        hideByData: function hideByData(data) {
          return data['isNew'];
        }
      }, {
        label: '详',
        key: 'oil_detail'
      }, {
        label: '调',
        key: 'tiao',
        hideByData: function hideByData(data) {
          return !data['isNew'];
        }
      }, {
        label: '库',
        key: 'psk',
        hideByData: function hideByData(data) {
          return !data['isNew'];
        }
      }, {
        label: '删',
        key: 'del',
        hideByData: function hideByData(data) {
          return !data['isNew'];
        }
      }],
      tableActionOil: [{
        label: '详',
        key: 'oil_detail'
      }, {
        label: '库',
        key: 'psk',
        hideByData: function hideByData(data) {
          return !data['isNew'];
        }
      }, {
        label: '删',
        key: 'del',
        hideByData: function hideByData(data) {
          return !data['isNew'];
        }
      }],
      carOrderListThs: [{
        label: 'ID',
        key: 'SFID'
      }, {
        label: '加油站',
        key: '油站名'
      }, {
        label: '罐',
        key: '罐号'
      }, {
        label: '油品',
        key: '油品名'
      }, {
        label: '配送量',
        key: '配送升数'
      }, {
        label: '不容纳',
        key: '不容纳时间'
      }, {
        label: '发车',
        key: '预计发车时间'
      }, {
        label: '断货',
        key: '断货时间'
      }, {
        label: '在途',
        key: '在途时间'
      }, {
        label: '趟次',
        key: '趟次'
      }, {
        label: '油库',
        key: '油库'
      }],
      carOrderListThsOil: [{
        label: '车牌号',
        key: '车牌号',
        clickAction: 'choose_car'
      }, {
        label: '加油站',
        key: '油站名'
      }, {
        label: '罐',
        key: '罐号'
      }, {
        label: '油品',
        key: '油品名'
      }, {
        label: '配送量',
        key: '配送升数'
      }, {
        label: '不容纳',
        key: '不容纳时间'
      }, {
        label: '发车',
        key: '预计发车时间'
      }, {
        label: '断货',
        key: '断货时间'
      }, {
        label: '在途',
        key: '在途时间'
      }, {
        label: '趟次',
        key: '趟次'
      }, {
        label: '油库',
        key: '油库'
      }]
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.flowStatus < 30) {
      next({ name: 'single.single' });
    } else if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.flowStatus === 30) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('assignCarOrder', false);
      next();
    } else {
      next();
    }
  },
  created: function created() {
    this.initOnKeydown();
    var datas = [];
    if (this.oilArea === 'dl') {
      datas = carTeamDl;
    } else if (this.oilArea === 'hh') {
      datas = carTeamHh;
    } else if (this.oilArea === 'km') {
      datas = carTeamKm;
    } else if (this.oilArea === 'zt') {
      datas = carTeamZp;
    } else if (this.oilArea === 'yx') {
      datas = carTeamYp;
    }
    this.carTeams = datas;
    this.team = this.carTeams[0];
    this.loadData();
    this.loadOrderList(['plan', 'normal']);
  },

  watch: {
    allCar: function allCar() {
      this.loadCarList();
    },
    inputPSL: function inputPSL(value) {
      this.dealInputPSL(value);
    },
    inputCKSS: function inputCKSS(value) {
      this.dealInputCKSS(value);
    },
    oilType: function oilType(value, oldValue) {
      this.clearNum += 1;
      this.loadCarList();
      this.loadOrderList(['plan', 'normal']);
    },
    team: function team(value, oldValue) {
      this.clearNum += 1;
      if (oldValue) {
        this.loadOrderList(['plan', 'normal']);
      }
      if (!this.allCar) {
        this.loadCarList();
      }
    },
    chooseCar: function chooseCar(value, oldValue) {
      this.carOrderList = [];
      if (value && (!oldValue || value !== oldValue)) {
        this.loadCarOrderList();
      }
      this.chooseOrder1 = null;
      this.chooseOrder2 = null;
      this.chooseOrder3 = null;
    },
    orderStatus: function orderStatus() {
      this.loadOrderList(['normal']);
    },
    chooseG: function chooseG(value) {
      if (!value) {
        return;
      }
      this.inputPSL = 10000;
      this.inputCKSS = 10000;
      this.newOrder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__cllib__["b" /* mapCp */])(nullOrder);
      if (value['油站代码']) {
        this.newOrder['油站代码'] = value['油站代码'];
        this.newOrder['油库代码'] = this.depotList[0]['油库代码'];
        this.newOrder['代号'] = value['代号'];
        this.newOrder['时间'] = this.todayStr;
        this.newOrder['入库升数'] = value['配送升数'] || 0;
        this.newOrder['期初库存'] = value['期末库存'] || 0;
      }
      this.dealInputCKSS(this.inputCKSS, true);
      this.dealInputPSL(this.inputPSL);
    }
  },
  computed: {
    jxcDatas: {
      get: function get() {
        var _this = this;

        var data = this.$store.getters.oilHisJxcDatas;
        data.forEach(function (item) {
          item = _this.delOrderData(item);
        });
        return data;
      }
    },
    jhOrderListThs: {
      get: function get() {
        var _this2 = this;

        var data = [];
        jhOrderThs.forEach(function (item, index) {
          data.push(item);
          if (item['key'] === '建议配送量' && _this2.yaoHuoBJ) {
            data.push({ key: '要货量', label: '要货量' });
          }
        });
        return data;
      }
    },
    allOrderListThs: {
      get: function get() {
        var _this3 = this;

        var data = [];
        allOrderThs.forEach(function (item) {
          data.push(item);
          if (item['key'] === '建议配送量' && _this3.boardings.includes('delivery')) {
            data.push({
              key: 'PS_TOTAL',
              label: '上车量',
              clickAction: 'choose_station_ps'
            });
          }
          if (item['key'] === '建议配送量' && _this3.yaoHuoBJ) {
            data.push({ key: '要货量', label: '要货量' });
          }
        });
        return data;
      }
    },
    chooseG: {
      get: function get() {
        if (this.chooseGIndex === 0 || this.chooseGIndex && this.chooseGIndex > -1) {
          return this.gasDatas[this.chooseGIndex];
        } else {
          return {};
        }
      }
    },
    chooseAdjustOrders: {
      get: function get() {
        var _this4 = this;

        var cd1 = null;
        var cd2 = null;
        var cd3 = null;
        this.canChooseOrders.forEach(function (item) {
          if (item['SFID'] === _this4.chooseOrder1) {
            cd1 = item;
          }
          if (item['SFID'] === _this4.chooseOrder2) {
            cd2 = item;
          }
          if (item['SFID'] === _this4.chooseOrder3) {
            cd3 = item;
          }
        });
        var data = {
          qc: cd1,
          zc: cd2,
          hc: cd3
        };
        return data;
      }
    },
    orderCar: {
      get: function get() {
        var _this5 = this;

        var data = [];
        this.$store.getters.orderCar.forEach(function (item) {
          var need = false;
          _this5.outPutOilType.forEach(function (itemOilType) {
            if (item['油品名称'].includes(itemOilType)) {
              need = true;
            }
          });
          if (need) {
            data.push(item);
          }
        });
        return data;
      }
    },
    canChooseOrders: {
      get: function get() {
        var data = [];
        this.chooseOrderCg.forEach(function (item) {
          data.push(item);
        });
        this.chooseOrders.forEach(function (item) {
          data.push(item);
        });
        return data;
      }
    },
    showCarList: {
      get: function get() {
        var _this6 = this;

        var data = [];
        this.carList.forEach(function (item) {
          if (item['车牌号'].indexOf(_this6.carKey) > -1 || item['承运商'].indexOf(_this6.carKey) > -1) {
            data.push(item);
          }
        });
        return data;
      }
    },
    showOrderList: {
      get: function get() {
        var _this7 = this;

        var data1 = [];
        this.orderList.forEach(function (item) {
          if (_this7.boardings.includes('delivery') && item['STATUS'] === 'done') {
            data1.push(item);
          }
          if (_this7.boardings.includes('no_delivery') && item['STATUS'] !== 'done') {
            data1.push(item);
          }
        });
        var data = [];
        data1.forEach(function (item) {
          var DXCHART = item['DXCHART'] || '';
          if (DXCHART.includes(_this7.wfpKey) || String(item['SFID']).includes(_this7.wfpKey) || item['油库代码'].includes(_this7.wfpKey) || item['加油站名称'].includes(_this7.wfpKey)) {
            data.push(item);
          }
        });
        return data;
      }
    },
    todayStr: {
      get: function get() {
        return this.$store.getters.todayStr;
      }
    },
    orderTj: {
      get: function get() {
        var _this8 = this;

        var data = [];
        this.$store.getters.orderTj.forEach(function (item) {
          var need = false;
          _this8.outPutOilType.forEach(function (itemOilType) {
            if (item['油品名称'].includes(itemOilType)) {
              need = true;
            }
          });
          if (need) {
            data.push(item);
          }
        });
        return data;
      }
    },
    oilArea: {
      get: function get() {
        return this.$store.getters.oilArea;
      }
    },
    splitOrderData: {
      get: function get() {
        var amount = parseInt((this.chooseOrderChangeDepot['建议配送量'] || 0) / this.splitNum);
        var datas = { '1': amount, '2': amount, '3': amount, '4': amount, '5': amount, '6': amount, '7': amount, '8': amount, '9': amount, '10': amount };
        return datas;
      }
    },
    newCarOrder: {
      get: function get() {
        var newData = null;
        if (this.chooseOrder && this.chooseCar) {
          newData = {
            '车牌号': this.chooseCar['车牌号'],
            '油库名称': this.chooseOrder['油库名称'],
            '加油站名称': this.chooseOrder['加油站名称'],
            '配送升数': this.chooseCar['合计'],
            '油品名称': this.chooseOrder['油品名称'],
            '不容纳时间': this.getBRNTime(this.chooseOrder, this.chooseCar['合计']),
            '预计发车时间': '',
            '在途时间': this.getOnlineTime(this.chooseOrder['油库代码'], this.chooseOrder['油站代码']),
            '断货时间': this.chooseOrder['断货时间'],
            '油站代码': this.chooseOrder['油站代码'],
            'SFID': this.chooseOrder['SFID'],
            '罐号': this.chooseOrder['罐号'],
            'isNew': true
          };
          this.delCarOrderData(newData);
        }
        return newData;
      }
    },
    showCarOrderList: {
      get: function get() {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__cllib__["f" /* concatList */])(this.carOrderList, this.newCarOrder ? [this.newCarOrder] : []);
      }
    },
    showYaoHuoCheckList: {
      get: function get() {
        var _this9 = this;

        var data = [];
        var searchKey = this.searchYaohuo;
        this.yaoHuoCheckList.forEach(function (item) {
          var DXCHART = item['DXCHART'] || '';
          if (DXCHART.includes(searchKey) || item['加油站名称'].includes(searchKey)) {
            data.push(item);
          }
        });
        var newData = [];
        data.forEach(function (item) {
          var need = false;
          _this9.yaoHuoOilType.forEach(function (itemOilType) {
            if (item['油品名称'].includes(itemOilType)) {
              need = true;
            }
          });
          if (need) {
            newData.push(item);
          }
        });
        var yaoHuoMin = Number(this.yaoHuoMin) || 0;
        if (yaoHuoMin !== 0) {
          var newData2 = [];
          newData.forEach(function (item) {
            var cz = item['差值'] || 0;
            if (cz * cz > yaoHuoMin * yaoHuoMin) {
              newData2.push(item);
            }
          });
          newData = newData2;
        }
        return newData;
      }
    }
  },
  methods: {
    clickRowDataCarOrder: function clickRowDataCarOrder(data) {
      if (data.action === 'choose_car') {
        this.clearNumZd += 1;
        var carData = null;
        this.carList.forEach(function (item) {
          if (item['车牌号'] === data.value) {
            carData = item;
          }
        });
        if (carData) {
          this.chooseCarValue = this.clearNumZd + 'car_id-' + carData['车牌号'];
          this.showCarOrderType = 'car';
        } else {
          if (this.allCar) {
            this.$store.dispatch('showNoticeMsg', {
              type: 'warning',
              title: '系统提示',
              message: '该车未找到，请联系管理员'
            });
          } else {
            this.$store.dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '该车未找到，请打开全部车辆后点击车牌号'
            });
          }
        }
      }
    },
    clickRowData: function clickRowData(data) {
      var rowdata = data.rowdata;
      if (data.action === 'choose_jyps') {
        this.$store.dispatch('setOpdOilCode', rowdata['油站代码']);
        this.jxcTitle = rowdata['油站名'];
        this.showCarOrderType = 'jxc';
        return;
      }
      var carOrderTitle = rowdata['油站名'];
      var carOrderOilData = {
        '油站代码': rowdata['油站代码']
      };
      if (data.action !== 'choose_station') {
        carOrderTitle += ' >> ' + data.value;
      }
      if (data.action === 'choose_station_guan') {
        carOrderOilData['罐号'] = rowdata['罐号'];
      } else if (data.action === 'choose_station_oiltype') {
        carOrderOilData['油品名称'] = rowdata['油品名称'];
      } else if (data.action === 'choose_station_ps') {
        carOrderOilData['罐号'] = rowdata['罐号'];
      }
      this.carOrderTitle = carOrderTitle;
      this.carOrderOilData = carOrderOilData;
      this.showCarOrderType = 'oil';
      this.loadCarOrderListOil();
    },
    loadYaoHuoCheckList: function loadYaoHuoCheckList() {
      var _this10 = this;

      this.yaoHuoCheckList = [];
      var parm = {
        action: 'get_yaohuo_checkdata',
        data: {}
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["h" /* depotValume */])(parm).then(function (data) {
        _this10.yaoHuoCheckList = data;
      });
    },
    addYaohuoToplan: function addYaohuoToplan() {
      var _this11 = this;

      this.yaoHuoCheckList = [];
      var parm = {
        action: 'add_yaohuo_toplan',
        data: {}
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["h" /* depotValume */])(parm).then(function (data) {
        _this11.loadOrderList(['plan', 'normal']);
        _this11.$store.dispatch('showNoticeMsg', {
          type: 'success',
          title: '系统提示',
          message: '未上车要货订单已加入计划中'
        });
      });
    },
    initOnKeydown: function initOnKeydown() {
      var _this12 = this;

      try {
        var needKeyCodes = [38, 40];
        document.onkeydown = function (event) {
          var keyCode = event.keyCode || null;
          if (event.target.nodeName === 'BODY' && needKeyCodes.includes(keyCode)) {
            if (keyCode === 38) {
              _this12.nextCar('top');
            } else if (keyCode === 40) {
              _this12.nextCar('btm');
            }
          }
        };
      } catch (e) {
        console.log(e);
      }
    },
    nextCar: function nextCar(key) {
      this.num += 1;
      var value = '';
      if (key === 'top') {
        value = 'top_' + this.num;
      } else if (key === 'btm') {
        value = 'btm_' + this.num;
      }
      if (this.showOilDetail) {
        this.chooseOrderValue = value;
      } else {
        this.chooseCarValue = value;
      }
    },
    outputPsDatas: function outputPsDatas() {
      this.$store.dispatch('outputPsDatas', { clear: true, oilType: this.outPutOilType });
      this.showOutput = false;
    },
    loadData: function loadData() {
      this.loadDepotList();
      this.loadYunJuList();
      this.getGasData();
    },
    getCarDetail: function getCarDetail() {
      var _this13 = this;

      var parm = {
        action: 'get_car_detail',
        data: {
          carId: this.chooseCar['车牌号']
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["e" /* car */])(parm).then(function (data) {
        _this13.carDetail = data;
      });
    },
    chooseJsxQy: function chooseJsxQy(area) {
      this.selectArea = area;
      this.$store.dispatch('filteHisJxcDatas', { area: area, oilType: this.oilType });
      this.showAreaJxc = true;
    },
    dealInputCKSS: function dealInputCKSS(value, deal) {
      if (!deal) {
        this.inputPSL = 0;
      }
      var num = Number(value) || 0;
      if (!(num === 0 || num)) {
        this.inputCKSS = '0';
      }
      this.newOrder['平均销量'] = num;
      this.newOrder['出库升数'] = num;
      this.newOrder['期末库存'] = this.newOrder['期初库存'] - value + this.newOrder['入库升数'];
      this.newOrder['空容'] = this.chooseG['物理容积'] - this.newOrder['期末库存'];
      if (num !== 0) {
        var dhHour = ((this.newOrder['期末库存'] || 0) - (this.chooseG['停泵库存'] || 0)) / num * 24 + 8;
        this.newOrder['断货时间'] = __WEBPACK_IMPORTED_MODULE_7__cllib__["g" /* dateOperating */].formatDate({ date: new Date(new Date(this.todayStr + 'T00:00').getTime() + (dhHour + 24) * 60 * 60 * 1000), format: 'yy-mm-dd hh:mm' }).slice(5);
      } else {
        this.newOrder['断货时间'] = '';
      }
    },
    dealInputPSL: function dealInputPSL(value) {
      var num = Number(value) || 0;
      if (!(num === 0 || num)) {
        this.inputCKSS = '0';
      }
      this.newOrder['建议配送量'] = num;
      if (num !== 0 && this.newOrder['平均销量']) {
        var dhHour = ((this.newOrder['期末库存'] || 0) - ((this.chooseG['有效容积'] || 0) - num)) / (this.newOrder['平均销量'] || 10000) * 24 + 8;
        this.newOrder['不容纳时间'] = __WEBPACK_IMPORTED_MODULE_7__cllib__["g" /* dateOperating */].formatDate({ date: new Date(new Date(this.todayStr + 'T00:00').getTime() + dhHour * 60 * 60 * 1000), format: 'yy-mm-dd hh:mm' }).slice(5);
      } else {
        this.newOrder['不容纳时间'] = '';
      }
    },
    addTsAction: function addTsAction(action) {
      if (action === 'change') {
        this.chooseOrder = this.chooseOrderBX;
        this.chooseOrderBX = null;
        this.chooseOrderBXHis = null;
      } else if (action === 'sc') {
        this.chooseOrderBXHis = this.chooseOrderBX;
        this.chooseOrderBX = null;
        this.saveCarOrder();
      } else {
        this.chooseOrderBX = null;
        this.chooseOrderBXHis = null;
      }
      this.showAddTs = false;
    },
    saveTctz: function saveTctz() {
      var _this14 = this;

      if (!this.tc) {
        return;
      }
      var parm = {
        action: 'tc_tz',
        data: {
          data: this.chooseCarOrder,
          tc: this.tc
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["h" /* depotValume */])(parm).then(function (data) {
        _this14.showTctz = false;
        _this14.loadCarOrderList();
      });
    },
    changeOrderStatus: function changeOrderStatus(sfid, status, isList) {
      var SFIDS = isList ? sfid : [sfid];
      this.orderList.forEach(function (item) {
        if (SFIDS.includes(item['SFID'])) {
          item['STATUS'] = status;
        }
      });
      var parm = {
        action: 'change_order_status',
        data: {
          sfid: SFIDS,
          status: status === 'done' ? 'normal' : status
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["d" /* gas */])(parm);
    },
    saveSplitOrder: function saveSplitOrder() {
      var _this15 = this;

      var vm = this;
      var amounts = [];
      var total = 0;
      for (var key in this.splitOrderData) {
        if (Number(key) === vm.splitNum || Number(key) < vm.splitNum) {
          amounts.push(vm.splitOrderData[key]);
          total += Number(vm.splitOrderData[key]);
        }
      }
      if (isNaN(total)) {
        return;
      }
      var parm = {
        action: 'split_order',
        data: {
          order_id: this.chooseOrderChangeDepot['SFID'],
          amounts: amounts
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["h" /* depotValume */])(parm).then(function (data) {
        _this15.loadOrderList(['normal']);
        _this15.showSplitOrder = false;
        _this15.splitNum = 2;
      });
    },
    saveGasOrder: function saveGasOrder() {
      var _this16 = this;

      if (!this.newOrder['油站代码']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择加油站'
        });
        return;
      }
      if (!this.newOrder['出库升数']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请填写出库升数'
        });
        return;
      }
      if (!this.newOrder['油库代码']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择配送油库'
        });
        return;
      }
      if (!this.newOrder['建议配送量']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请填写建议配送量'
        });
        return;
      }
      var parm = {
        action: 'add_gas_data',
        data: this.newOrder
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        if (data.code === 1) {
          _this16.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '配送单新增完成'
          });
          _this16.showAdd = false;
          _this16.loadOrderList(['normal']);
        } else {
          _this16.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '配送单新增失败'
          });
        }
      }).catch(function (e) {
        _this16.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '配送单新增失败'
        });
      });
    },
    clearDcChooseOrderInDatas: function clearDcChooseOrderInDatas(sfids) {
      if (sfids.includes(this.chooseOrder1)) {
        this.chooseOrder1 = null;
      }
      if (sfids.includes(this.chooseOrder2)) {
        this.chooseOrder2 = null;
      }
      if (sfids.includes(this.chooseOrder3)) {
        this.chooseOrder3 = null;
      }
    },
    clearOrders: function clearOrders(clearDatas, type, status) {
      clearDatas = clearDatas || [];
      var oldDatas = type === 'plan' ? this.chooseOrderCg : this.chooseOrders;
      // 清chooseorder
      if (this.checkChooseOrderInDatas(oldDatas)) {
        this.chooseOrder = null;
      }
      // 清多仓
      var SFIDs = [];
      clearDatas.forEach(function (item) {
        if (item && item['SFID']) {
          SFIDs.push(item['SFID']);
        }
      });
      this.clearDcChooseOrderInDatas(SFIDs);
      // 修改状态
      this.changeOrderStatus(SFIDs, status, true);
      // 清chooseOrderCg
      var newDatas = [];
      oldDatas.forEach(function (item) {
        if (!SFIDs.includes(item['SFID'])) {
          newDatas.push(item);
        }
      });
      if (type === 'plan') {
        this.chooseOrderCg = newDatas;
      } else {
        this.chooseOrders = newDatas;
      }
    },
    clickMenu: function clickMenu(key) {
      if (key === 'add') {
        this.showAdd = true;
        this.chooseGIndex = null;
      } else if (key === 'yaohuo_check') {
        this.loadYaoHuoCheckList();
        this.showYaohuo = true;
      } else if (key === 'clear3') {
        this.clearOrders(this.chooseOrderCg, 'plan', 'normal');
      } else if (key === 'clear') {
        this.clearOrders(this.chooseOrders, 'locking', 'normal');
      } else if (key === 'out_put') {
        this.showOutput = true;
        this.$store.dispatch('getOrderCars');
        var depotCodes = [];
        this.depotList.forEach(function (item) {
          depotCodes.push(item['油库代码']);
        });
        this.$store.dispatch('getTjData', depotCodes);
      }
    },
    clickMenuS: function clickMenuS(key) {
      if (key === 'sys_pipei') {
        this.$store.dispatch('assignCarOrder', true);
      }
    },
    checkChooseOrderInDatas: function checkChooseOrderInDatas(datas) {
      var _this17 = this;

      var inDatas = false;
      if (this.chooseOrder) {
        datas.forEach(function (item) {
          if (item['SFID'] === _this17.chooseOrder['SFID']) {
            inDatas = true;
          }
        });
      }
      return inDatas;
    },
    chooseThisOrder: function chooseThisOrder(data) {
      if (data['STATUS'] === 'normal') {
        this.addToPlan(data);
      }
    },
    addToPlan: function addToPlan(data) {
      var newOrder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__cllib__["b" /* mapCp */])(data);
      this.chooseOrderCg.push(newOrder);
      this.changeOrderStatus(data['SFID'], 'plan');
    },
    saveChangeOrderDepot: function saveChangeOrderDepot() {
      var _this18 = this;

      var parm = {
        action: 'change_order_depot',
        data: {
          'depot_code': this.chooseOrderChangeDepot['油库代码'],
          'sfid': this.chooseOrderChangeDepot['SFID']
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        if (data.code === 1) {
          _this18.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '修改配送油库成功'
          });
          _this18.loadOrderList(['normal']);
          _this18.showChooseDepot = false;
        } else {
          _this18.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '修改配送油库失败'
          });
        }
      }).catch(function (e) {
        _this18.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '修改配送油库失败'
        });
      });
    },
    saveChangePsDepot: function saveChangePsDepot() {
      var _this19 = this;

      var parm = {
        action: 'change_ps_depot',
        data: {
          'depot_code': this.psDepot,
          'order': this.chooseCarOrder,
          'allCarOrder': this.allCarOrder
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        if (data.code === 1) {
          _this19.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '修改配送油库成功'
          });
          _this19.loadCarOrderList();
          _this19.showChooseDepotPs = false;
        } else {
          _this19.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '修改配送油库失败'
          });
        }
      }).catch(function (e) {
        _this19.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '修改配送油库失败'
        });
      });
    },
    clickTdBtn: function clickTdBtn(parm) {
      var _this20 = this;

      this.chooseCarOrder = parm.data;
      if (parm.key === 'del') {
        this.delCarOrder();
      } else if (parm.key === 'save') {
        this.saveCarOrder();
      } else if (parm.key === 'oil_detail') {
        this.oilDetailMap = parm.data;
        this.$store.dispatch('setOpdOilCode', this.oilDetailMap['油站代码']);
        this.showOilDetail = true;
      } else if (parm.key === 'psk') {
        this.psDepot = this.chooseCarOrder['油库代码'];
        this.showChooseDepotPs = true;
      } else if (parm.key === 'tiao') {
        this.tc = '';
        this.tcList = [];
        this.showTctz = true;
        this.carOrderList.forEach(function (item) {
          if (item['趟次'] !== _this20.chooseCarOrder['趟次'] && _this20.tcList.indexOf(item['趟次']) === -1) {
            _this20.tcList.push(item['趟次']);
          }
        });
      }
    },
    clickOrderTdBtnSD: function clickOrderTdBtnSD(parm) {
      var data = parm.data;
      if (parm.key === 'back') {
        this.clearOrders([data], 'plan', 'normal');
      } else if (parm.key === 'clock') {
        this.chooseOrders.push(data);
        this.clearOrders([data], 'plan', 'plan');
      } else if (parm.key === 'area_jxc') {
        this.chooseJsxQy(data['区域']);
      }
    },
    clickOrderTdBtn: function clickOrderTdBtn(parm) {
      if (parm.key === 'back') {
        this.clearOrders([parm.data], 'locking', 'normal');
        return;
      }
      if (parm.key === 'area_jxc') {
        this.chooseJsxQy(parm.data['区域']);
        return;
      }
      if (parm.key === 'oil_detail') {
        this.oilDetailMap = parm.data;
        this.$store.dispatch('setOpdOilCode', this.oilDetailMap['油站代码']);
        this.showOilDetail = true;
        return;
      }
      if (parm.key === 'detail') {
        this.showCarDetail = true;
        this.carDetail = {
          psData: [],
          xzData: {}
        };
        this.chooseCar = parm.data;
        this.getCarDetail();
        return;
      }
      this.chooseOrderChangeDepot = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__cllib__["b" /* mapCp */])(parm.data);
      if (parm.key === 'change_depot') {
        this.showChooseDepot = true;
      } else if (parm.key === 'split_order') {
        this.showSplitOrder = true;
      }
    },
    getOnlineTime: function getOnlineTime(depotCode, gasCode) {
      var yunJu = this.yunJuMap[gasCode] ? this.yunJuMap[gasCode][depotCode] : 1000;
      yunJu = yunJu || 1000;
      return (yunJu / (yunJu > 100 ? 30 : 20)).toFixed(2);
    },
    getBRNTime: function getBRNTime(orderData, psl) {
      var qmkc = orderData['期末库存'] || 0;
      var yxrj = orderData['有效容积'] || 0;
      var pjxl = orderData['平均销量'] || 10000;
      psl = psl || 0;
      var dhHour = (qmkc - (yxrj - psl)) / pjxl * 24 + 8;
      return __WEBPACK_IMPORTED_MODULE_7__cllib__["g" /* dateOperating */].formatDate({ date: new Date(new Date(this.todayStr + 'T00:00').getTime() + (dhHour + 24) * 60 * 60 * 1000), format: 'yy-mm-dd hh:mm' }).slice(5);
    },
    clickCarRow: function clickCarRow(data) {
      if (!data.dc) {
        this.chooseOrder = null;
      }
      this.showCarOrderType = 'car';
      this.chooseCar = data;
    },
    clickOrderRow: function clickOrderRow(data) {
      this.showCarOrderType = 'car';
      if (this.chooseCar) {
        if (this.chooseCar.dc) {
          if (this.chooseOrder && this.chooseOrder['SFID'] !== data['SFID']) {
            this.chooseOrderBX = data;
            this.showAddTs = true;
          } else {
            this.chooseOrder = data;
          }
        } else {
          if (this.chooseOrder1 === null && this.chooseCar['前仓']) {
            this.chooseOrder1 = data.SFID;
          } else if (this.chooseOrder2 === null && this.chooseCar['中仓']) {
            this.chooseOrder2 = data.SFID;
          } else if (this.chooseOrder2 === null && this.chooseCar['后仓']) {
            this.chooseOrder3 = data.SFID;
          } else if (this.chooseCar['后仓']) {
            this.chooseOrder3 = data.SFID;
          } else if (this.chooseCar['中仓']) {
            this.chooseOrder2 = data.SFID;
          } else {
            this.chooseOrder1 = data.SFID;
          }
        }
      }
    },
    loadCarList: function loadCarList() {
      var _this21 = this;

      this.carLoading = true;
      var parm = {
        action: 'get_work_cars',
        data: {
          oil_type: this.oilType,
          team: this.allCar ? '' : this.team
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["e" /* car */])(parm).then(function (data) {
        _this21.carList = data || [];
        var inList = false;
        _this21.carList.forEach(function (item) {
          item['dc'] = !item['中仓'] && !item['后仓'];
          item['oldPs'] = item['oldPs'].split('加油站').join('');
          item['承运商'] = item['承运商'].slice(0, 4);
          if (_this21.chooseCar && item['车牌号'] === _this21.chooseCar['车牌号']) {
            inList = true;
          }
        });
        if (!inList) {
          _this21.chooseOrder = null;
          _this21.chooseCar = null;
        }
        _this21.carLoading = false;
      });
    },
    loadDepotList: function loadDepotList() {
      var data = [{ '油库代码': '33450015', '油库名称': '云南昆东油库' }, { '油库代码': '33450016', '油库名称': '云南长坡油库' }, { '油库代码': '36910016', '油库名称': '云南中石油安宁炼厂地付库' }, { '油库代码': '33450709', '油库名称': '云南石林油库' }];
      if (this.oilArea === 'dl') {
        data = [{ '油库代码': '33450534', '油库名称': '云南凤仪油库' }, { '油库代码': '33451133', '油库名称': '云南振戎油库' }, { '油库代码': '36919004', '油库名称': '云南中石油清华洞油库' }, { '油库代码': '36910018', '油库名称': '云南中石油保山油库' }, { '油库代码': '33451833', '油库名称': '云南楚西油库' }];
      } else if (this.oilArea === 'hh') {
        data = [{ '油库代码': '33450016', '油库名称': '云南长坡油库' }, { '油库代码': '33450348', '油库名称': '云南滇中油库' }, { '油库代码': '33450709', '油库名称': '云南石林油库' }, { '油库代码': '33453124', '油库名称': '云南文山广南油库' }, { '油库代码': '33453125', '油库名称': '云南红河蒙自油库' }, { '油库代码': '36910017', '油库名称': '云南中石油蒙自油库' }];
      } else if (this.oilArea === 'yx') {
        data = [{ '油库代码': '33450016', '油库名称': '云南长坡油库' }, { '油库代码': '33450348', '油库名称': '云南滇中油库' }, { '油库代码': '33450709', '油库名称': '云南石林油库' }];
      } else if (this.oilArea === 'zt') {
        data = [{ '油库代码': '33450211', '油库名称': '云南松林油库' }, { '油库代码': '33450622', '油库名称': '云南水富油库' }, { '油库代码': '33450709', '油库名称': '云南石林油库' }, { '油库代码': '33451453', '油库名称': '云南北闸油库' }];
      }
      this.depotList = data;
    },
    loadOrderList: function loadOrderList(typeData) {
      var _this22 = this;

      this.orderLoading = true;
      var parm = {
        action: 'get_no_car_order',
        data: {
          oil_type: this.oilType,
          order_status: this.orderStatus,
          team: this.team,
          type: typeData
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        if (typeData.indexOf('normal') > -1) {
          var orderList = data.orderData || [];
          orderList.forEach(function (item) {
            _this22.delOrderData(item);
          });
          _this22.orderList = data.orderData;
        }
        if (typeData.indexOf('plan') > -1) {
          var planData = data.planData || [];
          var choosedDatasId = [];
          _this22.chooseOrders.forEach(function (item) {
            choosedDatasId.push(item['SFID']);
          });
          var newData = [];
          planData.forEach(function (item) {
            if (!choosedDatasId.includes(item['SFID'])) {
              newData.push(_this22.delOrderData(item));
            }
          });
          _this22.chooseOrderCg = newData;
        }
        _this22.orderLoading = false;
      });
    },
    loadCarOrderList: function loadCarOrderList() {
      var _this23 = this;

      this.carOrderLoading = true;
      this.carOrderList = [];
      var parm = {
        action: 'get_car_order',
        data: {
          car_id: this.chooseCar['车牌号']
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["h" /* depotValume */])(parm).then(function (data) {
        data.forEach(function (item) {
          _this23.delCarOrderData(item);
        });
        _this23.carOrderList = data || [];
        _this23.carOrderLoading = false;
      });
    },
    loadCarOrderListOil: function loadCarOrderListOil() {
      var _this24 = this;

      this.carOrderLoading = true;
      this.showOilCarOrderList = [];
      var parm = {
        action: 'get_car_order',
        data: this.carOrderOilData
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["h" /* depotValume */])(parm).then(function (data) {
        data.forEach(function (item) {
          _this24.delCarOrderData(item);
        });
        _this24.showOilCarOrderList = data || [];
        _this24.carOrderLoading = false;
      });
    },
    loadYunJuList: function loadYunJuList() {
      var _this25 = this;

      var parm = {
        action: 'get_yun_ju',
        data: 'none'
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        var yunJuMap = {};
        data.forEach(function (item) {
          yunJuMap[item['到站代码']] = yunJuMap[item['到站代码']] ? yunJuMap[item['到站代码']] : {};
          yunJuMap[item['到站代码']][item['发站代码']] = item['运距'];
        });
        _this25.yunJuMap = yunJuMap;
      });
    },
    getGasData: function getGasData() {
      var _this26 = this;

      var parm = {
        action: 'get_gas_data',
        data: 'none'
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        _this26.gasDatas = data;
      });
    },
    saveCarOrder: function saveCarOrder() {
      var _this27 = this;

      // 保存配送单
      this.carOrderLoading = true;
      var datas = [{
        '车牌号': this.chooseCar['车牌号'],
        '时间': this.chooseOrder['时间'],
        '油库代码': this.chooseOrder['油库代码'],
        '油站代码': this.chooseOrder['油站代码'],
        '代号': this.chooseOrder['代号'],
        '不容纳时间': this.newCarOrder['不容纳时间'],
        '油品名称': this.newCarOrder['油品名称'],
        '配送升数': this.newCarOrder['配送升数'],
        '在途时间': this.newCarOrder['在途时间'],
        'SFID': this.chooseOrder['SFID'],
        '隔仓号': 1,
        '数据来源': 1
      }];
      var parm = {
        action: 'add_car_order',
        data: datas
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["h" /* depotValume */])(parm).then(function (data) {
        _this27.clearOrders([_this27.chooseOrder], 'plan', 'done');
        _this27.clearOrders([_this27.chooseOrder], 'locking', 'done');
        if (_this27.chooseOrderBXHis) {
          _this27.chooseOrder = _this27.chooseOrderBXHis;
          _this27.chooseOrderBXHis = null;
        }
        _this27.carOrderLoading = false;
        _this27.loadCarList();
        _this27.loadOrderList(['normal']);
        _this27.loadCarOrderList();
      });
    },
    delOrderData: function delOrderData(item) {
      item['建议配送量'] = parseInt(item['建议配送量']);
      item['油站名'] = item['加油站名称'].split('加油站')[0] + (item['加油站名称'].split('加油站')[1] || '');
      item['油品名'] = item['油品名称'].split('号')[0];
      item['订单紧急'] = item['订单紧急程度'] ? item['订单紧急程度'].slice(0, -2) : '';
      item['油库'] = item['油库名称'] ? item['油库名称'].split('油库')[0] : '';
      return item;
    },
    delCarOrderData: function delCarOrderData(item) {
      item['油站名'] = item['加油站名称'].split('加油站')[0] + (item['加油站名称'].split('加油站')[1] || '');
      item['油品名'] = item['油品名称'].split('号')[0];
      item['油库'] = item['油库名称'].split('油库')[0];
      return item;
    },
    saveCarOrderDuo: function saveCarOrderDuo() {
      var _this28 = this;

      // 保存配送单
      if (!this.chooseAdjustOrders['qc'] && !this.chooseAdjustOrders['zc'] && !this.chooseAdjustOrders['hc']) {
        return;
      }
      this.carOrderLoading = true;
      var cdData = [];
      var i = 1;
      var datas = [];
      for (var key in this.chooseAdjustOrders) {
        if (this.chooseAdjustOrders[key]) {
          datas.push(this.chooseAdjustOrders[key]);
          var psss = key === 'qc' ? this.chooseCar['前仓'] : key === 'zc' ? this.chooseCar['中仓'] : this.chooseCar['后仓'];
          cdData.push({
            '车牌号': this.chooseCar['车牌号'],
            '时间': this.chooseAdjustOrders[key]['时间'],
            '油库代码': this.chooseAdjustOrders[key]['油库代码'],
            '油站代码': this.chooseAdjustOrders[key]['油站代码'],
            '代号': this.chooseAdjustOrders[key]['代号'],
            '油品名称': this.chooseAdjustOrders[key]['油品名称'],
            '配送升数': psss,
            '不容纳时间': this.getBRNTime(this.chooseAdjustOrders[key], psss),
            '在途时间': this.getOnlineTime(this.chooseAdjustOrders[key]['油库代码'], this.chooseAdjustOrders[key]['油站代码']),
            'SFID': this.chooseAdjustOrders[key]['SFID'],
            '隔仓号': i,
            '数据来源': 1
          });
          i += 1;
        }
      }
      var parm = {
        action: 'add_car_order',
        data: cdData
      };
      this.chooseOrder1 = null;
      this.chooseOrder2 = null;
      this.chooseOrder3 = null;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["h" /* depotValume */])(parm).then(function (data) {
        _this28.clearOrders(datas, 'plan', 'done');
        _this28.clearOrders(datas, 'locking', 'done');
        _this28.carOrderLoading = false;
        _this28.loadCarList();
        _this28.loadOrderList(['normal']);
        _this28.loadCarOrderList();
      });
    },
    searchInputChange1: function searchInputChange1(value) {
      this.wfpKey = value.toUpperCase();
    },
    searchInputChange3: function searchInputChange3(value) {
      this.searchYaohuo = value.toUpperCase();
    },
    searchInputChange2: function searchInputChange2(value) {
      this.carKey = value.toUpperCase();
    },
    delCarOrder: function delCarOrder() {
      var _this29 = this;

      this.carOrderLoading = true;
      var parm = {
        action: 'del_car_order',
        data: {
          'carId': this.chooseCarOrder['车牌号'],
          'date': this.chooseCarOrder['时间'],
          'index': this.chooseCarOrder['趟次']
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_oli_api__["h" /* depotValume */])(parm).then(function (data) {
        // 添加到 锁定
        data = data || [];
        var SFIDs = [];
        data.forEach(function (item) {
          _this29.chooseOrders.push(_this29.delOrderData(item));
          if (!SFIDs.includes(item['SFID'])) {
            SFIDs.push(item['SFID']);
          }
        });
        // 修改为plan
        _this29.changeOrderStatus(SFIDs, 'plan', true);
        _this29.carOrderLoading = false;
        _this29.loadCarList();
        _this29.loadOrderList(['normal']);
        if (_this29.showCarOrderType === 'car') {
          _this29.loadCarOrderList();
        } else {
          _this29.loadCarOrderListOil();
        }
      });
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiTableOil__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiTableOil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_MiiTableOil__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cars',
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a,
    MiiTableOil: __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiTableOil___default.a
  },
  data: function data() {
    return {
      jxcThs: [{
        label: '加油站',
        key: '加油站名称'
      }, {
        label: '罐号',
        key: '罐号'
      }, {
        label: '油品类型',
        key: '油品名称'
      }, {
        label: '预计空容',
        key: '预计空容'
      }, {
        label: '入库(L)',
        key: '入库升数'
      }, {
        label: '出库L',
        key: '出库升数'
      }, {
        label: '期末L',
        key: '期末库存'
      }, {
        label: '空容L',
        key: '空容'
      }, {
        label: '平均销量(L)',
        key: '平均销量'
      }, {
        label: '在途(L)',
        key: '在途计划升数'
      }, {
        label: '配送计划(L)',
        key: '配送计划'
      }, {
        label: '物理容积(L)',
        key: '物理容积'
      }, {
        label: '停泵库存(L)',
        key: '停泵库存'
      }, {
        label: '有效容积(L)',
        key: '有效容积'
      }]
    };
  },

  computed: {
    showJxcDatas: {
      get: function get() {
        var datas = this.$store.getters.areaHisJxcDatas;
        datas.forEach(function (item) {
          item['预计空容'] = item['空容'] + item['出库升数'] - item['在途计划升数'] || null;
        });
        return this.$store.getters.areaHisJxcDatas || [];
      }
    },
    preDay: {
      get: function get() {
        return this.$store.getters.todayStr;
      }
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_oli_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_static_data__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cllib__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var warningTypes = {
  'carStatusWaring': '车辆状态异常',
  'blackCar': '车辆黑名单',
  'noDriver': '无驾驶员',
  'driverStatusWaring': '驾驶员状态异常',
  'blackDriver': '驾驶员黑名单',
  'tooEarly': '在途中',
  'late': '空闲中'
};



var nulCar = {
  '车牌号': '',
  '配送中心': '',
  '承运商': '',
  '牵引车': '',
  '车辆轴数': '',
  '核定载质量': '',
  '道路运输证准运油品': '',
  '电子运单装载油品': '',
  '合计': '',
  '前仓': '',
  '中仓': '',
  '后仓': '',
  '通行证': '',
  '更改油品': '',
  '可配送油站限制': '',
  '停车油库代码': ''
};

var nulChangeOil = {
  '车牌号': '',
  '更改油品': '',
  '实际油品容积和': '',
  '前仓': '',
  '中仓': '',
  '后仓': '',
  '品名变更记录': ''
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a,
    MiiBaseTable: __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable___default.a
  },
  data: function data() {
    return {
      showQdError: false,
      errorData: [],
      loadingWarning: false,
      warningData: [],
      showCheckData: false,
      driver_list: [],
      s_car_id: '',
      selectGas: null,
      xzGasList: [],
      depotList: [{ '油库代码': '33450015', '油库名称': '云南昆东油库' }, { '油库代码': '33450016', '油库名称': '云南长坡油库' }, { '油库代码': '36910016', '油库名称': '云南中石油安宁炼厂地付库' }],
      gasList: [],
      isNew: false,
      PASS_LIST: __WEBPACK_IMPORTED_MODULE_3__api_static_data__["a" /* PASS_LIST */],
      AXLE_LIST: __WEBPACK_IMPORTED_MODULE_3__api_static_data__["b" /* AXLE_LIST */],
      car_center: '',
      axle_key: '',
      carMap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cllib__["b" /* mapCp */])(nulCar),
      changeOil: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cllib__["b" /* mapCp */])(nulChangeOil),
      loading: true,
      showDel: false,
      showAdd: false,
      showChange: false,
      showQiandao: false,
      showGasXz: false,
      titleAction: [{
        key: 'qiandaoCheck',
        icon: 'icon-duocengshujuxiaoyan'
      }],
      carList: [],
      ths: [{
        key: '车牌号',
        label: '车牌号'
      }, {
        key: '牵引车',
        label: '牵引车'
      }, {
        key: '核定载质量',
        label: '核定载质量'
      }, {
        key: '合计',
        label: '合计仓容'
      }, {
        key: '车辆轴数',
        label: '轴数'
      }, {
        key: '道路运输证准运油品',
        label: '准运油品'
      }, {
        key: '更改油品文字',
        label: '油品更改'
      }, {
        key: '司机',
        label: '驾驶员'
      }, {
        key: '人员状态',
        label: '驾驶员状态'
      }, {
        key: '黑司机',
        label: '司机黑名单'
      }, {
        key: '签到状态文字',
        label: '签到状态'
      }, {
        key: 'STATUS',
        label: '车辆状态'
      }, {
        key: '拉黑状态',
        label: '拉黑状态'
      }],
      thsE: [{
        key: '车牌号',
        label: '车牌号'
      }, {
        key: 'errorInfo',
        label: '异常原因'
      }],
      thsW: [{
        key: '车牌号',
        label: '车牌号'
      }, {
        key: '牵引车',
        label: '牵引车'
      }, {
        key: '核定载质量',
        label: '核定载质量'
      }, {
        key: '合计',
        label: '合计仓容'
      }, {
        key: '车辆轴数',
        label: '轴数'
      }, {
        key: '道路运输证准运油品',
        label: '准运油品'
      }, {
        key: '更改油品文字',
        label: '油品更改'
      }, {
        key: '司机',
        label: '驾驶员'
      }, {
        key: '人员状态',
        label: '驾驶员状态'
      }, {
        key: '黑司机',
        label: '司机黑名单'
      }, {
        key: '签到状态文字',
        label: '签到状态'
      }, {
        key: 'STATUS',
        label: '车辆状态'
      }, {
        key: '拉黑状态',
        label: '拉黑状态'
      }, {
        key: '异常原因',
        label: '异常原因'
      }]
    };
  },

  watch: {
    car_center: function car_center() {
      this.loadCarList();
    },
    axle_key: function axle_key() {
      this.loadCarList();
    },
    selectGas: function selectGas(value) {
      if (value) {
        var inDatas = false;
        this.xzGasList.forEach(function (item) {
          if (item['油站代码'] === value['油站代码']) {
            inDatas = true;
          }
        });
        if (!inDatas) {
          this.xzGasList.push(value);
        }
      }
    }
  },
  computed: {
    warningDataQd: {
      get: function get() {
        var data = [];
        this.warningData.forEach(function (item) {
          if (item['签到状态'] === '1' || item['签到状态'] === 1) {
            data.push(item);
          }
        });
        return data;
      }
    },
    warningDataWqd: {
      get: function get() {
        var data = [];
        this.warningData.forEach(function (item) {
          if (item['签到状态'] !== '1' && item['签到状态'] !== 1) {
            data.push(item);
          }
        });
        return data;
      }
    },
    pszxDatas: {
      get: function get() {
        return this.$store.getters.canChoosePSZXs;
      }
    },
    table_actionsw: {
      get: function get() {
        var data = this.showQiandao ? [{
          label: '拉黑',
          key: 'black',
          hideByData: function hideByData(data) {
            return data['BLACK'] !== 'black';
          }
        }, {
          label: '取消黑名单',
          key: 'black_back',
          hideByData: function hideByData(data) {
            return data['BLACK'] === 'black';
          }
        }] : [{
          label: '改签',
          key: 'gq'
        }, {
          label: '拉黑',
          key: 'black',
          hideByData: function hideByData(data) {
            return data['BLACK'] !== 'black';
          }
        }, {
          label: '取消黑名单',
          key: 'black_back',
          hideByData: function hideByData(data) {
            return data['BLACK'] === 'black';
          }
        }];
        return data;
      }
    },
    table_actions: {
      get: function get() {
        var data = this.showQiandao ? [{
          label: '编辑',
          key: 'edit'
        }, {
          label: '更改油品',
          key: 'change_oil_type'
        }, {
          label: '限制可配送油站',
          key: 'change_gas_xz'
        }, {
          label: '拉黑',
          key: 'black',
          hideByData: function hideByData(data) {
            return data['BLACK'] !== 'black';
          }
        }, {
          label: '取消黑名单',
          key: 'black_back',
          hideByData: function hideByData(data) {
            return data['BLACK'] === 'black';
          }
        }] : [{
          label: '改签',
          key: 'gq'
        }, {
          label: '编辑',
          key: 'edit'
        }, {
          label: '更改油品',
          key: 'change_oil_type'
        }, {
          label: '限制可配送油站',
          key: 'change_gas_xz'
        }, {
          label: '拉黑',
          key: 'black',
          hideByData: function hideByData(data) {
            return data['BLACK'] !== 'black';
          }
        }, {
          label: '取消黑名单',
          key: 'black_back',
          hideByData: function hideByData(data) {
            return data['BLACK'] === 'black';
          }
        }];
        return data;
      }
    }
  },
  created: function created() {
    this.car_center = this.$store.getters.oilArea;
    this.loadGasList();
    this.loadDriverList();
  },

  methods: {
    loadDriverList: function loadDriverList() {
      var _this = this;

      var parm = {
        action: 'get_driver',
        data: {}
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["f" /* driver */])(parm).then(function (data) {
        _this.driver_list = data;
      });
    },
    qdFileChange: function qdFileChange(e) {
      var filePlant = this.checkFile(e.target.files || e.dataTransfer.files);
      if (!filePlant) {
        document.getElementById('file-4').value = '';
      } else {
        this.inputOlderPlan({ excelFile: filePlant, fileId: 'file-4' });
      }
    },
    checkFile: function checkFile(files) {
      if (!files.length) {
        return null;
      } else if (['xlsx', 'xls'].indexOf(files[0].name.split('.').slice(-1)[0]) > -1) {
        return files[0];
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择excel文件。'
        });
        return false;
      }
    },
    searchCar: function searchCar() {
      var _this2 = this;

      var newData = [];
      this.carList.forEach(function (item) {
        if (item['车牌号'].indexOf(_this2.s_car_id) !== -1) {
          newData.push(item);
        }
      });
      return newData;
    },
    inputOlderPlan: function inputOlderPlan(_ref) {
      var _this3 = this;

      var excelFile = _ref.excelFile,
          fileId = _ref.fileId;

      var sheets = [{
        needDataKeys: ['签到', '不签到']
      }];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cllib__["e" /* readExcelFileData */])({ file: excelFile, sheets: sheets, allsheets: true, type: 'row_object_array' }).then(function (data) {
        _this3.warningData = [];
        _this3.errorData = [];
        _this3.loading = true;
        var allData = [];
        for (var key in data) {
          data[key].forEach(function (item) {
            allData.push(item);
          });
        }
        var parm = {
          action: 'car_qd',
          data: {
            qdData: allData
          }
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["e" /* car */])(parm).then(function (data) {
          console.log(data);
          if (data.code === '1') {
            _this3.errorData = data.error_data;
            _this3.showQdError = true;
          } else {
            _this3.showCheckData = true;
            _this3.warningData = _this3.delWCarData(data);
            _this3.loadCarList();
          }
          _this3.loading = false;
          document.getElementById(fileId).value = '';
        });
      }).catch(function (e) {
        _this3.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '导入文件解析失败',
          message: '请检查文件格式是否符合导入规则'
        });
        document.getElementById(fileId).value = '';
        console.log(e);
      });
    },
    delXzGas: function delXzGas(gas) {
      var newDatas = [];
      this.xzGasList.forEach(function (item) {
        if (item['油站代码'] !== gas['油站代码']) {
          newDatas.push(item);
        }
      });
      this.xzGasList = newDatas;
    },
    loadGasList: function loadGasList() {
      var _this4 = this;

      var parm = {
        action: 'get_gas',
        data: {}
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        _this4.gasList = data;
      });
    },
    loadCarList: function loadCarList() {
      var _this5 = this;

      this.loading = true;
      var parm = {
        action: 'get_cars',
        data: {
          '配送中心': this.car_center,
          '车辆轴数': this.axle_key === '0' ? '' : this.axle_key
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["e" /* car */])(parm).then(function (data) {
        _this5.showQiandao = true;
        _this5.titleAction = [{
          key: 'qiandaoCheck',
          icon: 'icon-duocengshujuxiaoyan'
        }, {
          key: 'qiandao',
          icon: 'icon-qiandao'
        }];
        data.forEach(function (item) {
          if (item['签到状态']) {
            _this5.showQiandao = false;
            _this5.titleAction = [{
              key: 'qiandaoCheck',
              icon: 'icon-duocengshujuxiaoyan'
            }];
          }
          item.checked = false;
          item['签到状态文字'] = item['签到状态'] === '1' || item['签到状态'] === '1' ? '已签到' : '';
          item['更改油品文字'] = item['更改油品'] === '1' ? '已更改' : '';
          item['拉黑状态'] = item['BLACK'] === 'black' ? '已拉黑' : '';
        });
        _this5.carList = data;
        _this5.loading = false;
      });
    },
    setGasXz: function setGasXz() {
      var _this6 = this;

      var gasCodeStr = '';
      this.xzGasList.forEach(function (item) {
        gasCodeStr += item['油站代码'] + ',';
      });
      var parm = {
        action: 'set_car_gas_xz',
        data: {
          'xz_gas': gasCodeStr.slice(0, -1),
          'car_id': this.carMap['车牌号']
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["e" /* car */])(parm).then(function (data) {
        if (data.code === 1) {
          _this6.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '修改配送指定油站成功'
          });
          _this6.carMap['可配送油站限制'] = gasCodeStr.slice(0, -1);
          _this6.showGasXz = false;
        } else {
          _this6.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '修改配送指定油站失败'
          });
        }
      }).catch(function (e) {
        _this6.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '修改配送指定油站失败'
        });
      });
    },
    delWCarData: function delWCarData(datas) {
      datas.forEach(function (item) {
        item['签到状态文字'] = item['签到状态'] === '1' || item['签到状态'] === '1' ? '已签到' : '';
        item['更改油品文字'] = item['更改油品'] === '1' ? '已更改' : '';
        item['拉黑状态'] = item['BLACK'] === 'black' ? '已拉黑' : '';
        var wText = [];
        item['WTYPE'].split(',').forEach(function (item) {
          wText.push(warningTypes[item]);
        });
        item['异常原因'] = wText.join(',');
      });
      return datas;
    },
    setCarOilType: function setCarOilType() {
      var _this7 = this;

      var parm = {
        action: 'set_car_oil_change',
        data: this.changeOil
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["e" /* car */])(parm).then(function (data) {
        if (data.code === 1) {
          _this7.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '更改油品成功'
          });
          _this7.carMap['更改油品'] = 1;
          _this7.showChange = false;
          _this7.loadCarList();
        } else {
          _this7.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '更改油品失败'
          });
        }
      }).catch(function (e) {
        _this7.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '更改油品失败'
        });
      });
    },
    delChangeCarOilType: function delChangeCarOilType() {
      var _this8 = this;

      var parm = {
        action: 'del_car_oil_change',
        data: { '车牌号': this.carMap['车牌号'] }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["e" /* car */])(parm).then(function (data) {
        if (data.code === 1) {
          _this8.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '油品更改删除成功'
          });
          _this8.carMap['更改油品'] = 0;
          _this8.showChange = false;
          _this8.loadCarList();
        } else {
          _this8.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '油品更改删除失败'
          });
        }
      }).catch(function (e) {
        _this8.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '油品更改删除失败'
        });
      });
    },
    qiandao: function qiandao() {
      var _this9 = this;

      this.warningData = [];
      this.loadingWarning = true;
      this.showCheckData = true;
      var checkedList = [];
      this.carList.forEach(function (item) {
        if (item.checked) {
          checkedList.push({ '签到': item['车牌号'] });
        }
      });
      var parm = {
        action: 'car_qd',
        data: {
          qdData: checkedList
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["e" /* car */])(parm).then(function (data) {
        _this9.warningData = _this9.delWCarData(data);
        _this9.loadingWarning = false;
        _this9.loadCarList();
      });
    },
    qiandaoCheck: function qiandaoCheck() {
      var _this10 = this;

      this.warningData = [];
      this.loadingWarning = true;
      this.showCheckData = true;
      var parm = {
        action: 'car_qd_check',
        data: {}
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["e" /* car */])(parm).then(function (data) {
        _this10.warningData = _this10.delWCarData(data);
        _this10.loadingWarning = false;
      });
    },
    clickTitleMenu: function clickTitleMenu(key) {
      if (key === 'add') {
        this.carMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cllib__["b" /* mapCp */])(nulCar);
        this.isNew = true;
        this.showAdd = true;
      } else if (key === 'qiandao') {
        this.qiandao();
      } else if (key === 'qiandaoCheck') {
        this.qiandaoCheck();
      }
    },
    clickTdBtn: function clickTdBtn(dataMap) {
      var _this11 = this;

      this.carMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cllib__["b" /* mapCp */])(dataMap.data);
      if (dataMap.key === 'del') {
        this.showDel = true;
      } else if (dataMap.key === 'edit') {
        this.isNew = false;
        this.showAdd = true;
      } else if (dataMap.key === 'gq') {
        this.changeQianDao();
      } else if (dataMap.key === 'change_oil_type') {
        this.showChange = true;
        if (Number(this.carMap['更改油品']) === 1) {
          this.getChangeInfo();
        } else {
          this.changeOil = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cllib__["b" /* mapCp */])(nulChangeOil);
          this.changeOil['车牌号'] = this.carMap['车牌号'];
        }
      } else if (dataMap.key === 'change_gas_xz') {
        this.xzGasList = [];
        var gasCodeList = this.carMap['可配送油站限制'] ? this.carMap['可配送油站限制'].split(',') : [];
        this.gasList.forEach(function (item) {
          if (gasCodeList.indexOf(item['油站代码']) > -1) {
            _this11.xzGasList.push(item);
          }
        });
        this.showGasXz = true;
      } else if (dataMap.key === 'black') {
        this.changeBlack('black');
      } else if (dataMap.key === 'black_back') {
        this.changeBlack('black_back');
      }
    },
    changeBlack: function changeBlack(type) {
      var _this12 = this;

      this.loading = true;
      var parm = {
        action: 'car_change_black',
        data: {
          'carId': this.carMap['车牌号'],
          'status': type === 'black_back' ? 'white' : 'black'
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["e" /* car */])(parm).then(function (data) {
        _this12.$store.dispatch('showNoticeMsg', {
          type: 'success',
          title: '系统提示',
          message: data.msg
        });
        _this12.loading = false;
        _this12.loadCarList();
      });
    },
    changeQianDao: function changeQianDao() {
      var _this13 = this;

      this.loading = true;
      var parm = {
        action: 'car_gaiqian',
        data: {
          'carId': this.carMap['车牌号'],
          'ySatus': this.carMap['签到状态']
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["e" /* car */])(parm).then(function (data) {
        _this13.$store.dispatch('showNoticeMsg', {
          type: 'success',
          title: '系统提示',
          message: data.msg
        });
        _this13.loading = false;
        _this13.loadCarList();
      });
    },
    getChangeInfo: function getChangeInfo() {
      var _this14 = this;

      var parm = {
        action: 'get_car_oil_change',
        data: {
          '车牌号': this.carMap['车牌号']
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["e" /* car */])(parm).then(function (data) {
        _this14.changeOil = data.length > 0 ? data[0] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cllib__["b" /* mapCp */])(nulChangeOil);
      });
    },
    saveCar: function saveCar() {
      var _this15 = this;

      if (!this.carMap['车牌号']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '车牌号必填',
          message: '请输入车牌号'
        });
        return;
      }
      var parm = {
        action: this.isNew ? 'add_car' : 'edit_car',
        data: this.carMap
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["e" /* car */])(parm).then(function (data) {
        if (data.code === 1) {
          _this15.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: _this15.isNew ? '车辆新增完成' : '车辆修改完成'
          });
          _this15.showAdd = false;
          _this15.loadCarList();
        } else {
          _this15.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: _this15.isNew ? '新增油站失败' : '修改油站失败'
          });
        }
      }).catch(function (e) {
        _this15.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: _this15.isNew ? '新增油站失败' : '修改油站失败'
        });
      });
    },
    delCar: function delCar() {
      var _this16 = this;

      var parm = {
        action: 'del_car',
        data: { '车牌号': this.carMap['车牌号'] }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["e" /* car */])(parm).then(function (data) {
        if (data.code === 1) {
          _this16.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '车辆删除成功'
          });
          _this16.loadCarList();
          _this16.showDel = false;
        } else {
          _this16.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '车辆删除失败'
          });
        }
      }).catch(function (e) {
        _this16.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '车辆删除失败'
        });
      });
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_oli_api__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a,
    MiiBaseTable: __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable___default.a
  },
  data: function data() {
    return {
      loading: false,
      driver_name: '',
      driver_list: [],
      ths: [{
        key: '人员代码',
        label: '人员代码'
      }, {
        key: '所属车队',
        label: '车队'
      }, {
        key: '姓名',
        label: '姓名'
      }, {
        key: '人员状态',
        label: '状态'
      }, {
        key: '黑名单',
        label: '黑名单'
      }]
    };
  },

  computed: {
    showDriverList: {
      get: function get() {
        var _this = this;

        var data = [];
        this.driver_list.forEach(function (item) {
          if (item['姓名'].includes(_this.driver_name)) {
            data.push(item);
          }
        });
        return data;
      }
    },
    table_actions: {
      get: function get() {
        var data = [{
          label: '拉黑',
          key: 'black',
          hideByData: function hideByData(data) {
            return !data['黑名单'];
          }
        }, {
          label: '取消黑名单',
          key: 'black_back',
          hideByData: function hideByData(data) {
            return data['黑名单'];
          }
        }];
        return data;
      }
    }
  },
  created: function created() {
    this.loadDriverList();
  },

  methods: {
    loadDriverList: function loadDriverList() {
      var _this2 = this;

      this.loading = true;
      var parm = {
        action: 'get_driver',
        data: {}
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["f" /* driver */])(parm).then(function (data) {
        _this2.driver_list = data;
        _this2.loading = false;
      });
    },
    clickTdBtn: function clickTdBtn(dataMap) {
      if (dataMap.key === 'black') {
        this.changeBlack(dataMap.data, 'black');
      } else if (dataMap.key === 'black_back') {
        this.changeBlack(dataMap.data, 'black_back');
      }
    },
    changeBlack: function changeBlack(data, type) {
      var _this3 = this;

      this.loading = true;
      var parm = {
        action: 'driver_change_black',
        data: {
          'driver': data,
          'status': type === 'black_back' ? 'white' : 'black'
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["f" /* driver */])(parm).then(function (data) {
        _this3.$store.dispatch('showNoticeMsg', {
          type: 'success',
          title: '系统提示',
          message: data.msg
        });
        _this3.loading = false;
        _this3.loadDriverList();
      });
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiBaseTable__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiBaseTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_bit_MiiBaseTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_oli_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_static_data__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cllib__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var nullGas = {
  '油站代码': '',
  '区域': '',
  '单位名称': '',
  '加油站名称': '',
  '指定车辆配送限制': ''
};

var nullGasG = {
  '油站代码': '',
  '油品名称': '',
  '罐号': '',
  '油罐状态': '',
  '停泵库存': '',
  '有效容积': '',
  '物理容积': ''
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default.a,
    MiiBaseTable: __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiBaseTable___default.a
  },
  data: function data() {
    return {
      selectCar: null,
      carList: [],
      xzCarList: [],
      delType: 'gas',
      showAddG: false,
      isNewG: false,
      canSetXz: false,
      isNew: false,
      PASS_LIST: __WEBPACK_IMPORTED_MODULE_4__api_static_data__["a" /* PASS_LIST */],
      AXLE_LIST: __WEBPACK_IMPORTED_MODULE_4__api_static_data__["b" /* AXLE_LIST */],
      GASG_STATUS: __WEBPACK_IMPORTED_MODULE_4__api_static_data__["c" /* GASG_STATUS */],
      OIL_TYPES: __WEBPACK_IMPORTED_MODULE_4__api_static_data__["d" /* OIL_TYPES */],
      pass_key: '',
      axle_key: '',
      selectGas: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cllib__["b" /* mapCp */])(nullGas),
      gasMap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cllib__["b" /* mapCp */])(nullGas),
      gasGMap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cllib__["b" /* mapCp */])(nullGasG),
      loadingG: false,
      loading: true,
      showDel: false,
      showAdd: false,
      table_actions: [{
        label: '编辑',
        key: 'edit'
      }, {
        label: '删除',
        key: 'del'
      }],
      titleAction: [{
        key: 'edit',
        icon: 'icon-bj'
      }, {
        key: 'del',
        icon: 'icon-105'
      }, {
        key: 'add',
        icon: 'icon-addfriend'
      }],
      titleAction2: [{
        key: 'add',
        icon: 'icon-addfriend'
      }],
      gasList: [],
      oilGGList: [],
      ths: [{
        key: '罐号',
        label: '罐号'
      }, {
        key: '油罐状态',
        label: '油罐状态'
      }, {
        key: '油品名称',
        label: '油品'
      }, {
        key: '物理容积',
        label: '物理容积'
      }, {
        key: '停泵库存',
        label: '停泵库存'
      }, {
        key: '有效容积',
        label: '有效容积'
      }]
    };
  },

  watch: {
    selectGas: function selectGas(value) {
      var _this = this;

      this.canSetXz = false;
      this.loadGasGGList();
      this.pass_key = value['通行证'];
      this.axle_key = value['场地限制'];
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
        _this.canSetXz = true;
      });
      this.xzCarList = [];
      var carIdList = value['指定车辆配送限制'] ? value['指定车辆配送限制'].split(',') : [];
      this.carList.forEach(function (item) {
        if (carIdList.indexOf(item['车牌号']) > -1) {
          _this.xzCarList.push(item);
        }
      });
    },
    pass_key: function pass_key(value) {
      if (this.canSetXz) {
        this.setXZGas({
          '通行证': value
        });
      }
    },
    axle_key: function axle_key(value) {
      if (this.canSetXz) {
        this.setXZGas({
          '场地限制': value
        });
      }
    },
    selectCar: function selectCar(value) {
      if (value) {
        var inDatas = false;
        this.xzCarList.forEach(function (item) {
          if (item['车牌号'] === value['车牌号']) {
            inDatas = true;
          }
        });
        if (!inDatas) {
          this.xzCarList.push(value);
          this.setGasXz();
        }
      }
    }
  },
  created: function created() {
    this.loadCarList();
  },

  methods: {
    getTextTXZ: function getTextTXZ(str) {
      console.log(str);
      var reStr = '无';
      if (str) {
        var txzList = ['一环通行证', '二环通行证', '三环通行证'];
        var strList = str.split(';');
        if (strList.length === 1) {
          reStr = txzList[Number(strList[0].split('=')[1]) - 1];
        } else if (strList.length > 1) {
          reStr = '昆东三环通行证长坡无';
        }
      }
      return reStr;
    },
    setGasXz: function setGasXz() {
      var _this2 = this;

      var carIdStr = '';
      this.xzCarList.forEach(function (item) {
        carIdStr += item['车牌号'] + ',';
      });
      var parm = {
        action: 'set_gas_car_xz',
        data: {
          'xz_car': carIdStr.slice(0, -1),
          'gas_code': this.selectGas['油站代码']
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        if (data.code === 1) {
          _this2.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '修改指定配送车辆成功'
          });
          _this2.gasMap['指定车辆配送限制'] = carIdStr.slice(0, -1);
        } else {
          _this2.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '修改配送指定油站失败'
          });
        }
      }).catch(function (e) {
        _this2.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '修改配送指定油站失败'
        });
      });
    },
    delXzCar: function delXzCar(gas) {
      var newDatas = [];
      this.xzCarList.forEach(function (item) {
        if (item['车牌号'] !== gas['车牌号']) {
          newDatas.push(item);
        }
      });
      this.xzCarList = newDatas;
      this.setGasXz();
    },
    loadCarList: function loadCarList() {
      var _this3 = this;

      var parm = {
        action: 'get_cars',
        data: {
          '配送中心': this.$store.getters.oilArea === 'dl' ? '大配' : '昆配',
          '车辆轴数': ''
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["e" /* car */])(parm).then(function (data) {
        _this3.carList = data;
        _this3.loadGasList();
      });
    },
    loadGasList: function loadGasList() {
      var _this4 = this;

      var parm = {
        action: 'get_gas',
        data: {}
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        _this4.gasList = data;
        _this4.loading = false;
        if (!_this4.selectGas['油站代码']) {
          _this4.selectGas = data.length > 0 ? data[0] : {};
        }
      });
    },
    loadGasGGList: function loadGasGGList() {
      var _this5 = this;

      this.loadingG = true;
      var parm = {
        action: 'get_gg_gas',
        data: {
          '油站代码': this.selectGas['油站代码']
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        _this5.oilGGList = data;
        _this5.loadingG = false;
      });
    },
    clickTitleMenu: function clickTitleMenu(key) {
      if (key === 'add') {
        this.isNew = true;
        this.gasMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cllib__["b" /* mapCp */])(nullGas);
        this.showAdd = true;
      } else if (key === 'edit') {
        this.isNew = false;
        this.gasMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cllib__["b" /* mapCp */])(this.selectGas);
        this.showAdd = true;
      } else if (key === 'del') {
        this.showDel = true;
        this.delType = 'gas';
      }
    },
    clickTitleMenuG: function clickTitleMenuG(key) {
      if (key === 'add') {
        this.isNewG = true;
        this.gasGMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cllib__["b" /* mapCp */])(nullGasG);
        this.gasGMap['油站代码'] = this.selectGas['油站代码'];
        this.showAddG = true;
      }
    },
    clickTdBtn: function clickTdBtn(dataMap) {
      console.log(dataMap);
      this.gasGMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cllib__["b" /* mapCp */])(dataMap.data);
      if (dataMap.key === 'del') {
        this.delType = 'gas_gg';
        this.showDel = true;
      } else if (dataMap.key === 'edit') {
        this.isNewG = false;
        this.showAddG = true;
      }
    },
    setXZGas: function setXZGas(data) {
      var _this6 = this;

      data['油站代码'] = this.selectGas['油站代码'];
      var parm = {
        action: 'set_xz_gas',
        data: data
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        if (data.code === 1) {
          _this6.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '油站限制已修改'
          });
        } else {
          _this6.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '油站限制修改失败'
          });
        }
      }).catch(function (e) {
        _this6.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '油站限制修改失败'
        });
      });
    },
    saveGas: function saveGas() {
      var _this7 = this;

      if (!this.gasMap['油站代码']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '油站代码必填',
          message: '请输入油站代码'
        });
        return;
      }
      var parm = {
        action: this.isNew ? 'add_gas' : 'edit_gas',
        data: this.gasMap
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        if (data.code === 1) {
          _this7.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: _this7.isNew ? '油站新增完成' : '油站修改完成'
          });
          _this7.selectGas = _this7.gasMap;
          _this7.showAdd = false;
          _this7.loadGasList();
        } else {
          _this7.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: _this7.isNew ? '新增油站失败' : '修改油站失败'
          });
        }
      }).catch(function (e) {
        _this7.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: _this7.isNew ? '新增油站失败' : '修改油站失败'
        });
      });
    },
    saveGasG: function saveGasG() {
      var _this8 = this;

      if (!this.gasGMap['罐号']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '罐号必填',
          message: '请输入罐号'
        });
        return;
      }
      var parm = {
        action: this.isNewG ? 'add_gg_gas' : 'edit_gg_gas',
        data: this.gasGMap
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        if (data.code === 1) {
          _this8.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: _this8.isNewG ? '油罐新增完成' : '油罐修改完成'
          });
          _this8.showAddG = false;
          _this8.loadGasGGList();
        } else {
          _this8.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: _this8.isNewG ? '新增油罐失败' : '修改油罐失败'
          });
        }
      }).catch(function (e) {
        _this8.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: _this8.isNewG ? '新增油罐失败' : '修改油罐失败'
        });
      });
    },
    delGasG: function delGasG() {
      var _this9 = this;

      var parm = {
        action: 'del_gg_gas',
        data: { '代号': this.gasGMap['代号'] }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        if (data.code === 1) {
          _this9.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '油罐删除成功'
          });
          _this9.loadGasGGList();
          _this9.showDel = false;
        } else {
          _this9.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '油罐删除失败'
          });
        }
      }).catch(function (e) {
        _this9.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '油罐删除失败'
        });
      });
    },
    delGas: function delGas() {
      var _this10 = this;

      if (this.delType !== 'gas') {
        return this.delGasG();
      }
      var parm = {
        action: 'del_gas',
        data: { '油站代码': this.selectGas['油站代码'] }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        if (data.code === 1) {
          _this10.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '加油站删除成功'
          });
          _this10.selectGas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cllib__["b" /* mapCp */])(nullGas);
          _this10.loadGasList();
          _this10.showDel = false;
        } else {
          _this10.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '加油站删除失败'
          });
        }
      }).catch(function (e) {
        _this10.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '加油站删除失败'
        });
      });
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapTools__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios_init__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_oli_api__ = __webpack_require__(13);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




window.echarts = __webpack_require__(51);

window.myGasChat = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      gasLocation: null,
      gasData: []
    };
  },
  mounted: function mounted() {
    window.initMapGas = this.initCharGas;
    var chat = window.echarts.init(document.getElementById('chart-map-gas'));
    window.myGasChat = chat;
    this.loadBdmapApi();
  },
  created: function created() {
    this.getLocationData();
  },

  methods: {
    change: function change() {
      this.$router.push({ name: 'oil_chart' });
    },
    loadBdmapApi: function loadBdmapApi() {
      var script = document.createElement('script');
      script.src = 'https://api.map.baidu.com/api?v=2.0&ak=O8eyfQgNIOYnnGYqM2xVAqXtmqkyk6CT&callback=initMapGas';
      document.body.appendChild(script);
    },
    getLocationData: function getLocationData() {
      var _this = this;

      // 加油站、油库位置数据
      __WEBPACK_IMPORTED_MODULE_2__axios_init__["b" /* axiosSysApi */].get('/static/location.json').then(function (response) {
        _this.gasLocation = response.data['加油站位置'];
        _this.getGasData();
      });
    },
    getGasData: function getGasData() {
      var vm = this;
      var parm = {
        action: 'get_order_map_data',
        data: ''
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        var mapData = [];
        var mapData2 = [];
        for (var key in data) {
          if (key in vm.gasLocation) {
            data[key]['total'] = data[key]['total'].toFixed(2);
            if (Number(data[key]['xgdx'])) {
              mapData2.push({ name: key, value: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(vm.gasLocation[key]), [data[key]]) });
            } else {
              mapData.push({ name: key, value: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(vm.gasLocation[key]), [data[key]]) });
            }
          }
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["a" /* setDataGasOption */])('gas_nom', mapData);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["a" /* setDataGasOption */])('gas_xgdx', mapData2);
      });
    },
    initCharGas: function initCharGas() {
      window.myGasChat.clear();
      window.myGasChat.setOption(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mapTools__["b" /* initGasOption */])(), true);
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cllib__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_oli_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_bit_ContentTitle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      allPs: false,
      dataType: null,
      fileId: 'file-input',
      hisData: [],
      chooseHis: {},
      inputDate: ''
    };
  },

  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_2__components_bit_ContentTitle___default.a
  },
  computed: {
    isAdmin: {
      get: function get() {
        console.log(this.$store.getters.userInfo);
        return this.$store.getters.userInfo && this.$store.getters.userInfo.USER_ACCOUNT === 'miiro';
      }
    },
    dataTypes: {
      get: function get() {
        var data = [];
        if (this.isAdmin) {
          data = ['当日有实际出库的配送计划', '按ERP出库时间导入配送计划', 'driver', 'driver_black', 'car_zz', 'update_oil_name'];
        }
        return data;
      }
    },
    canInput: {
      get: function get() {
        return true;
      }
    }
  },
  watch: {
    allPs: function allPs(value) {
      this.loadData(this.dataType);
    },
    dataType: function dataType(value) {
      this.loadData(value);
    }
  },
  methods: {
    loadData: function loadData(type) {
      this.inputDate = '';
      this.hisData = [];
      this.chooseHis = {};
      if (type === '进销存') {
        this.loadJxcInputData();
      } else if (type === '配送计划') {
        this.loadPsjhInputData();
      }
    },
    loadJxcInputData: function loadJxcInputData() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["g" /* inputAllData */])({ action: 'get_jxc_input_data', data: { dayNum: 10, allPs: this.allPs ? 1 : 0 } }).then(function (data) {
        _this.hisData = data;
      });
    },
    loadPsjhInputData: function loadPsjhInputData() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["g" /* inputAllData */])({ action: 'get_ps_input_data', data: { dayNum: 10, allPs: this.allPs ? 1 : 0 } }).then(function (data) {
        _this2.hisData = data;
      });
    },
    checkFile: function checkFile(files) {
      if (!files.length) {
        return null;
      } else if (['xlsx', 'xls'].indexOf(files[0].name.split('.').slice(-1)[0]) > -1) {
        return files[0];
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择excel文件。'
        });
        return false;
      }
    },
    fileChange: function fileChange(e) {
      var fileInput = this.checkFile(e.target.files || e.dataTransfer.files);
      if (!fileInput) {
        document.getElementById(this.fileId).value = '';
      } else {
        if (this.dataType === 'driver') {
          this.inputDriverData(fileInput);
        } else if (this.dataType === 'driver_black') {
          this.inputDriverBlackData(fileInput);
        } else if (this.dataType === 'car_zz') {
          this.inputCarZZ(fileInput);
        } else if (this.dataType === '当日有实际出库的配送计划') {
          this.inputPsSjData(fileInput);
        } else if (this.dataType === '按ERP出库时间导入配送计划') {
          this.inputCJSJData(fileInput);
        } else if (this.dataType === 'update_oil_name') {
          this.inputOilNameUpdate(fileInput);
        }
        document.getElementById(this.fileId).value = '';
      }
    },
    inputPsData: function inputPsData(fileInput) {
      this.$store.dispatch('inputOlderPlan', { excelFile: fileInput, fileId: this.fileId, date: this.inputDate });
    },
    inputPsSjData: function inputPsSjData(fileInput) {
      this.$store.dispatch('inputOlderPlan', { excelFile: fileInput, fileId: this.fileId, realData: 1 });
    },
    inputCJSJData: function inputCJSJData(fileInput) {
      this.$store.dispatch('inputOlderPlan', { excelFile: fileInput, fileId: this.fileId, realData: 2 });
    },
    inputJxcData: function inputJxcData(fileInput) {
      this.$store.dispatch('dealJxcExceldata', { excelFile: fileInput, fileId: this.fileId, date: this.inputDate });
    },
    inputDriverData: function inputDriverData(excelFile) {
      var _this3 = this;

      var sheets = [{
        needDataKeys: ['承运商名称', '所属车队', '人员代码', '姓名', '联系电话', '工种', '人员状态', '身份证号码', '机动车驾驶证号']
      }];
      var dispatch = this.$store.dispatch;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["e" /* readExcelFileData */])({ file: excelFile, sheets: sheets, allsheets: true, type: 'row_object_array' }).then(function (data) {
        var allData = [];
        for (var key in data) {
          data[key].forEach(function (item) {
            allData.push(item);
          });
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["g" /* inputAllData */])({ action: 'driver', data: allData }).then(function (data) {
          if (data['code'] !== '-1') {
            dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '文件导入成功'
            });
          } else {
            throw new Error('error');
          }
        });
      }).catch(function (e) {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '导入文件解析失败',
          message: '请检查文件格式是否符合导入规则'
        });
        document.getElementById(_this3.fileId).value = '';
        console.log(e);
      });
    },
    inputDriverBlackData: function inputDriverBlackData(excelFile) {
      var _this4 = this;

      var sheets = [{
        needDataKeys: ['姓名', '身份证号', '岗位', '违规记录']
      }];
      var dispatch = this.$store.dispatch;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["e" /* readExcelFileData */])({ file: excelFile, sheets: sheets, allsheets: true, type: 'row_object_array' }).then(function (data) {
        var allData = [];
        for (var key in data) {
          data[key].forEach(function (item) {
            allData.push(item);
          });
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["g" /* inputAllData */])({ action: 'driver_black', data: allData }).then(function (data) {
          if (data['code'] !== '-1') {
            dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '文件导入成功'
            });
          } else {
            throw new Error('error');
          }
        });
      }).catch(function (e) {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '导入文件解析失败',
          message: '请检查文件格式是否符合导入规则'
        });
        document.getElementById(_this4.fileId).value = '';
        console.log(e);
      });
    },
    inputOilNameUpdate: function inputOilNameUpdate(excelFile) {
      var _this5 = this;

      // 更新加油站名称
      var sheets = [{
        needDataKeys: ['加油站代码', '加油名称']
      }];
      var dispatch = this.$store.dispatch;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["e" /* readExcelFileData */])({ file: excelFile, sheets: sheets, allsheets: true, type: 'row_object_array' }).then(function (data) {
        var allData = [];
        for (var key in data) {
          data[key].forEach(function (item) {
            allData.push(item);
          });
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["g" /* inputAllData */])({ action: 'update_oil_name', data: allData }).then(function (data) {
          if (data['code'] !== '-1') {
            dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '文件导入成功'
            });
          } else {
            throw new Error('error');
          }
        });
      }).catch(function (e) {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '导入文件解析失败',
          message: '请检查文件格式是否符合导入规则'
        });
        document.getElementById(_this5.fileId).value = '';
        console.log(e);
      });
    },
    inputCarZZ: function inputCarZZ(excelFile) {
      var _this6 = this;

      var sheets = [{
        needDataKeys: ['车牌号', '车辆类型', '牵引车号', '驾驶员']
      }];
      var dispatch = this.$store.dispatch;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cllib__["e" /* readExcelFileData */])({ file: excelFile, sheets: sheets, allsheets: true, type: 'row_object_array' }).then(function (data) {
        var allData = [];
        for (var key in data) {
          data[key].forEach(function (item) {
            allData.push(item);
          });
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_oli_api__["g" /* inputAllData */])({ action: 'car_zz', data: allData }).then(function (data) {
          if (data['code'] !== '-1') {
            dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '文件导入成功'
            });
          } else {
            throw new Error('error');
          }
        });
      }).catch(function (e) {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '导入文件解析失败',
          message: '请检查文件格式是否符合导入规则'
        });
        document.getElementById(_this6.fileId).value = '';
        console.log(e);
      });
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_oli_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      titleAction: [{
        key: 'load',
        icon: 'icon-meitian'
      }],
      showDetail: false,
      loading: false,
      fileIdJxc: 'file-input-jxc',
      fileIdPsjh: 'file-input-psjh',
      hisData: [],
      dataType: null,
      chooseHis: null,
      canChooseDate: ''
    };
  },

  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default.a
  },
  computed: {
    allPs: {
      get: function get() {
        return this.$store.getters.userInfo && this.$store.getters.userInfo.USER_TYPE === 'manager';
      }
    }
  },
  created: function created() {
    this.loadAllInputData();
  },

  methods: {
    clickTitleMenu: function clickTitleMenu(key) {
      if (key === 'load') {
        this.loadAllInputData();
      }
    },
    chooseOne: function chooseOne(data) {
      if (data['日期'] === this.canChooseDate) {
        this.chooseHis = data;
        this.showDetail = true;
      } else if (data['status'] === 'ok') {
        this.chooseHis = data;
        this.showDetail = true;
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请先处理' + this.canChooseDate + '数据'
        });
      }
    },
    loadAllInputData: function loadAllInputData() {
      var _this = this;

      this.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_oli_api__["g" /* inputAllData */])({ action: 'get_input_data', data: { dayNum: 10, allPs: this.allPs ? 1 : 0 } }).then(function (data) {
        data.forEach(function (item) {
          if (item['jxc'] && item['psjh'] && item['hx']) {
            item['status'] = 'ok';
          } else {
            item['status'] = 'warning';
            _this.canChooseDate = item['日期'];
          }
        });
        _this.hisData = data;
        _this.loading = false;
      });
    },
    checkFile: function checkFile(files) {
      if (!files.length) {
        return null;
      } else if (['xlsx', 'xls'].indexOf(files[0].name.split('.').slice(-1)[0]) > -1) {
        return files[0];
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择excel文件。'
        });
        return false;
      }
    },
    fileChangeJxc: function fileChangeJxc(e) {
      var fileInput = this.checkFile(e.target.files || e.dataTransfer.files);
      if (!fileInput) {
        document.getElementById(this.fileIdJxc).value = '';
      } else {
        this.inputJxcData(fileInput);
      }
    },
    fileChangePsjh: function fileChangePsjh(e) {
      var fileInput = this.checkFile(e.target.files || e.dataTransfer.files);
      if (!fileInput) {
        document.getElementById(this.fileIdPsjh).value = '';
      } else {
        this.inputPsData(fileInput);
      }
    },
    inputPsData: function inputPsData(fileInput) {
      this.$store.dispatch('inputOlderPlan', { excelFile: fileInput, fileId: this.fileIdPsjh, date: this.chooseHis['日期'] });
    },
    inputJxcData: function inputJxcData(fileInput) {
      this.$store.dispatch('dealJxcExceldata', { excelFile: fileInput, fileId: this.fileIdJxc, date: this.chooseHis['日期'] });
    },
    hxJxc: function hxJxc() {
      this.$store.dispatch('setHxDate', this.chooseHis['日期']);
      this.$store.dispatch('setAllPs', this.allPs);
      this.$router.push({ 'name': 'single.ruku_check' });
      this.$store.dispatch('loadWaitHx');
      this.showDetail = false;
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gas_map__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gas_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gas_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Echarts__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chartTools__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_oli_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cllib__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    GasMap: __WEBPACK_IMPORTED_MODULE_0__gas_map___default.a,
    Echarts: __WEBPACK_IMPORTED_MODULE_1__components_Echarts___default.a
  },
  data: function data() {
    return {
      colors: [{
        'background-color': '#168fff'
      }, {
        'background-color': '#65c4d7'
      }, {
        'background-color': '#6ab4a0'
      }],
      leDatas: [],
      horizontalScreen: false,
      topLeftChartOption: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chartTools__["a" /* initOptionBar1 */])([], [], []),
      topRightChartOption: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chartTools__["b" /* initOptionTreemap */])([], []),
      bottomLeftChartOption: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chartTools__["c" /* initOptionBar2 */])([], [], [], []),
      bottomRightChartOption1: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chartTools__["d" /* initOptionBar4 */])([], []),
      bottomRightChartOption2: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chartTools__["e" /* initOptionBar3 */])([], []),
      topLeftLoading: true
    };
  },
  created: function created() {
    this.loadDatas();
    this.horizontalScreen = window.screen.width / window.screen.height > 1;
  },

  methods: {
    change: function change() {
      this.$router.push({ 'name': 'gas_map' });
    },
    loadDatas: function loadDatas() {
      this.getDepotValume();
      this.getXgdxOrder();
      this.getCompanyWorkCarNum();
      this.getCompanyDistance();
    },
    getXgdxOrder: function getXgdxOrder() {
      var _this = this;

      var parm = {
        action: 'get_xgdx_order',
        data: ''
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["d" /* gas */])(parm).then(function (data) {
        var xDatas = [];
        var legends = ['平均销量', '期初库存', '入库升数'];
        var chartDatas = [[], []];
        var chartDatas2 = [[]];
        data.forEach(function (item, index1) {
          xDatas.push(item['加油站名称'].slice(2) + item['代号'].split('-')[1]);
          legends.forEach(function (lItem, index) {
            if (index === 0) {
              chartDatas2[index].push(item[lItem]);
            } else {
              chartDatas[index - 1].push(item[lItem]);
            }
          });
        });
        _this.bottomLeftChartOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chartTools__["c" /* initOptionBar2 */])(xDatas, legends, chartDatas, chartDatas2);
      });
    },
    getDepotValume: function getDepotValume() {
      var _this2 = this;

      this.topLeftLoading = true;
      var parm = {
        action: 'get_depot_valume',
        data: ''
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["h" /* depotValume */])(parm).then(function (data) {
        data.forEach(function (item) {
          item['油品'] = item['油品名称'].indexOf('汽油') > -1 ? item['油品名称'].slice(0, 2) + '#' : '柴油';
          item['油库名称'] = item['油库名称'] === '云南中石油安宁炼厂地付库' ? '安宁炼厂地付库' : item['油库名称'];
        });
        var dealData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cllib__["k" /* listToChartData */])(data, '油库名称', '油品', '指标量');
        var treemapData = [];
        dealData['xDatas'].forEach(function (item) {
          var total = 0;
          var children = [];
          dealData['legends'].forEach(function (itemLegend) {
            var valueOne = dealData['dealData'][item][itemLegend];
            children.push({
              name: itemLegend,
              value: valueOne
            });
            total += valueOne;
          });
          treemapData.push({
            name: item,
            value: total,
            children: children
          });
        });
        _this2.topLeftChartOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chartTools__["a" /* initOptionBar1 */])(dealData['xDatas'], dealData['legends'], dealData['chartDatas']);
        _this2.leDatas = dealData['xDatas'].length === 3 ? [dealData['xDatas'][1], dealData['xDatas'][0], dealData['xDatas'][2]] : dealData['xDatas'];
        _this2.topRightChartOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chartTools__["b" /* initOptionTreemap */])(dealData['xDatas'], treemapData);
        _this2.topLeftLoading = false;
      });
    },
    getCompanyWorkCarNum: function getCompanyWorkCarNum() {
      var _this3 = this;

      var parm = {
        action: 'get_company_work_car_num',
        data: ''
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["h" /* depotValume */])(parm).then(function (data) {
        var xDatas = [];
        var chartDatas = [[]];
        data.forEach(function (item) {
          var label = ['云南', '昆明'].indexOf(item['承运商'].slice(0, 2)) > -1 ? item['承运商'].slice(2) : item['承运商'];
          xDatas.push(label);
          chartDatas[0].push(item['TOTAL_CAR']);
        });
        _this3.bottomRightChartOption2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chartTools__["e" /* initOptionBar3 */])(xDatas, chartDatas);
      });
    },
    getCompanyDistance: function getCompanyDistance() {
      var _this4 = this;

      var parm = {
        action: 'get_company_distance',
        data: ''
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_oli_api__["h" /* depotValume */])(parm).then(function (data) {
        var xDatas = [];
        var chartDatas = [];
        data.forEach(function (item) {
          var label = ['云南', '昆明'].indexOf(item['承运商'].slice(0, 2)) > -1 ? item['承运商'].slice(2) : item['承运商'];
          xDatas.push(label);
          chartDatas.push(item['TOTAL_YJ']);
        });
        _this4.bottomRightChartOption1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chartTools__["d" /* initOptionBar4 */])(xDatas, chartDatas);
      });
    }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_oli_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cllib__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a,
    MiiBaseTable: __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable___default.a
  },
  data: function data() {
    return {
      newDepot: {
        '油库名称': '',
        '油库地址': ''
      },
      isNew: false,
      loading: true,
      showDel: false,
      showAdd: false,
      table_actions: [{
        label: '编辑',
        key: 'edit'
      }, {
        label: '删除',
        key: 'del'
      }],
      tableAction: [{
        key: 'add',
        icon: 'icon-addfriend'
      }],
      oilDepotList: [],
      ths: [{
        key: '油库代码',
        label: '油库代码'
      }, {
        key: '油库名称',
        label: '油库名称'
      }]
    };
  },
  created: function created() {
    this.loadDepot();
  },

  methods: {
    loadDepot: function loadDepot() {
      var _this = this;

      this.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["c" /* depot */])({ data: {}, action: 'get_depot' }).then(function (data) {
        _this.oilDepotList = data;
        _this.loading = false;
      });
    },
    clickTitleMenu: function clickTitleMenu(key) {
      if (key === 'add') {
        this.newDepot = {
          '油库代码': '',
          '油库名称': ''
        };
        this.isNew = true;
        this.showAdd = true;
      }
    },
    clickTdBtn: function clickTdBtn(dataMap) {
      this.newDepot = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cllib__["b" /* mapCp */])(dataMap.data);
      if (dataMap.key === 'del') {
        this.showDel = true;
      } else if (dataMap.key === 'edit') {
        this.isNew = false;
        this.showAdd = true;
      }
    },
    saveDepot: function saveDepot() {
      var _this2 = this;

      if (!this.newDepot['油库代码']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '油库代码必填',
          message: '请输入油库代码'
        });
        return;
      }
      var parm = {
        action: this.isNew ? 'add_depot' : 'edit_depot',
        data: this.newDepot
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["c" /* depot */])(parm).then(function (data) {
        if (data.code === 1) {
          _this2.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: _this2.isNew ? '油库新增完成' : '油库修改完成'
          });
          _this2.showAdd = false;
          _this2.loadDepot();
        } else {
          _this2.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: _this2.isNew ? '新增油库失败' : '修改油库失败'
          });
        }
      }).catch(function (e) {
        _this2.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: _this2.isNew ? '新增油库失败' : '修改油库失败'
        });
      });
    },
    delDepot: function delDepot() {
      var _this3 = this;

      var parm = {
        action: 'del_depot',
        data: { '油库代码': this.newDepot['油库代码'] }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["c" /* depot */])(parm).then(function (data) {
        if (data.code === 1) {
          _this3.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '油库删除成功'
          });
          _this3.loadDepot();
          _this3.showDel = false;
        } else {
          _this3.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '油库删除失败'
          });
        }
      }).catch(function (e) {
        _this3.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '油库删除失败'
        });
      });
    }
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      jxcThs: [{
        label: '加油站',
        key: '加油站名称'
      }, {
        label: '罐号',
        key: '罐号'
      }, {
        label: '油品类型',
        key: '油品名称'
      }, {
        label: '入库(L)',
        key: '入库升数'
      }, {
        label: '出库(L)',
        key: '出库升数'
      }, {
        label: '期末库存(L)',
        key: '期末库存'
      }, {
        label: '空容(L)',
        key: '空容'
      }, {
        label: '平均销量(L)',
        key: '平均销量'
      }, {
        label: '在途(L)',
        key: '在途计划升数'
      }, {
        label: '配送计划(L)',
        key: '配送计划'
      }, {
        label: '物理容积(L)',
        key: '物理容积'
      }, {
        label: '停泵库存(L)',
        key: '停泵库存'
      }, {
        label: '有效容积(L)',
        key: '有效容积'
      }],
      loading: false,
      psThs: [{
        key: 'SFID',
        label: 'ID'
      }, {
        key: '车牌号',
        label: '车牌号'
      }, {
        key: '罐号',
        label: '罐号'
      }, {
        key: '物理容积',
        label: '物理容积'
      }, {
        key: '空容',
        label: '空容'
      }, {
        key: '平均销量',
        label: '平均销量'
      }, {
        key: '配送升数',
        label: '配送升数'
      }, {
        key: '不容纳时间',
        label: '不容纳时间'
      }, {
        key: '断货时间',
        label: '断货时间'
      }, {
        key: '预计发车时间',
        label: '预计发车时间'
      }, {
        key: '趟次',
        label: '趟次'
      }, {
        key: '隔仓号',
        label: '隔仓号'
      }],
      orThs: [{
        key: 'SFID',
        label: 'ID'
      }, {
        key: '罐号',
        label: '罐号'
      }, {
        key: '物理容积',
        label: '物理容积'
      }, {
        key: '空容',
        label: '空容'
      }, {
        key: '平均销量',
        label: '平均销量'
      }, {
        key: '建议配送量',
        label: '配送升数'
      }, {
        key: '不容纳时间',
        label: '不容纳时间'
      }, {
        key: '断货时间',
        label: '断货时间'
      }]
    };
  },

  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a,
    MiiBaseTable: __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable___default.a
  },
  computed: {
    jxcDatas: {
      get: function get() {
        return this.$store.getters.oilHisJxcDatas;
      }
    },
    opdOilDetail: {
      get: function get() {
        return this.$store.getters.opdOilDetail;
      }
    },
    opdLoading: {
      get: function get() {
        return this.$store.getters.opdLoading;
      }
    }
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiBaseTable2__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiBaseTable2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_bit_MiiBaseTable2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cllib__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cars',
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default.a,
    MiiBaseTable2: __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiBaseTable2___default.a
  },
  data: function data() {
    return {
      actions: [{
        icon: 'icon-daochu',
        key: 'output'
      }],
      pageParm: {
        row_num: 10,
        dataTotal: 0
      },
      pageParm2: {
        row_num: 10,
        dataTotal: 0
      },
      jxcThs: [{
        label: '加油站',
        key: '加油站名称'
      }, {
        label: '油品类型',
        key: '油品名称'
      }, {
        label: '罐号',
        key: '罐号'
      }, {
        label: '时间',
        key: '时间'
      }, {
        label: '期初库存(L)',
        key: '期初库存'
      }, {
        label: '入库升数(L)',
        key: '入库升数'
      }, {
        label: '出库升数(L)',
        key: '出库升数'
      }, {
        label: '期末库存(L)',
        key: '期末库存'
      }, {
        label: '空容(L)',
        key: '空容'
      }],
      jxcThs2: [{
        label: '平均销量(L)',
        key: '平均销量'
      }, {
        label: '建议配送升数(L)',
        key: '建议配送量'
      }, {
        label: '消耗率',
        key: '消耗率'
      }, {
        label: '断货时间点',
        key: '断货时间'
      }, {
        label: '订单紧急程度',
        key: '订单紧急程度'
      }],
      jxcThs3: [{
        label: '订单类型',
        key: '订单紧急程度',
        style: function style(data) {
          if (data === '紧急订单') {
            return {
              'background-color': '#012e53',
              'color': '#00ccff'
            };
          } else if (data === '可配送订单') {
            return {
              'background-color': '#98aab9'
            };
          }
        }
      }, {
        label: '加油站',
        key: '加油站名称'
      }, {
        label: '油品',
        key: '油品名称'
      }, {
        label: '罐号',
        key: '罐号'
      }, {
        label: '空容',
        key: '空容'
      }, {
        label: '平均销量',
        key: '平均销量'
      }, {
        label: '建议配送升数(L)',
        key: '建议配送量'
      }, {
        label: '断货时间点',
        key: '断货时间'
      }],
      jxcThs4: [{
        label: '加油站名称',
        key: '加油站名称'
      }, {
        label: '油品类型',
        key: '油品名称'
      }, {
        label: '罐号',
        key: '罐号'
      }, {
        label: '平均销量',
        key: '平均销量'
      }, {
        label: '有效容积',
        key: '有效容积'
      }, {
        label: '有效容积-平均销量',
        key: 'sub'
      }],
      start_index: 0,
      start_index_dx: 0,
      showNote: false,
      row_num: 10,
      oilStation: ''
    };
  },

  methods: {
    clickMenu: function clickMenu(key) {
      console.log();
      var datas = [{
        data: [],
        sheetName: 'data1'
      }];
      var row1 = [];
      for (var _key in this.preDayData[0] || {}) {
        row1.push(_key);
      }
      datas[0].data.push(row1);
      this.preDayData.forEach(function (item) {
        var oneData = [];
        row1.forEach(function (itemKey) {
          oneData.push(item[itemKey]);
        });
        datas[0].data.push(oneData);
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cllib__["a" /* outPutExcelFile */])(datas, '每日订单（' + this.preDay + '）.xls');
    },
    pageChange: function pageChange(currentPage) {
      this.start_index = (currentPage - 1) * this.row_num;
    },
    pageChangeDx: function pageChangeDx(currentPage) {
      this.start_index_dx = (currentPage - 1) * this.row_num;
    }
  },
  computed: {
    showData: {
      get: function get() {
        var data = [];
        var allData = this.$store.getters.predictionDatas || [];
        if (allData) {
          var vm = this;
          allData.forEach(function (item) {
            if (item.oil === vm.oilStation) {
              item.data.forEach(function (itemC) {
                data.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cllib__["b" /* mapCp */])(itemC));
              });
            }
          });
          var row1 = {};
          var row2 = {};
          data.forEach(function (item, index) {
            var data1 = item['加油站名称'];
            if (!row1[data1]) {
              row1[data1] = { index: index, data: { label: data1, rowspan: 1 } };
            } else {
              row1[data1].data.rowspan++;
              item['加油站名称'] = { label: data1, rowspan: 0 };
            }
            var data2 = item['油品名称'];
            if (!row2[data2]) {
              row2[data2] = { index: index, data: { label: data2, rowspan: 1 } };
            } else {
              row2[data2].data.rowspan++;
              item['油品名称'] = { label: data2, rowspan: 0 };
            }
          });
          for (var key in row1) {
            data[row1[key].index]['加油站名称'] = row1[key].data;
          }
          for (var _key2 in row2) {
            data[row2[_key2].index]['油品名称'] = row2[_key2].data;
          }
        }
        return data;
      }
    },
    dxData: {
      get: function get() {
        var datas = this.$store.getters.predictionDatasXD;
        this.pageParm2.dataTotal = datas.length;
        return datas;
      }
    },
    preDay: {
      get: function get() {
        return this.$store.getters.todayStr;
      }
    },
    preDayData: {
      get: function get() {
        var newData = [];
        var data = this.$store.getters.predictionDatasDay;
        data.forEach(function (item) {
          newData.push(item);
        });
        this.pageParm.dataTotal = newData.length;
        return newData;
      }
    },
    predictionGasList: {
      get: function get() {
        var data = this.$store.getters.predictionGasList;
        this.oilStation = data ? data[0] : '';
        return data;
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.flowStatus < 20) {
      next({ name: 'single.single' });
    } else {
      next();
    }
  },
  created: function created() {
    this.$store.dispatch('prediction');
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiTableOil__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiTableOil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_bit_MiiTableOil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cllib__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var oilType = {
  '0': '60205886',
  '92': '60206059',
  '95': '60206060',
  '98': '60209058'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default.a,
    MiiTableOil: __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiTableOil___default.a
  },
  data: function data() {
    return {
      pageParm: {
        row_num: 3,
        dataTotal: 0,
        pageSizeChangeList: [3, 7, 10, 20, 50]
      },
      columns: [{
        label: '车号',
        key: '车牌号'
      }, {
        label: '仓号',
        key: '车辆仓号'
      }, {
        label: '仓容积',
        key: '仓容积'
      }, {
        label: '日期',
        key: '时间'
      }, {
        label: '订单类型',
        key: '订单紧急程度'
      }, {
        label: '油库',
        key: '油库名称'
      }],
      columnsDrder: [{
        label: '加油站',
        key: 'SMID'
      }, {
        label: '油品',
        key: '油品名称'
      }, {
        label: '罐号',
        key: '罐号'
      }, {
        label: '不容纳时间点',
        key: '不容纳时间'
      }, {
        label: '断货时间点',
        key: '断货时间'
      }, {
        label: '预计发车时间',
        key: '预计发车时间'
      }, {
        label: '在途时间',
        key: '在途时间'
      }],
      dateList: ['', ''],
      chat: false,
      quy: '昆明',
      start_index: 0,
      change_index: -1,
      search_car: ''
    };
  },

  methods: {
    pageSizeChange: function pageSizeChange(pageSize) {
      this.pageParm.row_num = pageSize;
      this.start_index = 0;
    },
    optPutFile: function optPutFile() {
      var datas = [{
        data: [],
        sheetName: 'data1'
      }];
      var row1 = ['配送日期', '车牌号', '隔仓号', '到站代码', '到站名称', '罐号', '油品代码', '油品名称', '升数 （升）', '数量（公斤）', '油库代码', '油库名称', '趟', '次', '班次', '驾驶员代码', '驾驶员姓名', '送达时间', '进销货标识', '配送类型', '进货类型'];
      datas[0].data.push(row1);
      this.showData.forEach(function (item) {
        var psDate = item['预计发车时间'] ? item['时间'].slice(0, 5) + item['预计发车时间'].slice(0, 5) : __WEBPACK_IMPORTED_MODULE_3__cllib__["g" /* dateOperating */].computeDay({ date: new Date(), days: 1, format: 'yy-mm-dd' });
        psDate = psDate.split('-')[0] + '/' + Number(psDate.split('-')[1]) + '/' + Number(psDate.split('-')[2]);
        var gch = item['隔仓号'] || 1;
        var ypdm = oilType[item['油品名称'].split('号')[0]] || '';
        var tang = item['趟次'] || 1;
        datas[0].data.push([psDate, item['车牌号'], gch, item['油站代码'], item['加油站名称'], item['罐号'], ypdm, item['油品名称'], item['配送升数'], '', item['油库代码'], item['油库名称'], tang, 1, 1, '66', '', psDate, '', '', '']);
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cllib__["a" /* outPutExcelFile */])(datas, '每日订单' + this.preDay + '.xls');
    },
    pageChange: function pageChange(currentPage) {
      this.start_index = (currentPage - 1) * this.pageParm.row_num;
    }
  },
  computed: {
    tableData: {
      get: function get() {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cllib__["h" /* listToTableData */])(this.showData.slice(this.start_index, this.start_index + this.pageParm.row_num), ['车牌号']);
      }
    },
    charData: {
      get: function get() {
        var data = [];
        var vm = this;
        var startDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cllib__["d" /* cmpDate */])(this.dateList[0] + ' 16:00');
        console.log(this.showData.slice(vm.start_index, vm.start_index + vm.pageParm.row_num));
        this.showData.slice(vm.start_index, vm.start_index + vm.pageParm.row_num).forEach(function (item, index) {
          var oneData = {
            name: item['车牌号'],
            lines: []
          };
          var inOld = false;
          data.forEach(function (itemD) {
            if (item['车牌号'] === itemD.name) {
              oneData = itemD;
              inOld = true;
            }
          });
          var startTimes = [];
          var startTime = item['预计发车时间'];
          var long = String(item['在途时间']).slice(0, 4) || 0;
          if (startTimes.indexOf(startTime) === -1) {
            startTimes.push(startTime);
            var endDate = item['预计发车时间'] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cllib__["d" /* cmpDate */])(item['预计发车时间'].length > 13 ? item['预计发车时间'] : vm.dateList[0].slice(0, 5) + item['预计发车时间']) : null;
            var left = item['预计发车时间'] ? ((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24 * 100).toFixed(2) + '%' : '0%';
            var lineData = {
              style: {
                width: long / 24 * 100 + '%',
                left: left
              },
              start_time: startTime,
              long: long
            };
            oneData.lines.push(lineData);
          }
          if (!inOld) {
            data.push(oneData);
          }
        });
        return data;
      }
    },
    preDay: {
      get: function get() {
        var toDay = this.$store.getters.todayStr;
        var tDay = __WEBPACK_IMPORTED_MODULE_3__cllib__["g" /* dateOperating */].computeDay({ date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cllib__["d" /* cmpDate */])(toDay), days: 1, format: 'yy-mm-dd' });
        this.dateList = [toDay, tDay];
        return toDay;
      }
    },
    showData: {
      get: function get() {
        var datas = this.$store.getters.orderCar;
        this.pageParm.dataTotal = datas.length;
        return datas;
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.flowStatus < 40) {
      next({ name: 'single.single' });
    } else {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('assignCarOrder');
      next();
    }
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiTableOil__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiTableOil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_bit_MiiTableOil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cllib__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cars',
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default.a,
    MiiTableOil: __WEBPACK_IMPORTED_MODULE_2__components_bit_MiiTableOil___default.a
  },
  data: function data() {
    return {
      selectOilType: '',
      oilTypes: ['汽油', '柴油'],
      selectArea: '',
      canEditKey: ['期初库存', '入库升数', '出库升数', '期末库存', '损溢', '配送计划'],
      tzThs: [{
        label: '加油站',
        key: '加油站名称'
      }, {
        label: '油品类型',
        key: '油品名称'
      }, {
        label: '时间',
        key: '日期'
      }, {
        label: '罐号',
        key: '罐号'
      }, {
        label: '期初库存(L)',
        key: '期初库存'
      }, {
        label: '入库升数(L)',
        key: '入库升数'
      }, {
        label: '出库升数(L)',
        key: '出库升数'
      }, {
        label: '期末库存(L)',
        key: '期末库存'
      }, {
        label: '损溢(L)',
        key: '损溢'
      }, {
        label: '平均销量(L)',
        key: '平均销量'
      }, {
        label: '配送计划(L)',
        key: '配送计划'
      }],
      jxcThs: [{
        label: '加油站',
        key: '加油站名称'
      }, {
        label: '油品类型',
        key: '油品名称'
      }, {
        label: '罐号',
        key: '罐号'
      }, {
        label: '期初库存(L)',
        key: '期初库存'
      }, {
        label: '入库升数(L)',
        key: '入库升数'
      }, {
        label: '出库升数(L)',
        key: '出库升数'
      }, {
        label: '期末库存(L)',
        key: '期末库存'
      }, {
        label: '空容(L)',
        key: '空容'
      }, {
        label: '损溢(L)',
        key: '损溢'
      }, {
        label: '平均销量(L)',
        key: '平均销量'
      }, {
        label: '物理容积(L)',
        key: '物理容积'
      }, {
        label: '配送计划(L)',
        key: '配送计划'
      }, {
        label: '在途(L)',
        key: '在途计划升数'
      }],
      edit_data: '',
      dialogVisible: false
    };
  },

  methods: {
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    checkData: function checkData(data) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cllib__["i" /* checkData */])(data) === 0;
    },
    hxJxc: function hxJxc() {
      this.$store.dispatch('setHxDate', this.yesterDayStr);
      this.$store.dispatch('setAllPs', this.$store.getters.userInfo && this.$store.getters.userInfo.USER_TYPE === 'manager');
      this.$router.push({ 'name': 'single.ruku_check' });
      this.$store.dispatch('loadWaitHx');
    },
    checkRk: function checkRk(data) {
      var datas = [];
      this.$store.getters.hisJxcDatas.forEach(function (itemData) {
        if (itemData.oil === data['加油站名称']) {
          datas = itemData.data;
        }
      });
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cllib__["j" /* checkRkData */])(data, datas);
    },
    sure: function sure() {
      this.dialogVisible = false;
      this.$store.dispatch('updateErrorHisJxcDatas');
    },
    hul: function hul() {
      this.dialogVisible = false;
      this.$store.dispatch('hlErrorHisJxcDatas');
    },
    focusEdit: function focusEdit(data, key) {
      var num = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cllib__["i" /* checkData */])(data);
      num = num === 0 ? data[key] : ['期初库存', '入库升数'].indexOf(key) === -1 ? Number(data[key]) + num : Number(data[key]) - num;
      this.edit_data = num < 0 && key !== '损溢' ? 0 : num;
    },
    blur: function blur(data, key) {
      this.$store.dispatch('editOneHisJxcData', { data: data, key: key, value: this.edit_data });
      this.edit_data = '';
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.flowStatus === 0) {
      next({ name: 'single.source_data_pre' });
    } else {
      next();
    }
  },

  computed: {
    showJxcDatas: {
      get: function get() {
        var _this = this;

        var datas = [];
        this.$store.getters.hisJxcDatas.forEach(function (item) {
          item['data'].forEach(function (itemD) {
            if ((!_this.selectArea || itemD['区域'] && itemD['区域'].indexOf(_this.selectArea) > -1) && (!_this.selectOilType || itemD['油品名称'] && itemD['油品名称'].indexOf(_this.selectOilType) > -1)) {
              datas.push(itemD);
            }
          });
        });
        return datas;
      }
    },
    preDay: {
      get: function get() {
        return this.$store.getters.todayStr;
      }
    },
    yesterDayStr: {
      get: function get() {
        return this.$store.getters.yesterDayStr;
      }
    },
    errorHisJxcDatas: {
      get: function get() {
        return this.$store.getters.errorHisJxcDatas;
      }
    },
    areaList: {
      get: function get() {
        return this.$store.getters.allAreas;
      }
    }
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cllib__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dateList: ['', '', ''],
      ths: [{
        key: '加油站名称',
        label: '加油站'
      }, {
        key: '时间',
        label: '日期'
      }, {
        key: '订单紧急程度',
        label: '订单类型'
      }, {
        key: '油品名称',
        label: '油品'
      }, {
        key: '罐号',
        label: '罐号'
      }, {
        key: '空容',
        label: '空容'
      }, {
        key: '油库名称',
        label: '油库'
      }],
      ths2: [{
        key: '车牌号',
        label: '车号'
      }, {
        key: '车辆仓号',
        label: '车辆仓号'
      }, {
        key: '仓容积',
        label: '仓容积'
      }, {
        key: '不容纳时间',
        label: '不容纳时间点'
      }, {
        key: '断货时间',
        label: '断货时间点'
      }, {
        key: '空容',
        label: '空容'
      }, {
        key: '预计发车时间',
        label: '预计发车时间'
      }, {
        key: '在途时间',
        label: '在途时间'
      }],
      start_index: 0,
      row_num: 7
    };
  },

  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default.a
  },
  methods: {
    clickOutPutFileIcon: function clickOutPutFileIcon() {
      var datas = [{
        data: [],
        sheetName: 'data1'
      }];
      var row1 = ['加油站', '日期', '订单类型', '油品', '罐号', '空容', '车号', '所用车辆仓号', '仓容积', '不容纳时间点', '断货时间点', '预计发车时间', '在途时间'];
      datas[0].data.push(row1);
      this.showData.forEach(function (item) {
        datas[0].data.push([item['加油站名称'], item['时间'], item['订单紧急程度'], item['油品名称'], item['罐号'], item['空容'], item['车牌号'], item['车辆仓号'], item['仓容积'], item['不容纳时间'], item['断货时间'], item['预计发车时间'], item['在途时间']]);
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cllib__["a" /* outPutExcelFile */])(datas, '每日订单（' + this.preDay + '）.xls');
    },
    pageChange: function pageChange(currentPage) {
      this.start_index = (currentPage - 1) * this.row_num;
    },
    handleSizeChange: function handleSizeChange(pageSize) {
      this.row_num = pageSize;
      this.start_index = 0;
    }
  },
  computed: {
    preDay: {
      get: function get() {
        var toDay = this.$store.getters.todayStr;
        var tDay = __WEBPACK_IMPORTED_MODULE_2__cllib__["g" /* dateOperating */].computeDay({ date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cllib__["d" /* cmpDate */])(toDay), days: 1, format: 'yy-mm-dd' });
        var t2Day = __WEBPACK_IMPORTED_MODULE_2__cllib__["g" /* dateOperating */].computeDay({ date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cllib__["d" /* cmpDate */])(toDay), days: 2, format: 'yy-mm-dd' });
        this.dateList = [toDay, tDay, t2Day];
        return toDay;
      }
    },
    showData: {
      get: function get() {
        return this.$store.getters.orderGas;
      }
    },
    charData: {
      get: function get() {
        var data = [];
        var vm = this;
        var startDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cllib__["d" /* cmpDate */])(this.dateList[0] + ' 00:00');
        var maxDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cllib__["d" /* cmpDate */])(this.dateList[2] + ' 23:59');
        this.showData.slice(vm.start_index, vm.start_index + vm.row_num).forEach(function (item, index) {
          var oneData = {
            name: '订单' + (vm.start_index + index + 1),
            style1: {
              width: 0
            },
            style2: {
              width: 0
            },
            dh_date: item['断货时间'],
            brn_date: item['不容纳时间']
          };
          var endDate = item['不容纳时间'] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cllib__["d" /* cmpDate */])(item['不容纳时间'].length > 13 ? item['不容纳时间'] : vm.dateList[0].slice(0, 5) + item['不容纳时间']) : null;
          var endDate2 = item['断货时间'] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cllib__["d" /* cmpDate */])(item['断货时间'].length > 13 ? item['断货时间'] : vm.dateList[0].slice(0, 5) + item['断货时间']) : null;
          oneData.style1.width = item['不容纳时间'] ? ((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 72 * 100).toFixed(2) + '%' : '50%';
          oneData.style2.width = item['断货时间'] ? ((maxDate.getTime() - endDate2.getTime()) / 1000 / 60 / 60 / 72 * 100).toFixed(2) + '%' : '50%';
          data.push(oneData);
        });
        return data;
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.flowStatus < 40) {
      next({ name: 'single.single' });
    } else {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('assignCarOrder');
      next();
    }
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_oli_api__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a,
    MiiBaseTable: __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable___default.a
  },
  data: function data() {
    return {
      hxStatus: false,
      loading: false,
      showHeXiao: false,
      tbAction: [{
        label: '核销',
        key: 'hexiao',
        hideByData: function hideByData(data) {
          return !data['核销'];
        }
      }],
      canHxPsjhList: [],
      thsPs: [{
        label: '车牌号',
        key: '车牌号'
      }, {
        label: '油品',
        key: '油品名称'
      }, {
        label: '配送升数',
        key: '配送升数ERP'
      }, {
        label: '出库时间',
        key: 'ERP出库时间',
        shortType: 'date_time'
      }, {
        label: '状态',
        key: 'STATUS'
      }],
      ths: [{
        label: '加油站',
        key: '加油站名称'
      }, {
        label: '罐号',
        key: '罐号'
      }, {
        label: '油品',
        key: '油品名称'
      }, {
        label: '入库升数(L)',
        key: '入库升数'
      }, {
        label: '核销状态',
        key: '核销状态',
        shortType: 'text'
      }]
    };
  },

  computed: {
    isAdmin: {
      get: function get() {
        return this.$store.getters.userInfo && this.$store.getters.userInfo.USER_TYPE === 'manager';
      }
    },
    loadingHxJxc: {
      get: function get() {
        return this.$store.getters.loadingHxJxc;
      }
    },
    loadingCanHxPsjh: {
      get: function get() {
        return this.$store.getters.loadingCanHxPsjh;
      }
    },
    loadingSysHx: {
      get: function get() {
        return this.$store.getters.loadingSysHx;
      }
    },
    loadingUserHx: {
      get: function get() {
        var data = this.$store.getters.loadingUserHx;
        if (data) {
          this.showHeXiao = false;
        }
        return data;
      }
    },
    hxDate: {
      get: function get() {
        return this.$store.getters.hxDate;
      }
    },
    waitHxList: {
      get: function get() {
        var _this = this;

        var data = [];
        this.$store.getters.waitHxList.forEach(function (item) {
          if (_this.hxStatus) {
            if (!item['核销']) {
              data.push(item);
            }
          } else {
            data.push(item);
          }
        });
        return data;
      }
    },
    allPs: {
      get: function get() {
        return this.$store.getters.allPs;
      },
      set: function set(value) {
        this.$store.dispatch('setAllPs', value);
      }
    },
    hxJxc: {
      get: function get() {
        return this.$store.getters.hxJxc;
      },
      set: function set(value) {
        this.$store.dispatch('setUserHxJxc', value);
      }
    }
  },
  methods: {
    userHxjxc: function userHxjxc() {
      var checkedPsjh = [];
      this.canHxPsjhList.forEach(function (item) {
        if (item.checked) {
          checkedPsjh.push(item['SMID']);
        }
      });
      this.$store.dispatch('userHxjxc', checkedPsjh);
    },
    clickTdBtn: function clickTdBtn(parm) {
      this.$store.dispatch('setUserHxJxc', parm.data);
      this.showHeXiao = true;
      this.getCanHxPsjhList();
    },
    sysHx: function sysHx() {
      this.$store.dispatch('sysHxjxc');
    },
    getCanHxPsjhList: function getCanHxPsjhList() {
      var _this2 = this;

      var getters = this.$store.getters;
      // 获取可用核销配送计划
      var parm = {
        action: 'get_canhx_psjh',
        data: {
          date: getters.hxDate,
          jxc: getters.hxJxc
        }
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_oli_api__["g" /* inputAllData */])(parm).then(function (data) {
        data.forEach(function (item) {
          item['checked'] = false;
        });
        _this2.canHxPsjhList = data;
      });
    }
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_map_pre__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_map_pre___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_map_pre__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_SwitchMapBtn__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_SwitchMapBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_SwitchMapBtn__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    switch_map_btn: __WEBPACK_IMPORTED_MODULE_1__components_bit_SwitchMapBtn___default.a,
    chart_map_pre: __WEBPACK_IMPORTED_MODULE_0__view_map_pre___default.a
  },
  computed: {
    inputDataLoading: {
      get: function get() {
        return this.$store.getters.inputDataLoading;
      }
    },
    path: {
      get: function get() {
        return this.$store.state.route.path;
      }
    }
  },
  created: function created() {
    this.$store.dispatch('loadInputData');
    this.$store.dispatch('loadLocationData');
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LeftBarSingle__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LeftBarSingle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_LeftBarSingle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHead__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bit_Loading__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bit_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_bit_Loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.logined !== 1) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('setLoginFor', 'single_home');
      next({ name: 'login' });
    } else if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.oilArea) {
      next({ name: 'index' });
    } else {
      next();
    }
  },

  components: {
    LeftBarSingle: __WEBPACK_IMPORTED_MODULE_1__components_LeftBarSingle___default.a,
    PageHead: __WEBPACK_IMPORTED_MODULE_2__components_PageHead___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_3__components_bit_Loading___default.a
  },
  computed: {
    path: {
      get: function get() {
        return this.$store.state.route.path;
      }
    }
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a,
    MiiBaseTable: __WEBPACK_IMPORTED_MODULE_1__components_bit_MiiBaseTable___default.a
  },
  data: function data() {
    return {
      showYHcount: false,
      showYHerror: false,
      titleAction: [{
        key: 'his',
        icon: 'icon-meitian'
      }],
      thsC: [{
        label: '油品名称',
        key: '油品名称'
      }, {
        label: '总条数',
        key: 'count'
      }, {
        label: '总吨数',
        key: 'total'
      }],
      ths: [{
        label: '加油站代码',
        key: '加油站代码'
      }, {
        label: '92#',
        key: '92#'
      }, {
        label: '95#',
        key: '95#'
      }, {
        label: '98#',
        key: '98#'
      }, {
        label: '0#',
        key: '0#'
      }, {
        label: '备注',
        key: '备注'
      }, {
        label: '错误',
        key: '错误'
      }]
    };
  },

  methods: {
    clickTitleMenu: function clickTitleMenu(key) {
      if (key === 'his') {
        this.$router.push({ 'name': 'single.input_data_date' });
      }
    },
    checkFile: function checkFile(files) {
      if (!files.length) {
        return null;
      } else if (['xlsx', 'xls'].indexOf(files[0].name.split('.').slice(-1)[0]) > -1) {
        return files[0];
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择excel文件。'
        });
        return false;
      }
    },
    oldFileChange: function oldFileChange(e) {
      var fileOld = this.checkFile(e.target.files || e.dataTransfer.files);
      if (!fileOld) {
        document.getElementById('file-1').value = '';
      } else {
        this.$store.dispatch('dealJxcExceldata', { excelFile: fileOld, fileId: 'file-1' });
      }
    },
    plantFileChange: function plantFileChange(e) {
      var filePlant = this.checkFile(e.target.files || e.dataTransfer.files);
      if (!filePlant) {
        document.getElementById('file-4').value = '';
      } else {
        this.$store.dispatch('inputOlderPlan', { excelFile: filePlant, fileId: 'file-4' });
      }
    },
    toGoodsFileChange: function toGoodsFileChange(e) {
      var filePlant = this.checkFile(e.target.files || e.dataTransfer.files);
      if (!filePlant) {
        document.getElementById('file-5').value = '';
      } else {
        this.$store.dispatch('inputToGoods', { excelFile: filePlant, fileId: 'file-5' });
      }
    },
    stationFileChange: function stationFileChange(e) {
      var fileStation = this.checkFile(e.target.files || e.dataTransfer.files);
      if (!fileStation) {
        document.getElementById('file-3').value = '';
      } else {
        this.$store.dispatch('inputDepotValume', { excelFile: fileStation, fileId: 'file-3' });
      }
    }
  },
  computed: {
    toGoodsErrorData: {
      get: function get() {
        var data = this.$store.getters.toGoodsErrorData;
        this.showYHerror = data.length > 0;
        return data;
      }
    },
    toGoodsCount: {
      get: function get() {
        var data = this.$store.getters.toGoodsCount;
        this.showYHcount = data.length > 0;
        return data;
      }
    },
    preDay: {
      get: function get() {
        return this.$store.getters.todayStr;
      }
    },
    inputJxcOk: {
      get: function get() {
        return this.$store.getters.inputJxcOk;
      }
    },
    inputOrderPlantOk: {
      get: function get() {
        return this.$store.getters.inputOrderPlantOk;
      }
    },
    inputToGoodsOk: {
      get: function get() {
        return this.$store.getters.inputToGoodsOk;
      }
    },
    inputDepotValumeOk: {
      get: function get() {
        return this.$store.getters.inputDepotValumeOk;
      }
    }
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a
  },
  methods: {
    saveCase: function saveCase() {
      this.$store.dispatch('saveCase');
    },
    close: function close() {
      this.showEditName = false;
    },
    goLgin: function goLgin() {
      this.$router.push('/login');
      this.$store.dispatch('setLoginFor', '/home/output');
    }
  },
  computed: {
    login: {
      get: function get() {
        return this.$store.getters.login;
      }
    },
    caseList: {
      get: function get() {
        return this.$store.getters.caseList;
      }
    },
    caseName: {
      get: function get() {
        return this.$store.getters.caseName;
      },
      set: function set(value) {
        this.$store.dispatch('setCaseName', value);
      }
    },
    activeCase: {
      get: function get() {
        return this.$store.getters.activeCase;
      }
    }
  },
  data: function data() {
    return {
      showEditName: false,
      activeImportWayKey: 'demo',
      outPutWays: [{
        name: '存储至浏览器',
        key: 'browser'
      }],
      activeOutPutWayKey: 'browser',
      down1: true
    };
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_init__ = __webpack_require__(53);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      checked: false,
      info: {
        name: '',
        phone: '',
        email: '',
        unit: '',
        job: '',
        password: '',
        rePassword: ''
      }
    };
  },

  methods: {
    register: function register() {
      var vm = this;
      if (this.info.password === this.info.rePassword) {
        var data = {
          account: this.info.name,
          password: this.info.password,
          other_info: 'email=' + this.info.email + '&phone=' + this.info.phone + '&unit=' + this.info.unit + '&job=' + this.info.job
        };
        __WEBPACK_IMPORTED_MODULE_0__axios_init__["a" /* axiosSysApi2 */].post('/register', window.JSON.stringify(data)).then(function (response) {
          vm.$store.dispatch('showNoticeMsg', {
            type: 'info',
            title: '注册成功',
            message: '跳转登录！'
          });
          vm.$router.push('/login');
        }).catch(function (e) {
          vm.$store.dispatch('showNoticeMsg', {
            type: 'warning',
            title: '注册失败',
            message: e
          });
        });
      } else {
        console.log('密码不一致');
      }
    },
    goLogin: function goLogin() {
      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a
  },
  created: function created() {
    if (this.solutionStatus === 10) {
      this.$store.dispatch('setSolutionStatus', 20);
    }
  },

  computed: {
    groupsNum: {
      get: function get() {
        return this.$store.getters.groupsNum;
      },
      set: function set(value) {
        return this.$store.dispatch('setGroupsNum', value);
      }
    },
    solutionStatus: {
      get: function get() {
        return this.$store.getters.solutionStatus;
      }
    },
    maxCustomersNum: {
      get: function get() {
        return this.$store.getters.maxCustomersNum;
      },
      set: function set(value) {
        return this.$store.dispatch('setMaxCustomersNum', value);
      }
    },
    groupTimeLimit: {
      get: function get() {
        return this.$store.getters.groupTimeLimit;
      },
      set: function set(value) {
        return this.$store.dispatch('setGroupTimeLimit', value);
      }
    },
    groupMipGap: {
      get: function get() {
        return this.$store.getters.groupMipGap * 100;
      },
      set: function set(value) {
        return this.$store.dispatch('setGroupMipGap', value / 100);
      }
    },
    routeTimeLimit: {
      get: function get() {
        return this.$store.getters.routeTimeLimit;
      },
      set: function set(value) {
        return this.$store.dispatch('setRouteTimeLimit', value);
      }
    },
    routeMipGap: {
      get: function get() {
        return this.$store.getters.routeMipGap;
      },
      set: function set(value) {
        return this.$store.dispatch('setRouteMipGap', value);
      }
    },
    solutionWay: {
      get: function get() {
        return this.$store.getters.solutionWay;
      },
      set: function set(value) {
        return this.$store.dispatch('setSolutionWay', value);
      }
    },
    solutionDay: {
      get: function get() {
        return this.$store.getters.solutionDay;
      },
      set: function set(value) {
        return this.$store.dispatch('setSolutionDay', value);
      }
    },
    solutionWeeks: {
      get: function get() {
        return this.$store.getters.solutionWeeks;
      }
    },
    solutionWays: {
      get: function get() {
        return this.$store.getters.solutionWays;
      }
    }
  },
  data: function data() {
    return {
      show_note: true,
      setting_note: '\n      \u672C\u89E3\u51B3\u65B9\u6848\u5206\u4E3A\u4E24\u6B65\u6C42\u89E3\uFF0C\u7B2C\u4E00\u6B65\u6C42\u89E3\u8F66\u8F86\u8C03\u5EA6\u6A21\u578B\uFF0C\u8BE5\u6A21\u578B\u628A\u6240\u6709\u8BA2\u5355\u5206\u7FA4\u7EC4\uFF0C\u4E00\u8F86\u8F66\u670D\u52A1\u4E00\u4E2A\u7FA4\u7EC4\u91CC\u7684\u6240\u6709\u5BA2\u6237\u3002<br>\u7B2C\u4E8C\u6B65\u6C42\u89E3\u8DEF\u5F84\u89C4\u5212\u6A21\u578B\uFF0C\u8BE5\u6A21\u578B\u4E3A\u6BCF\u4E2A\u8F66\u8F86\u5206\u522B\u89C4\u5212\u914D\u9001\u8DEF\u7EBF\u3002\n      ',
      notes: ['车辆数 ———— 所能调配的车辆总数', '每个车辆配送最大客户数 ———— 每辆车所能配送的最大客户数', '车辆调度模型的TimeLimit ———— 允许车辆调度模型求解的最大时间(单位：秒)', '车辆调度模型的MIPGap ———— 当目标函数的最小值和最大值的差值的绝对值小于最大值的MIPGap倍时，求解器会终止并返回一个最优解。空格中填写的默认为小数，比如填写0.01则该模型的MIPGap为1%。', '路径规划模型的TimeLimit ———— 允许车辆调度模型求解的最大时间(单位：秒)', '路径规划模型的MIPGap ———— 当目标函数的最小值和最大值的差值的绝对值小于最大值的MIPGap倍时，求解器会终止并返回一个最优解。空格中填写的默认为小数，比如填写0.01则该模型的MIPGap为1%']
    };
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_WeekData__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_WeekData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_WeekData__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MiiTable: __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable___default.a,
    WeekData: __WEBPACK_IMPORTED_MODULE_1__components_bit_WeekData___default.a
  },
  computed: {
    canEdit: {
      get: function get() {
        return this.$store.getters.solutionStatus < 21;
      }
    },
    sourceDataType: {
      get: function get() {
        return this.$store.getters.sourceDataType;
      }
    },
    orderWeight: {
      get: function get() {
        return this.$store.getters.orderWeight;
      }
    },
    orderVolume: {
      get: function get() {
        return this.$store.getters.orderVolume;
      }
    },
    orderDays: {
      get: function get() {
        return this.$store.getters.orderDays;
      }
    },
    ths: {
      get: function get() {
        var ths = [{
          key: 'shop'
        }, {
          key: 'dry'
        }, {
          key: 'Fresh'
        }, {
          key: 'frozen'
        }];
        var labels = this.$store.getters.sourceDataField[this.$store.getters.sourceDataType];
        ths.forEach(function (item) {
          item.label = labels[item.key];
        });
        return ths;
      }
    }
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Echarts__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EchartsOptions__ = __webpack_require__(99);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cars',
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default.a,
    MiiTable: __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable___default.a,
    Echarts: __WEBPACK_IMPORTED_MODULE_2__components_Echarts___default.a
  },
  computed: {
    sourceDataType: {
      get: function get() {
        return this.$store.getters.sourceDataType;
      }
    },
    carRoutes: {
      get: function get() {
        return this.$store.getters.carRoutes;
      }
    },
    solutionData: {
      get: function get() {
        return this.$store.getters.solutionData;
      }
    },
    echartsOption: {
      get: function get() {
        var echartsOption = {
          option: {},
          outOption: {
            style: ''
          }
        };
        var showDatas = {
          car: this.car2,
          data: [{
            'value1': this.sourceDataType === 'tobacco' ? '红塔山' : this.sourceDataType !== 'shop' ? '0号柴油' : '干货',
            'value2': 0
          }, {
            'value1': this.sourceDataType === 'tobacco' ? '玉溪' : this.sourceDataType !== 'shop' ? '92号汽油' : '新鲜货',
            'value2': 0
          }, {
            'value1': this.sourceDataType === 'tobacco' ? '云烟' : this.sourceDataType !== 'shop' ? '95号汽油' : '冰冻货',
            'value2': 0
          }]
        };
        if (this.car2) {
          var customers = [];
          var vm = this;
          this.clusterCutomer.forEach(function (item) {
            if (item[0].slice(2) === vm.car2.slice(2)) {
              customers = item.slice(1);
            }
          });
          this.orderWeight.forEach(function (item) {
            if (customers.indexOf(item.shop) > -1) {
              showDatas.data[0]['value2'] += item.Fresh;
              showDatas.data[1]['value2'] += item.dry;
              showDatas.data[2]['value2'] += item.frozen;
            }
          });
          console.log(showDatas);
          echartsOption = { option: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__EchartsOptions__["a" /* initOption */])(showDatas.data, this.option), outOption: { style: this.option.style } };
        }
        return echartsOption;
      }
    },
    clusterCutomer: {
      get: function get() {
        return this.$store.getters.clusterCutomer;
      }
    },
    orderWeight: {
      get: function get() {
        return this.$store.getters.orderWeight;
      }
    },
    cars: {
      get: function get() {
        this.car_first = this.car_first || this.$store.getters.cars[0];
        this.car2 = this.car2 || this.$store.getters.cars[0];
        return this.$store.getters.cars;
      }
    },
    oneCarRoutes: {
      get: function get() {
        var data = [];
        var vm = this;
        this.carRoutes.forEach(function (item) {
          if (item.car === vm.car_first) {
            item.route_data.forEach(function (one) {
              data.push({ 'route': one[0] + '<i class="iconfont icon-jiantou"></i>' + one[1] });
            });
          }
        });
        return data;
      }
    }
  },
  data: function data() {
    return {
      car_first: '',
      car2: '',
      option: {
        chartType: 'huan',
        dataX: 'value1',
        dataY: 'value2',
        otherOption: {
          title: ''
        },
        style: ''
      },
      ths2: [{
        key: 'route'
      }]
    };
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Echarts__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EchartsOptions__ = __webpack_require__(99);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cars',
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_1__components_bit_ContentTitle___default.a,
    MiiTable: __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable___default.a,
    Echarts: __WEBPACK_IMPORTED_MODULE_2__components_Echarts___default.a
  },
  methods: {},
  computed: {
    sourceDataType: {
      get: function get() {
        return this.$store.getters.sourceDataType;
      }
    },
    orderWeight: {
      get: function get() {
        return this.$store.getters.orderWeight;
      }
    },
    carOrders: {
      get: function get() {
        var data = [];
        if (this.show_order_car) {
          var customers = [];
          var vm = this;
          this.clusterCutomer.forEach(function (item) {
            if (item[0].slice(2) === vm.show_order_car.slice(2)) {
              customers = item.slice(1);
            }
          });
          this.orderWeight.forEach(function (item) {
            if (customers.indexOf(item.shop) > -1) {
              data.push(item);
            }
          });
        }
        return data;
      }
    },
    echarts_option: {
      get: function get() {
        var vm = this;
        var datas = [];
        this.carOrders.forEach(function (item) {
          vm.ths.forEach(function (one, index) {
            if (index > 0) {
              datas.push({ value1: item.shop, value2: one.label, value3: item[one.key] });
            }
          });
        });
        return { option: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__EchartsOptions__["a" /* initOption */])(datas, this.option), outOption: { style: this.option.style } };
      }
    },
    cars: {
      get: function get() {
        var data = this.$store.getters.cars;
        if (data.length > 0) {
          this.show_order_car = data[0];
        }
        return data;
      },
      set: function set(value) {
        return this.$store.dispatch('setCars', value);
      }
    },
    clusterCutomer: {
      get: function get() {
        return this.$store.getters.clusterCutomer;
      },
      set: function set(value) {
        return this.$store.dispatch('setClusterCutomer', value);
      }
    },
    centroids: {
      get: function get() {
        return this.$store.getters.centroids;
      },
      set: function set(value) {
        return this.$store.dispatch('setCentroids', value);
      }
    },
    ths: {
      get: function get() {
        var ths = [{
          key: 'shop'
        }, {
          key: 'dry'
        }, {
          key: 'Fresh'
        }, {
          key: 'frozen'
        }];
        var labels = this.$store.getters.sourceDataField[this.$store.getters.sourceDataType];
        ths.forEach(function (item) {
          item.label = labels[item.key];
        });
        return ths;
      }
    }
  },
  data: function data() {
    return {
      show_order_car: '',
      datas: [],
      option: {
        chartType: 'bar',
        dataX: 'value1',
        dataY: 'value3',
        dataZ: 'value2',
        otherOption: {
          title: ''
        },
        style: ''
      },
      thsCentroids: [{
        label: '车辆名称',
        key: 'car_name'
      }, {
        label: '中心点',
        key: 'center'
      }, {
        label: '顾客数',
        key: 'customer_num'
      }, {
        label: '订货数量',
        key: 'order_num'
      }, {
        label: '总距离',
        key: 'distance'
      }]
    };
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a
  },
  methods: {
    startImport: function startImport(throwAway) {
      if (this.activeCase.status === 'new' && !throwAway) {
        this.dialogVisible = true;
      } else {
        this.$store.dispatch('addCase', '烟草DEMO');
        this.$store.dispatch('setSourceDataType', 'tobacco');
        this.$store.dispatch('initMapOption');
        this.$store.dispatch('loadSourceData', 'source_data_to.json');
        this.$router.push({ name: 'tobacco' });
      }
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    changeCase: function changeCase(data) {
      this.$store.dispatch('switchCase', data.key);
      this.$router.push({ name: 'tobacco' });
    }
  },
  computed: {
    caseList: {
      get: function get() {
        return this.$store.getters.caseList;
      }
    },
    activeCase: {
      get: function get() {
        return this.$store.getters.activeCase;
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      importWays: [{
        name: '烟草DEMO',
        key: 'demo3'
      }],
      activeImportWayKey: 'demo3',
      outPutWays: [{
        name: '存储至浏览器',
        key: 'browser'
      }, {
        name: '导出至Excel',
        key: 'excel'
      }],
      activeOutPutWayKey: 'browser',
      down1: true
    };
  }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_map__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LeftBarTo__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LeftBarTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_LeftBarTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeadTo__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeadTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeadTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bit_Loading__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bit_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_bit_Loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    chart_map: __WEBPACK_IMPORTED_MODULE_0__view_map___default.a,
    left_bar_to: __WEBPACK_IMPORTED_MODULE_1__components_LeftBarTo___default.a,
    page_head: __WEBPACK_IMPORTED_MODULE_2__components_PageHeadTo___default.a,
    switch_map_btn: __WEBPACK_IMPORTED_MODULE_3__components_bit_SwitchMapBtn___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_4__components_bit_Loading___default.a
  },
  created: function created() {
    this.$store.dispatch('getCaseList');
    if (this.solutionStatus === 0 && this.$router.history.current.name === 'cycle') {
      this.$router.push({ name: 'import' });
    }
  },

  computed: {
    solutionStatus: {
      get: function get() {
        return this.$store.getters.solutionStatus;
      }
    },
    path: {
      get: function get() {
        return this.$store.state.route.path;
      }
    }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a
  },
  methods: {
    saveCase: function saveCase() {
      this.$store.dispatch('saveCase');
    },
    close: function close() {
      this.showEditName = false;
    },
    goLgin: function goLgin() {
      this.$router.push('/login');
      this.$store.dispatch('setLoginFor', '/home/output');
    }
  },
  computed: {
    login: {
      get: function get() {
        return this.$store.getters.login;
      }
    },
    caseList: {
      get: function get() {
        return this.$store.getters.caseList;
      }
    },
    caseName: {
      get: function get() {
        return this.$store.getters.caseName;
      },
      set: function set(value) {
        this.$store.dispatch('setCaseName', value);
      }
    },
    activeCase: {
      get: function get() {
        return this.$store.getters.activeCase;
      }
    }
  },
  data: function data() {
    return {
      showEditName: false,
      activeImportWayKey: 'demo',
      outPutWays: [{
        name: '存储至浏览器',
        key: 'browser'
      }],
      activeOutPutWayKey: 'browser',
      down1: true
    };
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cars',
  data: function data() {
    return {
      start_index: 0,
      showNote: false,
      row_num: 10,
      day: ''
    };
  },

  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a
  },
  methods: {
    pageChange: function pageChange(currentPage) {
      this.start_index = (currentPage - 1) * this.row_num;
    }
  },
  computed: {
    showData: {
      get: function get() {
        var data = [];
        if (this.preData) {
          var vm = this;
          this.preData.forEach(function (item) {
            if (item.oil === vm.oilStation) {
              data = item.data;
            }
          });
          if (data[0] && data[0][0] && data[0][0].label) {
            return data;
          }
          var row1 = {};
          var row2 = {};
          data.forEach(function (item, index) {
            var data1 = item[0];
            if (!row1[data1]) {
              row1[data1] = { index: index, data: { label: data1, rowspan: 1 } };
            } else {
              row1[data1].data.rowspan++;
              item[0] = { label: data1, rowspan: 0 };
            }
            var data2 = item[1];
            if (!row2[data2]) {
              row2[data2] = { index: index, data: { label: data2, rowspan: 1 } };
            } else {
              row2[data2].data.rowspan++;
              item[1] = { label: data2, rowspan: 0 };
            }
          });
          for (var key in row1) {
            data[row1[key].index][0] = row1[key].data;
          }
          for (var _key in row2) {
            data[row2[_key].index][1] = row2[_key].data;
          }
        }
        return data;
      }
    },
    showDayData: {
      get: function get() {
        var data = [];
        if (this.preDayData.length > 0) {
          data = this.preDayData;
          if (data[0] && data[0][0] && data[0][0].label) {
            return data;
          }
          var row1 = {};
          data.forEach(function (item, index) {
            var data1 = item[0];
            if (!row1[data1]) {
              row1[data1] = { index: index, data: { label: data1, rowspan: 1 } };
            } else {
              row1[data1].data.rowspan++;
              item[0] = { label: data1, rowspan: 0 };
            }
          });
          for (var key in row1) {
            data[row1[key].index][0] = row1[key].data;
          }
        }
        return data;
      }
    },
    preData: {
      get: function get() {
        return this.$store.getters.preData;
      }
    },
    preStatus: {
      get: function get() {
        return this.$store.getters.preStatus;
      }
    },
    preDayData: {
      get: function get() {
        var vm = this;
        var newData = [];
        var data = this.$store.getters.preDayData;
        this.day = data.length > 0 ? data[0][0] : '';
        data.forEach(function (item) {
          if (item[0] === vm.day) {
            newData.push(item);
          }
        });
        return newData;
      }
    },
    oilStation: {
      get: function get() {
        return this.$store.getters.oilStation;
      },
      set: function set(value) {
        return this.$store.dispatch('setOilStation', value);
      }
    },
    oilStations: {
      get: function get() {
        return this.$store.getters.oilStations;
      }
    }
  },
  created: function created() {
    if (!this.$store.getters.preData || this.$store.getters.preData.length === 0) {
      this.$store.dispatch('loadPreData', 'prediction_to.json');
    }
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentTitle: __WEBPACK_IMPORTED_MODULE_0__components_bit_ContentTitle___default.a
  },
  created: function created() {
    if (this.solutionStatus === 10) {
      this.$store.dispatch('setSolutionStatus', 20);
    }
  },

  computed: {
    groupsNum: {
      get: function get() {
        return this.$store.getters.groupsNum;
      },
      set: function set(value) {
        return this.$store.dispatch('setGroupsNum', value);
      }
    },
    solutionStatus: {
      get: function get() {
        return this.$store.getters.solutionStatus;
      }
    },
    maxCustomersNum: {
      get: function get() {
        return this.$store.getters.maxCustomersNum;
      },
      set: function set(value) {
        return this.$store.dispatch('setMaxCustomersNum', value);
      }
    },
    groupTimeLimit: {
      get: function get() {
        return this.$store.getters.groupTimeLimit;
      },
      set: function set(value) {
        return this.$store.dispatch('setGroupTimeLimit', value);
      }
    },
    groupMipGap: {
      get: function get() {
        return this.$store.getters.groupMipGap * 100;
      },
      set: function set(value) {
        return this.$store.dispatch('setGroupMipGap', value / 100);
      }
    },
    routeTimeLimit: {
      get: function get() {
        return this.$store.getters.routeTimeLimit;
      },
      set: function set(value) {
        return this.$store.dispatch('setRouteTimeLimit', value);
      }
    },
    routeMipGap: {
      get: function get() {
        return this.$store.getters.routeMipGap;
      },
      set: function set(value) {
        return this.$store.dispatch('setRouteMipGap', value);
      }
    },
    solutionWay: {
      get: function get() {
        return this.$store.getters.solutionWay;
      },
      set: function set(value) {
        return this.$store.dispatch('setSolutionWay', value);
      }
    },
    solutionDay: {
      get: function get() {
        return this.$store.getters.solutionDay;
      },
      set: function set(value) {
        return this.$store.dispatch('setSolutionDay', value);
      }
    },
    solutionWeeks: {
      get: function get() {
        return this.$store.getters.solutionWeeks;
      }
    },
    solutionWays: {
      get: function get() {
        return this.$store.getters.solutionWays;
      }
    }
  },
  data: function data() {
    return {
      show_note: true,
      setting_note: '\n      \u672C\u89E3\u51B3\u65B9\u6848\u5206\u4E3A\u4E24\u6B65\u6C42\u89E3\uFF0C\u7B2C\u4E00\u6B65\u6C42\u89E3\u8F66\u8F86\u8C03\u5EA6\u6A21\u578B\uFF0C\u8BE5\u6A21\u578B\u628A\u6240\u6709\u8BA2\u5355\u5206\u7FA4\u7EC4\uFF0C\u4E00\u8F86\u8F66\u670D\u52A1\u4E00\u4E2A\u7FA4\u7EC4\u91CC\u7684\u6240\u6709\u5BA2\u6237\u3002<br>\u7B2C\u4E8C\u6B65\u6C42\u89E3\u8DEF\u5F84\u89C4\u5212\u6A21\u578B\uFF0C\u8BE5\u6A21\u578B\u4E3A\u6BCF\u4E2A\u8F66\u8F86\u5206\u522B\u89C4\u5212\u914D\u9001\u8DEF\u7EBF\u3002\n      ',
      notes: ['车辆数 ———— 所能调配的车辆总数', '每个车辆配送最大客户数 ———— 每辆车所能配送的最大客户数', '车辆调度模型的TimeLimit ———— 允许车辆调度模型求解的最大时间(单位：秒)', '车辆调度模型的MIPGap ———— 当目标函数的最小值和最大值的差值的绝对值小于最大值的MIPGap倍时，求解器会终止并返回一个最优解。空格中填写的默认为小数，比如填写0.01则该模型的MIPGap为1%。', '路径规划模型的TimeLimit ———— 允许车辆调度模型求解的最大时间(单位：秒)', '路径规划模型的MIPGap ———— 当目标函数的最小值和最大值的差值的绝对值小于最大值的MIPGap倍时，求解器会终止并返回一个最优解。空格中填写的默认为小数，比如填写0.01则该模型的MIPGap为1%']
    };
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_WeekData__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bit_WeekData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_bit_WeekData__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MiiTable: __WEBPACK_IMPORTED_MODULE_0__components_bit_MiiTable___default.a,
    WeekData: __WEBPACK_IMPORTED_MODULE_1__components_bit_WeekData___default.a
  },
  computed: {
    canEdit: {
      get: function get() {
        return this.$store.getters.solutionStatus < 21;
      }
    },
    sourceDataType: {
      get: function get() {
        return this.$store.getters.sourceDataType;
      }
    },
    orderWeight: {
      get: function get() {
        return this.$store.getters.orderWeight;
      }
    },
    orderVolume: {
      get: function get() {
        return this.$store.getters.orderVolume;
      }
    },
    orderDays: {
      get: function get() {
        return this.$store.getters.orderDays;
      }
    },
    ths: {
      get: function get() {
        var ths = [{
          key: 'shop'
        }, {
          key: 'dry'
        }, {
          key: 'Fresh'
        }, {
          key: 'frozen'
        }];
        var labels = this.$store.getters.sourceDataField[this.$store.getters.sourceDataType];
        ths.forEach(function (item) {
          item.label = labels[item.key];
        });
        return ths;
      }
    }
  }
});

/***/ }),
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTk5MEIwQzM2MkRDMTFFNzlFMDQ5OENGMzFGQjc4QzIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTk5MEIwQzQ2MkRDMTFFNzlFMDQ5OENGMzFGQjc4QzIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxOTkwQjBDMTYyREMxMUU3OUUwNDk4Q0YzMUZCNzhDMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxOTkwQjBDMjYyREMxMUU3OUUwNDk4Q0YzMUZCNzhDMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pi+tqxAAAAEISURBVHjaYuQQM2YgE5gAcSgTmZpDgfgIEIuykKE5AoiXADEzEL8DGfCfgXzAAnOBAhB/IqBYEIiPArEEkpgGzIAPQPyRgAHT0DT/AeIbuALRA4g5kfjuUL8jA1sgLkA3QBKIVwHxdiDOhPkTiPuR1DyD0idABLIBIA3XoVEEAmVQV8QAsSZU7DUQByPbiGzAfiA+jMQXB+JsIK6G8v8CcRTUEqwG3ABiPyDOhQYQCLQCsQqUXQ7Ee9ADCz0MQGliChAHAfEPIGaDiq8B4j5soY0rFjYDsS8Q/wLi50CcjivB4UvKIOcmA/E/UJLFmRQJJJ4lBNMylBbA4x10wIfNgAfk5iaAAAMANxkreMzjed8AAAAASUVORK5CYII="

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/c2-1.eddd241.png";

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/c4-1.3fd626b.png";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/c4-2.afa61bf.png";

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/c4-3.2a69f66.png";

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/c4-4.a21cb5c.png";

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qr.b854008.png";

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/powerlogo.0b217de.png";

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTk5MEIwQzc2MkRDMTFFNzlFMDQ5OENGMzFGQjc4QzIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTk5MEIwQzg2MkRDMTFFNzlFMDQ5OENGMzFGQjc4QzIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxOTkwQjBDNTYyREMxMUU3OUUwNDk4Q0YzMUZCNzhDMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxOTkwQjBDNjYyREMxMUU3OUUwNDk4Q0YzMUZCNzhDMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PsCZTRUAAAA/SURBVHjaYuQQM/7PQAZggdIKQPyJSD18QPwApvEDEH8kUuM/EMHEQCYY1Tg8NMJSjgAJhvAha3xAqo0AAQYAc8AHU4i8/9EAAAAASUVORK5CYII="

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(851)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(1006),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cc248b1a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(857)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(1012),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f34b0b4a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(821)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(985),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-533fb2ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(781)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(956),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-15be74ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(768)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(944),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01d142e7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(848)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(1004),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-abf42814",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(774)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(949),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0660e3d3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(853)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(1008),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e42bbc12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(783)
  __webpack_require__(784)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(958),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1cfe6698",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(831)
  __webpack_require__(832)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(992),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6787a70e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(822)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(986),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55dc8a7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(770)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(946),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0214a586",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(793)
  __webpack_require__(794)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(967),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b75de4c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(788)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(962),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20f65c7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(854)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(1009),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e5322348",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(779)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(954),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f47382e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(836)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(996),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d0a615e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(791)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(965),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28b827c9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(803)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(973),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-369ae45c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(855)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(1010),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e8b29592",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(837)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(997),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72df3ac4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(835)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(995),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6bd32347",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(792)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(966),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b42e97f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(860)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(1014),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fa6b7730",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(816)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(981),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c71e77f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(799)
  __webpack_require__(800)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(971),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34d92656",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(823)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(987),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-586cece8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(813)
  __webpack_require__(812)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(979),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-48b5c49a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(834)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(994),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-69a7bbad",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(787)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(961),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1fb00fdf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(806)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(975),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d4ec032",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(818)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(983),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50d3a894",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(786)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(960),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1da4d647",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(849)
  __webpack_require__(850)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(1005),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c8e2586c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(777)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(952),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c8eab20",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(947),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0533d079",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(842)
  __webpack_require__(841)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(1000),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-763e4d46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(805)
  __webpack_require__(804)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(974),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3bda62db",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(796)
  __webpack_require__(795)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(968),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ffa2e4f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(839)
  __webpack_require__(838)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(998),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-755464bb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(840)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(999),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-759a5b26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(798)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(970),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-32b8ebff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(769)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(945),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02143f62",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(797)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(969),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-315cb0ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(990),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60a880db",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(845)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(1002),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8d08e606",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(807)
  __webpack_require__(808)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(976),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e3a9934",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(776)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(951),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c69a064",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(819)
  __webpack_require__(820)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(984),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51313010",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(772)
  __webpack_require__(773)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(948),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05f97bf7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(852)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1007),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e0bb809e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(782)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(957),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-194302ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(833)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(993),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68eb1ad5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(859)
  __webpack_require__(858)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(1013),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f71f24f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(846)
  __webpack_require__(847)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1003),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a3302ac4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(780)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(955),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-12ada7e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-head"
  }, [_c('a', {
    staticClass: "head-logo",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticClass: "logo-100",
    attrs: {
      "src": __webpack_require__(123),
      "alt": ""
    },
    on: {
      "click": _vm.gohome
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "head-user"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('span', {
    staticClass: "head-btn-a",
    on: {
      "click": _vm.goOther
    }
  }, [_vm._v(_vm._s(_vm.path.indexOf('adjust_home') ? '配单' : '流程'))])])]), _vm._v(" "), _c('div', {
    staticClass: "head-user"
  }, [_c('div', {
    staticClass: "user-info qh-btn"
  }, [_c('span', {
    staticClass: "head-btn-a"
  }, [_vm._v(_vm._s(_vm.getLabel(_vm.oilArea)))]), _vm._v(" "), _c('div', {
    staticClass: "choose-ps"
  }, _vm._l((_vm.pszxDatas), function(item) {
    return _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.oilArea = item.key
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))])]), _vm._v(" "), _c('user-info'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.path) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('page-head', {
    staticClass: "page-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [(_vm.path.indexOf('oil_chart') === -1 && _vm.path.indexOf('gas_map') === -1) ? _c('left-bar-single') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('loading')], 1)
},staticRenderFns: []}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cycle-page"
  }, [_c('page-head', {
    staticClass: "page-top",
    attrs: {
      "noLogin": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left-data-content"
  }, [(!_vm.routerOk) ? _c('a', {
    staticClass: "qj-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.routerOk = true;
        _vm.loadRouter()
      }
    }
  }, [_vm._v("\n      路径求解\n    ")]) : _c('div', {
    staticClass: "content-div"
  }, _vm._l((_vm.tableData), function(item) {
    return _c('div', {
      staticClass: "text-one"
    }, [_vm._v(_vm._s(item))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "content-map"
  }, [_c('demo-map')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.opdLoading),
      expression: "opdLoading"
    }]
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1.5rem"
    }
  }, [_c('content-title', {
    attrs: {
      "title": "当日进销存"
    }
  }), _vm._v(" "), _c('mii-base-table', {
    staticStyle: {
      "margin-bottom": "0.3rem"
    },
    attrs: {
      "datas": _vm.jxcDatas,
      "table_style": 1,
      "ths": _vm.jxcThs
    }
  })], 1), _vm._v(" "), _vm._l((_vm.opdOilDetail.orderList), function(item, key) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "1.5rem"
      }
    }, [_c('content-title', {
      attrs: {
        "title": key + ': ' + item['total']
      }
    }), _vm._v(" "), _c('mii-base-table', {
      staticStyle: {
        "margin-bottom": "0.3rem"
      },
      attrs: {
        "datas": item['psList'],
        "table_style": 1,
        "ths": _vm.psThs
      }
    }), _vm._v(" "), (item['orders'] && item['orders'].length > 0) ? _c('mii-base-table', {
      staticStyle: {
        "margin-bottom": "1.5rem"
      },
      attrs: {
        "datas": item['orders'],
        "table_style": 2,
        "ths": _vm.orThs,
        "lineQF": true
      }
    }) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "one-content"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.centroids,
      "table_style": 2,
      "ths": _vm.thsCentroids,
      "title": "车辆配送信息"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gu-duan"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择车辆类型"
    },
    model: {
      value: (_vm.show_order_car),
      callback: function($$v) {
        _vm.show_order_car = $$v
      },
      expression: "show_order_car"
    }
  }, _vm._l((_vm.cars), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "two-content"
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.carOrders,
      "table_style": 1,
      "ths": _vm.ths,
      "title": _vm.sourceDataType === 'shop' ? '订单重量' : '订单量'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-2"
  }, [_c('content-title', {
    attrs: {
      "title": "柱状图展示"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "car-echart"
  }, [_c('echarts', {
    style: (_vm.echarts_option.outOption.style),
    attrs: {
      "chart_id": "car-echart",
      "option": _vm.echarts_option.option
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.echarts_option) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-head"
  }, [_c('a', {
    staticClass: "head-logo",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticClass: "logo-100",
    attrs: {
      "src": __webpack_require__(123),
      "alt": ""
    },
    on: {
      "click": _vm.gohome
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "head-menus-div"
  }, [_c('div', {
    staticClass: "head-menus"
  }, [
    [(_vm.solutionStatus > 10 || _vm.solutionStatus === 10) ? _c('a', {
      staticClass: "menu-1",
      class: {
        'menu-1-active': _vm.show_menu === 'left'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.clickLeftMenu('left')
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-dingdan"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "menu-2"
    }, [_c('transition-group', {
      attrs: {
        "name": "list",
        "tag": "div"
      }
    }, _vm._l((_vm.left_menus), function(menu, index) {
      return (_vm.solutionStatus > menu.minStatus || _vm.solutionStatus === menu.minStatus) ? _c('a', {
        key: "index",
        staticClass: "menu-one",
        class: {
          'active-menu-one': _vm.active_menu === menu.route_name
        },
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            _vm.chooseMenu(menu)
          }
        }
      }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
    }))], 1), _vm._v(" "), (_vm.solutionStatus > 30 || _vm.solutionStatus === 30) ? _c('div', {
      staticClass: "fg-line"
    }) : _vm._e(), _vm._v(" "), (_vm.solutionStatus > 30 || _vm.solutionStatus === 30) ? _c('a', {
      staticClass: "menu-1",
      class: {
        'menu-1-active': _vm.show_menu === 'right'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.clickLeftMenu('right')
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-shuju"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "menu-2"
    }, [_c('transition-group', {
      attrs: {
        "name": "list",
        "tag": "div"
      }
    }, _vm._l((_vm.right_menus), function(menu, index) {
      return (_vm.solutionStatus > menu.minStatus || _vm.solutionStatus === menu.minStatus) ? _c('a', {
        key: "index + '-right'",
        staticClass: "menu-one",
        class: {
          'active-menu-one': _vm.active_menu === menu.route_name
        },
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            _vm.chooseMenu(menu)
          }
        }
      }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
    }))], 1)]
  ], 2)]), _vm._v(" "), _c('div', {
    staticClass: "head-user"
  }, [(_vm.login) ? _c('div', {
    staticClass: "user-info"
  }, [_c('i', {
    staticClass: "iconfont icon-user"
  }), _vm._v(" "), _c('div', {
    staticClass: "fg-line-2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.loginOut
    }
  }, [_vm._v("安全退出")])]) : _c('div', {
    staticClass: "user-info"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("登录")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.path) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-title"
  }, [_c('div', [_c('span', {
    staticClass: "title-kh-1"
  }, [_vm._v("》")]), _c('span', {
    staticClass: "title-kh-2"
  }, [_vm._v("》")]), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.rightText) ? _c('div', {
    staticClass: "right-text"
  }, [_vm._v("\n    " + _vm._s(_vm.rightText) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.searchInput) ? _c('div', {
    staticClass: "right-text"
  }, [_c('el-input', {
    staticStyle: {
      "width": "10rem"
    },
    attrs: {
      "size": "mini",
      "placeholder": "",
      "icon": "search"
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.actions) ? _c('div', {
    staticClass: "title-menus"
  }, _vm._l((_vm.actions), function(action) {
    return _c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: action.icon,
      on: {
        "click": function($event) {
          _vm.clickMenu(action.key)
        }
      }
    })])
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page"
  }, [_c('div', {
    staticClass: "two-content"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.orderWeight,
      "table_style": 2,
      "ths": _vm.ths,
      "title": _vm.sourceDataType === 'shop' ? '订单重量' : '订单量',
      "canEdit": _vm.canEdit,
      "row_num": 10,
      "show_pagination": true
    },
    on: {
      "update:canEdit": function($event) {
        _vm.canEdit = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gu-duan"
  }), _vm._v(" "), _c('mii-table', {
    attrs: {
      "datas": _vm.orderVolume,
      "table_style": 1,
      "ths": _vm.ths,
      "title": _vm.sourceDataType === 'shop' ? '订单体积' : '有效容积',
      "canEdit": _vm.canEdit,
      "row_num": 10,
      "show_pagination": true
    },
    on: {
      "update:canEdit": function($event) {
        _vm.canEdit = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gu-duan-width"
  }), _vm._v(" "), _c('div', {
    staticClass: "one-content"
  }, [_c('week-data', {
    attrs: {
      "datas": _vm.orderDays,
      "title": "订货时间"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('content-title', {
    attrs: {
      "title": "油库管理",
      "actions": _vm.tableAction
    },
    on: {
      "clickMenu": _vm.clickTitleMenu
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "output-content"
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.oilDepotList,
      "table_actions": _vm.table_actions,
      "table_style": 2,
      "ths": _vm.ths
    },
    on: {
      "clickTdBtn": _vm.clickTdBtn
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增油库",
      "visible": _vm.showAdd
    },
    on: {
      "update:visible": function($event) {
        _vm.showAdd = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("油库代码")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": !_vm.isNew,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.newDepot['油库代码']),
      callback: function($$v) {
        _vm.$set(_vm.newDepot, '油库代码', $$v)
      },
      expression: "newDepot['油库代码']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("油库名称")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.newDepot['油库名称']),
      callback: function($$v) {
        _vm.$set(_vm.newDepot, '油库名称', $$v)
      },
      expression: "newDepot['油库名称']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showAdd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDepot
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.showDel,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDel = $event
      }
    }
  }, [_c('span', [_vm._v("你确定删除该油库吗？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDel = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delDepot
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-user"
  }, [(_vm.logined) ? _c('div', {
    staticClass: "user-info"
  }, [_c('i', {
    staticClass: "iconfont icon-user"
  }), _vm._v(" "), _c('a', {
    staticClass: "user-name",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v(_vm._s(_vm.userInfo.USER_NAME))]), _vm._v(" "), _c('div', {
    staticClass: "user-menu"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showChangePwd = true
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("注销登录")])])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增运送订单",
      "visible": _vm.showChangePwd,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.showChangePwd = $event
      }
    }
  }, [_c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "",
      "value": "",
      "placeholder": "新密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repassword),
      expression: "repassword"
    }],
    attrs: {
      "type": "password",
      "name": "",
      "value": "",
      "placeholder": "重复新密码"
    },
    domProps: {
      "value": (_vm.repassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showChangePwd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveUserPwd
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v",
    attrs: {
      "id": "result-page"
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "choose-show-cases dialog-choose-show-cases"
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "large",
      "fill": "#324057",
      "text-color": "#a4aebd",
      "min": 1,
      "max": 3
    },
    model: {
      value: (_vm.compareCasesName),
      callback: function($$v) {
        _vm.compareCasesName = $$v
      },
      expression: "compareCasesName"
    }
  }, _vm._l((_vm.casesEle), function(caseOne) {
    return _c('el-checkbox-button', {
      key: caseOne.name,
      attrs: {
        "label": caseOne.name,
        "disabled": caseOne.status !== 30
      }
    }, [_vm._v(_vm._s(caseOne.name))])
  }))], 1), _vm._v(" "), _c('case-compare-table', {
    attrs: {
      "caseDatas": _vm.compareCases,
      "table_height": 22
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page"
  }, [_c('div', {
    staticClass: "two-content"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.orderWeight,
      "table_style": 2,
      "ths": _vm.ths,
      "title": _vm.sourceDataType === 'shop' ? '订单重量' : '订单量',
      "canEdit": _vm.canEdit,
      "row_num": 10,
      "show_pagination": true
    },
    on: {
      "update:canEdit": function($event) {
        _vm.canEdit = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gu-duan"
  }), _vm._v(" "), _c('mii-table', {
    attrs: {
      "datas": _vm.orderVolume,
      "table_style": 1,
      "ths": _vm.ths,
      "title": _vm.sourceDataType === 'shop' ? '订单体积' : '有效容积',
      "canEdit": _vm.canEdit,
      "row_num": 10,
      "show_pagination": true
    },
    on: {
      "update:canEdit": function($event) {
        _vm.canEdit = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gu-duan-width"
  }), _vm._v(" "), _c('div', {
    staticClass: "one-content"
  }, [_c('week-data', {
    attrs: {
      "datas": _vm.orderDays,
      "title": "订货时间"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-bar",
    class: {
      'big-bar': _vm.big_size, 'sm-bar': !_vm.big_size
    }
  }, [_vm._l((_vm.menus), function(menu, index) {
    return _c('a', {
      staticClass: "one-bar",
      class: {
        'active-bar': _vm.active_index === index, 'hide-bar': !menu.active
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.clickMenuF(menu.key, index, menu.active)
        }
      }
    }, [_c('div', {
      staticClass: "bar-icon",
      class: {
        'sm-iconfont': !_vm.big_size
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: menu.icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "bar-leabel",
      class: {
        'big-bar-leabel': _vm.big_size, 'sm-bar-leabel': !_vm.big_size
      }
    }, [_vm._v("\n      " + _vm._s(menu.leabel) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "right-menu"
    }, _vm._l((menu.children), function(data) {
      return _c('a', {
        staticClass: "children-menu",
        class: {
          'hide-bar': !data.active
        },
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.clickMenu(data.key, data.active, index)
          }
        }
      }, [_vm._v(_vm._s(data.leabel))])
    }))])
  }), _vm._v(" "), _c('a', {
    staticClass: "one-bar",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goOther
    }
  }, [_c('div', {
    staticClass: "bar-icon",
    class: {
      'sm-iconfont': !_vm.big_size
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shishijiankong"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bar-leabel",
    class: {
      'big-bar-leabel': _vm.big_size, 'sm-bar-leabel': !_vm.big_size
    }
  }, [_vm._v("\n      实时监控\n    ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.path) + _vm._s(_vm.solutionStatus))])], 2)
},staticRenderFns: []}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('page_head', {
    staticClass: "page-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('left_bar_to'), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "content-map",
    class: {
      'hide-map': _vm.path !== '/tobacco'
    }
  }, [_c('chart_map')], 1), _vm._v(" "), _c('switch_map_btn', {
    attrs: {
      "mapPathName": "tobacco"
    }
  })], 1)], 1), _vm._v(" "), _c('loading')], 1)
},staticRenderFns: []}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "gu-duan"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择车辆类型"
    },
    model: {
      value: (_vm.car_first),
      callback: function($$v) {
        _vm.car_first = $$v
      },
      expression: "car_first"
    }
  }, _vm._l((_vm.cars), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "two-content"
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.oneCarRoutes,
      "table_style": 3,
      "one_row": true,
      "ths": _vm.ths2,
      "title": "车辆配送线路"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "content-column-1"
  }, [_c('content-title', {
    attrs: {
      "title": "结果报告"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "result-content"
  }, [_c('div', {
    staticClass: "result-one"
  }, [_c('span', [_vm._v("总成本")]), _c('div', [_vm._v(_vm._s(_vm.solutionData['总成本']) + " 元")])]), _vm._v(" "), _c('div', {
    staticClass: "result-one"
  }, [_c('span', [_vm._v("车辆数量")]), _c('div', [_vm._v(_vm._s(_vm.solutionData['车辆数量']) + " 辆")])]), _vm._v(" "), _c('div', {
    staticClass: "result-one"
  }, [_c('span', [_vm._v("订单数量")]), _c('div', [_vm._v(_vm._s(_vm.solutionData['订单数量']) + " 单")])]), _vm._v(" "), _c('div', {
    staticClass: "result-one"
  }, [_c('span', [_vm._v("配送订单数量")]), _c('div', [_vm._v(_vm._s(_vm.solutionData['配送订单数量']) + " 单")])]), _vm._v(" "), _c('div', {
    staticClass: "result-one"
  }, [_c('span', [_vm._v("未配送订单数量")]), _c('div', [_vm._v(_vm._s(_vm.solutionData['未配送订单数量']) + " 单")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-column-1"
  }, [_c('content-title', {
    attrs: {
      "title": "车辆容量利用"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "car-content"
  }, [_c('div', {
    staticClass: "car-content-1"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择车辆类型"
    },
    model: {
      value: (_vm.car2),
      callback: function($$v) {
        _vm.car2 = $$v
      },
      expression: "car2"
    }
  }, _vm._l((_vm.cars), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "car-content-1"
  }, [_c('echarts', {
    style: (_vm.echartsOption.outOption.style),
    attrs: {
      "chart_id": "car-echart",
      "option": _vm.echartsOption.option
    }
  })], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.carRoutes.length) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echarts-block"
  }, [_c('div', {
    staticClass: "echarts-contant",
    attrs: {
      "id": _vm.chart_id
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "content-one"
  }, [_c('content-title', {
    attrs: {
      "title": '历史数据状态',
      "actions": _vm.titleAction
    },
    on: {
      "clickMenu": _vm.clickTitleMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('div', {
    staticClass: "output-content-2"
  }, _vm._l((_vm.hisData), function(item) {
    return _c('a', {
      staticClass: "data-one",
      class: {
        'data-one-ok': item['status'] === 'ok', 'data-one-warning': item['status'] !== 'ok'
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseOne(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item['日期']))]), _vm._v(" "), _c('span', [_vm._v("进销存: " + _vm._s(item['jxc']))]), _vm._v(" "), _c('span', [_vm._v("配送计划: " + _vm._s(item['psjh']))]), _vm._v(" "), _c('span', [_vm._v("核销: " + _vm._s(item['hx']))])])
  }))])], 1), _vm._v(" "), (_vm.chooseHis) ? _c('el-dialog', {
    attrs: {
      "title": _vm.chooseHis['日期'],
      "visible": _vm.showDetail,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDetail = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "content-one-w"
  }, [_c('span', [_vm._v("进销存: " + _vm._s(_vm.chooseHis['jxc']))]), _vm._v(" "), (_vm.chooseHis['jxc'] === 0) ? _c('input', {
    attrs: {
      "type": "file",
      "id": _vm.fileIdJxc
    },
    on: {
      "change": _vm.fileChangeJxc
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-one-w"
  }, [_c('span', [_vm._v("配送计划: " + _vm._s(_vm.chooseHis['psjh']))]), _vm._v(" "), (_vm.chooseHis['psjh'] === 0) ? _c('input', {
    attrs: {
      "type": "file",
      "id": _vm.fileIdPsjh
    },
    on: {
      "change": _vm.fileChangePsjh
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-one-w"
  }, [_c('span', [_vm._v("核销: " + _vm._s(_vm.chooseHis['hx']))]), _vm._v(" "), (_vm.chooseHis['jxc'] !== 0) ? _c('a', {
    staticClass: "this-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.hxJxc
    }
  }, [_vm._v("核销")]) : _vm._e()])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1rem",
      "display": "flex"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.driver_name),
      callback: function($$v) {
        _vm.driver_name = $$v
      },
      expression: "driver_name"
    }
  })], 1), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": "驾驶员管理"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "output-content"
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.showDriverList,
      "table_actions": _vm.table_actions,
      "table_style": 2,
      "ths": _vm.ths
    },
    on: {
      "clickTdBtn": _vm.clickTdBtn
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('content-title', {
    attrs: {
      "title": "资料下载"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("文档下载")]), _vm._v(" "), _c('a', {
    staticClass: "checkbox-one",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.down3 = _vm.down2;
        _vm.down2 = !_vm.down2;
      }
    }
  }, [(_vm.down2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(21),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.down2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox-label"
  }, [_vm._v("\n            简洁版VPR介绍资料\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "checkbox-one",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.down2 = _vm.down3;
        _vm.down3 = !_vm.down3
      }
    }
  }, [(_vm.down3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(21),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.down3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox-label"
  }, [_vm._v("\n            详细版VPR介绍资料\n          ")])]), _vm._v(" "), (_vm.login === 1) ? _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": _vm.down2 ? '/static/问题介绍简洁版.pdf' : '/static/问题介绍详细版.pdf',
      "download": _vm.down2 ? '问题介绍简洁版.pdf' : '问题介绍详细版.pdf'
    }
  }, [_vm._v("下载文档")]) : _c('a', {
    staticClass: "output-btn btm-btn",
    on: {
      "click": _vm.goLgin
    }
  }, [_vm._v("下载文档")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v ajust-order"
  }, [_c('div', {
    staticClass: "href-content t-content"
  }, [_c('div', {
    staticClass: "left-content search-form"
  }, [_c('content-title', {
    attrs: {
      "title": _vm.todayStr,
      "actions": _vm.actions_search
    },
    on: {
      "clickMenu": _vm.clickMenuS
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "油品"
    },
    model: {
      value: (_vm.oilType),
      callback: function($$v) {
        _vm.oilType = $$v
      },
      expression: "oilType"
    }
  }, _vm._l((['汽油', '柴油']), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "油库"
    },
    model: {
      value: (_vm.team),
      callback: function($$v) {
        _vm.team = $$v
      },
      expression: "team"
    }
  }, _vm._l((_vm.carTeams), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })), _vm._v(" "), _c('a', {
    staticClass: "adjust-btn",
    staticStyle: {
      "background-color": "#0b5591",
      "color": "#fff"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.addYaohuoToplan
    }
  }, [_vm._v("要货定单加入计划中")]), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "margin": "0 1rem",
      "display": "flex !important"
    },
    model: {
      value: (_vm.boardings),
      callback: function($$v) {
        _vm.boardings = $$v
      },
      expression: "boardings"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "no_delivery"
    }
  }, [_vm._v("未上车")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "delivery"
    }
  }, [_vm._v("已上车")])], 1), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#666",
      "margin-right": "0.5rem",
      "line-height": "2rem"
    }
  }, [_vm._v("要货")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": '显示要货',
      "inactive-text": '不显示要货'
    },
    model: {
      value: (_vm.yaoHuoBJ),
      callback: function($$v) {
        _vm.yaoHuoBJ = $$v
      },
      expression: "yaoHuoBJ"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#666",
      "margin-right": "0.5rem",
      "line-height": "2rem"
    }
  }, [_vm._v("全部车辆")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": '全部车辆',
      "inactive-text": '车队筛选'
    },
    model: {
      value: (_vm.allCar),
      callback: function($$v) {
        _vm.allCar = $$v
      },
      expression: "allCar"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right-content-1",
    staticStyle: {
      "margin-right": "0.7rem"
    }
  }, [_c('content-title', {
    attrs: {
      "title": '计划：' + _vm.chooseOrderCg.length,
      "actions": _vm.actions3
    },
    on: {
      "clickMenu": _vm.clickMenu
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "flex": "1"
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.chooseOrderCg,
      "table_style": 1,
      "ths": _vm.jhOrderListThs,
      "table_actions": _vm.tableActionOrder3,
      "lineQF": true
    },
    on: {
      "click_row": _vm.clickOrderRow,
      "clickTdBtn": _vm.clickOrderTdBtnSD
    }
  }), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": '锁定：' + _vm.chooseOrders.length,
      "actions": _vm.actions
    },
    on: {
      "clickMenu": _vm.clickMenu
    }
  }), _vm._v(" "), _c('mii-base-table', {
    attrs: {
      "datas": _vm.chooseOrders,
      "table_style": 1,
      "ths": _vm.jhOrderListThs,
      "table_actions": _vm.tableActionOrder2,
      "lineQF": true
    },
    on: {
      "click_row": _vm.clickOrderRow,
      "clickTdBtn": _vm.clickOrderTdBtn
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.orderLoading),
      expression: "orderLoading"
    }],
    staticClass: "right-content-1-2"
  }, [_c('content-title', {
    attrs: {
      "title": '订单：' + _vm.showOrderList.length,
      "actions": _vm.actions2,
      "searchInput": true,
      "clearNum": _vm.clearNum
    },
    on: {
      "clickMenu": _vm.clickMenu,
      "searchInputChange": _vm.searchInputChange1
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "flex": "1"
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.showOrderList,
      "table_style": 2,
      "ths": _vm.allOrderListThs,
      "table_actions": _vm.tableActionOrder,
      "lineQF": true,
      "show_dian": true,
      "lineSuo": 'SFID',
      "chooseRowValue": _vm.chooseOrderValue,
      "chooseAction": {
        action: 'clickTdBtn',
        key: 'oil_detail'
      }
    },
    on: {
      "click_row": _vm.chooseThisOrder,
      "clickTdBtn": _vm.clickOrderTdBtn,
      "click_row_data": _vm.clickRowData
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "href-content",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.carLoading),
      expression: "carLoading"
    }],
    staticClass: "left-content"
  }, [_c('content-title', {
    attrs: {
      "title": '车辆：' + _vm.carList.length,
      "searchInput": true,
      "clearNum": _vm.clearNum + _vm.clearNumZd
    },
    on: {
      "searchInputChange": _vm.searchInputChange2
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "flex": "1"
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.showCarList,
      "table_style": 2,
      "ths": _vm.carListThs,
      "table_actions": _vm.tableActionCar,
      "lineSuo": '车牌号',
      "chooseRowValue": _vm.chooseCarValue,
      "chooseAction": {
        action: 'click_row'
      }
    },
    on: {
      "click_row": _vm.clickCarRow,
      "clickTdBtn": _vm.clickOrderTdBtn
    }
  })], 1)], 1), _vm._v(" "), (_vm.showCarOrderType === 'car') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.carOrderLoading),
      expression: "carOrderLoading"
    }],
    staticClass: "right-content-2 static-content"
  }, [(_vm.chooseCar && !_vm.chooseCar.dc) ? _c('div', {
    staticClass: "static-content-div"
  }, [(_vm.chooseCar['前仓']) ? _c('div', {
    staticClass: "one-input select-order"
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "placeholder": '前仓：' + _vm.chooseCar['前仓']
    },
    model: {
      value: (_vm.chooseOrder1),
      callback: function($$v) {
        _vm.chooseOrder1 = $$v
      },
      expression: "chooseOrder1"
    }
  }, _vm._l((_vm.canChooseOrders), function(item, index) {
    return _c('el-option', {
      key: item.SFID + String(index),
      staticStyle: {
        "max-width": "30rem"
      },
      attrs: {
        "label": item.SFID + '：' + item.加油站名称 + ' --- ' + item.油品名称 + ' --- ' + item.断货时间 + ' --- ' + item.建议配送量 + ' ------------------------------------------------- ' + item.DXCHART,
        "value": item.SFID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.chooseCar['中仓']) ? _c('div', {
    staticClass: "one-input select-order"
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "placeholder": '中仓：' + _vm.chooseCar['中仓']
    },
    model: {
      value: (_vm.chooseOrder2),
      callback: function($$v) {
        _vm.chooseOrder2 = $$v
      },
      expression: "chooseOrder2"
    }
  }, _vm._l((_vm.canChooseOrders), function(item, index) {
    return _c('el-option', {
      key: item.SFID + String(index) + '_1',
      staticStyle: {
        "max-width": "30rem"
      },
      attrs: {
        "label": item.SFID + '：' + item.加油站名称 + ' --- ' + item.油品名称 + ' --- ' + item.断货时间 + ' --- ' + item.建议配送量 + ' ------------------------------------------------- ' + item.DXCHART,
        "value": item.SFID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.chooseCar['后仓']) ? _c('div', {
    staticClass: "one-input select-order"
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "placeholder": '后仓：' + _vm.chooseCar['后仓']
    },
    model: {
      value: (_vm.chooseOrder3),
      callback: function($$v) {
        _vm.chooseOrder3 = $$v
      },
      expression: "chooseOrder3"
    }
  }, _vm._l((_vm.canChooseOrders), function(item, index) {
    return _c('el-option', {
      key: item.SFID + String(index) + '_2',
      staticStyle: {
        "max-width": "30rem"
      },
      attrs: {
        "label": item.SFID + '：' + item.加油站名称 + ' --- ' + item.油品名称 + ' --- ' + item.断货时间 + ' --- ' + item.建议配送量 + ' ------------------------------------------------- ' + item.DXCHART,
        "value": item.SFID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "adjust-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.saveCarOrderDuo
    }
  }, [_vm._v("保存")])]) : _vm._e(), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": (_vm.chooseCar ? _vm.chooseCar['车牌号'] : '') + (_vm.chooseOrder ? ' >> ' + _vm.chooseOrder['油站名'] : ''),
      "actions": _vm.actions4
    },
    on: {
      "clickMenu": _vm.clickMenu
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "flex": "1"
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.showCarOrderList,
      "table_style": 1,
      "table_actions": _vm.tableAction,
      "ths": _vm.carOrderListThs,
      "realAction": true
    },
    on: {
      "clickTdBtn": _vm.clickTdBtn
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showCarOrderType === 'oil') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.carOrderLoading),
      expression: "carOrderLoading"
    }],
    staticClass: "right-content-2 static-content"
  }, [_c('content-title', {
    attrs: {
      "title": _vm.carOrderTitle,
      "actions": _vm.actions4
    },
    on: {
      "clickMenu": _vm.clickMenu
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "flex": "1"
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.showOilCarOrderList,
      "table_style": 1,
      "table_actions": _vm.tableActionOil,
      "ths": _vm.carOrderListThsOil,
      "realAction": true
    },
    on: {
      "click_row_data": _vm.clickRowDataCarOrder,
      "clickTdBtn": _vm.clickTdBtn
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showCarOrderType === 'jxc') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.carOrderLoading),
      expression: "carOrderLoading"
    }],
    staticClass: "right-content-2 static-content"
  }, [_c('content-title', {
    attrs: {
      "title": _vm.jxcTitle + ' >> 进销存'
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "flex": "1"
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.jxcDatas,
      "table_style": 1,
      "ths": _vm.jxcThs
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.chooseOrderChangeDepot['加油站名称'] + ' >>> 订单油库变更',
      "visible": _vm.showChooseDepot,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showChooseDepot = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('span', [_vm._v("选择油库")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.chooseOrderChangeDepot['油库代码']),
      callback: function($$v) {
        _vm.$set(_vm.chooseOrderChangeDepot, '油库代码', $$v)
      },
      expression: "chooseOrderChangeDepot['油库代码']"
    }
  }, _vm._l((_vm.depotList), function(item) {
    return _c('el-option', {
      key: item['油库代码'],
      attrs: {
        "label": item['油库名称'],
        "value": item['油库代码']
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showChooseDepot = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveChangeOrderDepot
    }
  }, [_vm._v("保存修改")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.chooseCarOrder ? (_vm.chooseCarOrder['加油站名称'] + ' >>> 配送单油库变更') : '',
      "visible": _vm.showChooseDepotPs,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showChooseDepotPs = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#666",
      "margin-right": "0.5rem",
      "line-height": "2rem"
    }
  }, [_vm._v("整车调整")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.allCarOrder),
      callback: function($$v) {
        _vm.allCarOrder = $$v
      },
      expression: "allCarOrder"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'only'
    }
  }, [_vm._v("该运单")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'tang'
    }
  }, [_vm._v("本趟次")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'dayCar'
    }
  }, [_vm._v("全车")])], 1)], 1), _vm._v(" "), (_vm.chooseCarOrder) ? _c('div', {
    staticClass: "case-form"
  }, [_c('span', [_vm._v("选择油库")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.psDepot),
      callback: function($$v) {
        _vm.psDepot = $$v
      },
      expression: "psDepot"
    }
  }, _vm._l((_vm.depotList), function(item) {
    return _c('el-option', {
      key: item['油库代码'],
      attrs: {
        "label": item['油库名称'],
        "value": item['油库代码']
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showChooseDepotPs = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveChangePsDepot
    }
  }, [_vm._v("保存修改")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.chooseCar ? _vm.chooseCar['车牌号'] : '',
      "visible": _vm.showCarDetail
    },
    on: {
      "update:visible": function($event) {
        _vm.showCarDetail = $event
      }
    }
  }, [(_vm.chooseCar) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [(_vm.chooseCar['前仓']) ? _c('div', {
    staticClass: "one-input",
    staticStyle: {
      "display": "flex",
      "margin-top": "1rem",
      "align-items": "center",
      "flex": "1"
    }
  }, [_c('span', [_vm._v(_vm._s('前仓-' + this.chooseCar['前仓']))])]) : _vm._e(), _vm._v(" "), (_vm.chooseCar['中仓']) ? _c('div', {
    staticClass: "one-input",
    staticStyle: {
      "display": "flex",
      "margin-top": "1rem",
      "align-items": "center",
      "flex": "1"
    }
  }, [_c('span', [_vm._v(_vm._s('中仓-' + this.chooseCar['中仓']))])]) : _vm._e(), _vm._v(" "), (_vm.chooseCar['后仓']) ? _c('div', {
    staticClass: "one-input",
    staticStyle: {
      "display": "flex",
      "margin-top": "1rem",
      "align-items": "center",
      "flex": "1"
    }
  }, [_c('span', [_vm._v(_vm._s('后仓-' + this.chooseCar['后仓']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.carDetail['xzData']), function(item, key) {
    return (item && key !== '车牌号') ? _c('div', {
      staticClass: "one-input",
      staticStyle: {
        "display": "flex",
        "margin-top": "1rem",
        "align-items": "center",
        "flex": "1"
      }
    }, [_c('span', [_vm._v(_vm._s(key + '-' + item))])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.carDetail['psData'].length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('content-title', {
    attrs: {
      "title": "近三天配送记录"
    }
  }), _vm._v(" "), _c('mii-base-table', {
    attrs: {
      "datas": _vm.carDetail['psData'],
      "table_style": 2,
      "ths": _vm.psjlThs,
      "lineQF": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showCarDetail = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.chooseOrderChangeDepot['加油站名称'] + ' >>> 订单拆分',
      "visible": _vm.showSplitOrder,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showSplitOrder = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('span', [_vm._v("拆单数")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "选择拆单数"
    },
    model: {
      value: (_vm.splitNum),
      callback: function($$v) {
        _vm.splitNum = $$v
      },
      expression: "splitNum"
    }
  }, _vm._l(([2, 3, 4, 5, 6, 7, 8, 9, 10]), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.splitOrderData), function(item, index) {
    return (item && !(Number(index) > _vm.splitNum)) ? _c('div', {
      staticClass: "one-input",
      staticStyle: {
        "display": "flex",
        "margin-top": "1rem",
        "align-items": "center",
        "width": "50%"
      }
    }, [_c('span', {
      staticStyle: {
        "width": "3rem"
      }
    }, [_vm._v(_vm._s('新单' + index))]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "7rem"
      },
      attrs: {
        "size": "small",
        "placeholder": "请输入"
      },
      model: {
        value: (_vm.splitOrderData[index]),
        callback: function($$v) {
          _vm.$set(_vm.splitOrderData, index, $$v)
        },
        expression: "splitOrderData[index]"
      }
    })], 1) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showSplitOrder = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveSplitOrder
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.chooseCarOrder && _vm.chooseCarOrder ? _vm.chooseCarOrder['车牌号'] + '  >>> ' + _vm.chooseCarOrder['加油站名称'] + ' >>> 趟次调整' : '',
      "visible": _vm.showTctz,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showTctz = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('span', [_vm._v("趟次调整")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "选择趟次"
    },
    model: {
      value: (_vm.tc),
      callback: function($$v) {
        _vm.tc = $$v
      },
      expression: "tc"
    }
  }, _vm._l((_vm.tcList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showTctz = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTctz
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "系统提示",
      "visible": _vm.showAddTs,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showAddTs = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('span', [_vm._v("配送单还未保存，是否确认切换")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTsAction('back')
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTsAction('change')
      }
    }
  }, [_vm._v("切换")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addTsAction('sc')
      }
    }
  }, [_vm._v("保存并切换")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "运单导出",
      "visible": _vm.showOutput
    },
    on: {
      "update:visible": function($event) {
        _vm.showOutput = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "margin": "0 1rem 1rem",
      "display": "flex !important"
    },
    model: {
      value: (_vm.outPutOilType),
      callback: function($$v) {
        _vm.outPutOilType = $$v
      },
      expression: "outPutOilType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "汽油"
    }
  }, [_vm._v("汽油")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "柴油"
    }
  }, [_vm._v("柴油")])], 1), _vm._v(" "), [_c('content-title', {
    attrs: {
      "title": '总单数:' + _vm.orderCar.length
    }
  }), _vm._v(" "), _c('mii-table-oil', {
    attrs: {
      "datas": _vm.orderTj,
      "columns": _vm.orderTjThs,
      "mergeRowKeyList": ['油库名称', '油品名称', 'DEPOT_TOTAL', 'DEPOT_TOTAL_L']
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showOutput = false
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.orderCar.length > 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.outputPsDatas
    }
  }, [_vm._v("导出")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "要货概览",
      "visible": _vm.showYaohuo
    },
    on: {
      "update:visible": function($event) {
        _vm.showYaohuo = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "margin": "0 1rem 1rem",
      "display": "flex !important"
    },
    model: {
      value: (_vm.yaoHuoOilType),
      callback: function($$v) {
        _vm.yaoHuoOilType = $$v
      },
      expression: "yaoHuoOilType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "汽油"
    }
  }, [_vm._v("汽油")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "柴油"
    }
  }, [_vm._v("柴油")])], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "7rem"
    },
    attrs: {
      "size": "mini",
      "placeholder": "最小要货差值"
    },
    model: {
      value: (_vm.yaoHuoMin),
      callback: function($$v) {
        _vm.yaoHuoMin = $$v
      },
      expression: "yaoHuoMin"
    }
  })], 1), _vm._v(" "), [_c('content-title', {
    attrs: {
      "title": '要货量',
      "searchInput": true,
      "clearNum": _vm.clearNum
    },
    on: {
      "searchInputChange": _vm.searchInputChange3
    }
  }), _vm._v(" "), _c('mii-table-oil', {
    attrs: {
      "datas": _vm.showYaoHuoCheckList,
      "columns": _vm.yaohuoThs,
      "mergeRowKeyList": ['加油站名称', '油品名称', '要货量', 'TOTAL_PS', '差值']
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showYaohuo = false
      }
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.oilDetailMap['加油站名称'],
      "visible": _vm.showOilDetail,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.showOilDetail = $event
      }
    }
  }, [_c('oil-ps-detail'), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showOilDetail = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.selectArea,
      "visible": _vm.showAreaJxc,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.showAreaJxc = $event
      }
    }
  }, [_c('area-jxc'), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showAreaJxc = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增运送订单",
      "visible": _vm.showAdd,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.showAdd = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form case-form-gas"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.chooseGIndex),
      callback: function($$v) {
        _vm.chooseGIndex = $$v
      },
      expression: "chooseGIndex"
    }
  }, _vm._l((_vm.gasDatas), function(item, index) {
    return _c('el-option', {
      key: item['代号'] + index,
      staticStyle: {
        "max-width": "27rem"
      },
      attrs: {
        "label": item['加油站名称'] + '-' + item['罐号'] + '罐' + '-' + item['油品名称'] + '--------------------------' + item['DXCHART'],
        "value": index
      }
    })
  }))], 1), _vm._v(" "), (_vm.chooseG && _vm.chooseG.油站代码) ? _c('div', {
    staticClass: "case-form case-form-gas"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("加油站")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.chooseG.加油站名称),
      callback: function($$v) {
        _vm.$set(_vm.chooseG, "加油站名称", $$v)
      },
      expression: "chooseG.加油站名称"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("罐号")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.chooseG.罐号),
      callback: function($$v) {
        _vm.$set(_vm.chooseG, "罐号", $$v)
      },
      expression: "chooseG.罐号"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("油品")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.chooseG.油品名称),
      callback: function($$v) {
        _vm.$set(_vm.chooseG, "油品名称", $$v)
      },
      expression: "chooseG.油品名称"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("期初库存")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.newOrder.期初库存),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, "期初库存", $$v)
      },
      expression: "newOrder.期初库存"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("入库升数")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.newOrder.入库升数),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, "入库升数", $$v)
      },
      expression: "newOrder.入库升数"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("出库升数")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.inputCKSS),
      callback: function($$v) {
        _vm.inputCKSS = $$v
      },
      expression: "inputCKSS"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("期末库存")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": ""
    },
    model: {
      value: (_vm.newOrder.期末库存),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, "期末库存", $$v)
      },
      expression: "newOrder.期末库存"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("空容")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": ""
    },
    model: {
      value: (_vm.newOrder.空容),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, "空容", $$v)
      },
      expression: "newOrder.空容"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("断货时间")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": ""
    },
    model: {
      value: (_vm.newOrder.断货时间),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, "断货时间", $$v)
      },
      expression: "newOrder.断货时间"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("订单紧急程度")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.newOrder['订单紧急程度']),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, '订单紧急程度', $$v)
      },
      expression: "newOrder['订单紧急程度']"
    }
  }, _vm._l((['可配送订单', '紧急订单', '库存充足订单']), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("小罐多销")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.newOrder['小罐多销']),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, '小罐多销', $$v)
      },
      expression: "newOrder['小罐多销']"
    }
  }, _vm._l(([{
    label: '是',
    key: 1
  }, {
    label: '不是',
    key: 0
  }]), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("配送油库")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.newOrder['油库代码']),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, '油库代码', $$v)
      },
      expression: "newOrder['油库代码']"
    }
  }, _vm._l((_vm.depotList), function(item) {
    return _c('el-option', {
      key: item['油库代码'],
      attrs: {
        "label": item['油库名称'],
        "value": item['油库代码']
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("建议配送量")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.inputPSL),
      callback: function($$v) {
        _vm.inputPSL = $$v
      },
      expression: "inputPSL"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("不容纳时间")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": ""
    },
    model: {
      value: (_vm.newOrder['不容纳时间']),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, '不容纳时间', $$v)
      },
      expression: "newOrder['不容纳时间']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("当日加单")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.newOrder['当日加单']),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, '当日加单', $$v)
      },
      expression: "newOrder['当日加单']"
    }
  }, _vm._l(([{
    label: '是',
    key: 1
  }, {
    label: '不是',
    key: 0
  }]), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showAdd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveGasOrder
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "page-loading"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "line-3"
  }, [_c('div', {
    staticClass: "progress-rate"
  }, [_c('div', {
    staticClass: "progress-ok",
    style: (_vm.loading_style)
  }, [(_vm.loadingPercentage > 20) ? _c('div', {
    staticClass: "progress-hide"
  }, [_vm._v("\n          " + _vm._s(_vm.loadingPercentage + '%') + "\n        ")]) : _vm._e()])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "jiao-tl"
  }), _vm._v(" "), _c('div', {
    staticClass: "jiao-rb"
  }), _vm._v(" "), _c('div', {
    staticClass: "jiao-zl"
  }), _vm._v(" "), _c('div', {
    staticClass: "jiao-zr"
  }), _vm._v(" "), _c('a', {
    staticClass: "close-loading",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.loading = false
      }
    }
  }, [_vm._v("\n  X\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "loading-title-block"
  }, [_c('span', {
    staticClass: "icon-1"
  }, [_vm._v("》")]), _c('span', {
    staticClass: "loading-title"
  }, [_vm._v("》" + _vm._s(_vm.loadingText))]), _c('span', {
    staticClass: "icon-2"
  }, [_vm._v("《")]), _c('span', {
    staticClass: "icon-1"
  }, [_vm._v("《 ")]), _vm._v("    \n  ")]), _vm._v(" "), _vm._m(3)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-1"
  }, [_c('div', {
    staticClass: "line-1-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-1-content"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-1-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-2"
  }, [_c('div', {
    staticClass: "line-2-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-2-content"
  }, [_c('div', {
    staticClass: "line-2-content-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-2-content-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-2-content-3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-4"
  }, [_c('div', {
    staticClass: "line-4-content"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-4-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-loading-block"
  }, [_c('span', {
    staticClass: "loading-text"
  }, [_vm._v("Loading...")])])
}]}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v",
    attrs: {
      "id": "result-page"
    }
  }, [_c('div', {
    staticClass: "choose-show-cases"
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "large",
      "fill": "#324057",
      "text-color": "#a4aebd",
      "min": 1
    },
    on: {
      "change": _vm.gooter
    },
    model: {
      value: (_vm.showCasesName),
      callback: function($$v) {
        _vm.showCasesName = $$v
      },
      expression: "showCasesName"
    }
  }, _vm._l((_vm.casesEle), function(caseOne) {
    return _c('el-checkbox-button', {
      key: caseOne.name,
      attrs: {
        "label": caseOne.name,
        "disabled": caseOne.status !== 30
      }
    }, [_vm._v(_vm._s(caseOne.name))])
  })), _vm._v(" "), _c('a', {
    staticClass: "case-db",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goCompare
    }
  }, [_vm._v("方案对比")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ele-result-list"
  }, _vm._l((_vm.showCases), function(showCase, index) {
    return _c('div', {
      staticClass: "ele-result-one"
    }, [_c('div', {
      staticClass: "data-title",
      attrs: {
        "id": index + '_case'
      }
    }, [_vm._v("\n        " + _vm._s(showCase.name) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "data-chat-2"
    }, [_c('div', {
      staticClass: "case-info"
    }, [_c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("天气")]), _c('span', [_vm._v(_vm._s(showCase.d1))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("光伏成本")]), _c('span', [_vm._v(_vm._s(showCase.d2))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("固定存储容量")]), _c('span', [_vm._v(_vm._s(showCase.d3))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("SOC下限")]), _c('span', [_vm._v(_vm._s(showCase.d4))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("SOC上限")]), _c('span', [_vm._v(_vm._s(showCase.d5))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("SOC初始值")]), _c('span', [_vm._v(_vm._s(showCase.d6))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("储能放电成本")]), _c('span', [_vm._v(_vm._s(showCase.d7))])])]), _vm._v(" "), _c('div', {
      staticClass: "case-info"
    }, [_vm._l((showCase.result.logfile), function(data, key) {
      return _c('div', {
        staticClass: "case-info-one"
      }, [_c('span', [_vm._v(_vm._s(key))]), _c('span', [_vm._v(_vm._s(data))])])
    }), _vm._v(" "), _c('div', {
      staticClass: "case-info-one show-detail"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.dialog_content = showCase.result.CompleteLogfile;
          _vm.dialogVisible = true
        }
      }
    }, [_vm._v("详 细")])])], 2), _vm._v(" "), _c('div', {
      staticClass: "map-page map-page-pre",
      attrs: {
        "id": 'chart-2-' + showCase.index
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "data-table"
    }, [_c('mii-table', {
      attrs: {
        "datas": showCase.result['调度方案'],
        "table_style": 2,
        "ths": _vm.ths,
        "title": "结果",
        "scroll_table": "true",
        "table_height": 16,
        "output_file": "true"
      }
    })], 1)])
  })), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详细",
      "visible": _vm.dialogVisible,
      "size": "",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, _vm._l((_vm.dialog_content), function(data) {
    return _c('p', [_vm._v(_vm._s(data))])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "content-one"
  }, [_c('content-title', {
    attrs: {
      "title": "数据源"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("当前数据选择")]), _vm._v(" "), _vm._l((_vm.caseList), function(caseData) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.changeCase(caseData)
        }
      }
    }, [(_vm.activeCase.key === caseData.key) ? _c('img', {
      attrs: {
        "src": __webpack_require__(21),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(22),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n              " + _vm._s(caseData.name) + "\n            ")])])
  }), _vm._v(" "), (_vm.caseList.length === 0) ? _c('span', {
    staticClass: "app-note"
  }, [_vm._v("无可选case数据，请先导入！")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("数据导入")]), _vm._v(" "), _vm._l((_vm.importWays), function(wayData) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.activeImportWayKey = wayData.key
        }
      }
    }, [(wayData.key === _vm.activeImportWayKey) ? _c('img', {
      attrs: {
        "src": __webpack_require__(21),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(22),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n              " + _vm._s(wayData.name) + "\n            ")])])
  }), _vm._v(" "), _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.startImport(false)
      }
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "系统提醒",
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("当前case尚未存储，请确定是否丢弃该case。")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("返回存储")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false;
        _vm.startImport(true)
      }
    }
  }, [_vm._v("丢弃并导入")])], 1)])], 2)])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "map-page",
    attrs: {
      "id": "chart-map-demo"
    }
  })])
}]}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v prediction-source-page"
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('div', {
    staticClass: "gu-duan"
  }, [_c('div', [_c('el-select', {
    staticStyle: {
      "width": "10rem"
    },
    attrs: {
      "filterable": "",
      "size": "small",
      "placeholder": "请选择区域"
    },
    model: {
      value: (_vm.selectArea),
      callback: function($$v) {
        _vm.selectArea = $$v
      },
      expression: "selectArea"
    }
  }, _vm._l((_vm.areaList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "10rem"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择油品"
    },
    model: {
      value: (_vm.selectOilType),
      callback: function($$v) {
        _vm.selectOilType = $$v
      },
      expression: "selectOilType"
    }
  }, _vm._l((_vm.oilTypes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('a', {
    staticClass: "btm-btn",
    staticStyle: {
      "margin-right": "1rem"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.hxJxc
    }
  }, [_vm._v("\n          核销\n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [(_vm.errorHisJxcDatas.length > 0) ? _c('a', {
    staticClass: "btm-btn",
    staticStyle: {
      "margin-right": "1rem"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("\n          错误数据调整\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errorHisJxcDatas.length > 0) ? _c('a', {
    staticClass: "btm-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.hul
    }
  }, [_vm._v("\n          忽略\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-1-table-1 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": '进销存数据 ' + _vm.preDay
    }
  }), _vm._v(" "), _c('mii-table-oil', {
    attrs: {
      "datas": _vm.showJxcDatas,
      "columns": _vm.jxcThs,
      "mergeRowKeyList": ['加油站名称', '油品名称']
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "size": "large",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-1-table-1 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": "错误数据调整"
    }
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.tzThs), function(th) {
    return _c('th', [_vm._v(_vm._s(th.label))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.errorHisJxcDatas), function(data, index1) {
    return _c('tr', _vm._l((_vm.tzThs), function(th) {
      return _c('td', {
        class: {
          'data-td': !(data[th.key] || {}).label, 's-bak-td': !(data[th.key] || {}).label && (index1 % 2 === 1), 'edit-td': _vm.canEditKey.indexOf(th.key) !== -1, 'edit-td-error': !_vm.checkData(data) && _vm.canEditKey.indexOf(th.key) !== -1, 'edit-td-success': _vm.checkData(data) && _vm.canEditKey.indexOf(th.key) !== -1
        }
      }, [_c('span', {
        class: {
          'error-rk': (!_vm.checkRk(data)) && (th.key === '入库升数' || th.key === '配送计划')
        }
      }, [_vm._v(_vm._s((data[th.key] || {}).label || data[th.key]))]), _vm._v(" "), (_vm.canEditKey.indexOf(th.key) !== -1) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.edit_data),
          expression: "edit_data"
        }],
        staticClass: "edit-error-num",
        class: {
          'error-rk': (!_vm.checkRk(data)) && th.key === '入库升数'
        },
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (_vm.edit_data)
        },
        on: {
          "focus": function($event) {
            _vm.focusEdit(data, th.key)
          },
          "blur": function($event) {
            _vm.blur(data, th.key)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.edit_data = $event.target.value
          }
        }
      }) : _vm._e()])
    }))
  }))])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sure
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.hul
    }
  }, [_vm._v("全部忽略")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "content-one"
  }, [_c('content-title', {
    attrs: {
      "title": '数据源 ' + _vm.preDay + '',
      "actions": _vm.titleAction
    },
    on: {
      "clickMenu": _vm.clickTitleMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("进销存数据 "), (_vm.inputJxcOk) ? _c('i', {
    staticClass: "iconfont icon-checked suc-iconfont"
  }) : _vm._e()]), _vm._v(" "), (!_vm.inputJxcOk) ? _c('input', {
    attrs: {
      "type": "file",
      "disabled": _vm.inputJxcOk,
      "id": "file-1"
    },
    on: {
      "change": _vm.oldFileChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inputJxcOk) ? _c('div', {
    staticClass: "input-note-info"
  }, [_vm._v("昨日进销存数据已导入")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("今日配送计划 "), (_vm.inputOrderPlantOk) ? _c('i', {
    staticClass: "iconfont icon-checked suc-iconfont"
  }) : _vm._e()]), _vm._v(" "), (!_vm.inputOrderPlantOk) ? _c('input', {
    attrs: {
      "type": "file",
      "disabled": _vm.inputOrderPlantOk,
      "id": "file-4"
    },
    on: {
      "change": _vm.plantFileChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inputOrderPlantOk) ? _c('div', {
    staticClass: "input-note-info"
  }, [_vm._v("今日配送计划已导入")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("要货量 "), (_vm.inputToGoodsOk) ? _c('i', {
    staticClass: "iconfont icon-checked suc-iconfont"
  }) : _vm._e()]), _vm._v(" "), (!_vm.inputToGoodsOk) ? _c('input', {
    attrs: {
      "type": "file",
      "disabled": _vm.inputToGoodsOk,
      "id": "file-5"
    },
    on: {
      "change": _vm.toGoodsFileChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inputToGoodsOk) ? _c('div', {
    staticClass: "input-note-info"
  }, [_vm._v("今日要货量已导入")]) : _vm._e()])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "要货导入异常数据",
      "visible": _vm.showYHerror
    },
    on: {
      "update:visible": function($event) {
        _vm.showYHerror = $event
      }
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.toGoodsErrorData,
      "table_style": 2,
      "ths": _vm.ths
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showYHerror = false
      }
    }
  }, [_vm._v("关 闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "要货导入数据统计",
      "visible": _vm.showYHcount
    },
    on: {
      "update:visible": function($event) {
        _vm.showYHcount = $event
      }
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.toGoodsCount,
      "table_style": 2,
      "ths": _vm.thsC
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showYHcount = false
      }
    }
  }, [_vm._v("关 闭")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.toGoodsErrorData) + _vm._s(_vm.toGoodsCount) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-page"
  }, [_c('keep-alive', [_c('router-view', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.inputDataLoading),
      expression: "inputDataLoading"
    }]
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-map",
    class: {
      'hide-map': ['/home/single', '/single_home/single'].indexOf(_vm.path) === -1
    }
  }, [_c('chart_map_pre')], 1), _vm._v(" "), _c('switch_map_btn', {
    attrs: {
      "mapPathName": _vm.path.indexOf('/home/single') > -1 ? 'single' : 'single.single'
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "map-page",
    attrs: {
      "id": "chart-map-pre"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "map-btn"
  }, [_c('a', {
    staticClass: "btn-1",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.changeColor
    }
  }, [_vm._v("显示地名")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn-3",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.initBMap
    }
  }, [_vm._v(" 初 始 化 ")])]), _vm._v(" "), (_vm.flowStatus > 0) ? _c('div', {
    staticClass: "map-select-station"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选择油库"
    },
    model: {
      value: (_vm.activeStation),
      callback: function($$v) {
        _vm.activeStation = $$v
      },
      expression: "activeStation"
    }
  }, _vm._l((_vm.stationLocationList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mii-table",
    class: {
      'mii-table-1': _vm.tableStyle && _vm.tableStyle.all === 1, 'mii-table-2': !_vm.tableStyle || _vm.tableStyle.all === 2, 'mii-table-3': !_vm.tableStyle || [1, 2].indexOf(_vm.tableStyle.all) === -1
    }
  }, [(_vm.tableData.length > 0) ? _c('table', {
    class: {
      'table-style-1': _vm.tableStyle && _vm.tableStyle.table === 1, 'table-style-2': _vm.tableStyle && _vm.tableStyle.table === 2, 'table-style-3': !_vm.tableStyle || [1, 2].indexOf(_vm.tableStyle.table) === 01, 'scroll-table': _vm.tableStyle && _vm.tableStyle.scroll === 1
    }
  }, [_c('thead', [_c('tr', [(_vm.showCheckbox) ? _c('th', [_c('el-checkbox', {
    model: {
      value: (_vm.checkedAll),
      callback: function($$v) {
        _vm.checkedAll = $$v
      },
      expression: "checkedAll"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return _c('th', {
      on: {
        "click": function($event) {
          _vm.sortData(column.key)
        }
      }
    }, [_vm._v(_vm._s(column.label))])
  }), _vm._v(" "), (_vm.tableAction && _vm.tableAction.length > 0) ? _c('th', [_vm._v("操作")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(data, index) {
    return _c('tr', {
      on: {
        "click": function($event) {
          _vm.clickRow(data)
        }
      }
    }, [(_vm.showCheckbox) ? _c('td', [_c('el-checkbox', {
      model: {
        value: (data.checked),
        callback: function($$v) {
          _vm.$set(data, "checked", $$v)
        },
        expression: "data.checked"
      }
    })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
      return ((data[column.key] || {}).rowspan !== 0) ? _c('td', {
        class: {
          'difference-row': !(data[column.key] || {}).label && (index % 2 === 0), 'tb-td': _vm.s_key && _vm.s_key.indexOf(column.key) > -1
        },
        style: (column.style ? column.style(data[column.key]) : {}),
        attrs: {
          "rowspan": (data[column.key] || {}).rowspan || 1
        }
      }, [_vm._v(_vm._s((data[column.key] || {}).label || data[column.key]))]) : _vm._e()
    }), _vm._v(" "), (_vm.tableAction && _vm.tableAction.length > 0) ? _c('td', {
      staticClass: "table-action"
    }, _vm._l((_vm.tableAction), function(table_action) {
      return (!table_action.show || table_action.show(data)) ? _c('a', {
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.clickTdBtn(data, table_action.key)
          }
        }
      }, [_vm._v(_vm._s(table_action.label))]) : _vm._e()
    })) : _vm._e()], 2)
  }))]) : _vm._e(), _vm._v(" "), (_vm.pageParm) ? _c('div', {
    staticClass: "t-tfoot"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "layout": !_vm.pageParm.pageSizeChangeList || _vm.pageParm.pageSizeChangeList.length === 0 ? 'prev, pager, next' : 'sizes, prev, pager, next',
      "page-size": _vm.pageParm.row_num,
      "total": _vm.pageParm.tablePagination ? _vm.datas.length : _vm.pageParm.dataTotal,
      "page-sizes": _vm.pageParm.pageSizeChangeList || []
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.pageChange
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "choose-data-show"
  }, _vm._l((_vm.data_types), function(data_type, index) {
    return _c('a', {
      class: {
        'active-type': _vm.active_type === index
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.active_type = index
        }
      }
    }, [_vm._v("\n      " + _vm._s(data_type) + "\n    ")])
  })), _vm._v(" "), (_vm.active_type === 0) ? _c('div', {
    staticClass: "data-one"
  }, [_c('div', {
    staticClass: "table-content"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.dataGridPrice,
      "table_style": 2,
      "ths": _vm.ths_1,
      "title": "电价",
      "scroll_table": "true",
      "table_height": _vm.table_height
    }
  })], 1), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.active_type === 1) ? _c('div', {
    staticClass: "data-one"
  }, [_c('div', {
    staticClass: "table-content"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.dataLoad,
      "table_style": 2,
      "ths": _vm.ths_2,
      "title": "负荷",
      "scroll_table": "true",
      "table_height": _vm.table_height
    }
  })], 1), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.active_type === 2) ? _c('div', {
    staticClass: "data-one"
  }, [_c('div', {
    staticClass: "table-content"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.dataNewEng,
      "table_style": 2,
      "ths": _vm.ths_3,
      "title": "光伏出力",
      "scroll_table": "true",
      "table_height": _vm.table_height
    }
  })], 1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.active_type === 3) ? _c('div', {
    staticClass: "data-one"
  }, [_c('div', {
    staticClass: "table-content"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.dataSteadyBattery,
      "table_style": 2,
      "ths": _vm.ths_4,
      "title": "固定储能",
      "scroll_table": "true",
      "table_height": _vm.table_height
    }
  })], 1), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.active_type === 4) ? _c('div', {
    staticClass: "data-one"
  }, [_c('div', {
    staticClass: "table-content"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.dataMoveBattery,
      "table_style": 2,
      "ths": _vm.ths_5,
      "title": "移动储能",
      "scroll_table": "true",
      "table_height": _vm.table_height
    }
  })], 1), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.sourceDataEle) + "\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-content"
  }, [_c('div', {
    staticClass: "map-page",
    attrs: {
      "id": "chart-grid_price"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-content"
  }, [_c('div', {
    staticClass: "map-page",
    attrs: {
      "id": "chart-load"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-content"
  }, [_c('div', {
    staticClass: "map-page",
    attrs: {
      "id": "chart-new_eng"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-content"
  }, [_c('div', {
    staticClass: "map-page",
    attrs: {
      "id": "chart-steady-b"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-content"
  }, [_c('div', {
    staticClass: "map-page",
    attrs: {
      "id": "chart-move-b"
    }
  })])
}]}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (false),
      expression: "false"
    }],
    staticClass: "home-content-page-v prediction-car-page"
  }, [_c('div', {
    staticClass: "two-content"
  }, [_c('div', {
    staticClass: "content-1-1 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": '每日订单（' + _vm.preDay + '）'
    }
  }), _vm._v(" "), _c('mii-table-oil', {
    attrs: {
      "datas": _vm.tableData,
      "columns": _vm.columns,
      "pageParm": _vm.pageParm,
      "mergeRowKeyList": ['车牌号'],
      "listTable": true
    },
    on: {
      "pageChange": _vm.pageChange,
      "pageSizeChange": _vm.pageSizeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-1-2 mii-table"
  }, [_c('div', {
    staticClass: "table-tool"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daochu",
    on: {
      "click": _vm.optPutFile
    }
  })])]), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": ""
    }
  }), _vm._v(" "), _c('mii-table-oil', {
    attrs: {
      "datas": _vm.tableData,
      "columns": _vm.columnsDrder,
      "listTable": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "chat-title"
  }, [_vm._v("\n      图表展示\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "chat-block"
  }, [_c('div', {
    staticClass: "chat-content"
  }, [_c('div', {
    staticClass: "chat-y"
  }, [_c('div', {
    staticClass: "chat-y-line"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.charData), function(data) {
    return _c('div', {
      staticClass: "one-y"
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "chat-y-data"
  }, _vm._l((_vm.charData), function(data) {
    return _c('div', {
      staticClass: "data-one"
    }, [_c('div', {
      staticClass: "data-xian data-xian-sned"
    }, [_vm._l((data.lines), function(oneLine) {
      return _c('div', {
        staticClass: "data-num data-send",
        style: (oneLine.style)
      }, [_c('div', {
        staticClass: "data-brn-note"
      }, [_vm._v("\n                    预计发车时间:" + _vm._s(oneLine.start_time)), _c('br'), _vm._v("\n                    在途时间:" + _vm._s(oneLine.long) + "h\n                  ")])])
    }), _vm._v(" "), _c('div', {
      staticClass: "m-line"
    })], 2)])
  })), _vm._v(" "), _c('div', {
    staticClass: "car-data"
  }, _vm._l((_vm.showData.slice(_vm.start_index, _vm.start_index + _vm.pageParm.row_num)), function(data, index) {
    return _c('div', {
      staticClass: "one-car-data"
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "chat-x"
  }, [_c('div', {
    staticClass: "one-x",
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.dateList[0].slice(5)) + "\n            "), _c('div', {
    staticClass: "time-start"
  }, [_vm._v("\n              16:00\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "one-x one-x-last",
    staticStyle: {
      "width": "66%"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.dateList[1].slice(5)) + "\n            "), _c('div', {
    staticClass: "time-end"
  }, [_vm._v("\n              16:00\n            ")])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "y-top-note",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('span', {}, [_vm._v("车辆")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "1.5rem"
    }
  }, [_c('span', {
    staticClass: "y-top-note"
  }, [_vm._v("时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-info"
  }, [_c('div', {
    staticClass: "one-info"
  }, [_c('div', {
    staticClass: "dian dian-1"
  }), _vm._v(" "), _c('span', [_vm._v("在途时间")])])])
}]}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.selectGas),
      callback: function($$v) {
        _vm.selectGas = $$v
      },
      expression: "selectGas"
    }
  }, _vm._l((_vm.gasList), function(item) {
    return _c('el-option', {
      key: item['油站代码'],
      attrs: {
        "label": item['加油站名称'],
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": _vm.selectGas['加油站名称'],
      "actions": _vm.titleAction
    },
    on: {
      "clickMenu": _vm.clickTitleMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gas-info"
  }, [_c('div', {
    staticClass: "info-one"
  }, [_vm._v("\n      " + _vm._s(_vm.selectGas['单位名称']) + "    -    " + _vm._s(_vm.selectGas['区域']) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "info-one"
  }, [_c('span', [_vm._v("通行证限制:")]), _vm._v(" "), _c('div', {
    staticClass: "info-one"
  }, [_vm._v("\n        " + _vm._s(_vm.getTextTXZ(_vm.selectGas['通行证']) || '无') + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-one"
  }, [_c('span', [_vm._v("车轴限制:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "7rem"
    },
    attrs: {
      "size": "mini",
      "placeholder": "无限制"
    },
    model: {
      value: (_vm.axle_key),
      callback: function($$v) {
        _vm.axle_key = $$v
      },
      expression: "axle_key"
    }
  }, _vm._l((_vm.AXLE_LIST), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "info-one",
    staticStyle: {
      "width": "66%"
    }
  }, [_c('span', {
    staticStyle: {
      "min-width": "8rem"
    }
  }, [_vm._v("指定配送车辆:")]), _vm._v(" "), _c('div', {
    staticClass: "car-list"
  }, [(!_vm.xzCarList || _vm.xzCarList.length === 0) ? _c('strong', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("没有配送车辆限制")]) : _vm._l((_vm.xzCarList), function(data) {
    return _c('span', [_vm._v(_vm._s(data['车牌号'])), _c('i', {
      staticClass: "icon-105 iconfont",
      on: {
        "click": function($event) {
          _vm.delXzCar(data)
        }
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "info-one"
  }, [_c('span', [_vm._v("添加车辆:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "7rem"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.selectCar),
      callback: function($$v) {
        _vm.selectCar = $$v
      },
      expression: "selectCar"
    }
  }, _vm._l((_vm.carList), function(item, index) {
    return _c('el-option', {
      key: item['车牌号'] + index,
      attrs: {
        "label": item['车牌号'],
        "value": item
      }
    })
  }))], 1)]), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": "油品油罐",
      "actions": _vm.titleAction2
    },
    on: {
      "clickMenu": _vm.clickTitleMenuG
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingG),
      expression: "loadingG"
    }],
    staticClass: "output-content"
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.oilGGList,
      "table_actions": _vm.table_actions,
      "table_style": 2,
      "ths": _vm.ths
    },
    on: {
      "clickTdBtn": _vm.clickTdBtn
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isNew ? '新增加油站' : '修改加油站',
      "visible": _vm.showAdd
    },
    on: {
      "update:visible": function($event) {
        _vm.showAdd = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [(_vm.isNew) ? _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("油站代码")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasMap['油站代码']),
      callback: function($$v) {
        _vm.$set(_vm.gasMap, '油站代码', $$v)
      },
      expression: "gasMap['油站代码']"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("加油站名称")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasMap['加油站名称']),
      callback: function($$v) {
        _vm.$set(_vm.gasMap, '加油站名称', $$v)
      },
      expression: "gasMap['加油站名称']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("区域")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasMap['区域']),
      callback: function($$v) {
        _vm.$set(_vm.gasMap, '区域', $$v)
      },
      expression: "gasMap['区域']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("单位名称")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasMap['单位名称']),
      callback: function($$v) {
        _vm.$set(_vm.gasMap, '单位名称', $$v)
      },
      expression: "gasMap['单位名称']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showAdd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveGas
    }
  }, [_vm._v("保 存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isNewG ? '新增油罐' : '修改油罐',
      "visible": _vm.showAddG
    },
    on: {
      "update:visible": function($event) {
        _vm.showAddG = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("油站代码")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasGMap['油站代码']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '油站代码', $$v)
      },
      expression: "gasGMap['油站代码']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("罐号")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": !_vm.isNewG,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasGMap['罐号']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '罐号', $$v)
      },
      expression: "gasGMap['罐号']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("油品")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.gasGMap['油品名称']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '油品名称', $$v)
      },
      expression: "gasGMap['油品名称']"
    }
  }, _vm._l((_vm.OIL_TYPES), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("油罐状态")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.gasGMap['油罐状态']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '油罐状态', $$v)
      },
      expression: "gasGMap['油罐状态']"
    }
  }, _vm._l((_vm.GASG_STATUS), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("物理容积")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasGMap['物理容积']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '物理容积', $$v)
      },
      expression: "gasGMap['物理容积']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("停泵库存")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasGMap['停泵库存']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '停泵库存', $$v)
      },
      expression: "gasGMap['停泵库存']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("有效容积")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.gasGMap['有效容积']),
      callback: function($$v) {
        _vm.$set(_vm.gasGMap, '有效容积', $$v)
      },
      expression: "gasGMap['有效容积']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showAddG = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveGasG
    }
  }, [_vm._v("保 存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.showDel,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDel = $event
      }
    }
  }, [(_vm.delType === 'gas') ? [_c('span', [_vm._v("你确定删除该加油站吗？")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("该加油站相关数据也将被删除")])] : [_c('span', [_vm._v("你确定删除该油罐吗？")]), _c('br')], _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDel = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delGas
    }
  }, [_vm._v("确 定")])], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "one-content"
  }, [_c('content-title', {
    attrs: {
      "title": "模型参数设定"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setting-content"
  }, [_c('div', {
    staticClass: "model-setting"
  }, [_c('div', {
    staticClass: "one-model-setting"
  }, [_c('span', [_vm._v("车辆数")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.groupsNum),
      callback: function($$v) {
        _vm.groupsNum = $$v
      },
      expression: "groupsNum"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("辆")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "one-model-setting"
  }, [_c('span', [_vm._v("每个群主最大客户数")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.maxCustomersNum),
      callback: function($$v) {
        _vm.maxCustomersNum = $$v
      },
      expression: "maxCustomersNum"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("个")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "one-model-setting"
  }, [_c('span', [_vm._v("车辆调度模型的TimeLimit")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.groupTimeLimit),
      callback: function($$v) {
        _vm.groupTimeLimit = $$v
      },
      expression: "groupTimeLimit"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("秒")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "one-model-setting"
  }, [_c('span', [_vm._v("车辆调度模型的MIPGap")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.groupMipGap),
      callback: function($$v) {
        _vm.groupMipGap = $$v
      },
      expression: "groupMipGap"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(" % ")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "one-model-setting one-model-last"
  }, [_c('span', [_vm._v("路径规划模型的TimeLimit")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.routeTimeLimit),
      callback: function($$v) {
        _vm.routeTimeLimit = $$v
      },
      expression: "routeTimeLimit"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("秒")])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }, [_c('a', {
    staticClass: "show-note",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.show_note = !_vm.show_note
      }
    }
  }, [_vm._v(_vm._s(_vm.show_note ? '隐藏解析' : '显示解析'))])]), _vm._v(" "), _c('div', {
    staticClass: "setting-note"
  }, [(_vm.show_note) ? _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [
    [_c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.setting_note)
      }
    }), _vm._v(" "), _vm._l((_vm.notes), function(note) {
      return _c('li', [_vm._v(_vm._s(note))])
    })], 2)]
  ], 2) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "gu-duan"
  }), _vm._v(" "), _c('div', {
    staticClass: "two-content"
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('content-title', {
    attrs: {
      "title": "求解日期选择"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("该系统解决的是单日的配送问题，所以请选择所要查看配送安排的日期。")]), _vm._v(" "), _vm._l((_vm.solutionWeeks), function(week, index) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.solutionStatus > 20 ? null : _vm.solutionDay = index
        }
      }
    }, [(_vm.solutionDay === index) ? _c('img', {
      attrs: {
        "src": __webpack_require__(21),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.solutionDay !== index) ? _c('img', {
      attrs: {
        "src": __webpack_require__(22),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n            " + _vm._s(week) + "\n          ")])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "4em"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-1"
  }, [_c('content-title', {
    attrs: {
      "title": "求解器选择"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-content"
  }, _vm._l((_vm.solutionWays), function(type, index) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.solutionStatus > 20 ? null : _vm.solutionWay = index
        }
      }
    }, [(_vm.solutionWay === index) ? _c('img', {
      attrs: {
        "src": __webpack_require__(21),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.solutionWay !== index) ? _c('img', {
      attrs: {
        "src": __webpack_require__(22),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n            " + _vm._s(type) + "\n          ")])])
  }))], 1)])])
},staticRenderFns: []}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mii-table",
    class: {
      'mii-table-1': _vm.style === 1, 'mii-table-2': _vm.style !== 1
    }
  }, [(_vm.tableData.length > 0) ? _c('table', {
    class: {
      'table-style-1': _vm.table_style === 1, 'table-style-2': _vm.table_style !== 1, 'scroll-table': _vm.scroll_table_2
    }
  }, [(!_vm.notShowThs) ? _c('thead', [_c('tr', [(_vm.show_checkbox) ? _c('th', [_c('el-checkbox', {
    model: {
      value: (_vm.checkedAll),
      callback: function($$v) {
        _vm.checkedAll = $$v
      },
      expression: "checkedAll"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.ths), function(th) {
    return _c('th', {
      on: {
        "click": function($event) {
          _vm.sortData(th.key, th.shortType)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(th.label))])])
  }), _vm._v(" "), (_vm.realAction && _vm.table_actions && _vm.table_actions.length > 0) ? _c('th') : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('tbody', {
    style: (_vm.table_style_height)
  }, _vm._l(((_vm.show_pagination ? (_vm.tableData || []).slice(_vm.start_index, _vm.start_index + this.row_num) : (_vm.tableData || []))), function(data, index) {
    return _c('tr', {
      class: {
        'chooseRow': data[_vm.lineSuo] === _vm.chooseRow
      },
      staticStyle: {
        "overflow": "auto",
        "max-height": "20rem"
      },
      style: (_vm.getlineStyle ? _vm.getlineStyle(data) : {}),
      on: {
        "click": function($event) {
          _vm.clickRow(data, index)
        }
      }
    }, [(_vm.show_checkbox) ? _c('td', [_c('el-checkbox', {
      model: {
        value: (data.checked),
        callback: function($$v) {
          _vm.$set(data, "checked", $$v)
        },
        expression: "data.checked"
      }
    })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.ths), function(th, index2) {
      return _c('td', [(th.clickAction) ? _c('a', {
        staticClass: "td-a",
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.clickRowData(data, th.key, th.clickAction)
          }
        }
      }, [_vm._v("\n            " + _vm._s(th.showText ? th.showText(data[th.key]) : data[th.key]) + "\n          ")]) : _c('div', {
        domProps: {
          "innerHTML": _vm._s(th.showText ? th.showText(data[th.key]) : data[th.key])
        }
      })])
    }), _vm._v(" "), (_vm.realAction && _vm.table_actions && _vm.table_actions.length > 0) ? _c('td', {
      staticClass: "table-action"
    }, _vm._l((_vm.table_actions), function(table_action) {
      return (!table_action.hideByData || table_action.hideByData(data)) ? _c('a', {
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.clickTdBtn(data, table_action.key, index)
          }
        }
      }, [_vm._v(_vm._s(table_action.label))]) : _vm._e()
    })) : _vm._e(), _vm._v(" "), (!_vm.realAction && _vm.table_actions && _vm.table_actions.length > 0) ? _c('td', {
      staticClass: "action-td"
    }, [_c('div', {
      staticClass: "action-td-div"
    }, _vm._l((_vm.table_actions), function(table_action) {
      return (!table_action.hideByData || table_action.hideByData(data)) ? _c('a', {
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.clickTdBtn(data, table_action.key, index)
          }
        }
      }, [_vm._v(_vm._s(table_action.label))]) : _vm._e()
    }))]) : _vm._e()], 2)
  }))]) : _vm._e(), _vm._v(" "), (_vm.show_pagination && _vm.tableData.length > 0) ? _c('div', {
    staticClass: "pagination-table"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "page-size": _vm.row_num,
      "total": (_vm.tableData || []).length
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tableData.length === 0) ? _c('div', {
    staticClass: "nodata-note"
  }, [_vm._v("\n    无数据\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.chooseRowValue))])])
},staticRenderFns: []}

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-head"
  }, [_c('a', {
    staticClass: "head-logo",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticClass: "logo-100",
    attrs: {
      "src": __webpack_require__(123),
      "alt": ""
    },
    on: {
      "click": _vm.gohome
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "head-menus-div"
  }, [_c('div', {
    staticClass: "head-menus"
  }, [(['/down', '/'].indexOf(_vm.path) > -1) ? _c('div', {
    staticClass: "menu-2 menu-index"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, [_c('router-link', {
    key: "o1",
    staticClass: "menu-one",
    class: {
      'active-menu-one': _vm.path === '/home'
    },
    attrs: {
      "to": "/home"
    }
  }, [_vm._v("工作台")]), _vm._v(" "), _c('router-link', {
    key: "o2",
    staticClass: "menu-one",
    class: {
      'active-menu-one': _vm.path === '/down'
    },
    attrs: {
      "to": "/down"
    }
  }, [_vm._v("资料库")]), _vm._v(" "), _c('a', {
    key: "o3",
    staticClass: "menu-one",
    class: {
      'active-menu-one': _vm.active_menu_index === 2
    },
    attrs: {
      "href": "http://www.reemii.cn"
    },
    on: {
      "click": function($event) {
        _vm.chooseMenuIndex(2)
      }
    }
  }, [_vm._v("\n            关于我们\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.path.indexOf('/home/cycle') > -1) ? [(_vm.solutionStatus > 10 || _vm.solutionStatus === 10) ? _c('a', {
    staticClass: "menu-1",
    class: {
      'menu-1-active': _vm.show_menu === 'left'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.clickLeftMenu('left')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-2"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.left_menus), function(menu, index) {
    return (_vm.solutionStatus > menu.minStatus || _vm.solutionStatus === menu.minStatus) ? _c('a', {
      key: "index",
      staticClass: "menu-one",
      class: {
        'active-menu-one': _vm.active_menu === menu.route_name
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseMenu(menu)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.solutionStatus > 30 || _vm.solutionStatus === 30) ? _c('div', {
    staticClass: "fg-line"
  }) : _vm._e(), _vm._v(" "), (_vm.solutionStatus > 30 || _vm.solutionStatus === 30) ? _c('a', {
    staticClass: "menu-1",
    class: {
      'menu-1-active': _vm.show_menu === 'right'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.clickLeftMenu('right')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shuju"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-2"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.right_menus), function(menu, index) {
    return (_vm.solutionStatus > menu.minStatus || _vm.solutionStatus === menu.minStatus) ? _c('a', {
      key: "index + '-right'",
      staticClass: "menu-one",
      class: {
        'active-menu-one': _vm.active_menu === menu.route_name
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseMenu(menu)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
  }))], 1)] : _vm._e(), _vm._v(" "), (_vm.path.indexOf('/home/single') > -1) ? [(_vm.preStatus > 10 || _vm.preStatus === 10) ? _c('a', {
    staticClass: "menu-1",
    class: {
      'menu-1-active': _vm.show_menu === 'left'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.clickLeftMenu('left')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-2"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.left_menus_p), function(menu, index) {
    return (_vm.preStatus > menu.minStatus || _vm.preStatus === menu.minStatus) ? _c('a', {
      key: "index",
      staticClass: "menu-one",
      class: {
        'active-menu-one': _vm.active_menu === menu.route_name
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseMenu(menu)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.preStatus > 30 || _vm.preStatus === 30) ? _c('div', {
    staticClass: "fg-line"
  }) : _vm._e(), _vm._v(" "), (_vm.preStatus > 30 || _vm.preStatus === 30) ? _c('a', {
    staticClass: "menu-1",
    class: {
      'menu-1-active': _vm.show_menu === 'right'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.clickLeftMenu('right')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shuju"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-2"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.right_menus_p), function(menu, index) {
    return (_vm.preStatus > menu.minStatus || _vm.preStatus === menu.minStatus) ? _c('a', {
      key: "index + '-right'",
      staticClass: "menu-one",
      class: {
        'active-menu-one': _vm.active_menu === menu.route_name
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseMenu(menu)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
  }))], 1)] : _vm._e(), _vm._v(" "), (_vm.path.indexOf('/single_home/single') > -1) ? [(_vm.preStatus > 10 || _vm.preStatus === 10) ? _c('a', {
    staticClass: "menu-1",
    class: {
      'menu-1-active': _vm.show_menu === 'left'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.clickLeftMenu('left')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-2"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.left_menus_ps), function(menu, index) {
    return (_vm.preStatus > menu.minStatus || _vm.preStatus === menu.minStatus) ? _c('a', {
      key: "index",
      staticClass: "menu-one",
      class: {
        'active-menu-one': _vm.active_menu === menu.route_name
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseMenu(menu)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.preStatus > 30 || _vm.preStatus === 30) ? _c('div', {
    staticClass: "fg-line"
  }) : _vm._e(), _vm._v(" "), (_vm.preStatus > 30 || _vm.preStatus === 30) ? _c('a', {
    staticClass: "menu-1",
    class: {
      'menu-1-active': _vm.show_menu === 'right'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.clickLeftMenu('right')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shuju"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-2"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.right_menus_ps), function(menu, index) {
    return (_vm.preStatus > menu.minStatus || _vm.preStatus === menu.minStatus) ? _c('a', {
      key: "index + '-right'",
      staticClass: "menu-one",
      class: {
        'active-menu-one': _vm.active_menu === menu.route_name
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.chooseMenu(menu)
        }
      }
    }, [_vm._v("\n              " + _vm._s(menu.leabel) + "\n            ")]) : _vm._e()
  }))], 1)] : _vm._e()], 2)]), _vm._v(" "), (_vm.path.indexOf('/single_home/single') > -1) ? [_c('div', {
    staticClass: "head-user"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('span', {
    staticClass: "head-btn-a",
    on: {
      "click": _vm.goOther
    }
  }, [_vm._v(_vm._s(_vm.path.indexOf('adjust_home') ? '配单' : '流程'))])])]), _vm._v(" "), _c('div', {
    staticClass: "head-user"
  }, [_c('div', {
    staticClass: "user-info qh-btn"
  }, [_c('span', {
    staticClass: "head-btn-a"
  }, [_vm._v(_vm._s(_vm.getLabel(_vm.oilArea)))]), _vm._v(" "), (_vm.pszxDatas.length > 0) ? _c('div', {
    staticClass: "choose-ps"
  }, _vm._l((_vm.pszxDatas), function(item) {
    return _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.oilArea = item.key
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  })) : _vm._e()])])] : _vm._e(), _vm._v(" "), [(_vm.path.indexOf('oil_chart') === -1 && _vm.path.indexOf('gas_map') === -1) ? _c('user-info') : _vm._e()], _vm._v(" "), (!_vm.noLogin) ? [(_vm.path.indexOf('oil_chart') > -1 || _vm.path.indexOf('gas_map') > -1) ? _c('div', {
    staticClass: "head-user"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goHaveFun
    }
  }, [_vm._v("Have Fun")])])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.path) + "\n  ")])], 2)
},staticRenderFns: []}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v prediction-source-page"
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('div', {
    staticClass: "content-1-table-1 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": '进销存数据 ' + _vm.preDay
    }
  }), _vm._v(" "), _c('mii-table-oil', {
    attrs: {
      "datas": _vm.showJxcDatas,
      "columns": _vm.jxcThs,
      "mergeRowKeyList": ['加油站名称', '油品名称'],
      "s_key": ['出库升数', '期末库存', '空容']
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "week-data"
  }, [_c('content-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "div-table"
  }, [_c('div', {
    staticClass: "table-head"
  }, [_c('div', {
    staticClass: "null-block"
  }), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return _c('div', {
      staticClass: "table-column"
    }, [_vm._v("\n          " + _vm._s(column.leabel) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.datas.slice(_vm.start_index, _vm.start_index + 15)), function(data) {
    return _c('div', {
      staticClass: "row-content"
    }, [_c('div', {
      staticClass: "null-block"
    }, [_vm._v("\n          " + _vm._s(data.shop) + "\n        ")]), _vm._v(" "), _vm._l((_vm.columns), function(column, index) {
      return _c('div', {
        staticClass: "table-data-block"
      }, [(data.order_days.indexOf(index) > -1) ? _c('div', {
        staticClass: "work-day"
      }) : _vm._e()])
    })], 2)
  })], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "page-size": 15,
      "total": _vm.datas.length
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "login-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "placeholder": "用户名"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "",
      "value": "",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "other-option"
  }, [_c('div', {
    staticClass: "left-content"
  }, [(_vm.checked) ? _c('img', {
    attrs: {
      "src": __webpack_require__(866),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.checked = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.checked) ? _c('img', {
    staticClass: "unchecked-btn",
    attrs: {
      "src": __webpack_require__(887),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.checked = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("记住本电脑")])])]), _vm._v(" "), _c('a', {
    staticClass: "form-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n        登 录\n      ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(278),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-map-btn"
  }, [_c('div', {
    staticClass: "top-j"
  }, [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.path))])]), _vm._v(" "), _c('a', {
    staticClass: "btn-content",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.change
    }
  }, [_c('i', {
    staticClass: "iconfont icon-you"
  }), _vm._v("\n    " + _vm._s(_vm.isMap ? '切换到表格' : '切换到地图') + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-j"
  })])
},staticRenderFns: []}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "content-one"
  }, [_c('content-title', {
    attrs: {
      "title": '数据导入'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [(_vm.isAdmin) ? _c('div', {
    staticStyle: {
      "margin-bottom": "2rem"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#666",
      "margin-right": "0.5rem",
      "line-height": "2rem"
    }
  }, [_vm._v("全部配送中心")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.allPs),
      callback: function($$v) {
        _vm.allPs = $$v
      },
      expression: "allPs"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择文件类型"
    },
    model: {
      value: (_vm.dataType),
      callback: function($$v) {
        _vm.dataType = $$v
      },
      expression: "dataType"
    }
  }, _vm._l((_vm.dataTypes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "input-date"
  }, [_vm._v("导入数据时间:" + _vm._s(_vm.inputDate))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "disabled": !_vm.canInput,
      "id": _vm.fileId
    },
    on: {
      "change": _vm.fileChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "output-content-2"
  }, _vm._l((_vm.hisData), function(item) {
    return _c('div', {
      staticClass: "data-one",
      on: {
        "click": function($event) {
          _vm.inputDate = item['日期'];
          _vm.chooseHis = item
        }
      }
    }, [_vm._v(_vm._s(item['日期'] + ': ' + item['TOTAL']))])
  }))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "gu-duan"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择车辆类型"
    },
    model: {
      value: (_vm.car_first),
      callback: function($$v) {
        _vm.car_first = $$v
      },
      expression: "car_first"
    }
  }, _vm._l((_vm.cars), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "two-content"
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.oneCarRoutes,
      "table_style": 3,
      "one_row": true,
      "ths": _vm.ths2,
      "title": "车辆配送线路"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "content-column-1"
  }, [_c('content-title', {
    attrs: {
      "title": "结果报告"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "result-content"
  }, [_c('div', {
    staticClass: "result-one"
  }, [_c('span', [_vm._v("总成本")]), _c('div', [_vm._v(_vm._s(_vm.solutionData['总成本']) + " 元")])]), _vm._v(" "), _c('div', {
    staticClass: "result-one"
  }, [_c('span', [_vm._v("车辆数量")]), _c('div', [_vm._v(_vm._s(_vm.solutionData['车辆数量']) + " 辆")])]), _vm._v(" "), _c('div', {
    staticClass: "result-one"
  }, [_c('span', [_vm._v("订单数量")]), _c('div', [_vm._v(_vm._s(_vm.solutionData['订单数量']) + " 单")])]), _vm._v(" "), _c('div', {
    staticClass: "result-one"
  }, [_c('span', [_vm._v("配送订单数量")]), _c('div', [_vm._v(_vm._s(_vm.solutionData['配送订单数量']) + " 单")])]), _vm._v(" "), _c('div', {
    staticClass: "result-one"
  }, [_c('span', [_vm._v("未配送订单数量")]), _c('div', [_vm._v(_vm._s(_vm.solutionData['未配送订单数量']) + " 单")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-column-1"
  }, [_c('content-title', {
    attrs: {
      "title": "车辆容量利用"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "car-content"
  }, [_c('div', {
    staticClass: "car-content-1"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择车辆类型"
    },
    model: {
      value: (_vm.car2),
      callback: function($$v) {
        _vm.car2 = $$v
      },
      expression: "car2"
    }
  }, _vm._l((_vm.cars), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "car-content-1"
  }, [_c('echarts', {
    style: (_vm.echartsOption.outOption.style),
    attrs: {
      "chart_id": "car-echart",
      "option": _vm.echartsOption.option
    }
  })], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.carRoutes.length) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-bar",
    class: {
      'big-bar': _vm.big_size, 'sm-bar': !_vm.big_size
    }
  }, [_c('div', {
    staticClass: "left-bar-top-1"
  }, _vm._l((_vm.menus_top), function(menu, index) {
    return _c('a', {
      staticClass: "one-bar",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.clickMenuF(menu, index, 'top_top')
        }
      }
    }, [_c('div', {
      staticClass: "bar-icon",
      class: {
        'sm-iconfont': _vm.big_size
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: menu.icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "bar-leabel",
      class: {
        'big-bar-leabel': _vm.big_size, 'sm-bar-leabel': !_vm.big_size
      },
      domProps: {
        "innerHTML": _vm._s(menu.leabel)
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "bar-fg"
  }), _vm._v(" "), _c('div', {
    staticClass: "left-bar-top"
  }, _vm._l((_vm.menus), function(menu, index) {
    return _c('a', {
      staticClass: "one-bar",
      class: {
        'active-bar': _vm.active_type === 'top' && _vm.active_index === index, 'hide-bar': !menu.active
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.clickMenuF(menu, index, 'top')
        }
      }
    }, [_c('div', {
      staticClass: "bar-icon",
      class: {
        'sm-iconfont': _vm.big_size
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: menu.icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "bar-leabel",
      class: {
        'big-bar-leabel': _vm.big_size, 'sm-bar-leabel': !_vm.big_size
      },
      domProps: {
        "innerHTML": _vm._s(menu.leabel)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "right-menu"
    }, _vm._l((menu.children), function(data) {
      return _c('a', {
        staticClass: "children-menu",
        class: {
          'hide-bar': !data.active
        },
        attrs: {
          "href": "javascript:;"
        },
        domProps: {
          "innerHTML": _vm._s(data.leabel)
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.clickMenu(data.key, data.active, index, 'top')
          }
        }
      })
    }))])
  })), _vm._v(" "), _c('div', {
    staticClass: "bar-fg"
  }), _vm._v(" "), _c('div', {
    staticClass: "left-bar-bottom"
  }, _vm._l((_vm.bottomMenus), function(menu, index) {
    return _c('a', {
      staticClass: "one-bar",
      class: {
        'active-bar': _vm.active_type === 'btm' && _vm.active_index === index, 'hide-bar': !menu.active
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.clickMenuF(menu, index, 'btm')
        }
      }
    }, [_c('div', {
      staticClass: "bar-icon",
      class: {
        'sm-iconfont': _vm.big_size
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: menu.icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "bar-leabel",
      class: {
        'big-bar-leabel': _vm.big_size, 'sm-bar-leabel': !_vm.big_size
      },
      domProps: {
        "innerHTML": _vm._s(menu.leabel)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "right-menu"
    }, _vm._l((menu.children), function(data) {
      return _c('a', {
        staticClass: "children-menu",
        class: {
          'hide-bar': !data.active
        },
        attrs: {
          "href": "javascript:;"
        },
        domProps: {
          "innerHTML": _vm._s(data.leabel)
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.clickMenu(data.key, data.active, index, 'btm')
          }
        }
      })
    }))])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.path) + _vm._s(_vm.preStatus))])])
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cycle-page"
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "content-map",
    class: {
      'hide-map': _vm.path !== '/home/cycle'
    }
  }, [_c('chart_map')], 1), _vm._v(" "), _c('switch_map_btn', {
    attrs: {
      "mapPathName": "cycle"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('page-head', {
    staticClass: "page-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "right-content"
  }, [_c('adjust-order', {
    staticStyle: {
      "padding": "0"
    }
  })], 1)]), _vm._v(" "), _c('loading')], 1)
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-table"
  }, [(_vm.caseDatas.length > 0) ? _c('div', {
    staticClass: "mii-table mii-table-2",
    staticStyle: {
      "height": "8rem"
    }
  }, [_c('content-title', {
    attrs: {
      "title": "成本对比"
    }
  }), _vm._v(" "), _c('table', {
    class: {
      'table-style-2': 1, 'scroll-table': _vm.scroll_table
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "th-1"
  }, _vm._l((_vm.ths2), function(thData, indexn) {
    return _c('th', {
      attrs: {
        "colspan": _vm.caseDatas.length
      }
    }, [_vm._v(_vm._s(thData.label))])
  })), _vm._v(" "), _c('tr', [_vm._l((_vm.ths2), function(thData, index2) {
    return _vm._l((_vm.caseDatas), function(caseData, index) {
      return _c('th', {
        class: {
          'border-th': index === 0 && index2 !== 0
        }
      }, [_vm._v(_vm._s(caseData.name))])
    })
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.caseDatas[0]['result']['成本']), function(data) {
    return _c('tr', [_vm._l((_vm.ths2), function(thData, index) {
      return _vm._l((_vm.caseDatas), function(caseDataOne, indeCase) {
        return _c('td', {
          class: {
            'border-th': indeCase === 0 && index !== 0
          }
        }, [_vm._v(_vm._s(_vm.caseDatas[indeCase]['result']['成本'][0][thData.key]))])
      })
    })], 2)
  }))])], 1) : _vm._e(), _vm._v(" "), (_vm.caseDatas.length > 0) ? _c('div', {
    staticClass: "mii-table mii-table-2"
  }, [_c('div', {
    staticClass: "table-tool"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-zhankai-copy",
    on: {
      "click": function($event) {
        _vm.scroll_table_2 = !_vm.scroll_table_2
      }
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daochu",
    on: {
      "click": _vm.optPutFile
    }
  })])]), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": "结果对比"
    }
  }), _vm._v(" "), _c('table', {
    class: {
      'table-style-2': 1, 'scroll-table': _vm.scroll_table_2
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "th-1"
  }, _vm._l((_vm.ths), function(thData) {
    return _c('th', {
      attrs: {
        "colspan": thData.label === '时间' ? 1 : _vm.caseDatas.length
      }
    }, [_vm._v(_vm._s(thData.label))])
  })), _vm._v(" "), _c('tr', [_vm._l((_vm.ths), function(thData) {
    return [(thData.label === '时间') ? _c('th') : _vm._l((_vm.caseDatas), function(caseData, index1) {
      return _c('th', {
        class: {
          'border-th': index1 === 0
        }
      }, [_vm._v(_vm._s(caseData.name))])
    })]
  })], 2)]), _vm._v(" "), _c('tbody', {
    style: (_vm.table_style_height)
  }, _vm._l((_vm.caseDatas[0]['result']['调度方案']), function(data, index) {
    return _c('tr', {
      staticStyle: {
        "overflow": "auto",
        "max-height": "20rem"
      }
    }, [_vm._l((_vm.ths), function(thData) {
      return [(thData.label === '时间') ? _c('td', [_vm._v(_vm._s(_vm.caseDatas[0]['result']['调度方案'][index][thData.key]))]) : _vm._l((_vm.caseDatas), function(caseDataOne, indeCase) {
        return _c('td', {
          class: {
            'border-th': indeCase === 0
          }
        }, [_vm._v(_vm._s(_vm.caseDatas[indeCase]['result']['调度方案'][index][thData.key]))])
      })]
    })], 2)
  }))])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "map-page",
    attrs: {
      "id": "chart-map-gas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch-map-btn"
  }, [_c('div', {
    staticClass: "top-j"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn-content",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.change
    }
  }, [_c('i', {
    staticClass: "iconfont icon-you"
  }), _vm._v("\n          切换到图表\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-j"
  })])])
},staticRenderFns: []}

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "content-one"
  }, [_c('content-title', {
    attrs: {
      "title": "数据导出"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("数据存储")]), _vm._v(" "), _c('a', {
    staticClass: "checkbox-one",
    attrs: {
      "href": "javascript:;"
    }
  }, [(_vm.down1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(21),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.down1 = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.down1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.down1 = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.login === 1) ? _c('div', {
    staticClass: "checkbox-label"
  }, [_vm._v("\n              演示数据下载 "), (_vm.down1) ? _c('a', {
    staticClass: "output-btn",
    attrs: {
      "href": _vm.down1 ? '/static/演示数据.xlsx' : '',
      "download": "演示数据"
    },
    on: {
      "click": _vm.down
    }
  }, [_vm._v("导出到Excel")]) : _vm._e()]) : _c('div', {
    staticClass: "checkbox-label"
  }, [_vm._v("\n              演示数据下载 "), (_vm.down1) ? _c('a', {
    staticClass: "output-btn",
    attrs: {
      "download": "演示数据"
    },
    on: {
      "click": _vm.goLgin
    }
  }, [_vm._v("导出到Excel")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("case存储")]), _vm._v(" "), _vm._l((_vm.outPutWays), function(outPutWayData) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.activeOutPutWayKey = outPutWayData.key
        }
      }
    }, [(outPutWayData.key === _vm.activeOutPutWayKey) ? _c('img', {
      attrs: {
        "src": __webpack_require__(21),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(22),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n              " + _vm._s(outPutWayData.name) + "\n            ")])])
  }), _vm._v(" "), (this.activeCase.status) ? _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showEditName = true
      }
    }
  }, [_vm._v("存 储")]) : _vm._e()], 2)])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "系统提醒",
      "visible": _vm.showEditName,
      "size": "tiny",
      "before-close": _vm.close
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditName = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.caseName),
      callback: function($$v) {
        _vm.caseName = $$v
      },
      expression: "caseName"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("Case Name")])], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(this.activeCase.status) ? _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showEditName = false;
        _vm.saveCase()
      }
    }
  }, [_vm._v("存 储")]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "map-page",
    attrs: {
      "id": "chart-map"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "map-btn"
  }, [(_vm.solutionStatus === 40) ? _c('a', {
    staticClass: "btn-2",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.hideAllcar
    }
  }, [_vm._v("部分车辆")]) : _vm._e(), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn-1",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.changeColor
    }
  }, [_vm._v("显示地名")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn-3",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.initBMap
    }
  }, [_vm._v(" 初 始 化 ")])]), _vm._v(" "), (_vm.solutionStatus > 10 || _vm.solutionStatus === 10) ? _c('div', {
    staticClass: "map-select-week"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选择送货日期",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.solutionDay),
      callback: function($$v) {
        _vm.solutionDay = $$v
      },
      expression: "solutionDay"
    }
  }, _vm._l((_vm.solutionWeeks), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": index
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.sourceDataType) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "one-content"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.centroids,
      "table_style": 2,
      "ths": _vm.thsCentroids,
      "title": "车辆配送信息"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gu-duan"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择车辆类型"
    },
    model: {
      value: (_vm.show_order_car),
      callback: function($$v) {
        _vm.show_order_car = $$v
      },
      expression: "show_order_car"
    }
  }, _vm._l((_vm.cars), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "two-content"
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('mii-table', {
    attrs: {
      "datas": _vm.carOrders,
      "table_style": 1,
      "ths": _vm.ths,
      "title": _vm.sourceDataType === 'shop' ? '订单重量' : '订单量'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-2"
  }, [_c('content-title', {
    attrs: {
      "title": "柱状图展示"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "car-echart"
  }, [_c('echarts', {
    style: (_vm.echarts_option.outOption.style),
    attrs: {
      "chart_id": "car-echart",
      "option": _vm.echarts_option.option
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.echarts_option) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "content-one"
  }, [_c('content-title', {
    attrs: {
      "title": "数据导出"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("数据存储")]), _vm._v(" "), _c('a', {
    staticClass: "checkbox-one",
    attrs: {
      "href": "javascript:;"
    }
  }, [(_vm.down1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(21),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.down1 = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.down1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.down1 = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.login === 1) ? _c('div', {
    staticClass: "checkbox-label"
  }, [_vm._v("\n              演示数据下载 "), (_vm.down1) ? _c('a', {
    staticClass: "output-btn",
    attrs: {
      "href": _vm.down1 ? '/static/演示数据.xlsx' : '',
      "download": "演示数据"
    },
    on: {
      "click": _vm.down
    }
  }, [_vm._v("导出到Excel")]) : _vm._e()]) : _c('div', {
    staticClass: "checkbox-label"
  }, [_vm._v("\n              演示数据下载 "), (_vm.down1) ? _c('a', {
    staticClass: "output-btn",
    attrs: {
      "download": "演示数据"
    },
    on: {
      "click": _vm.goLgin
    }
  }, [_vm._v("导出到Excel")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("case存储")]), _vm._v(" "), _vm._l((_vm.outPutWays), function(outPutWayData) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.activeOutPutWayKey = outPutWayData.key
        }
      }
    }, [(outPutWayData.key === _vm.activeOutPutWayKey) ? _c('img', {
      attrs: {
        "src": __webpack_require__(21),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(22),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n              " + _vm._s(outPutWayData.name) + "\n            ")])])
  }), _vm._v(" "), (this.activeCase.status) ? _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showEditName = true
      }
    }
  }, [_vm._v("存 储")]) : _vm._e()], 2)])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "系统提醒",
      "visible": _vm.showEditName,
      "size": "tiny",
      "before-close": _vm.close
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditName = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.caseName),
      callback: function($$v) {
        _vm.caseName = $$v
      },
      expression: "caseName"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("Case Name")])], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(this.activeCase.status) ? _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showEditName = false;
        _vm.saveCase()
      }
    }
  }, [_vm._v("存 储")]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1rem",
      "display": "flex"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "配送中心"
    },
    model: {
      value: (_vm.car_center),
      callback: function($$v) {
        _vm.car_center = $$v
      },
      expression: "car_center"
    }
  }, _vm._l((_vm.pszxDatas), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "车轴筛选"
    },
    model: {
      value: (_vm.axle_key),
      callback: function($$v) {
        _vm.axle_key = $$v
      },
      expression: "axle_key"
    }
  }, _vm._l((_vm.AXLE_LIST), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('div', [_c('el-input', {
    attrs: {
      "placeholder": "请输入车牌号"
    },
    model: {
      value: (_vm.s_car_id),
      callback: function($$v) {
        _vm.s_car_id = $$v
      },
      expression: "s_car_id"
    }
  })], 1), _vm._v(" "), (_vm.showQiandao) ? _c('div', {
    staticClass: "file-input"
  }, [_c('span', {
    staticStyle: {
      "color": "#777",
      "font-size": "1rem",
      "margin-right": "1rem"
    }
  }, [_vm._v("导入签到")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file-4"
    },
    on: {
      "change": _vm.qdFileChange
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": "车辆管理",
      "actions": _vm.titleAction
    },
    on: {
      "clickMenu": _vm.clickTitleMenu
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "output-content"
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.searchCar(),
      "table_actions": _vm.table_actions,
      "table_style": 2,
      "ths": _vm.ths,
      "show_checkbox": _vm.showQiandao
    },
    on: {
      "clickTdBtn": _vm.clickTdBtn
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isNew ? '新增车辆' : '修改车辆',
      "visible": _vm.showAdd
    },
    on: {
      "update:visible": function($event) {
        _vm.showAdd = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("车牌号")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "disabled": !_vm.isNew,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['车牌号']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '车牌号', $$v)
      },
      expression: "carMap['车牌号']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("配送中心")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['配送中心']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '配送中心', $$v)
      },
      expression: "carMap['配送中心']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("承运商")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['承运商']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '承运商', $$v)
      },
      expression: "carMap['承运商']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("牵引车")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['牵引车']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '牵引车', $$v)
      },
      expression: "carMap['牵引车']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("车辆轴数")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.carMap['车辆轴数']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '车辆轴数', $$v)
      },
      expression: "carMap['车辆轴数']"
    }
  }, _vm._l((_vm.AXLE_LIST.slice(0, -1)), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("停车点")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.carMap['停车油库代码']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '停车油库代码', $$v)
      },
      expression: "carMap['停车油库代码']"
    }
  }, _vm._l((_vm.depotList), function(item) {
    return _c('el-option', {
      key: item['油库代码'],
      attrs: {
        "label": item['油库名称'],
        "value": item['油库代码']
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("驾驶员")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.carMap['司机']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '司机', $$v)
      },
      expression: "carMap['司机']"
    }
  }, _vm._l((_vm.driver_list), function(item, index) {
    return _c('el-option', {
      key: item['姓名'] + index,
      attrs: {
        "label": item['姓名'],
        "value": item['姓名']
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("道路运输证准运油品")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.carMap['道路运输证准运油品']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '道路运输证准运油品', $$v)
      },
      expression: "carMap['道路运输证准运油品']"
    }
  }, _vm._l((['汽油', '柴油']), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("电子运单装载油品")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.carMap['电子运单装载油品']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '电子运单装载油品', $$v)
      },
      expression: "carMap['电子运单装载油品']"
    }
  }, _vm._l((['汽油', '柴油']), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("合计")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['合计']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '合计', $$v)
      },
      expression: "carMap['合计']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("前仓")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['前仓']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '前仓', $$v)
      },
      expression: "carMap['前仓']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("中仓")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['中仓']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '中仓', $$v)
      },
      expression: "carMap['中仓']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("后仓")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['后仓']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '后仓', $$v)
      },
      expression: "carMap['后仓']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("通行证")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.carMap['通行证']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '通行证', $$v)
      },
      expression: "carMap['通行证']"
    }
  }, _vm._l((_vm.PASS_LIST), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showAdd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveCar
    }
  }, [_vm._v("保 存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "油品变更",
      "visible": _vm.showChange
    },
    on: {
      "update:visible": function($event) {
        _vm.showChange = $event
      }
    }
  }, [(Number(_vm.carMap['更改油品']) === 1) ? _c('div', {
    staticClass: "case-form"
  }, [_c('span', [_vm._v("油品已变更，变更信息如下")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "case-form"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("车牌号")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "disabled": !_vm.isNew,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.changeOil['车牌号']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '车牌号', $$v)
      },
      expression: "changeOil['车牌号']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("更改油品")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.changeOil['更改油品']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '更改油品', $$v)
      },
      expression: "changeOil['更改油品']"
    }
  }, _vm._l((['汽油', '柴油']), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("实际油品容积和")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.changeOil['实际油品容积和']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '实际油品容积和', $$v)
      },
      expression: "changeOil['实际油品容积和']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("前仓")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.changeOil['前仓']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '前仓', $$v)
      },
      expression: "changeOil['前仓']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("中仓")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.changeOil['中仓']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '中仓', $$v)
      },
      expression: "changeOil['中仓']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("后仓")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.changeOil['后仓']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '后仓', $$v)
      },
      expression: "changeOil['后仓']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("品名变更记录")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.changeOil['品名变更记录']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '品名变更记录', $$v)
      },
      expression: "changeOil['品名变更记录']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showChange = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (Number(_vm.carMap['更改油品']) === 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delChangeCarOilType
    }
  }, [_vm._v("取消变更")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setCarOilType
    }
  }, [_vm._v("确定变更")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.carMap['车牌号'] + ' >>> 限制可配送油站',
      "visible": _vm.showGasXz
    },
    on: {
      "update:visible": function($event) {
        _vm.showGasXz = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form xz-gas"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("可配送油站")]), _vm._v(" "), _c('div', {
    staticClass: "gas-list"
  }, [(!_vm.xzGasList || _vm.xzGasList.length === 0) ? _c('strong', [_vm._v("没有可配送油站限制")]) : _vm._l((_vm.xzGasList), function(data) {
    return _c('span', [_vm._v(_vm._s(data['加油站名称'])), _c('i', {
      staticClass: "icon-105 iconfont",
      on: {
        "click": function($event) {
          _vm.delXzGas(data)
        }
      }
    })])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "case-form"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("添加油站")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.selectGas),
      callback: function($$v) {
        _vm.selectGas = $$v
      },
      expression: "selectGas"
    }
  }, _vm._l((_vm.gasList), function(item) {
    return _c('el-option', {
      key: item['油站代码'],
      attrs: {
        "label": item['加油站名称'],
        "value": item
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "case-form",
    staticStyle: {
      "color": "#888",
      "font-size": "1rem"
    }
  }, [_c('span', [_vm._v("添加可配送油站后，该车辆只能配送指定加油站。")])]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showGasXz = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setGasXz
    }
  }, [_vm._v("保存限制")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.showDel,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDel = $event
      }
    }
  }, [_c('span', [_vm._v("你确定删除该车辆吗？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDel = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delCar
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.showCheckData,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.showCheckData = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingWarning),
      expression: "loadingWarning"
    }]
  }, [(_vm.warningDataWqd.length > 0) ? _c('content-title', {
    attrs: {
      "title": "未签到异常车辆"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.warningDataWqd.length > 0) ? _c('div', {
    staticClass: "output-content"
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.warningDataWqd,
      "table_style": 2,
      "ths": _vm.thsW
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.warningDataQd.length > 0) ? _c('content-title', {
    attrs: {
      "title": "已签到异常车辆"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.warningDataQd.length > 0) ? _c('div', {
    staticClass: "output-content"
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.warningDataQd,
      "table_style": 2,
      "ths": _vm.thsW
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showCheckData = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.showQdError
    },
    on: {
      "update:visible": function($event) {
        _vm.showQdError = $event
      }
    }
  }, [_c('div', [_c('content-title', {
    attrs: {
      "title": "导入文件签到异常数据"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.errorData,
      "table_style": 2,
      "ths": _vm.thsE
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showQdError = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('page_head', {
    staticClass: "page-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('left_bar'), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('loading')], 1)
},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "content-one"
  }, [_c('content-title', {
    attrs: {
      "title": "数据源"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("数据导入")]), _vm._v(" "), _vm._l((_vm.importWays), function(wayData) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.activeImportWayKey = wayData.key
        }
      }
    }, [(wayData.key === _vm.activeImportWayKey) ? _c('img', {
      attrs: {
        "src": __webpack_require__(21),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(22),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n              " + _vm._s(wayData.name) + "\n            ")]), _vm._v(" "), (wayData.key === 'local_file' && wayData.key === _vm.activeImportWayKey) ? _c('input', {
      staticStyle: {
        "margin-left": "4rem"
      },
      attrs: {
        "type": "file",
        "id": "file-1"
      },
      on: {
        "change": _vm.importf
      }
    }) : _vm._e(), _vm._v(" "), (wayData.key === 'local_file' && wayData.key === _vm.activeImportWayKey) ? _c('a', {
      staticClass: "output-btn-sm",
      attrs: {
        "href": "/static/ele_demo.xlsx",
        "download": "演示数据"
      }
    }, [_vm._v("演示数据下载")]) : _vm._e()])
  }), _vm._v(" "), _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goSourceDataPage
    }
  }, [_vm._v("导入")])], 2)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page"
  }, [_c('div', {
    staticClass: "error-content-block"
  }, [_c('div', {
    staticClass: "error-content"
  }, [_c('i', {
    staticClass: "iconfont icon-caution"
  }), _vm._v(" "), _c('span', [_vm._v("温馨提示"), _c('br'), _vm._v("请先导入数据")])])])])
}]}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v prediction-car-page"
  }, [_c('div', {
    staticClass: "two-content"
  }, [_c('div', {
    staticClass: "content-1-1 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": '每日订单（' + _vm.preDay + '）'
    }
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("订单名称")]), _vm._v(" "), _vm._l((_vm.ths), function(th) {
    return _c('th', [_vm._v(_vm._s(th.label))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.showData.slice(_vm.start_index, _vm.start_index + _vm.row_num)), function(data, index) {
    return _c('tr', [_c('td', {
      class: {
        's-bak-td': index % 3 === 1
      },
      staticStyle: {
        "width": "8em"
      }
    }, [_vm._v(_vm._s('订单' + (_vm.start_index + index + 1)))]), _vm._v(" "), _vm._l((_vm.ths), function(th) {
      return _c('td', {
        class: {
          's-bak-td': index % 3 === 1, 'td-station': th.label === '油库'
        }
      }, [_c('span', [_vm._v(_vm._s(data[th.key]))])])
    })], 2)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "content-1-page"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "total": _vm.showData.length,
      "page-sizes": [3, 7, 20, 50],
      "page-size": _vm.row_num,
      "layout": "sizes, prev, pager, next"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.pageChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-1-2 mii-table"
  }, [_c('div', {
    staticClass: "table-tool"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daochu",
    on: {
      "click": _vm.clickOutPutFileIcon
    }
  })])]), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": "运送车辆"
    }
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.ths2), function(th) {
    return _c('th', [_vm._v(_vm._s(th.label))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.showData.slice(_vm.start_index, _vm.start_index + _vm.row_num)), function(data, index) {
    return _c('tr', _vm._l((_vm.ths2), function(th) {
      return _c('td', {
        class: {
          's-bak-td': index % 3 === 1
        },
        staticStyle: {
          "position": "relative"
        }
      }, [_c('span', [_vm._v(_vm._s(th.key === '在途时间' ? String(data[th.key]).slice(0, 4) : data[th.key]))])])
    }))
  }))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "chat-title"
  }, [_vm._v("\n      图表展示\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "chat-block"
  }, [_c('div', {
    staticClass: "chat-content"
  }, [_c('div', {
    staticClass: "chat-y"
  }, [_c('div', {
    staticClass: "chat-y-line"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.charData), function(data) {
    return _c('div', {
      staticClass: "one-y"
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "chat-y-data"
  }, _vm._l((_vm.charData), function(data) {
    return _c('div', {
      staticClass: "data-one"
    }, [_c('div', {
      staticClass: "data-xian data-first-xian",
      style: (data.style1)
    }, [_c('div', {
      staticClass: "data-none"
    })]), _vm._v(" "), _c('div', {
      staticClass: "data-xian"
    }, [_c('div', {
      staticClass: "data-num data-brn"
    }, [_c('div', {
      staticClass: "data-brn-note"
    }, [_vm._v("\n                    不容纳时间点"), _c('br'), _vm._v("\n                    " + _vm._s(data.brn_date) + "\n                  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "data-xian data-xian-sned"
    }, [_c('div', {
      staticClass: "data-num data-send"
    }, [_c('div', {
      staticClass: "data-brn-note"
    }, [_vm._v("\n                    不容纳时间点 - 断货时间点"), _c('br'), _vm._v("\n                    " + _vm._s(data.brn_date) + " - " + _vm._s(data.dh_date) + "\n                  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "data-xian"
    }, [_c('div', {
      staticClass: "data-num data-dh"
    }, [_c('div', {
      staticClass: "data-brn-note"
    }, [_vm._v("\n                    断货时间点"), _c('br'), _vm._v("\n                    " + _vm._s(data.dh_date) + "\n                  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "data-xian",
      style: (data.style2)
    }, [_c('div', {
      staticClass: "data-none"
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "car-data"
  }, _vm._l((_vm.showData.slice(_vm.start_index, _vm.start_index + _vm.row_num)), function(data, index) {
    return _c('div', {
      staticClass: "one-car-data"
    }, [_vm._v("\n              " + _vm._s(data['车牌号']) + "\n            ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "chat-x"
  }, [_c('div', {
    staticClass: "one-x"
  }, [_vm._v("\n            " + _vm._s(_vm.dateList[0].slice(5)) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "one-x"
  }, [_vm._v("\n            " + _vm._s(_vm.dateList[1].slice(5)) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "one-x one-x-last"
  }, [_vm._v("\n            " + _vm._s(_vm.dateList[2].slice(5)) + "\n          ")]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "y-top-note",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('span', {}, [_vm._v("订单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('span', {
    staticClass: "y-top-note"
  }, [_vm._v("时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-info"
  }, [_c('div', {
    staticClass: "one-info"
  }, [_c('div', {
    staticClass: "dian dian-1"
  }), _vm._v(" "), _c('span', [_vm._v("可送货窗口")])]), _vm._v(" "), _c('div', {
    staticClass: "one-info"
  }, [_c('div', {
    staticClass: "dian dian-2"
  }), _vm._v(" "), _c('span', [_vm._v("不容纳缓冲")])]), _vm._v(" "), _c('div', {
    staticClass: "one-info"
  }, [_c('div', {
    staticClass: "dian dian-3"
  }), _vm._v(" "), _c('span', [_vm._v("断货缓冲")])])])
}]}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1rem",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#666",
      "margin-right": "0.5rem",
      "line-height": "2rem"
    }
  }, [_vm._v("未核销")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.hxStatus),
      callback: function($$v) {
        _vm.hxStatus = $$v
      },
      expression: "hxStatus"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "this-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.sysHx
    }
  }, [_vm._v("系统核销")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingHxJxc || _vm.loadingSysHx),
      expression: "loadingHxJxc || loadingSysHx"
    }],
    staticClass: "content-one"
  }, [_c('content-title', {
    attrs: {
      "title": '进销存核销 ' + _vm.hxDate
    }
  }), _vm._v(" "), _c('mii-base-table', {
    attrs: {
      "datas": _vm.waitHxList,
      "table_style": 1,
      "ths": _vm.ths,
      "table_actions": _vm.tbAction,
      "lineQF": true
    },
    on: {
      "clickTdBtn": _vm.clickTdBtn
    }
  })], 1), _vm._v(" "), (_vm.hxJxc) ? _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingUserHx || _vm.loadingCanHxPsjh),
      expression: "loadingUserHx || loadingCanHxPsjh"
    }],
    attrs: {
      "title": _vm.hxDate + ' -- ' + _vm.hxJxc['加油站名称'] + ' -- ' + _vm.hxJxc['油品名称'] + ' -- 入库' + _vm.hxJxc['入库升数'],
      "visible": _vm.showHeXiao
    },
    on: {
      "update:visible": function($event) {
        _vm.showHeXiao = $event
      }
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.canHxPsjhList,
      "table_style": 2,
      "ths": _vm.thsPs,
      "show_checkbox": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showHeXiao = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.userHxjxc
    }
  }, [_vm._v("保 存")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v prediction-page"
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('div', {
    staticClass: "gu-duan"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择加油站"
    },
    model: {
      value: (_vm.oilStation),
      callback: function($$v) {
        _vm.oilStation = $$v
      },
      expression: "oilStation"
    }
  }, _vm._l((_vm.predictionGasList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "content-1-tables"
  }, [_c('div', {
    staticClass: "content-1-table-1 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": "进销存数据"
    }
  }), _vm._v(" "), _c('mii-base-table2', {
    attrs: {
      "datas": _vm.showData,
      "rowDef": true,
      "ths": _vm.jxcThs
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-1-table-2 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": "预测结果"
    }
  }), _vm._v(" "), _c('mii-base-table2', {
    attrs: {
      "datas": _vm.showData,
      "rowDef": true,
      "ths": _vm.jxcThs2
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "content-2-table mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": '每日订单 ' + _vm.preDay,
      "actions": _vm.actions
    },
    on: {
      "clickMenu": _vm.clickMenu
    }
  }), _vm._v(" "), _c('mii-base-table2', {
    attrs: {
      "datas": _vm.preDayData,
      "ths": _vm.jxcThs3,
      "scroll_table": true
    }
  })], 1), _vm._v(" "), (_vm.showNote) ? _c('div', {
    staticClass: "content-2-note"
  }, [_vm._v("\n      日销量预测分析步骤："), _c('br'), _vm._v("\n      1.时间趋势检验：通过线图以及Dickey-Fuller对数据进行检验，如果时间趋势不稳定，则需要对数据进行分解和转换。"), _c('br'), _vm._v("\n      2.自相关，偏相关函数分析，选择匹配时间序列数据的模型 - ARIMA"), _c('br'), _vm._v("\n      3.模型拟合以及检验：用RStudio中tseries已经forecast程序包进行分析，检验和预测。模型检验参数赤池信息法(AIC)，贝叶斯信息法(BIC)数值最终用来判断模型的拟合。"), _c('br'), _vm._v("\n      断货时间点预测:"), _c('br'), _vm._v("\n      我们针对5个加油站(昭通昭阳元宝山加油站，昭通昭阳头道沟加油站，昆明安宁丰营加油站，昆明西山照壁加油站，玉溪易门蒲贝加油站)，利用其20天的历史数据，运用上述分析方法，预测出之后三天内的订单情况。"), _c('br'), _vm._v("\n      订单紧急程度划分说明："), _c('br'), _vm._v("\n      1.可配送订单：24小时<断货时间点≤48小时；"), _c('br'), _vm._v("\n      1.紧急订单：断货时间点≤24小时。\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-2-btn"
  }, [_c('div', {
    staticClass: "btn-top-jiao"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showNote = !_vm.showNote
      }
    }
  }, [_vm._v("预"), _c('br'), _vm._v("测"), _c('br'), _vm._v("分"), _c('br'), _vm._v("析"), _c('br'), _vm._v("方"), _c('br'), _vm._v("法")]), _vm._v(" "), _c('div', {
    staticClass: "btn-bottom-jiao"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "content-3-table mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": '小罐多销加油站'
    }
  }), _vm._v(" "), _c('mii-base-table2', {
    attrs: {
      "datas": _vm.dxData,
      "ths": _vm.jxcThs4,
      "scroll_table": true
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mii-table",
    class: {
      'mii-table-1': _vm.style === 1, 'mii-table-2': _vm.style !== 1
    }
  }, [(_vm.output_file) ? _c('div', {
    staticClass: "table-tool"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-zhankai-copy",
    on: {
      "click": function($event) {
        _vm.scroll_table_2 = !_vm.scroll_table_2
      }
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daochu",
    on: {
      "click": _vm.optPutFile
    }
  })])]) : _vm._e(), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('table', {
    class: {
      'table-style-1': _vm.table_style === 1 && !_vm.one_row, 'table-style-2': _vm.table_style !== 1 && !_vm.one_row, 'one-row': _vm.one_row, 'scroll-table': _vm.scroll_table_2
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.ths), function(th) {
    return _c('th', [_vm._v(_vm._s(th.label))])
  }))]), _vm._v(" "), _c('tbody', {
    style: (_vm.table_style_height)
  }, _vm._l(((_vm.show_pagination ? (_vm.datas || []).slice(_vm.start_index, _vm.start_index + this.row_num) : (_vm.datas || []))), function(data, index) {
    return _c('tr', {
      staticStyle: {
        "overflow": "auto",
        "max-height": "20rem"
      }
    }, _vm._l((_vm.ths), function(th, index2) {
      return _c('td', {
        on: {
          "dblclick": function($event) {
            _vm.startEdit(index, th.key, data[th.key], data[_vm.ths[0].key])
          }
        }
      }, [(index2 !== 0 && _vm.canEdit && index === _vm.edit_value.column && th.key === _vm.edit_value.key) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.new_value),
          expression: "new_value"
        }],
        attrs: {
          "name": "",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.new_value)
        },
        on: {
          "blur": _vm.save,
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.new_value = $event.target.value
          }
        }
      }) : _c('div', {
        domProps: {
          "innerHTML": _vm._s(data[th.key])
        }
      })])
    }))
  }))]), _vm._v(" "), (_vm.show_pagination) ? _c('div', {
    staticClass: "pagination-table"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "page-size": _vm.row_num,
      "total": (_vm.datas || []).length
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-page"
  }, [_c('div', {
    staticClass: "register-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.name),
      expression: "info.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的姓名"
    },
    domProps: {
      "value": (_vm.info.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.phone),
      expression: "info.phone"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "请输入您的电话"
    },
    domProps: {
      "value": (_vm.info.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.email),
      expression: "info.email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的邮箱"
    },
    domProps: {
      "value": (_vm.info.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.unit),
      expression: "info.unit"
    }],
    attrs: {
      "type": "text",
      "placeholder": "所在单位/学校名"
    },
    domProps: {
      "value": (_vm.info.unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.job),
      expression: "info.job"
    }],
    attrs: {
      "type": "text",
      "placeholder": "职位"
    },
    domProps: {
      "value": (_vm.info.job)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "job", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.password),
      expression: "info.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请填写6-12位密码"
    },
    domProps: {
      "value": (_vm.info.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.rePassword),
      expression: "info.rePassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请重新输入您的密码"
    },
    domProps: {
      "value": (_vm.info.rePassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "rePassword", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "other-option"
  }, [_c('div', {
    staticClass: "left-content"
  }), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("登录")]), _c('a', [_vm._v("|")]), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("注册")])])]), _vm._v(" "), _c('a', {
    staticClass: "form-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("\n      现在注册\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(278),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "one-content"
  }, [_c('content-title', {
    attrs: {
      "title": "模型参数设定"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setting-content"
  }, [_c('div', {
    staticClass: "model-setting"
  }, [_c('div', {
    staticClass: "one-model-setting"
  }, [_c('span', [_vm._v("车辆数")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.groupsNum),
      callback: function($$v) {
        _vm.groupsNum = $$v
      },
      expression: "groupsNum"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("辆")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "one-model-setting"
  }, [_c('span', [_vm._v("每个群主最大客户数")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.maxCustomersNum),
      callback: function($$v) {
        _vm.maxCustomersNum = $$v
      },
      expression: "maxCustomersNum"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("个")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "one-model-setting"
  }, [_c('span', [_vm._v("车辆调度模型的TimeLimit")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.groupTimeLimit),
      callback: function($$v) {
        _vm.groupTimeLimit = $$v
      },
      expression: "groupTimeLimit"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("秒")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "one-model-setting"
  }, [_c('span', [_vm._v("车辆调度模型的MIPGap")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.groupMipGap),
      callback: function($$v) {
        _vm.groupMipGap = $$v
      },
      expression: "groupMipGap"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(" % ")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "one-model-setting one-model-last"
  }, [_c('span', [_vm._v("路径规划模型的TimeLimit")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.routeTimeLimit),
      callback: function($$v) {
        _vm.routeTimeLimit = $$v
      },
      expression: "routeTimeLimit"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("秒")])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }, [_c('a', {
    staticClass: "show-note",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.show_note = !_vm.show_note
      }
    }
  }, [_vm._v(_vm._s(_vm.show_note ? '隐藏解析' : '显示解析'))])]), _vm._v(" "), _c('div', {
    staticClass: "setting-note"
  }, [(_vm.show_note) ? _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [
    [_c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.setting_note)
      }
    }), _vm._v(" "), _vm._l((_vm.notes), function(note) {
      return _c('li', [_vm._v(_vm._s(note))])
    })], 2)]
  ], 2) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "gu-duan"
  }), _vm._v(" "), _c('div', {
    staticClass: "two-content"
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('content-title', {
    attrs: {
      "title": "求解日期选择"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("该系统解决的是单日的配送问题，所以请选择所要查看配送安排的日期。")]), _vm._v(" "), _vm._l((_vm.solutionWeeks), function(week, index) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.solutionStatus > 20 ? null : _vm.solutionDay = index
        }
      }
    }, [(_vm.solutionDay === index) ? _c('img', {
      attrs: {
        "src": __webpack_require__(21),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.solutionDay !== index) ? _c('img', {
      attrs: {
        "src": __webpack_require__(22),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n            " + _vm._s(week) + "\n          ")])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "4em"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-1"
  }, [_c('content-title', {
    attrs: {
      "title": "求解器选择"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-content"
  }, _vm._l((_vm.solutionWays), function(type, index) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.solutionStatus > 20 ? null : _vm.solutionWay = index
        }
      }
    }, [(_vm.solutionWay === index) ? _c('img', {
      attrs: {
        "src": __webpack_require__(21),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.solutionWay !== index) ? _c('img', {
      attrs: {
        "src": __webpack_require__(22),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n            " + _vm._s(type) + "\n          ")])])
  }))], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "head-menus-div"
  }, [_c('div', {
    staticClass: "head-menus"
  }, [_c('div', {
    staticClass: "menu-2 menu-index"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, [(_vm.eleStatus > 0) ? _c('router-link', {
    key: "o1",
    staticClass: "menu-one",
    class: {
      'active-menu-one': _vm.path === '/electricity/ele_source_data'
    },
    attrs: {
      "to": "/electricity/ele_source_data"
    }
  }, [_vm._v("源数据")]) : _vm._e(), _vm._v(" "), (_vm.eleStatus > 1) ? _c('router-link', {
    key: "o2",
    staticClass: "menu-one",
    class: {
      'active-menu-one': _vm.path === '/electricity/ele_case'
    },
    attrs: {
      "to": "/electricity/ele_case"
    }
  }, [_vm._v("方案")]) : _vm._e(), _vm._v(" "), (_vm.eleStatus > 1) ? _c('router-link', {
    key: "o3",
    staticClass: "menu-one",
    class: {
      'active-menu-one': _vm.path === '/electricity/ele_result'
    },
    attrs: {
      "to": "/electricity/ele_result"
    }
  }, [_vm._v("结果")]) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "head-user"
  }, [(_vm.login) ? _c('div', {
    staticClass: "user-info"
  }, [_c('i', {
    staticClass: "iconfont icon-user"
  }), _vm._v(" "), _c('div', {
    staticClass: "fg-line-2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.loginOut
    }
  }, [_vm._v("安全退出")])]) : _c('div', {
    staticClass: "user-info"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("登录")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.path) + "\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "head-logo",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticClass: "logo-100",
    attrs: {
      "src": __webpack_require__(886),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "oil-chart",
    class: {
      'hs-oil-chart': !_vm.horizontalScreen
    }
  }, [_c('div', {
    staticClass: "top-content content-all-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "chart-content top-left"
  }, [_c('echarts', {
    attrs: {
      "chart_id": "top-left",
      "option": _vm.topLeftChartOption
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "zhong-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "chart-content top-right"
  }, [_c('echarts', {
    attrs: {
      "chart_id": "top-right",
      "option": _vm.topRightChartOption
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tr-le"
  }, _vm._l((_vm.leDatas), function(item, index) {
    return _c('div', {
      staticClass: "le-one"
    }, [_c('div', {
      staticClass: "kuai-l",
      style: (_vm.colors[index % 3])
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item))])])
  }))], 1)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "bottom-content"
  }, [_c('div', {
    staticClass: "content-all-block bottom-left"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content-block title-chart-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('echarts', {
    attrs: {
      "chart_id": "bottom-left",
      "option": _vm.bottomLeftChartOption
    }
  })], 1)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "switch-map-btn"
  }, [_c('div', {
    staticClass: "top-j"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn-content",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.change
    }
  }, [_c('i', {
    staticClass: "iconfont icon-you"
  }), _vm._v("\n          切换到地图\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-j"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-all-block bottom-right"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "chart-content title-chart-content",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('echarts', {
    attrs: {
      "chart_id": "bottom-right-1",
      "option": _vm.bottomRightChartOption1
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chart-content title-chart-content last-chart",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('echarts', {
    attrs: {
      "chart_id": "bottom-right-2",
      "option": _vm.bottomRightChartOption2
    }
  })], 1)])]), _vm._v(" "), _vm._m(8)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-title"
  }, [_c('div', {
    staticClass: "xie-line"
  }), _vm._v(" "), _c('span', [_vm._v("油 库")]), _vm._v(" "), _c('div', {
    staticClass: "xie-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-other"
  }, [_c('div', {
    staticClass: "jiao"
  }), _vm._v(" "), _c('div', {
    staticClass: "cfx"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-bottom"
  }, [_c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-title"
  }, [_c('div', {
    staticClass: "xie-line"
  }), _vm._v(" "), _c('span', {
    staticClass: "t-z"
  }, [_vm._v("加油站")]), _vm._v(" "), _c('div', {
    staticClass: "xie-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-other"
  }, [_c('div', {
    staticClass: "jiao"
  }), _vm._v(" "), _c('div', {
    staticClass: "cfx"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-title"
  }, [_c('div', {
    staticClass: "title-block"
  }, [_c('span', [_vm._v("小罐多销油站")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-bottom"
  }, [_c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-title"
  }, [_c('div', {
    staticClass: "xie-line"
  }), _vm._v(" "), _c('span', [_vm._v("车辆")]), _vm._v(" "), _c('div', {
    staticClass: "xie-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-other"
  }, [_c('div', {
    staticClass: "jiao"
  }), _vm._v(" "), _c('div', {
    staticClass: "cfx"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-title"
  }, [_c('div', {
    staticClass: "title-block"
  }, [_c('span', [_vm._v("出 车 距 离")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-title"
  }, [_c('div', {
    staticClass: "title-block"
  }, [_c('span', [_vm._v("出 车 数 量")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-bottom"
  }, [_c('div')])
}]}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-bar",
    class: {
      'big-bar': _vm.big_size, 'sm-bar': !_vm.big_size
    }
  }, [_vm._l((_vm.menus), function(menu, index) {
    return _c('a', {
      staticClass: "one-bar",
      class: {
        'active-bar': _vm.active_index === index
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.clickMenuF(menu.key, index)
        }
      }
    }, [_c('div', {
      staticClass: "bar-icon",
      class: {
        'sm-iconfont': !_vm.big_size
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: menu.icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "bar-leabel",
      class: {
        'big-bar-leabel': _vm.big_size, 'sm-bar-leabel': !_vm.big_size
      }
    }, [_vm._v("\n      " + _vm._s(menu.leabel) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "right-menu"
    }, _vm._l((menu.children), function(data) {
      return _c('a', {
        staticClass: "children-menu",
        class: {
          'hide-bar': !data.active
        },
        attrs: {
          "href": "javascript:;"
        },
        domProps: {
          "innerHTML": _vm._s(data.leabel)
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.clickMenu(data.key, data.active, index)
          }
        }
      })
    }))])
  }), _vm._v(" "), _c('a', {
    staticClass: "one-bar",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goOther
    }
  }, [_c('div', {
    staticClass: "bar-icon",
    class: {
      'sm-iconfont': !_vm.big_size
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shishijiankong"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bar-leabel",
    class: {
      'big-bar-leabel': _vm.big_size, 'sm-bar-leabel': !_vm.big_size
    }
  }, [_vm._v("\n      实时监控\n    ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.path) + _vm._s(_vm.solutionStatus) + _vm._s(_vm.preStatus))])], 2)
},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "content-one"
  }, [_c('content-title', {
    attrs: {
      "title": "数据源"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("当前数据选择")]), _vm._v(" "), _vm._l((_vm.caseList), function(caseData) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.changeCase(caseData)
        }
      }
    }, [(_vm.activeCase.key === caseData.key) ? _c('img', {
      attrs: {
        "src": __webpack_require__(21),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(22),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n              " + _vm._s(caseData.name) + "\n            ")])])
  }), _vm._v(" "), (_vm.caseList.length === 0) ? _c('span', {
    staticClass: "app-note"
  }, [_vm._v("无可选case数据，请先导入！")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("数据导入")]), _vm._v(" "), _vm._l((_vm.importWays), function(wayData) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.activeImportWayKey = wayData.key
        }
      }
    }, [(wayData.key === _vm.activeImportWayKey) ? _c('img', {
      attrs: {
        "src": __webpack_require__(21),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(22),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n              " + _vm._s(wayData.name) + "\n            ")])])
  }), _vm._v(" "), _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.startImport(false)
      }
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "系统提醒",
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("当前case尚未存储，请确定是否丢弃该case。")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("返回存储")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false;
        _vm.startImport(true)
      }
    }
  }, [_vm._v("丢弃并导入")])], 1)])], 2)])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'scroll-table': _vm.scroll_table
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.ths), function(th) {
    return _c('th', [_vm._v(_vm._s(th.label))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.datas), function(data, index) {
    return _c('tr', _vm._l((_vm.ths), function(th) {
      return ((data[th.key] || {}).rowspan !== 0) ? _c('td', {
        class: {
          's-bak-td': _vm.rowDef && !(data[th.key] || {}).label && (index % 3 === 1)
        },
        style: (th.style ? th.style(data[th.key]) : {}),
        attrs: {
          "rowspan": (data[th.key] || {}).rowspan || 1
        }
      }, [_vm._v(_vm._s((data[th.key] || {}).label || data[th.key]))]) : _vm._e()
    }))
  }))]), _vm._v(" "), (_vm.page_parm) ? _c('div', {
    staticClass: "t-tfoot"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "page-size": _vm.page_parm.row_num,
      "total": _vm.page_parm.dataTotal
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "ele-case"
  }, [_c('div', {
    staticClass: "choose-cases"
  }, [_vm._l((_vm.casesEle), function(data) {
    return _c('a', {
      staticClass: "one-case",
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('div', {
      staticClass: "case-name"
    }, [_vm._v(_vm._s(data.name))]), _vm._v(" "), _c('div', {
      staticClass: "case-info"
    }, [_c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("天气")]), _c('span', [_vm._v(_vm._s(data.d1))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("光伏成本")]), _c('span', [_vm._v(_vm._s(data.d2))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("固定存储容量")]), _c('span', [_vm._v(_vm._s(data.d3))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("SOC下限")]), _c('span', [_vm._v(_vm._s(data.d4))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("SOC上限")]), _c('span', [_vm._v(_vm._s(data.d5))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("SOC初始值")]), _c('span', [_vm._v(_vm._s(data.d6))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("储能放电成本")]), _c('span', [_vm._v(_vm._s(data.d7))])])]), _vm._v(" "), _c('div', {
      staticClass: "case-checked",
      class: {
        'status-dh': data.status !== 30
      }
    }, [_c('span', {
      staticClass: "case-checked-text"
    }, [_vm._v("\n            " + _vm._s(_vm.status_text[String(data.status)]) + "\n          ")])])])
  }), _vm._v(" "), _c('a', {
    staticClass: "add-case",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.showAdd
    }
  }, [_c('i', {
    staticClass: "iconfont icon-addfriend"
  }), _c('span', [_vm._v("新增方案")])]), _vm._v(" "), _c('a', {
    staticClass: "add-case",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showImport = true
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daoru"
  }), _c('span', [_vm._v("导入方案")])])], 2)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增方案",
      "visible": _vm.addCase
    },
    on: {
      "update:visible": function($event) {
        _vm.addCase = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("方案名称")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.newCase.name),
      callback: function($$v) {
        _vm.$set(_vm.newCase, "name", $$v)
      },
      expression: "newCase.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("天气")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.newCase.d1),
      callback: function($$v) {
        _vm.$set(_vm.newCase, "d1", $$v)
      },
      expression: "newCase.d1"
    }
  }, _vm._l((_vm.weathers), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("光伏成本")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.newCase.d2),
      callback: function($$v) {
        _vm.$set(_vm.newCase, "d2", $$v)
      },
      expression: "newCase.d2"
    }
  }, _vm._l((_vm.datas1), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("固定存储容量")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.newCase.d3),
      callback: function($$v) {
        _vm.$set(_vm.newCase, "d3", $$v)
      },
      expression: "newCase.d3"
    }
  }, _vm._l((_vm.datas2), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("SOC下限")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.newCase.d4),
      callback: function($$v) {
        _vm.$set(_vm.newCase, "d4", $$v)
      },
      expression: "newCase.d4"
    }
  }, _vm._l((_vm.datas3), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("SOC上限")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.newCase.d5),
      callback: function($$v) {
        _vm.$set(_vm.newCase, "d5", $$v)
      },
      expression: "newCase.d5"
    }
  }, _vm._l((_vm.datas4), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("SOC初始值")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.newCase.d6),
      callback: function($$v) {
        _vm.$set(_vm.newCase, "d6", $$v)
      },
      expression: "newCase.d6"
    }
  }, _vm._l((_vm.datas5), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("储能放电成本")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.newCase.d7),
      callback: function($$v) {
        _vm.$set(_vm.newCase, "d7", $$v)
      },
      expression: "newCase.d7"
    }
  }, _vm._l((_vm.datas6), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addCase = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addNewCase
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导入方案",
      "visible": _vm.showImport,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showImport = $event
      }
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "small",
      "fill": "#324057",
      "text-color": "#a4aebd"
    },
    model: {
      value: (_vm.importCases),
      callback: function($$v) {
        _vm.importCases = $$v
      },
      expression: "importCases"
    }
  }, _vm._l((_vm.allSaveCasesName), function(data) {
    return _c('el-checkbox-button', {
      key: data,
      attrs: {
        "label": data,
        "disabled": _vm.testImported(data)
      }
    }, [_vm._v(_vm._s(data))])
  })), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showImport = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.importCase
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('page_head', {
    staticClass: "page-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('left_bar_ele'), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('loading')], 1)
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view', [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.notice) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-bar big-bar"
  }, [_vm._l((_vm.menus), function(menu, index) {
    return _c('a', {
      staticClass: "one-bar",
      class: {
        'active-bar': _vm.active_index === index
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.clickMenuF(menu.key, index)
        }
      }
    }, [_c('div', {
      staticClass: "bar-icon"
    }, [_c('i', {
      staticClass: "iconfont",
      class: menu.icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "bar-leabel big-bar-leabel"
    }, [_vm._v("\n      " + _vm._s(menu.leabel) + "\n    ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.path))])], 2)
},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('div', {
    staticClass: "gu-duan"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择加油站"
    },
    model: {
      value: (_vm.oilStation),
      callback: function($$v) {
        _vm.oilStation = $$v
      },
      expression: "oilStation"
    }
  }, _vm._l((_vm.oilStations), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "content-1-tables"
  }, [_c('div', {
    staticClass: "content-1-table-1 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": "进销存数据"
    }
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.showData), function(data, index) {
    return _c('tr', _vm._l((data.slice(0, 8)), function(value) {
      return (value.rowspan !== 0) ? _c('td', {
        class: {
          'data-td': !value.label, 's-bak-td': !value.label && (index % 3 === 1)
        },
        attrs: {
          "rowspan": value.rowspan || 1
        }
      }, [_vm._v(_vm._s(value.label || value))]) : _vm._e()
    }))
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-1-table-2 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": "预测结果"
    }
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.showData), function(data, index) {
    return _c('tr', _vm._l((data.slice(8)), function(value) {
      return (value.rowspan !== 0) ? _c('td', {
        class: {
          's-bak-td': !value.label && (index % 3 === 1)
        }
      }, [_vm._v(_vm._s(value.label || value))]) : _vm._e()
    }))
  }))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "content-2-table mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": '每日订单（' + _vm.day + '）'
    }
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.preDayData.slice(_vm.start_index, _vm.start_index + 10)), function(data, index) {
    return _c('tr', _vm._l((data.slice(1)), function(value) {
      return (value.rowspan !== 0) ? _c('td', {
        class: {
          'jj-bak-td': value === '紧急订单', 'ps-bak-td': value === '可配送订单'
        },
        attrs: {
          "rowspan": value.rowspan || 1
        }
      }, [_vm._v(_vm._s(value.label || value))]) : _vm._e()
    }))
  }))]), _vm._v(" "), _c('div', {
    staticClass: "content-2-page"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "page-size": _vm.row_num,
      "total": _vm.preDayData.length
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)], 1), _vm._v(" "), (_vm.showNote) ? _c('div', {
    staticClass: "content-2-note"
  }, [_vm._v("\n      日销量预测分析步骤："), _c('br'), _vm._v("\n      1.时间趋势检验：通过线图以及Dickey-Fuller对数据进行检验，如果时间趋势不稳定，则需要对数据进行分解和转换。"), _c('br'), _vm._v("\n      2.自相关，偏相关函数分析，选择匹配时间序列数据的模型 - ARIMA"), _c('br'), _vm._v("\n      3.模型拟合以及检验：用RStudio中tseries已经forecast程序包进行分析，检验和预测。模型检验参数赤池信息法(AIC)，贝叶斯信息法(BIC)数值最终用来判断模型的拟合。"), _c('br'), _vm._v("\n      订单紧急程度划分说明："), _c('br'), _vm._v("\n      1.可配送订单：24小时<断货时间点≤48小时；"), _c('br'), _vm._v("\n      1.紧急订单：断货时间点≤24小时。\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-2-btn"
  }, [_c('div', {
    staticClass: "btn-top-jiao"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showNote = !_vm.showNote
      }
    }
  }, [_vm._v("预"), _c('br'), _vm._v("测"), _c('br'), _vm._v("分"), _c('br'), _vm._v("析"), _c('br'), _vm._v("方"), _c('br'), _vm._v("法")]), _vm._v(" "), _c('div', {
    staticClass: "btn-bottom-jiao"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.preData) + "\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("店名")]), _vm._v(" "), _c('th', [_vm._v("商品")]), _vm._v(" "), _c('th', [_vm._v("时间")]), _vm._v(" "), _c('th', [_vm._v("期初库存")]), _vm._v(" "), _c('th', [_vm._v("入库量")]), _vm._v(" "), _c('th', [_vm._v("出库量")]), _vm._v(" "), _c('th', [_vm._v("期末库存")]), _vm._v(" "), _c('th', [_vm._v("空容")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("平均销量")]), _vm._v(" "), _c('th', [_vm._v("消耗率")]), _vm._v(" "), _c('th', [_vm._v("断货时间点")]), _vm._v(" "), _c('th', [_vm._v("在途时间(H)")]), _vm._v(" "), _c('th', [_vm._v("订单紧急程度")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("订单类型")]), _vm._v(" "), _c('th', [_vm._v("点名")]), _vm._v(" "), _c('th', [_vm._v("区域")]), _vm._v(" "), _c('th', [_vm._v("商品")]), _vm._v(" "), _c('th', [_vm._v("空容")]), _vm._v(" "), _c('th', [_vm._v("平均销量")]), _vm._v(" "), _c('th', [_vm._v("断货时间点")]), _vm._v(" "), _c('th', [_vm._v("在途时间(H)")])])])
}]}

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page-index"
  }, [_c('page_head', {
    staticClass: "page-top"
  }), _vm._v(" "), (_vm.path === '/') ? [_c('div', {
    staticClass: "top-img"
  }, [_c('div', {
    staticClass: "top-img-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "top-img-content-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.gowork
    }
  }, [_vm._v("\n        Have Fun\n      ")])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "index-content-3"
  }, [_c('div', {
    staticClass: "content-3-title"
  }, [_vm._v("\n      Mii-RO行业应用\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content-3-text"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(877)
    },
    on: {
      "click": _vm.goSingle
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "index-content-line"
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)] : _vm._e(), _vm._v(" "), _c('router-view')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(867),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(871),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-img-content-text"
  }, [_vm._v("\n        最大化企业利润的基础上"), _c('br'), _vm._v("\n        最优化管理库存和车队排"), _c('br'), _vm._v("\n        期调度\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-content-1"
  }, [_c('div', {
    staticClass: "content-1-title"
  }, [_vm._v("\n      专业 / 创新 / 前沿\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content-1-text"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(882),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(883),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(884),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-1-text content-1-text-2"
  }, [_c('div', [_vm._v("\n        专业的数据分析和"), _c('br'), _vm._v("数据优化建模团队\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        数据源的整合、网络规划"), _c('br'), _vm._v("实时监控\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        互联网开放团队，炫酷UI设计"), _c('br'), _vm._v("厚实高效的算法引擎\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-content-2"
  }, [_c('div', {
    staticClass: "content-2-title"
  }, [_vm._v("\n      Mii-RO亮点是什么？\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content-2-text"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "55.2em"
    },
    attrs: {
      "src": __webpack_require__(868),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "conten-2-right"
  }, [_c('div', {
    staticClass: "conten-2-right-c"
  }, [_c('div', {
    staticClass: "img-text"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(870),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("强大的优化算法引擎")])]), _vm._v(" "), _c('strong', [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "img-text"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(869),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("前沿的用户界面体验")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(872),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(873),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(874),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(875),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(876),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-content-4"
  }, [_c('div', {
    staticClass: "content-4-title"
  }, [_vm._v("\n      Mii-RO鲁棒功能组合\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text"
  }, [_c('div', {
    staticClass: "content-4-text-c"
  }, [_c('div', {
    staticClass: "content-4-text-title"
  }, [_c('div', [_c('span', {
    staticClass: "big-text"
  }, [_vm._v("VRPTW")]), _vm._v("(VRP with time window)")])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-note"
  }, [_vm._v("\n          即带有时间窗的车辆路径问题。每个客户都可以有对应的要求送达时间窗口，时间窗口可以多个。由于客户数比较多，我们会先把客户分组，然后对每个组求解路径规划模型。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(878),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-c"
  }, [_c('div', {
    staticClass: "content-4-text-title"
  }, [_c('div', [_c('span', {
    staticClass: "big-text"
  }, [_vm._v("MDVRP")]), _vm._v("(Mulit-Depot VRP)")])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-note"
  }, [_vm._v("\n          即多个仓库的车辆路径问题。同样的货物可以在多个仓库获取，自动分配最优的选择给客户。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(879),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text"
  }, [_c('div', {
    staticClass: "content-4-text-c"
  }, [_c('div', {
    staticClass: "content-4-text-title"
  }, [_c('div', [_c('span', {
    staticClass: "big-text"
  }, [_vm._v("Heterogeneous Fleet VRP")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-note content-4-text-note-2"
  }, [_vm._v("\n          即多种车型的车辆路径问题。"), _c('br'), _c('br'), _vm._v("\n          例如："), _c('br'), _vm._v("\n          重型货车指汽车总质量在12吨以上，车长6米以上。"), _c('br'), _vm._v("\n          中型货车指汽车总质量大于4.5吨、小于12吨，车长小于6米。"), _c('br'), _vm._v("\n          轻型货车指汽车总质量小于等于4.5吨，车长小于6米。"), _c('br'), _vm._v("\n          微型货车指总质量小于1.8吨，车长小于等于3.56米的货车。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(880),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-c"
  }, [_c('div', {
    staticClass: "content-4-text-title"
  }, [_c('div', [_c('span', {
    staticClass: "big-text"
  }, [_vm._v("IRP")]), _vm._v("(Inventory Routing Problem)")])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-note content-4-text-note-2"
  }, [_vm._v("\n          即与库存结合的车辆路径问题。与客户库存管理结合的补货配送问题，自动生成配送订单，匹配配送车辆，用最优的配送方案，保证客户的库存 在指定范围内。"), _c('br'), _vm._v("\n          例如："), _c('br'), _vm._v("\n          车容量：13t"), _c('br'), _vm._v("\n          客户A：最大库存量8t        每天销量：8t"), _c('br'), _vm._v("\n          客户B：最大库存量10t       每天销量：5t\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(881),
      "alt": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-content-5"
  }, [_c('div', {
    staticClass: "index-content-5-text"
  }, [_c('div', {
    staticClass: "logo-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(123),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "logo-c-info"
  }, [_c('span', [_vm._v("邮箱：info@reemii.cn")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("电话: 0871-64589278")])]), _vm._v(" "), _c('div', {
    staticClass: "logo-c-info"
  }, [_c('span', [_vm._v("官网：http://www.reemii.cn")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("地址：昆明市西山区红星财富中心B座28楼")])]), _vm._v(" "), _c('div', {
    staticClass: "logo-c-qr"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(885),
      "alt": ""
    }
  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("扫一扫更精彩")])])])])
}]}

/***/ }),
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[352]);


// WEBPACK FOOTER //
// static/js/app.8f161662d54e0d15df6e.js